if (typeof String.prototype !== 'undefined' && typeof String.prototype.replaceAll !== 'function') {
  String.prototype.replaceAll = function (target, replacement) {
    return this.split(target).join(replacement);
  };
}
(function ($) {
  $.fn.inputFilter = function (inputFilter) {
    return this.on("input keydown keyup mousedown mouseup select contextmenu drop", function () {
      if (inputFilter(this.value)) {
        this.oldValue = this.value;
        this.oldSelectionStart = this.selectionStart;
        this.oldSelectionEnd = this.selectionEnd;
      } else if (this.hasOwnProperty("oldValue")) {
        this.value = this.oldValue;
        this.setSelectionRange(this.oldSelectionStart, this.oldSelectionEnd);
      } else {
        this.value = "";
      }
    });
  };
})(jQuery);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Events = /*#__PURE__*/function () {
  function Events() {
    _classCallCheck(this, Events);
  }
  _createClass(Events, [{
    key: "on",
    value: function on(event, callback) {
      var _this = this;
      ('' + event).split(',').forEach(function (ev) {
        ev = ev.trim();
        if (typeof _this._onEvent === 'undefined') {
          _this._onEvent = [];
        }
        if (typeof _this._onEvent[ev] === 'undefined') {
          _this._onEvent[ev] = [];
        }
        _this._onEvent[ev].push(callback.bind(_this));
      });
      return this;
    }
  }, {
    key: "once",
    value: function once(event, callback) {
      if (typeof this._onEvent === 'undefined') {
        this._onceEvent = [];
      }
      if (typeof this._onceEvent[event] === 'undefined') {
        this._onceEvent[event] = [];
      }
      this._onceEvent[event].push(callback.bind(this));
      return this;
    }
  }, {
    key: "emit",
    value: function emit(event) {
      if (typeof this._onEvent === 'undefined') {
        this._onEvent = [];
      }
      if (typeof this._onceEvent === 'undefined') {
        this._onceEvent = [];
      }
      for (var _len = arguments.length, data = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        data[_key - 1] = arguments[_key];
      }
      if (event.indexOf('#') === 0) {
        var obj = event.substr(0, event.indexOf('-'));
        var prop = event.substr(event.indexOf('-') + 1);
        var id = prop.indexOf('-') > -1 ? prop.substr(prop.indexOf('-') + 1) : null;
        if (id) {
          prop = prop.substr(0, prop.indexOf('-'));
        }
        if (obj && prop && id) {
          if (typeof this._onEvent[obj] !== 'undefined') {
            for (var i = 0; i < this._onEvent[obj].length; i++) {
              if (typeof this._onEvent[obj][i] === 'function') {
                var _this$_onEvent$obj;
                (_this$_onEvent$obj = this._onEvent[obj])[i].apply(_this$_onEvent$obj, [id, prop].concat(data));
              }
            }
          }
          if (typeof this._onceEvent[obj] !== 'undefined') {
            while (this._onceEvent[obj].length > 0) {
              var ev = this._onceEvent[obj].shift();
              if (typeof ev === 'function') {
                ev.apply(void 0, [id, prop].concat(data));
              }
            }
          }
          return;
        }
        if (typeof this._onEvent[obj] !== 'undefined') {
          for (var i = 0; i < this._onEvent[obj].length; i++) {
            if (typeof this._onEvent[obj][i] === 'function') {
              var _this$_onEvent$obj2;
              (_this$_onEvent$obj2 = this._onEvent[obj])[i].apply(_this$_onEvent$obj2, [prop, null].concat(data));
            }
          }
        }
        if (typeof this._onceEvent[obj] !== 'undefined') {
          while (this._onceEvent[obj].length > 0) {
            var ev = this._onceEvent[obj].shift();
            if (typeof ev === 'function') {
              ev.apply(void 0, [prop, null].concat(data));
            }
          }
        }
        return;
      }
      if (typeof this._onEvent[event] !== 'undefined') {
        for (var i = 0; i < this._onEvent[event].length; i++) {
          if (typeof this._onEvent[event][i] === 'function') {
            var _this$_onEvent$event;
            (_this$_onEvent$event = this._onEvent[event])[i].apply(_this$_onEvent$event, data);
          }
        }
      }
      if (typeof this._onceEvent[event] !== 'undefined') {
        while (this._onceEvent[event].length > 0) {
          var ev = this._onceEvent[event].shift();
          if (typeof ev === 'function') {
            ev.apply(void 0, data);
          }
        }
      }
      return this;
    }
  }, {
    key: "unbind",
    value: function unbind(event) {
      if (typeof this._onEvent !== 'undefined') {
        this._onEvent[event] = [];
      }
      if (typeof this._onceEvent !== 'undefined') {
        this._onceEvent[event] = [];
      }
      return this;
    }
  }]);
  return Events;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourCountry = /*#__PURE__*/function () {
  function VegamourCountry() {
    _classCallCheck(this, VegamourCountry);
    this.exchangeRate = 1;
    this.setExchangeRate();
  }
  _createClass(VegamourCountry, [{
    key: "countryList",
    value: function countryList() {
      return {
        'AF': 'Afghanistan',
        'AX': 'Aland Islands',
        'AL': 'Albania',
        'DZ': 'Algeria',
        'AS': 'American Samoa',
        'AD': 'Andorra',
        'AO': 'Angola',
        'AI': 'Anguilla',
        'AQ': 'Antarctica',
        'AG': 'Antigua And Barbuda',
        'AR': 'Argentina',
        'AM': 'Armenia',
        'AW': 'Aruba',
        'AU': 'Australia',
        'AT': 'Austria',
        'AZ': 'Azerbaijan',
        'BS': 'Bahamas',
        'BH': 'Bahrain',
        'BD': 'Bangladesh',
        'BB': 'Barbados',
        'BY': 'Belarus',
        'BE': 'Belgium',
        'BZ': 'Belize',
        'BJ': 'Benin',
        'BM': 'Bermuda',
        'BT': 'Bhutan',
        'BO': 'Bolivia',
        'BA': 'Bosnia And Herzegovina',
        'BW': 'Botswana',
        'BV': 'Bouvet Island',
        'BR': 'Brazil',
        'IO': 'British Indian Ocean Territory',
        'BN': 'Brunei Darussalam',
        'BG': 'Bulgaria',
        'BF': 'Burkina Faso',
        'BI': 'Burundi',
        'KH': 'Cambodia',
        'CM': 'Cameroon',
        'CA': 'Canada',
        'CV': 'Cape Verde',
        'KY': 'Cayman Islands',
        'CF': 'Central African Republic',
        'TD': 'Chad',
        'CL': 'Chile',
        'CN': 'China',
        'CX': 'Christmas Island',
        'CC': 'Cocos (Keeling) Islands',
        'CO': 'Colombia',
        'KM': 'Comoros',
        'CG': 'Congo',
        'CD': 'Congo, Democratic Republic',
        'CK': 'Cook Islands',
        'CR': 'Costa Rica',
        'CI': 'Cote D\'Ivoire',
        'HR': 'Croatia',
        'CU': 'Cuba',
        'CY': 'Cyprus',
        'CZ': 'Czech Republic',
        'DK': 'Denmark',
        'DJ': 'Djibouti',
        'DM': 'Dominica',
        'DO': 'Dominican Republic',
        'EC': 'Ecuador',
        'EG': 'Egypt',
        'SV': 'El Salvador',
        'GQ': 'Equatorial Guinea',
        'ER': 'Eritrea',
        'EE': 'Estonia',
        'ET': 'Ethiopia',
        'EU': 'Europe',
        'FK': 'Falkland Islands (Malvinas)',
        'FO': 'Faroe Islands',
        'FJ': 'Fiji',
        'FI': 'Finland',
        'FR': 'France',
        'GF': 'French Guiana',
        'PF': 'French Polynesia',
        'TF': 'French Southern Territories',
        'GA': 'Gabon',
        'GM': 'Gambia',
        'GE': 'Georgia',
        'DE': 'Germany',
        'GH': 'Ghana',
        'GI': 'Gibraltar',
        'GR': 'Greece',
        'GL': 'Greenland',
        'GD': 'Grenada',
        'GP': 'Guadeloupe',
        'GU': 'Guam',
        'GT': 'Guatemala',
        'GG': 'Guernsey',
        'GN': 'Guinea',
        'GW': 'Guinea-Bissau',
        'GY': 'Guyana',
        'HT': 'Haiti',
        'HM': 'Heard Island & Mcdonald Islands',
        'VA': 'Holy See (Vatican City State)',
        'HN': 'Honduras',
        'HK': 'Hong Kong',
        'HU': 'Hungary',
        'IS': 'Iceland',
        'IN': 'India',
        'ID': 'Indonesia',
        'IR': 'Iran, Islamic Republic Of',
        'IQ': 'Iraq',
        'IE': 'Ireland',
        'IM': 'Isle Of Man',
        'IL': 'Israel',
        'IT': 'Italy',
        'JM': 'Jamaica',
        'JP': 'Japan',
        'JE': 'Jersey',
        'JO': 'Jordan',
        'KZ': 'Kazakhstan',
        'KE': 'Kenya',
        'KI': 'Kiribati',
        'KR': 'Korea',
        'KW': 'Kuwait',
        'KG': 'Kyrgyzstan',
        'LA': 'Lao People\'s Democratic Republic',
        'LV': 'Latvia',
        'LB': 'Lebanon',
        'LS': 'Lesotho',
        'LR': 'Liberia',
        'LY': 'Libyan Arab Jamahiriya',
        'LI': 'Liechtenstein',
        'LT': 'Lithuania',
        'LU': 'Luxembourg',
        'MO': 'Macao',
        'MK': 'Macedonia',
        'MG': 'Madagascar',
        'MW': 'Malawi',
        'MY': 'Malaysia',
        'MV': 'Maldives',
        'ML': 'Mali',
        'MT': 'Malta',
        'MH': 'Marshall Islands',
        'MQ': 'Martinique',
        'MR': 'Mauritania',
        'MU': 'Mauritius',
        'YT': 'Mayotte',
        'MX': 'Mexico',
        'FM': 'Micronesia, Federated States Of',
        'MD': 'Moldova',
        'MC': 'Monaco',
        'MN': 'Mongolia',
        'ME': 'Montenegro',
        'MS': 'Montserrat',
        'MA': 'Morocco',
        'MZ': 'Mozambique',
        'MM': 'Myanmar',
        'NA': 'Namibia',
        'NR': 'Nauru',
        'NP': 'Nepal',
        'NL': 'Netherlands',
        'AN': 'Netherlands Antilles',
        'NC': 'New Caledonia',
        'NZ': 'New Zealand',
        'NI': 'Nicaragua',
        'NE': 'Niger',
        'NG': 'Nigeria',
        'NU': 'Niue',
        'NF': 'Norfolk Island',
        'MP': 'Northern Mariana Islands',
        'NO': 'Norway',
        'OM': 'Oman',
        'PK': 'Pakistan',
        'PW': 'Palau',
        'PS': 'Palestinian Territory, Occupied',
        'PA': 'Panama',
        'PG': 'Papua New Guinea',
        'PY': 'Paraguay',
        'PE': 'Peru',
        'PH': 'Philippines',
        'PN': 'Pitcairn',
        'PL': 'Poland',
        'PT': 'Portugal',
        'PR': 'Puerto Rico',
        'QA': 'Qatar',
        'RE': 'Reunion',
        'RO': 'Romania',
        'RU': 'Russian Federation',
        'RW': 'Rwanda',
        'BL': 'Saint Barthelemy',
        'SH': 'Saint Helena',
        'KN': 'Saint Kitts And Nevis',
        'LC': 'Saint Lucia',
        'MF': 'Saint Martin',
        'PM': 'Saint Pierre And Miquelon',
        'VC': 'Saint Vincent And Grenadines',
        'WS': 'Samoa',
        'SM': 'San Marino',
        'ST': 'Sao Tome And Principe',
        'SA': 'Saudi Arabia',
        'SN': 'Senegal',
        'RS': 'Serbia',
        'SC': 'Seychelles',
        'SL': 'Sierra Leone',
        'SG': 'Singapore',
        'SK': 'Slovakia',
        'SI': 'Slovenia',
        'SB': 'Solomon Islands',
        'SO': 'Somalia',
        'ZA': 'South Africa',
        'GS': 'South Georgia And Sandwich Isl.',
        'ES': 'Spain',
        'LK': 'Sri Lanka',
        'SD': 'Sudan',
        'SR': 'Suriname',
        'SJ': 'Svalbard And Jan Mayen',
        'SZ': 'Swaziland',
        'SE': 'Sweden',
        'CH': 'Switzerland',
        'SY': 'Syrian Arab Republic',
        'TW': 'Taiwan',
        'TJ': 'Tajikistan',
        'TZ': 'Tanzania',
        'TH': 'Thailand',
        'TL': 'Timor-Leste',
        'TG': 'Togo',
        'TK': 'Tokelau',
        'TO': 'Tonga',
        'TT': 'Trinidad And Tobago',
        'TN': 'Tunisia',
        'TR': 'Turkey',
        'TM': 'Turkmenistan',
        'TC': 'Turks And Caicos Islands',
        'TV': 'Tuvalu',
        'UG': 'Uganda',
        'UA': 'Ukraine',
        'AE': 'United Arab Emirates',
        'GB': 'United Kingdom',
        'US': 'United States',
        'UM': 'United States Outlying Islands',
        'UY': 'Uruguay',
        'UZ': 'Uzbekistan',
        'VU': 'Vanuatu',
        'VE': 'Venezuela',
        'VN': 'Viet Nam',
        'VG': 'Virgin Islands, British',
        'VI': 'Virgin Islands, U.S.',
        'WF': 'Wallis And Futuna',
        'EH': 'Western Sahara',
        'YE': 'Yemen',
        'ZM': 'Zambia',
        'ZW': 'Zimbabwe'
      };
    }
  }, {
    key: "currencyList",
    value: function currencyList() {
      return {
        'AF': {
          'code': 'AFN',
          'name': 'Afghani',
          'symbol': '؋'
        },
        'AL': {
          'code': 'ALL',
          'name': 'Lek',
          'symbol': 'Lek'
        },
        'DZ': {
          'code': 'DZD',
          'name': 'Dinar',
          'symbol': false
        },
        'AS': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'AD': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'AO': {
          'code': 'AOA',
          'name': 'Kwanza',
          'symbol': 'Kz'
        },
        'AI': {
          'code': 'XCD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'AG': {
          'code': 'XCD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'AR': {
          'code': 'ARS',
          'name': 'Peso',
          'symbol': '$'
        },
        'AM': {
          'code': 'AMD',
          'name': 'Dram',
          'symbol': false
        },
        'AW': {
          'code': 'AWG',
          'name': 'Guilder',
          'symbol': 'ƒ'
        },
        'AU': {
          'code': 'AUD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'AT': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'AZ': {
          'code': 'AZN',
          'name': 'Manat',
          'symbol': 'ман'
        },
        'BS': {
          'code': 'BSD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'BH': {
          'code': 'BHD',
          'name': 'Dinar',
          'symbol': false
        },
        'BD': {
          'code': 'BDT',
          'name': 'Taka',
          'symbol': false
        },
        'BB': {
          'code': 'BBD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'BY': {
          'code': 'BYR',
          'name': 'Ruble',
          'symbol': 'p.'
        },
        'BE': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'BZ': {
          'code': 'BZD',
          'name': 'Dollar',
          'symbol': 'BZ$'
        },
        'BJ': {
          'code': 'XOF',
          'name': 'Franc',
          'symbol': false
        },
        'BM': {
          'code': 'BMD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'BT': {
          'code': 'BTN',
          'name': 'Ngultrum',
          'symbol': false
        },
        'BO': {
          'code': 'BOB',
          'name': 'Boliviano',
          'symbol': '$b'
        },
        'BA': {
          'code': 'BAM',
          'name': 'Marka',
          'symbol': 'KM'
        },
        'BW': {
          'code': 'BWP',
          'name': 'Pula',
          'symbol': 'P'
        },
        'BV': {
          'code': 'NOK',
          'name': 'Krone',
          'symbol': 'kr'
        },
        'BR': {
          'code': 'BRL',
          'name': 'Real',
          'symbol': 'R$'
        },
        'IO': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'VG': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'BN': {
          'code': 'BND',
          'name': 'Dollar',
          'symbol': '$'
        },
        'BG': {
          'code': 'BGN',
          'name': 'Lev',
          'symbol': 'лв'
        },
        'BF': {
          'code': 'XOF',
          'name': 'Franc',
          'symbol': false
        },
        'BI': {
          'code': 'BIF',
          'name': 'Franc',
          'symbol': false
        },
        'KH': {
          'code': 'KHR',
          'name': 'Riels',
          'symbol': '៛'
        },
        'CM': {
          'code': 'XAF',
          'name': 'Franc',
          'symbol': 'FCF'
        },
        'CA': {
          'code': 'CAD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'CV': {
          'code': 'CVE',
          'name': 'Escudo',
          'symbol': false
        },
        'KY': {
          'code': 'KYD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'CF': {
          'code': 'XAF',
          'name': 'Franc',
          'symbol': 'FCF'
        },
        'TD': {
          'code': 'XAF',
          'name': 'Franc',
          'symbol': false
        },
        'CL': {
          'code': 'CLP',
          'name': 'Peso',
          'symbol': false
        },
        'CN': {
          'code': 'CNY',
          'name': 'YuanRenminbi',
          'symbol': '¥'
        },
        'CX': {
          'code': 'AUD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'CC': {
          'code': 'AUD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'CO': {
          'code': 'COP',
          'name': 'Peso',
          'symbol': '$'
        },
        'KM': {
          'code': 'KMF',
          'name': 'Franc',
          'symbol': false
        },
        'CK': {
          'code': 'NZD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'CR': {
          'code': 'CRC',
          'name': 'Colon',
          'symbol': '₡'
        },
        'HR': {
          'code': 'HRK',
          'name': 'Kuna',
          'symbol': 'kn'
        },
        'CU': {
          'code': 'CUP',
          'name': 'Peso',
          'symbol': '₱'
        },
        'CY': {
          'code': 'CYP',
          'name': 'Pound',
          'symbol': false
        },
        'CZ': {
          'code': 'CZK',
          'name': 'Koruna',
          'symbol': 'Kč'
        },
        'CD': {
          'code': 'CDF',
          'name': 'Franc',
          'symbol': false
        },
        'DK': {
          'code': 'DKK',
          'name': 'Krone',
          'symbol': 'kr'
        },
        'DJ': {
          'code': 'DJF',
          'name': 'Franc',
          'symbol': false
        },
        'DM': {
          'code': 'XCD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'DO': {
          'code': 'DOP',
          'name': 'Peso',
          'symbol': 'RD$'
        },
        'TL': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'EC': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'EG': {
          'code': 'EGP',
          'name': 'Pound',
          'symbol': '£'
        },
        'SV': {
          'code': 'SVC',
          'name': 'Colone',
          'symbol': '$'
        },
        'GQ': {
          'code': 'XAF',
          'name': 'Franc',
          'symbol': 'FCF'
        },
        'ER': {
          'code': 'ERN',
          'name': 'Nakfa',
          'symbol': 'Nfk'
        },
        'EE': {
          'code': 'EEK',
          'name': 'Kroon',
          'symbol': 'kr'
        },
        'ET': {
          'code': 'ETB',
          'name': 'Birr',
          'symbol': false
        },
        'FK': {
          'code': 'FKP',
          'name': 'Pound',
          'symbol': '£'
        },
        'FO': {
          'code': 'DKK',
          'name': 'Krone',
          'symbol': 'kr'
        },
        'FJ': {
          'code': 'FJD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'FI': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'FR': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'GF': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'PF': {
          'code': 'XPF',
          'name': 'Franc',
          'symbol': false
        },
        'TF': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'GA': {
          'code': 'XAF',
          'name': 'Franc',
          'symbol': 'FCF'
        },
        'GM': {
          'code': 'GMD',
          'name': 'Dalasi',
          'symbol': 'D'
        },
        'GE': {
          'code': 'GEL',
          'name': 'Lari',
          'symbol': false
        },
        'DE': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'GH': {
          'code': 'GHC',
          'name': 'Cedi',
          'symbol': '¢'
        },
        'GI': {
          'code': 'GIP',
          'name': 'Pound',
          'symbol': '£'
        },
        'GR': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'GL': {
          'code': 'DKK',
          'name': 'Krone',
          'symbol': 'kr'
        },
        'GD': {
          'code': 'XCD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'GP': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'GU': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'GT': {
          'code': 'GTQ',
          'name': 'Quetzal',
          'symbol': 'Q'
        },
        'GN': {
          'code': 'GNF',
          'name': 'Franc',
          'symbol': false
        },
        'GW': {
          'code': 'XOF',
          'name': 'Franc',
          'symbol': false
        },
        'GY': {
          'code': 'GYD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'HT': {
          'code': 'HTG',
          'name': 'Gourde',
          'symbol': 'G'
        },
        'HM': {
          'code': 'AUD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'HN': {
          'code': 'HNL',
          'name': 'Lempira',
          'symbol': 'L'
        },
        'HK': {
          'code': 'HKD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'HU': {
          'code': 'HUF',
          'name': 'Forint',
          'symbol': 'Ft'
        },
        'IS': {
          'code': 'ISK',
          'name': 'Krona',
          'symbol': 'kr'
        },
        'IN': {
          'code': 'INR',
          'name': 'Rupee',
          'symbol': '₹'
        },
        'ID': {
          'code': 'IDR',
          'name': 'Rupiah',
          'symbol': 'Rp'
        },
        'IR': {
          'code': 'IRR',
          'name': 'Rial',
          'symbol': '﷼'
        },
        'IQ': {
          'code': 'IQD',
          'name': 'Dinar',
          'symbol': false
        },
        'IE': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'IL': {
          'code': 'ILS',
          'name': 'Shekel',
          'symbol': '₪'
        },
        'IT': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'CI': {
          'code': 'XOF',
          'name': 'Franc',
          'symbol': false
        },
        'JM': {
          'code': 'JMD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'JP': {
          'code': 'JPY',
          'name': 'Yen',
          'symbol': '¥'
        },
        'JO': {
          'code': 'JOD',
          'name': 'Dinar',
          'symbol': false
        },
        'KZ': {
          'code': 'KZT',
          'name': 'Tenge',
          'symbol': 'лв'
        },
        'KE': {
          'code': 'KES',
          'name': 'Shilling',
          'symbol': false
        },
        'KI': {
          'code': 'AUD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'KW': {
          'code': 'KWD',
          'name': 'Dinar',
          'symbol': false
        },
        'KG': {
          'code': 'KGS',
          'name': 'Som',
          'symbol': 'лв'
        },
        'LA': {
          'code': 'LAK',
          'name': 'Kip',
          'symbol': '₭'
        },
        'LV': {
          'code': 'LVL',
          'name': 'Lat',
          'symbol': 'Ls'
        },
        'LB': {
          'code': 'LBP',
          'name': 'Pound',
          'symbol': '£'
        },
        'LS': {
          'code': 'LSL',
          'name': 'Loti',
          'symbol': 'L'
        },
        'LR': {
          'code': 'LRD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'LY': {
          'code': 'LYD',
          'name': 'Dinar',
          'symbol': false
        },
        'LI': {
          'code': 'CHF',
          'name': 'Franc',
          'symbol': 'CHF'
        },
        'LT': {
          'code': 'LTL',
          'name': 'Litas',
          'symbol': 'Lt'
        },
        'LU': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'MO': {
          'code': 'MOP',
          'name': 'Pataca',
          'symbol': 'MOP'
        },
        'MK': {
          'code': 'MKD',
          'name': 'Denar',
          'symbol': 'ден'
        },
        'MG': {
          'code': 'MGA',
          'name': 'Ariary',
          'symbol': false
        },
        'MW': {
          'code': 'MWK',
          'name': 'Kwacha',
          'symbol': 'MK'
        },
        'MY': {
          'code': 'MYR',
          'name': 'Ringgit',
          'symbol': 'RM'
        },
        'MV': {
          'code': 'MVR',
          'name': 'Rufiyaa',
          'symbol': 'Rf'
        },
        'ML': {
          'code': 'XOF',
          'name': 'Franc',
          'symbol': false
        },
        'MT': {
          'code': 'MTL',
          'name': 'Lira',
          'symbol': false
        },
        'MH': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'MQ': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'MR': {
          'code': 'MRO',
          'name': 'Ouguiya',
          'symbol': 'UM'
        },
        'MU': {
          'code': 'MUR',
          'name': 'Rupee',
          'symbol': '₨'
        },
        'YT': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'MX': {
          'code': 'MXN',
          'name': 'Peso',
          'symbol': '$'
        },
        'FM': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'MD': {
          'code': 'MDL',
          'name': 'Leu',
          'symbol': false
        },
        'MC': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'MN': {
          'code': 'MNT',
          'name': 'Tugrik',
          'symbol': '₮'
        },
        'MS': {
          'code': 'XCD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'MA': {
          'code': 'MAD',
          'name': 'Dirham',
          'symbol': false
        },
        'MZ': {
          'code': 'MZN',
          'name': 'Meticail',
          'symbol': 'MT'
        },
        'MM': {
          'code': 'MMK',
          'name': 'Kyat',
          'symbol': 'K'
        },
        'NA': {
          'code': 'NAD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'NR': {
          'code': 'AUD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'NP': {
          'code': 'NPR',
          'name': 'Rupee',
          'symbol': '₨'
        },
        'NL': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'AN': {
          'code': 'ANG',
          'name': 'Guilder',
          'symbol': 'ƒ'
        },
        'NC': {
          'code': 'XPF',
          'name': 'Franc',
          'symbol': false
        },
        'NZ': {
          'code': 'NZD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'NI': {
          'code': 'NIO',
          'name': 'Cordoba',
          'symbol': 'C$'
        },
        'NE': {
          'code': 'XOF',
          'name': 'Franc',
          'symbol': false
        },
        'NG': {
          'code': 'NGN',
          'name': 'Naira',
          'symbol': '₦'
        },
        'NU': {
          'code': 'NZD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'NF': {
          'code': 'AUD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'KP': {
          'code': 'KPW',
          'name': 'Won',
          'symbol': '₩'
        },
        'MP': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'NO': {
          'code': 'NOK',
          'name': 'Krone',
          'symbol': 'kr'
        },
        'OM': {
          'code': 'OMR',
          'name': 'Rial',
          'symbol': '﷼'
        },
        'PK': {
          'code': 'PKR',
          'name': 'Rupee',
          'symbol': '₨'
        },
        'PW': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'PS': {
          'code': 'ILS',
          'name': 'Shekel',
          'symbol': '₪'
        },
        'PA': {
          'code': 'PAB',
          'name': 'Balboa',
          'symbol': 'B/.'
        },
        'PG': {
          'code': 'PGK',
          'name': 'Kina',
          'symbol': false
        },
        'PY': {
          'code': 'PYG',
          'name': 'Guarani',
          'symbol': 'Gs'
        },
        'PE': {
          'code': 'PEN',
          'name': 'Sol',
          'symbol': 'S/.'
        },
        'PH': {
          'code': 'PHP',
          'name': 'Peso',
          'symbol': 'Php'
        },
        'PN': {
          'code': 'NZD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'PL': {
          'code': 'PLN',
          'name': 'Zloty',
          'symbol': 'zł'
        },
        'PT': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'PR': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'QA': {
          'code': 'QAR',
          'name': 'Rial',
          'symbol': '﷼'
        },
        'CG': {
          'code': 'XAF',
          'name': 'Franc',
          'symbol': 'FCF'
        },
        'RE': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'RO': {
          'code': 'RON',
          'name': 'Leu',
          'symbol': 'lei'
        },
        'RU': {
          'code': 'RUB',
          'name': 'Ruble',
          'symbol': 'руб'
        },
        'RW': {
          'code': 'RWF',
          'name': 'Franc',
          'symbol': false
        },
        'SH': {
          'code': 'SHP',
          'name': 'Pound',
          'symbol': '£'
        },
        'KN': {
          'code': 'XCD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'LC': {
          'code': 'XCD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'PM': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'VC': {
          'code': 'XCD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'WS': {
          'code': 'WST',
          'name': 'Tala',
          'symbol': 'WS$'
        },
        'SM': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'ST': {
          'code': 'STD',
          'name': 'Dobra',
          'symbol': 'Db'
        },
        'SA': {
          'code': 'SAR',
          'name': 'Rial',
          'symbol': '﷼'
        },
        'SN': {
          'code': 'XOF',
          'name': 'Franc',
          'symbol': false
        },
        'CS': {
          'code': 'RSD',
          'name': 'Dinar',
          'symbol': 'Дин'
        },
        'SC': {
          'code': 'SCR',
          'name': 'Rupee',
          'symbol': '₨'
        },
        'SL': {
          'code': 'SLL',
          'name': 'Leone',
          'symbol': 'Le'
        },
        'SG': {
          'code': 'SGD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'SK': {
          'code': 'SKK',
          'name': 'Koruna',
          'symbol': 'Sk'
        },
        'SI': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'SB': {
          'code': 'SBD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'SO': {
          'code': 'SOS',
          'name': 'Shilling',
          'symbol': 'S'
        },
        'ZA': {
          'code': 'ZAR',
          'name': 'Rand',
          'symbol': 'R'
        },
        'GS': {
          'code': 'GBP',
          'name': 'Pound',
          'symbol': '£'
        },
        'KR': {
          'code': 'KRW',
          'name': 'Won',
          'symbol': '₩'
        },
        'ES': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'LK': {
          'code': 'LKR',
          'name': 'Rupee',
          'symbol': '₨'
        },
        'SD': {
          'code': 'SDD',
          'name': 'Dinar',
          'symbol': false
        },
        'SR': {
          'code': 'SRD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'SJ': {
          'code': 'NOK',
          'name': 'Krone',
          'symbol': 'kr'
        },
        'SZ': {
          'code': 'SZL',
          'name': 'Lilangeni',
          'symbol': false
        },
        'SE': {
          'code': 'SEK',
          'name': 'Krona',
          'symbol': 'kr'
        },
        'CH': {
          'code': 'CHF',
          'name': 'Franc',
          'symbol': 'CHF'
        },
        'SY': {
          'code': 'SYP',
          'name': 'Pound',
          'symbol': '£'
        },
        'TW': {
          'code': 'TWD',
          'name': 'Dollar',
          'symbol': 'NT$'
        },
        'TJ': {
          'code': 'TJS',
          'name': 'Somoni',
          'symbol': false
        },
        'TZ': {
          'code': 'TZS',
          'name': 'Shilling',
          'symbol': false
        },
        'TH': {
          'code': 'THB',
          'name': 'Baht',
          'symbol': '฿'
        },
        'TG': {
          'code': 'XOF',
          'name': 'Franc',
          'symbol': false
        },
        'TK': {
          'code': 'NZD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'TO': {
          'code': 'TOP',
          'name': 'Paanga',
          'symbol': 'T$'
        },
        'TT': {
          'code': 'TTD',
          'name': 'Dollar',
          'symbol': 'TT$'
        },
        'TN': {
          'code': 'TND',
          'name': 'Dinar',
          'symbol': false
        },
        'TR': {
          'code': 'TRY',
          'name': 'Lira',
          'symbol': 'YTL'
        },
        'TM': {
          'code': 'TMM',
          'name': 'Manat',
          'symbol': 'm'
        },
        'TC': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'TV': {
          'code': 'AUD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'VI': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'UG': {
          'code': 'UGX',
          'name': 'Shilling',
          'symbol': false
        },
        'UA': {
          'code': 'UAH',
          'name': 'Hryvnia',
          'symbol': '₴'
        },
        'AE': {
          'code': 'AED',
          'name': 'Dirham',
          'symbol': false
        },
        'GB': {
          'code': 'GBP',
          'name': 'Pound',
          'symbol': '£'
        },
        'US': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'UM': {
          'code': 'USD',
          'name': 'Dollar',
          'symbol': '$'
        },
        'UY': {
          'code': 'UYU',
          'name': 'Peso',
          'symbol': '$U'
        },
        'UZ': {
          'code': 'UZS',
          'name': 'Som',
          'symbol': 'лв'
        },
        'VU': {
          'code': 'VUV',
          'name': 'Vatu',
          'symbol': 'Vt'
        },
        'VA': {
          'code': 'EUR',
          'name': 'Euro',
          'symbol': '€'
        },
        'VE': {
          'code': 'VEF',
          'name': 'Bolivar',
          'symbol': 'Bs'
        },
        'VN': {
          'code': 'VND',
          'name': 'Dong',
          'symbol': '₫'
        },
        'WF': {
          'code': 'XPF',
          'name': 'Franc',
          'symbol': false
        },
        'EH': {
          'code': 'MAD',
          'name': 'Dirham',
          'symbol': false
        },
        'YE': {
          'code': 'YER',
          'name': 'Rial',
          'symbol': '﷼'
        },
        'ZM': {
          'code': 'ZMK',
          'name': 'Kwacha',
          'symbol': 'ZK'
        },
        'ZW': {
          'code': 'ZWD',
          'name': 'Dollar',
          'symbol': 'Z$'
        }
      };
    }
  }, {
    key: "stateList",
    value: function stateList() {
      return {
        'AL': 'Alabama',
        'AK': 'Alaska',
        'AS': 'American Samoa',
        'AZ': 'Arizona',
        'AR': 'Arkansas',
        'CA': 'California',
        'CO': 'Colorado',
        'CT': 'Connecticut',
        'DE': 'Delaware',
        'DC': 'District Of Columbia',
        'FM': 'Federated States Of Micronesia',
        'FL': 'Florida',
        'GA': 'Georgia',
        'GU': 'Guam',
        'HI': 'Hawaii',
        'ID': 'Idaho',
        'IL': 'Illinois',
        'IN': 'Indiana',
        'IA': 'Iowa',
        'KS': 'Kansas',
        'KY': 'Kentucky',
        'LA': 'Louisiana',
        'ME': 'Maine',
        'MH': 'Marshall Islands',
        'MD': 'Maryland',
        'MA': 'Massachusetts',
        'MI': 'Michigan',
        'MN': 'Minnesota',
        'MS': 'Mississippi',
        'MO': 'Missouri',
        'MT': 'Montana',
        'NE': 'Nebraska',
        'NV': 'Nevada',
        'NH': 'New Hampshire',
        'NJ': 'New Jersey',
        'NM': 'New Mexico',
        'NY': 'New York',
        'NC': 'North Carolina',
        'ND': 'North Dakota',
        'MP': 'Northern Mariana Islands',
        'OH': 'Ohio',
        'OK': 'Oklahoma',
        'OR': 'Oregon',
        'PW': 'Palau',
        'PA': 'Pennsylvania',
        'PR': 'Puerto Rico',
        'RI': 'Rhode Island',
        'SC': 'South Carolina',
        'SD': 'South Dakota',
        'TN': 'Tennessee',
        'TX': 'Texas',
        'UT': 'Utah',
        'VT': 'Vermont',
        'VI': 'Virgin Islands',
        'VA': 'Virginia',
        'WA': 'Washington',
        'WV': 'West Virginia',
        'WI': 'Wisconsin',
        'WY': 'Wyoming'
      };
    }
  }, {
    key: "getByCode",
    value: function getByCode(code) {
      return this.countryList()[code] || null;
    }
  }, {
    key: "getByState",
    value: function getByState(state) {
      return this.stateList()[state] || null;
    }
  }, {
    key: "getByName",
    value: function getByName(name) {
      if (!name) {
        return null;
      }
      var countryList = this.countryList();
      var keys = Object.keys(countryList);
      for (var key in keys) {
        if (countryList[keys[key]].toLowerCase() === name.toLowerCase()) {
          return keys[key];
        }
      }
      return null;
    }
  }, {
    key: "getStateByName",
    value: function getStateByName(name) {
      if (!name) {
        return null;
      }
      var stateList = this.stateList();
      var keys = Object.keys(stateList);
      for (var key in keys) {
        if (stateList[keys[key]].toLowerCase() === name.toLowerCase()) {
          return keys[key];
        }
      }
      return null;
    }
  }, {
    key: "stateLogic",
    value: function stateLogic(location) {
      if (location.state === vegamour.country.getByState('CA')) {
        $('.terms').find('span').removeClass('d-none');
      }
    }
  }, {
    key: "getCurrency",
    value: function getCurrency(country) {
      var currency = this.currencyList();
      if (typeof currency[country] === 'undefined') {
        return false;
      }
      return currency[country];
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      var _this = this;
      var cache = vegamour.cache.get('geo-api');
      if (cache) {
        this.stateLogic(cache);
        return cache;
      }
      if (this.performedRequest) {
        return;
      }
      this.performedRequest = true;
      $.ajax({
        url: 'https://geolocation-db.com/json/',
        type: 'get',
        dataType: 'json'
      }).done(function (data) {
        _this.stateLogic(data);
        vegamour.cache.put('geo-api', data, 86400);
        vegamour.emit('geolocationReady');
      }).fail(function (err) {
        if (typeof callback === 'function') {
          callback(err);
        }
      });
    }
  }, {
    key: "setExchangeRate",
    value: function setExchangeRate() {
      var _this2 = this;
      if (!window.vegamourOptions.currency || window.vegamourOptions.currency["short"] != 'USD') {
        var url = 'https://cdn.shopify.com/s/javascripts/currencies.js';
        $.get(url).done(function (data) {
          if (data) {
            eval(data);
            if (Currency && typeof Currency.rates[window.vegamourOptions.currency["short"]] !== 'undefined') {
              _this2.exchangeRate = Currency.rates[window.vegamourOptions.currency["short"]];
              if (vegamour.cart.discounts) {
                vegamour.cart.discounts.setDiscountDisplay();
              }
            }
          }
        });
      }
    }
  }, {
    key: "exchange",
    value: function exchange(amount, toUSD) {
      if (typeof toUSD !== 'undefined' && toUSD) {
        amount = amount * this.exchangeRate;
      } else {
        amount = amount / this.exchangeRate;
      }
      amount = parseFloat(amount).toFixed(2);
      return amount;
    }
  }]);
  return VegamourCountry;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourCache = /*#__PURE__*/function () {
  function VegamourCache() {
    _classCallCheck(this, VegamourCache);
    this.prefix = 'v-cache-';
  }
  _createClass(VegamourCache, [{
    key: "get",
    value: function get(key) {
      if (!window.localStorage) {
        return null;
      }
      var data = window.localStorage.getItem(this.prefix + key);
      if (_typeof(data !== 'undefined') && data !== null && data.length) {
        var json = JSON.parse(data);
        var now = new Date().getTime();

        // Check cache time is valid
        if (typeof json.ttl !== 'undefined') {
          if (now - json.ttl < 0) {
            return json.data;
          }

          // Expired
          this.forget(this.prefix + key);
        } else {
          return json.data;
        }
      }
      return null;
    }
  }, {
    key: "put",
    value: function put(key, obj, seconds) {
      if (!window.localStorage) {
        return;
      }
      var data = {
        data: obj
      };

      // Time to live for cache
      if (typeof seconds !== 'undefined') {
        data.ttl = new Date().getTime() + seconds * 1000;
      }
      window.localStorage.setItem(this.prefix + key, JSON.stringify(data));
    }
  }, {
    key: "forget",
    value: function forget(key) {
      if (!window.localStorage) {
        return;
      }
      window.localStorage.removeItem(this.prefix + key);
    }
  }, {
    key: "flush",
    value: function flush() {
      if (!window.localStorage) {
        return;
      }
      for (var i = 0, len = window.localStorage.length; i < len; ++i) {
        if (window.localStorage.key(i) && window.localStorage.key(i).startsWith(this.prefix)) {
          window.localStorage.removeItem(window.localStorage.key(i));
        }
      }
    }
  }]);
  return VegamourCache;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourSession = /*#__PURE__*/function () {
  function VegamourSession() {
    _classCallCheck(this, VegamourSession);
    this.prefix = 'v-session-';
  }
  _createClass(VegamourSession, [{
    key: "get",
    value: function get(key) {
      if (!window.sessionStorage) {
        return null;
      }
      var data = window.sessionStorage.getItem(this.prefix + key);
      if (_typeof(data !== 'undefined') && data !== null && data.length) {
        var json = JSON.parse(data);
        var now = new Date().getTime();

        // Check cache time is valid
        if (typeof json.ttl !== 'undefined') {
          if (now - json.ttl < 0) {
            return json.data;
          }

          // Expired
          this.forget(this.prefix + key);
        } else {
          return json.data;
        }
      }
      return null;
    }
  }, {
    key: "put",
    value: function put(key, obj, seconds) {
      if (!window.sessionStorage) {
        return;
      }
      var data = {
        data: obj
      };

      // Time to live for cache
      if (typeof seconds !== 'undefined') {
        data.ttl = new Date().getTime() + seconds * 1000;
      }
      window.sessionStorage.setItem(this.prefix + key, JSON.stringify(data));
    }
  }, {
    key: "forget",
    value: function forget(key) {
      if (!window.sessionStorage) {
        return;
      }
      window.sessionStorage.removeItem(this.prefix + key);
    }
  }, {
    key: "flush",
    value: function flush() {
      if (!window.sessionStorage) {
        return;
      }
      for (var i = 0, len = window.sessionStorage.length; i < len; ++i) {
        if (window.sessionStorage.key(i) && window.sessionStorage.key(i).startsWith(this.prefix)) {
          window.sessionStorage.removeItem(window.sessionStorage.key(i));
        }
      }
    }
  }]);
  return VegamourSession;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VegamourGeolocation = /*#__PURE__*/function (_Events) {
  _inherits(VegamourGeolocation, _Events);
  var _super = _createSuper(VegamourGeolocation);
  function VegamourGeolocation() {
    _classCallCheck(this, VegamourGeolocation);
    return _super.apply(this, arguments);
  }
  _createClass(VegamourGeolocation, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.apiData = null;
      this.appData = null;
      this.data = null;
      this.getLocationFromApi().then(function (data) {
        _this.apiData = data;
        vegamour.emit('geolocationReady', data);
      }, function (err) {
        _this.apiData = null;
        vegamour.emit('geolocationReady', null);
      });
      this.getLocationFromApp().then(function (data) {
        _this.appData = data;
        vegamour.emit('easylocationReady', data);
      }, function (err) {
        _this.appData = null;
        vegamour.emit('easylocationReady', null);
      });
    }
  }, {
    key: "getLocationData",
    value: function getLocationData() {
      return this.data;
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      var _this2 = this;
      var self = this;
      return new Promise(function (resolve, reject) {
        if (_this2.data) {
          return resolve(_this2.data);
        }
        self.getLocationFromApi().then(function (data) {
          _this2.getLocationFromApp().then(function (data) {
            resolve(_this2.data);
          }, function (err) {
            resolve(_this2.data);
          });
        }, function (err) {
          _this2.getLocationFromApp().then(function (data) {
            resolve(_this2.data);
          }, function (err) {
            reject();
          });
        });
      });
    }
  }, {
    key: "mergeData",
    value: function mergeData() {
      this.data = {
        country: {
          code: this.apiData && typeof this.apiData.country_code !== 'undefined' ? this.apiData.country_code.toUpperCase() : this.appData && typeof this.appData.country !== 'undefined' && typeof this.appData.country.iso_code !== 'undefined' ? this.appData.country.iso_code.toUpperCase() : null,
          name: this.apiData && typeof this.apiData.country_name !== 'undefined' ? this.apiData.country_name : this.appData && typeof this.appData.country !== 'undefined' && typeof this.appData.country.names !== 'undefined' && typeof this.appData.country.names.en !== 'undefined' ? this.appData.country.names.en : null
        },
        continent: {
          code: this.apiData && typeof this.apiData.continent_code !== 'undefined' ? this.apiData.continent_codecl : this.appData && typeof this.appData.continent !== 'undefined' && typeof this.appData.continent.code !== 'undefined' ? this.appData.continent.code : null,
          name: this.apiData && typeof this.apiData.continent_name !== 'undefined' ? this.apiData.continent_name : this.appData && typeof this.appData.continent !== 'undefined' && typeof this.appData.continent.names !== 'undefined' && typeof this.appData.continent.names.en !== 'undefined' ? this.appData.continent.names.en : null
        },
        city: this.apiData && typeof this.apiData.city !== 'undefined' ? this.apiData.city : this.appData && typeof this.appData.city !== 'undefined' ? this.appData.city : null,
        ip: this.apiData && typeof this.apiData.ip !== 'undefined' ? this.apiData.ip : this.appData && typeof this.appData.ip !== 'undefined' ? this.appData.ip : null,
        state: this.apiData && typeof this.apiData.region_name !== 'undefined' ? this.apiData.region_name : this.appData && typeof this.appData.region !== 'undefined' ? this.appData.region : null,
        postal: this.apiData && typeof this.apiData.zip !== 'undefined' ? this.apiData.zip : this.appData && typeof this.appData.postalCode !== 'undefined' ? this.appData.postalCode : null,
        currency: {
          code: this.apiData && typeof this.apiData.currency !== 'undefined' && typeof this.apiData.currency.code !== 'undefined' ? this.apiData.currency.code.toUpperCase() : this.appData && typeof this.appData.currency !== 'undefined' && typeof this.appData.currency.code !== 'undefined' ? this.appData.currency.code.toUpperCase() : null,
          symbol: this.apiData && typeof this.apiData.currency !== 'undefined' && typeof this.apiData.currency.symbol !== 'undefined' ? this.apiData.currency.symbol : this.appData && typeof this.appData.currency !== 'undefined' && typeof this.appData.currency.symbol !== 'undefined' ? this.appData.currency.symbol : null
        },
        api: this.apiData,
        app: this.appData
      };
    }
  }, {
    key: "getLocationFromApp",
    value: function getLocationFromApp() {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        var tries = 0;
        var pull = function pull() {
          if (typeof window.easylocation !== 'undefined' && typeof window.easylocation.locationData !== 'undefined' && window.easylocation.locationData !== null) {
            _this3.appData = window.easylocation.locationData;
            _this3.mergeData();
            resolve(window.easylocation.locationData);
          } else if (tries < 50) {
            tries++;
            setTimeout(pull, 100);
          } else {
            reject('max tries exceeded');
          }
        };
        pull();
      });
    }
  }, {
    key: "getLocationFromApi",
    value: function getLocationFromApi() {
      var _this4 = this;
      var self = this;
      return new Promise(function (resolve, reject) {
        var cache = vegamour.cache.get('geo-api');
        if (cache) {
          _this4.apiData = cache;
          _this4.mergeData();
          resolve(cache);
          return;
        }
        if (self.performedRequest) {
          var tries = 0;
          var checkCache = function checkCache() {
            var cache = vegamour.cache.get('geo-api');
            if (cache) {
              _this4.apiData = cache;
              _this4.mergeData();
              return resolve(cache);
            } else if (tries < 50) {
              tries++;
              setTimeout(checkCache, 50);
            } else {
              reject('max tries exceeded');
            }
          };
          checkCache();
          return;
        }
        self.performedRequest = true;
        $.ajax({
          url: 'https://api.ipstack.com/check?access_key=30e1f3f08d059a4082c419822e2f27c4',
          type: 'get',
          dataType: 'json'
        }).done(function (data) {
          _this4.apiData = data;
          _this4.mergeData();
          vegamour.cache.put('geo-api', data, 86400);
          resolve(data);
        }).fail(function (err) {
          reject(err);
        });
      });
    }
  }]);
  return VegamourGeolocation;
}(Events);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourCookie = /*#__PURE__*/function () {
  function VegamourCookie() {
    var _this = this;
    _classCallCheck(this, VegamourCookie);
    this.cookieName = '_vdid';
    this.klaviyoCookieName = '__kla_id';
    $(document).ready(function () {
      _this.init();
    });
  }
  _createClass(VegamourCookie, [{
    key: "init",
    value: function init() {
      this.setCustomerObj();
      var data = this.getCookie();
      var hours = 0;
      if (data) {
        hours = (new Date() - new Date(data.d)) / 36e5;
      }
      if ((!data || hours > 1) && this.setCookieFromKlaviyo()) {
        return;
      } else if (vegamourOptions.customer !== null) {
        if (typeof vegamourOptions.customer.id !== 'undefined' && vegamourOptions.customer.id) {
          data.i = vegamourOptions.customer.id;
        }
        if (typeof vegamourOptions.customer.email !== 'undefined' && vegamourOptions.customer.email) {
          data.e = vegamourOptions.customer.email;
        }
        if (typeof vegamourOptions.customer.phone !== 'undefined' && vegamourOptions.customer.phone) {
          data.p = vegamourOptions.customer.phone;
        }
        if (typeof vegamourOptions.customer.marketing !== 'undefined' && vegamourOptions.customer.marketing) {
          data.m = vegamourOptions.customer.marketing;
        }
      }
      this.set(data);
      this.setCustomerObj(data);
    }
  }, {
    key: "setCookie",
    value: function setCookie(obj) {
      if (!obj) {
        obj = {};
      }
      obj.t = new Date().toISOString();
      c = this.getCookie();
      obj.d = c === null || typeof c.d === 'undefined' || c.d.length !== 32 ? this.getRandomID() : c.d;
      var loc = this.getLocation();
      if (loc) {
        obj.c = loc.country;
        obj.z = loc.ip;
      }
      var val = btoa(JSON.stringify(obj));
      if (val && val.length > 0) {
        vegamour.setDomainCookie(this.cookieName, val, 730);
      }
    }
  }, {
    key: "setCustomerObj",
    value: function setCustomerObj(data) {
      if (vegamourOptions.customer === null) {
        vegamourOptions.customer = {};
      }
      var fieldMap = {
        e: 'email',
        p: 'phone',
        m: 'marketing',
        s: 'sms',
        i: 'id',
        c: 'country',
        z: 'ip'
      };
      for (var k in fieldMap) {
        if (typeof data !== 'undefined' && typeof data[k] !== 'undefined' && (data[k] || k == 'm' || k == 's')) {
          vegamourOptions.customer[fieldMap[k]] = data[k];
        } else if (typeof vegamourOptions.customer[fieldMap[k]] === 'undefined') {
          vegamourOptions.customer[fieldMap[k]] = null;
        }
      }
      vegamourOptions.customer.hasEmail = typeof data !== 'undefined' && typeof data.e !== 'undefined' && data.e ? true : false;
      vegamourOptions.customer.hasPhone = typeof data !== 'undefined' && typeof data.p !== 'undefined' && data.p ? true : false;
    }
  }, {
    key: "getCookie",
    value: function getCookie() {
      var cookie = vegamour.getCookie(this.cookieName, false);
      if (cookie) {
        cookie = JSON.parse(atob(cookie));
      }
      return cookie;
    }
  }, {
    key: "set",
    value: function set(attributes) {
      var original = this.getCookie();
      var cookie = this.getCookie();
      if (!cookie) {
        cookie = {};
      }
      for (var k in attributes) {
        cookie[k] = attributes[k];
      }
      if (cookie != original) {
        this.setCookie(cookie);
      }
    }
  }, {
    key: "get",
    value: function get(attribute) {
      var cookie = this.getCookie();
      if (!cookie || typeof cookie[attribute] === 'undefined') {
        return null;
      }
      return cookie[attribute];
    }
  }, {
    key: "getLocation",
    value: function getLocation(counter) {
      var _this2 = this;
      var loc = vegamour.geolocation.getLocationData();
      if (loc === null) {
        if (counter === 20) {
          return;
        }
        setTimeout(function () {
          var l = _this2.getLocation(counter ? counter + 1 : 1);
          if (typeof l.country !== 'undefined' && typeof l.ip !== 'undefined') {
            _this2.set({
              c: l.country,
              z: l.ip
            });
          }
        }, 200);
        return false;
      }
      if (typeof loc.country === 'undefined' || typeof loc.ip === 'undefined') {
        return false;
      }
      return {
        'country': loc.country.code,
        'ip': loc.ip
      };
    }
  }, {
    key: "getRandomID",
    value: function getRandomID() {
      var genRanHex = function genRanHex(size) {
        return _toConsumableArray(Array(size)).map(function () {
          return Math.floor(Math.random() * 16).toString(16);
        }).join('');
      };
      return genRanHex(32);
    }
  }, {
    key: "setCookieFromKlaviyo",
    value: function setCookieFromKlaviyo(attributes) {
      attributes = typeof attributes === 'undefined' ? false : attributes;
      var cookie = this.getCookie();
      var result = cookie ? cookie : {};
      var exchangeID = false;
      cookie = vegamour.getCookie(this.klaviyoCookieName, false);
      if (cookie) {
        cookie = atob(cookie);
        if (cookie) {
          cookie = JSON.parse(cookie);
        }
      }
      if (cookie && typeof cookie.$exchange_id !== 'undefined') {
        var fieldMap = {
          e: '$email',
          p: '$phone_number',
          m: 'Accepts Marketing',
          s: 'Accepts SMS',
          i: 'rc_external_customer_id'
        };
        var fields = '';
        for (var k in fieldMap) {
          if (fields.length > 0) {
            fields += ',';
          }
          fields += fieldMap[k];
        }
        var self = this;
        var url = window.vegamourOptions.backend.api + '/loyalty/kl.php?e=' + cookie.$exchange_id + '&f=' + encodeURIComponent(fields);
        $.getJSON(url, function (data) {
          if (data) {
            for (var _k in fieldMap) {
              if ((!attributes || attributes.indexOf(_k) > -1) && typeof data[fieldMap[_k]] !== 'undefined' && (data[fieldMap[_k]] || _k == 'm' || _k == 's')) {
                result[_k] = data[fieldMap[_k]];
              }
            }
            if (result != cookie) {
              self.setCookie(result);
              self.setCustomerObj(result);
            }
          }
          return result;
        });
        return true;
      }
      return false;
    }
  }]);
  return VegamourCookie;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _readOnlyError(name) { throw new TypeError("\"" + name + "\" is read-only"); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VegamourShippingRates = /*#__PURE__*/function (_Events) {
  _inherits(VegamourShippingRates, _Events);
  var _super = _createSuper(VegamourShippingRates);
  function VegamourShippingRates() {
    var _this;
    _classCallCheck(this, VegamourShippingRates);
    _this = _super.call(this);
    _this.data = null;
    return _this;
  }
  _createClass(VegamourShippingRates, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      var cache = vegamour.cache.get('shipping_zones');
      if (cache) {
        console.info('⚡ Got shipping zones from local cache');
        this.data = cache;
        vegamour.emit('shippingRatesReady');
        return;
      }
      $.get(vegamour.api.buildUrl('/shopify/shipping/zones')).done(function (res) {
        if (!res.success || !res.data) {
          return;
        }
        _this2.data = res.data;

        // Cache for day
        vegamour.cache.put('shipping_zones', res.data, 86400);
        vegamour.emit('shippingRatesReady');
      });
    }
  }, {
    key: "getCurrentCountryCode",
    value: function getCurrentCountryCode() {
      if (typeof window.vegamourOptions.country !== 'undefined') {
        return window.vegamourOptions.country;
      }
      var data = vegamour.geolocation.getLocationData();
      if (data) {
        return data.country.code;
      }
      return null;
    }
  }, {
    key: "getFreeShippingThreshold",
    value: function getFreeShippingThreshold() {
      var countryCode = this.getCurrentCountryCode();
      if (!countryCode) {
        'US', _readOnlyError("countryCode");
      }
      return this.getFreeShippingThresholdForCountry(countryCode);
    }
  }, {
    key: "getSubscriptionFreeShippingThreshold",
    value: function getSubscriptionFreeShippingThreshold() {
      var countryCode = this.getCurrentCountryCode();
      if (!countryCode) {
        return null;
      }
      if (countryCode === 'US') {
        return 0.0;
      }
      return this.getFreeShippingThresholdForCountry(countryCode);
    }
  }, {
    key: "getFreeShippingThresholdForCountry",
    value: function getFreeShippingThresholdForCountry(countryCode) {
      if (!this.data) {
        return null;
      }
      var threshold = null;
      countryCode = countryCode.toUpperCase();
      this.data.forEach(function (zone) {
        zone.countries.forEach(function (country) {
          if (country.code.toUpperCase() === countryCode) {
            zone.price_based_shipping_rates.forEach(function (rate) {
              var price = parseFloat(rate.price);
              var minSubtotal = rate.min_order_subtotal ? parseFloat(rate.min_order_subtotal) : 0.0;
              var maxSubtotal = rate.max_order_subtotal !== null ? parseFloat(rate.max_order_subtotal) : null;

              // minSubtotal 0.01
              if (price === 0.0 && minSubtotal > 0 && maxSubtotal === null) {
                threshold = parseFloat(rate.min_order_subtotal);
              }
            });
          }
        });
      });
      if (!threshold) {
        if (typeof window.vegamourOptions.freeShipping[countryCode] !== 'undefined') {
          threshold = window.vegamourOptions.freeShipping[countryCode];
        } else if (typeof window.vegamourOptions.freeShipping["default"] !== 'undefined') {
          threshold = window.vegamourOptions.freeShipping["default"];
        }
      }
      return threshold;
    }
  }]);
  return VegamourShippingRates;
}(Events);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourSelect = /*#__PURE__*/function () {
  function VegamourSelect($div) {
    _classCallCheck(this, VegamourSelect);
    this.cssClass = 'vegamour-select-v2';
    this._div = $div;
    this.init();
  }
  _createClass(VegamourSelect, [{
    key: "div",
    value: function div() {
      return this._div;
    }
  }, {
    key: "select",
    value: function select() {
      return this.div().find('select')[0];
    }
  }, {
    key: "open",
    value: function open() {
      this.div().find('.' + this.cssClass + '-selected').addClass(this.cssClass + '-arrow-active');
      this.div().find('.' + this.cssClass + '-items').removeClass(this.cssClass + '-hide');
    }
  }, {
    key: "close",
    value: function close() {
      this.div().find('.' + this.cssClass + '-selected').removeClass(this.cssClass + '-arrow-active');
      this.div().find('.' + this.cssClass + '-items').addClass(this.cssClass + '-hide');
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.div().find('.' + this.cssClass + '-selected').toggleClass(this.cssClass + '-arrow-active');
      this.div().find('.' + this.cssClass + '-items').toggleClass(this.cssClass + '-hide');
    }
  }, {
    key: "init",
    value: function init() {
      var self = this;
      this.div().addClass(this.cssClass + '-initialized');
      var selected = null;
      if (typeof this.select().options[this.select().selectedIndex] !== 'undefined') {
        selected = this.select().options[this.select().selectedIndex].innerHTML;
      } else {
        selected = '';
      }
      this.div().append('<div class="' + this.cssClass + '-selected">' + selected + '</div>');
      this.div().append('<div class="' + this.cssClass + '-items ' + this.cssClass + '-hide"></div>');
      this.div().find('option').each(function (i) {
        var value = self.select().options[i].innerHTML;
        var $option = $('<div class="' + self.cssClass + '-item' + (value == selected ? ' hidden' : '') + '">' + value + '</div>');
        $option.on('click', function (e) {
          e.preventDefault();
          self.div().find('select').val(self.select().options[i].value).trigger('change');
          self.close();
        });
        self.div().find('.' + self.cssClass + '-items').append($option);
      });
      this.div().on('click', function (e) {
        e.stopPropagation();
      });
      this.div().find('.' + this.cssClass + '-selected').on('click', function (e) {
        e.preventDefault();
        self.toggle();
      });
      this.div().find('select').on('change', function () {
        self.change();
      });
      $(document).on('click', function () {
        self.close();
      });
      this.div().find('select').data('select', this);
    }
  }, {
    key: "change",
    value: function change() {
      var selected = this.select().options[this.select().selectedIndex].innerHTML;
      this.div().find('.' + this.cssClass + '-selected').html(selected);
      this.div().find('.' + this.cssClass + '-item').each(function () {
        if ($(this).text() == selected || $(this).hasClass('hidden')) {
          $(this).toggleClass('hidden');
        }
      });
    }
  }]);
  return VegamourSelect;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VegamourImage = /*#__PURE__*/function (_Events) {
  _inherits(VegamourImage, _Events);
  var _super = _createSuper(VegamourImage);
  function VegamourImage($img) {
    var _this;
    _classCallCheck(this, VegamourImage);
    _this = _super.call(this);
    _this.image = $img;
    _this.loaded = false;
    _this.watch();
    _this.resize();
    return _this;
  }
  _createClass(VegamourImage, [{
    key: "resize",
    value: function resize() {
      if (this.image.data('image-aspect-ratio') === undefined) {
        return;
      }
      if (this.image.hasClass('lazyload')) {
        return;
      }
      var img = this.image[0];
      if (!img.complete) {
        return;
      }
      var $container = null;
      if (!this.image.hasClass('aspect-ratio-initialized')) {
        $container = this.image.wrap('<div></div>').parent();
        this.image.addClass('aspect-ratio-initialized');
      } else {
        $container = this.image.parent();
      }
      $container.css({
        position: 'relative',
        overflow: 'hidden'
      });
      var aspectRatio = parseFloat(this.image.data('image-aspect-ratio'));
      var imageAspectRatio = img.naturalWidth / img.naturalHeight;
      var transform = {
        x: 0,
        y: 0
      };
      var css = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: 'auto',
        maxWidth: 'initial',
        height: 'auto'
      };
      var containerWidth = $container.width();
      if (containerWidth === 0) {
        containerWidth = $container.parents(':visible').eq(0).width();
      }
      var height = containerWidth / aspectRatio;
      this.image.removeClass('image-master-height').removeClass('image-master-width');
      if (aspectRatio < imageAspectRatio) {
        // Consider height as master unit
        var width = height * imageAspectRatio;
        css.height = height;
        transform.x = '-' + (width - containerWidth) / 2 + 'px';
        this.image.addClass('image-master-height');
      } else {
        // Consider width as master unit
        var _width = containerWidth;
        var imageHeight = _width / imageAspectRatio;
        css.width = _width;
        transform.y = '-' + (imageHeight - height) / 2 + 'px';
        this.image.addClass('image-master-width');
      }
      css.transform = 'translate(' + transform.x + ', ' + transform.y + ')';
      this.image.css(css);
      $container.css({
        height: height
      });
    }
  }, {
    key: "watch",
    value: function watch() {
      var _this2 = this;
      this.image.imagesLoaded().always(function (instance) {
        if (!_this2.loaded) {
          _this2.loaded = true;
          _this2.emit('loaded');
        }
      });
      if (this.image.hasClass('aspect-ratio-initialized-events')) {
        return;
      }
      this.image.on('load', function () {
        _this2.src = _this2.image[0].src;
        _this2.resize(_this2.image);
      });
      if (this.image[0].complete) {
        this.image.trigger('load');
      }
      if (!this.image.hasClass('lazyload')) {
        return;
      }
      var interval = setInterval(function () {
        if (_this2.image.hasClass('lazyloaded')) {
          _this2.resize(_this2.image);
          clearInterval(interval);
        }
      }, 25);
      if (this.image.hasClass('lazyload-force')) {
        lazySizes.loader.unveil(this.image[0]);
      }
    }
  }], [{
    key: "initImages",
    value: function initImages() {
      $('img:not(.aspect-ratio-initialized-events)').each(function () {
        var image = new VegamourImage($(this));
        vegamour.images.push(image);
        $(this).data('image', image);
        $(this).addClass('aspect-ratio-initialized-events');
      });
      $(window).resize(function () {
        VegamourImage.resizeImages();
      });
    }
  }, {
    key: "resizeImages",
    value: function resizeImages() {
      vegamour.images.forEach(function (image) {
        image.resize();
      });
    }
  }]);
  return VegamourImage;
}(Events);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourLinks = /*#__PURE__*/function () {
  function VegamourLinks() {
    var _this = this;
    _classCallCheck(this, VegamourLinks);
    $(document).ready(function () {
      _this.init();
    });
  }
  _createClass(VegamourLinks, [{
    key: "init",
    value: function init() {
      if (window.location.href.indexOf('global.') === -1) {
        return false;
      }
      var langFull = window.vegamourOptions.language;
      var lang = langFull.split('-')[0];
      if (lang && lang != 'en') {
        $('a[href]').each(function () {
          var url = $(this).attr('href');
          if (url.length > 1 || url === '/') {
            var ignore = ['\/\/', '\/' + lang + '\/', '\/' + langFull + '\/', 'javascript:', 'mailto:'];
            var regex = new RegExp(ignore.join('|'), 'i');
            if (!regex.test(url)) {
              $(this).attr('href', '/' + lang + url);
            }
          }
        });
      }
    }
  }]);
  return VegamourLinks;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourCountdown = /*#__PURE__*/function () {
  function VegamourCountdown(div) {
    _classCallCheck(this, VegamourCountdown);
    this.interval = null;
    this.date = null;
    this.div = div;
    this.init();
  }
  _createClass(VegamourCountdown, [{
    key: "init",
    value: function init() {
      var _this = this;
      if (_typeof(this.div) !== 'object' || !this.div.length || this.div.hasClass('countdown-initialized') || this.div.find('cdD').length) {
        return false;
      }
      this.div.addClass('countdown-initialized');
      var dateString = '' + this.div.data('countdown');
      if (typeof dateString === 'undefined') {
        // [!] TODO Look up active campaign / discount end
      }
      if (dateString.length < 10) {
        return false;
      }
      console.info('⏱ Creating countdown - ' + dateString);
      var em = parseInt(dateString.substring(0, 2)) - 1;
      var ed = parseInt(dateString.substring(3, 5));
      var ey = parseInt(dateString.substring(6, 10));
      var eh = dateString.length >= 16 ? parseInt(dateString.substring(11, 13)) : 0;
      var en = dateString.length >= 16 ? parseInt(dateString.substring(14, 16)) : 0;
      this.date = new Date(ey, em, ed, eh, en, 0);
      if (_typeof(this.date) !== 'object') {
        return false;
      }
      if (this.date.getTime() <= this.now()) {
        this.hide();
        return false;
      }
      if (this.div.html().length) {
        return false;
      }
      var html = '<ul><li><span class="cdD"></span>Days</li><li><span class="cdH"></span>Hours</li><li><span class="cdM"></span>Minutes</li><li><span class="cdS"></span>Seconds</li></ul>';
      if (this.div.data('countdown-style') === 'short') {
        html = '<span class="cdD"></span><span class="cdUnit">days</span><span class="cdH"></span><span class="cdUnit">hrs</span><span class="cdM"></span><span class="cdUnit">min</span><span class="cdS"></span><span class="cdUnit">sec</span>';
      }
      this.div.html(html);
      this.update();
      this.interval = setInterval(function () {
        return _this.update();
      }, 500);
    }
  }, {
    key: "now",
    value: function now() {
      return new Date(new Date().toLocaleString('en-US', {
        timeZone: 'America/Los_Angeles'
      })).getTime();
    }
  }, {
    key: "hide",
    value: function hide() {
      vegamour.emit('countdownRemove', this);
      this.div.remove();
    }
  }, {
    key: "update",
    value: function update() {
      if (!this.div || !this.div.is(':visible')) {
        return;
      }
      var remainingTime = this.date.getTime() - this.now();
      if (remainingTime < 0) {
        clearInterval(this.interval);
        this.hide();
      }
      var s = 1000;
      var m = s * 60;
      var h = m * 60;
      var d = h * 24;
      this.div.find('.cdD').text(Math.floor(remainingTime / d));
      this.div.find('.cdH').text(Math.floor(remainingTime % d / h));
      this.div.find('.cdM').text(Math.floor(remainingTime % h / m));
      this.div.find('.cdS').text(Math.floor(remainingTime % m / s));
    }
  }]);
  return VegamourCountdown;
}();
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VegamourAccount = /*#__PURE__*/function (_Events) {
  _inherits(VegamourAccount, _Events);
  var _super = _createSuper(VegamourAccount);
  // {{{ constructor
  function VegamourAccount() {
    _classCallCheck(this, VegamourAccount);
    return _super.call(this);
  }
  // }}}
  // {{{ init
  _createClass(VegamourAccount, [{
    key: "init",
    value: function init() {
      var _this = this;
      if (window.location.search.indexOf('view=quick-actions') !== -1) {
        this.initQuickActions();
      }
      if (this.div().length === 0) {
        return;
      }
      if (this.getCustomerId()) {
        this.initNav();
        this.getSubscriptions();
        this.subscriptions = [];
        this.addresses = [];
        this.upcomingOrders = [];
        this.paymentMethods = [];
        this.customer = {};
        this.subscriptionCustomerId = 0;
        this.domesticCountry = 'US';
        this.isMobile = $(window).width() <= 1024;
        this.isPhone = $(window).width() <= 640;
        this.store = window.vegamourOptions.backend.store;
        this.currencyIso = window.vegamourOptions.currency["short"];
        this.currencySign = window.vegamourOptions.currency.sign;
        this.modalTriggerElement = null;
        this.cancelId = vegamour.getParam('cancelId');
        if (this.cancelId) {
          this.clearQS();
        }
        $(window).on('resize orientationchange', function () {
          if (_this.isPhone && $(window).width() > 640 || _this.isMobile && !_this.isPhone && ($(window).width() > 1024 || $(window).width() <= 640) || !_this.isMobile && $(window).width() <= 1024) {
            window.location = window.location.href;
          }
        });
        window.scrollTo(0, 0);
        if (!this.isMobile) {
          $(window).on('scroll', function () {
            var offset = 800;
            if ($(window).scrollTop() > $('#shopify-section-footer').offset().top - offset) {
              $('.nav').addClass('scroll');
            } else {
              $('.nav').removeClass('scroll');
            }
          });
        }
      }
      $(document).ready(function () {
        if (_this.getCustomerId()) {
          _this.initOrders();
          _this.setAddressSelector('state');
          _this.setAddressSelector('country');
        } else {
          _this.checkMultipass();
        }
      });
    }
    // }}}
    // {{{ checkMultipass
  }, {
    key: "checkMultipass",
    value: function checkMultipass() {
      if ($('#login').length > 0 && vegamour.hasParam('multipass')) {
        var $html = $('<div class="container"><div class="row"><div class="col-sm-8 col-md-6 col-lg-5 mx-auto text-center">' + '<h3>Multipass Login</h3>' + '<div class="form-group input-group">' + '<div class="input-group-prepend"><i aria-hidden="true" class="icon-ionicons_svg_md-person input-group-text"></i></div> ' + '<input type="email" name="multipass[email]" aria-label="email" id="multipassEmail" placeholder="Email" required="required" class="form-control ">' + '</div>' + '<div class="form-group input-group">' + '<div class="input-group-prepend"><i aria-hidden="true" class="icon-ionicons_svg_md-key input-group-text"></i></div> ' + '<input type="password" value="" id="multipassPassword" name="multipass[password]" aria-label="password" placeholder="Password" required="required" class="form-control ">' + '</div>' + '<a href="#" class="btn btn-primary btn-block">Sign In</a>' + '</div></div></div>');
        $html.find('a').on('click', function (e) {
          e.preventDefault();
          $.post(vegamour.api.buildUrl('/shopify/multipass'), {
            email: $html.find('[name="multipass[email]"]').val(),
            password: $html.find('[name="multipass[password]"]').val()
          }).done(function (res) {
            if (!res.success) {
              return alert('Error: ' + res.error);
            }
            window.location.href = '/account/login/multipass/' + res.data.token;
          });
        });
        $('section[data-template="account"]').html($html);
      }
    }
    // }}}
    // {{{ handleError
  }, {
    key: "handleError",
    value: function handleError(error) {
      this.done();
      $('#app').find('.disabled').removeClass('disabled').find('.loading').hide();
      console.error(error);
      this.errorMessage('Problem encountered loading data. Please try reloading and contact support if issue persists.');
    }
    // }}}
    // {{{ statusMessage
  }, {
    key: "statusMessage",
    value: function statusMessage(message, type, time) {
      if (typeof time === 'undefined' || !time) {
        time = 10;
      }
      var $message = $('#status-message');
      $message.removeClass();
      if (typeof type !== 'undefined') {
        $message.addClass(type);
      }
      $message.html(message);
      $message.slideDown();
      setTimeout(function () {
        $message.slideUp();
      }, time * 1000);
    }
    // }}}
    // {{{ errorMessage
  }, {
    key: "errorMessage",
    value: function errorMessage(message, time) {
      if (typeof time === 'undefined' || !time) {
        time = 20;
      }
      var svg = '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 0L27.9904 22.5H2.00962L15 0Z" fill="white"/><path d="M14.116 16.3747H15.396L15.748 11.8467V9.12675H13.78V11.8467L14.116 16.3747ZM14.756 20.3267C15.748 20.3267 16.484 19.6707 16.484 18.7907C16.484 17.9267 15.748 17.2707 14.756 17.2707C13.764 17.2707 13.028 17.9267 13.028 18.7907C13.028 19.6707 13.764 20.3267 14.756 20.3267Z" fill="#9F1515"/></svg>';
      message = svg + ' ' + message;
      this.statusMessage(message, 'error', time);
    }
    // }}}
    // {{{ hideStatusMessage
  }, {
    key: "hideStatusMessage",
    value: function hideStatusMessage() {
      $('#status-message').slideUp();
    }
    // }}}
    // {{{ div
  }, {
    key: "div",
    value: function div() {
      return $('#account');
    }
    // }}}
    // {{{ initNav
  }, {
    key: "initNav",
    value: function initNav() {
      $('[data-section-link]').unbind('click').click(function (e) {
        e.preventDefault();
        var section = $(this).data('section-link');
        $('.nav, .mobile-nav').find('.active').removeClass('active');
        $('.nav').find('[data-section-link="' + section + '"]').parent().addClass('active');
        $('.mobile-nav').find('[data-section-link="' + section + '"]').addClass('active');
        $('.content .account-section').hide();
        $('#' + section).show();
        window.scrollTo(0, 0);
      });
    }
    // }}}
    // {{{ processForm
  }, {
    key: "processForm",
    value: function processForm($form) {
      var formData = {};
      var valid = true;
      var self = this;
      $form.find('input, select, textarea').each(function () {
        if ($(this).is(':visible')) {
          var v = $(this).val();
          if (v && v.length > 0) {
            v = v.trim();
          }
          var id = $(this).data('id');
          var required = !$(this).is('[data-not-required]');
          var format = $(this).data('format');
          var name = $(this).closest('.field-element').find('.label').text();
          if ((!v || v.length === 0) && required) {
            self.errorMessage(name + ': value is required');
            valid = false;
          }
          if (valid && format && v && v.length > 0) {
            var regexp = new RegExp(format);
            if (!regexp.test(v)) {
              self.errorMessage(name + ': value is invalid');
              valid = false;
            }
          }
          if (!valid) {
            $(this).addClass('error');
            return valid;
          }
          $(this).removeClass('error');
          formData[id] = v;
        }
      });
      return valid ? formData : valid;
    }
    // }}}
    // {{{ getCustomerId
  }, {
    key: "getCustomerId",
    value: function getCustomerId() {
      return window.vegamourOptions.loggedIn && window.vegamourOptions.customer ? window.vegamourOptions.customer.id : null;
    }
    // }}}
    // {{{ getSubscriptionCustomerId
  }, {
    key: "getSubscriptionCustomerId",
    value: function getSubscriptionCustomerId() {
      return this.subscriptionCustomerId;
    }
    // }}}
    // {{{ getSubscriptions
  }, {
    key: "getSubscriptions",
    value: function getSubscriptions(validate, target) {
      var _this2 = this;
      var query = vegamour.api.buildUrl('/subscription/list') + '&variants=1&cache=0';
      vegamour.debug(query);
      validate = typeof validate !== 'undefined' ? validate : false;
      target = typeof target === 'undefined' || !target ? '#subscriptions' + (validate ? ',#upcoming-orders' : '') : target;
      this.wait(target);
      $.get(query).done(function (result) {
        _this2.subscriptions = result.data;
        var self = _this2;
        var subCount = result.data.length;
        var noSubs = function noSubs() {
          $('.subscription:not([data-template])').hide();
          $('.no-subscriptions').show();
        };
        var hasActive = false;
        if (!subCount) {
          noSubs();
          _this2.done(target);
          _this2.getCustomer();
        } else {
          _this2.subscriptionCustomerId = result.data[0].customer_id;
          if (target.indexOf(',') !== -1) {
            var t = target.split(',');
            t.forEach(function (n) {
              var d = n ? n.trim() : false;
              if (d) {
                if (d.indexOf('upcoming') !== -1) {
                  target = d;
                } else {
                  _this2.done(d);
                }
              }
            });
          } else {
            _this2.done(target);
            target = false;
          }
          _this2.getUpcomingOrders(validate, target);
          if ($.isEmptyObject(_this2.customer)) {
            _this2.getCustomer(_this2.subscriptionCustomerId);
          }
          $('#subscriptions .subscription:not([data-template])').remove();
          var subHTML = $('.subscription').html();
          var subContainerHTML = $('.subscription-container').html();
          var subItemHTML = $('.subscription .item').html();
          var active = [];
          var inactive = [];
          result.data.forEach(function (s, i) {
            if (s.status.toLowerCase() == 'active') {
              active[i] = s;
            } else {
              inactive[i] = s;
            }
          });
          if (active.length) {
            var nextShipDate = false;
            active.forEach(function (s, i) {
              if (s.id != _this2.cancelId) {
                if (!hasActive && typeof s.presentment_currency !== 'undefined') {
                  _this2.setStoreCurrency(s.presentment_currency);
                }
                hasActive = true;
                $('.subscriptions').append('<div class="subscription" data-subscription-id="' + s.id + '" data-address-id="' + s.address_id + '" data-charge-id="' + (s.charge ? s.charge.id : 0) + '">' + subHTML + '</div>');
                var $sub = self.getSubscription(s.id);
                _this2.setSubscription(s, $sub);
                if (_this2.isNextChargeDateToday(s)) {
                  $sub.find('a.shipnow').hide();
                } else {
                  $sub.find('a.shipnow').click(function () {
                    self.shipNow(s.id);
                  });
                }
                $sub.find('a.manage').click(function () {
                  self.manageSubscription(s.id);
                });
              }
            });
            _this2.setPaymentMethods();
          } else {
            _this2.checkAddresses(_this2.subscriptionCustomerId);
          }
          if (hasActive) {
            $('.no-subscriptions').hide();
            $('.subscription:not([data-template])').show();
          } else {
            noSubs();
          }
          if (inactive.length) {
            $inactive = $('.inactive-subscriptions .subscription-list');
            inactive.forEach(function (s, i) {
              $inactive.append('<div class="subscription" data-subscription-id="' + s.id + '" data-address-id="' + s.address_id + '"><div class="subscription-container">' + subContainerHTML + '<div class="subscription-cta"><a class="btn btn-primary sl reactivate">Reactivate and Save</a></div></div></div>');
              var $sub = self.getSubscription(s.id);
              _this2.setSubscription(s, $sub, true);
              if (s.shopify_product.status != 'active') {
                $sub.find('a.reactivate').addClass('disable').click(function () {
                  self.errorMessage('Product is no longer available', 10);
                });
              } else {
                $sub.find('a.reactivate').click(function () {
                  self.reactivate(s.id, true);
                  $sub.hide();
                });
              }
            });
            if (inactive.length > 3) {
              $('.inactive-all').click(function () {
                $('.inactive-subscriptions').addClass('all');
              });
            } else {
              $('.inactive-subscriptions .subscription-container').css('margin-bottom', 0);
              $('.inactive-all').hide();
            }
            $('.inactive-subscriptions').show();
          }
          console.log('🔁 Subscriptions loaded');
          vegamour.debug(active);
          _this2.checkCancelActions();
        }
      })["catch"](function (error) {
        _this2.handleError(error);
      });
    }
    // }}}
    // {{{ getSubscription
  }, {
    key: "getSubscription",
    value: function getSubscription(subscriptionId, obj) {
      var selector = '.subscription[data-subscription-id="' + subscriptionId + '"]';
      return typeof obj === 'undefined' || obj ? $(selector) : selector;
    }
    // }}}
    // {{{ getCharge
  }, {
    key: "getCharge",
    value: function getCharge(chargeId, obj) {
      var selector = '.upcoming-order[data-id="' + chargeId + '"]';
      return typeof obj === 'undefined' || obj ? $(selector) : selector;
    }
    // }}}
    // {{{ getChargeFromSubscription
  }, {
    key: "getChargeFromSubscription",
    value: function getChargeFromSubscription(subscriptionId, obj) {
      var $sub = this.getSubscription(subscriptionId);
      if (!$sub.length) {
        return false;
      }
      var chargeId = $sub.attr('data-charge-id');
      if (!chargeId) {
        return false;
      }
      return this.getCharge(chargeId, obj);
    }
    // }}}
    // {{{ submitDiscount
  }, {
    key: "submitDiscount",
    value: function submitDiscount(subscriptionId, addressId, code, close) {
      var _this3 = this;
      if (!addressId || !code) {
        this.handleError('Invalid discount code');
      } else {
        code = code.toUpperCase();
        var selector = this.getSubscription(subscriptionId, false);
        var $sub = $(selector);
        var _target = selector + ' .discount-code';
        var $discount = $(_target);
        if (!$discount.hasClass('disabled')) {
          this.wait(_target);
          $discount.addClass('disabled');
          var query = vegamour.api.buildUrl('/subscription/' + subscriptionId + '/apply_discount') + '&address_id=' + addressId + '&discount_code=' + encodeURIComponent(code);
          vegamour.debug(query);
          $.get(query).done(function (result) {
            _this3.done(_target);
            vegamour.debug(result.data);
            $discount.removeClass('disabled');
            var chargeId = $sub.attr('data-charge-id');
            if (result.success) {
              $discount.find('input').val('');
              _this3.showDiscountCode(subscriptionId, chargeId, code, result.data.total_discounts, result.data.total_price);
              close();
            } else {
              _this3.errorMessage(result.error, 5);
              if (chargeId) {
                _this3.getCharge(chargeId).find('.discount').hide();
              }
            }
          })["catch"](function (error) {
            _this3.done(_target);
            $discount.removeClass('disabled');
            _this3.errorMessage(error.responseJSON.error, 5);
            var chargeId = $sub.attr('data-charge-id');
            if (chargeId) {
              _this3.getCharge(chargeId).find('.discount').hide();
            }
          });
        }
      }
    }
    // }}}
    // {{{ applyIncentiveDiscount
  }, {
    key: "applyIncentiveDiscount",
    value: function applyIncentiveDiscount(subscriptionId) {
      var _this4 = this;
      if (!subscriptionId) {
        return false;
      }
      var selector = this.getSubscription(subscriptionId, false);
      var $sub = $(selector);
      var addressId = $sub.attr('data-address-id');
      if (!addressId) {
        return false;
      }
      var query = vegamour.api.buildUrl('/subscription/' + subscriptionId + '/apply_discount') + '&address_id=' + addressId + '&incentive=1';
      vegamour.debug(query);
      this.wait(selector);
      $.get(query).done(function (result) {
        vegamour.debug(result.data);
        var chargeId = $sub.attr('data-charge-id');
        if (result.success) {
          _this4.done(selector);
          _this4.showDiscountCode(subscriptionId, chargeId, result.data.discount_code, result.data.total_discounts, result.data.total_price);
        } else {
          _this4.errorMessage(result.error, 5);
          if (chargeId) {
            _this4.getCharge(chargeId).find('.discount').hide();
          }
        }
      })["catch"](function (error) {
        _this4.errorMessage(error.responseJSON.error, 5);
        var chargeId = $sub.attr('data-charge-id');
        if (chargeId) {
          _this4.getCharge(chargeId).find('.discount').hide();
        }
      });
    }
    // }}}
    // {{{ showDiscountCode
  }, {
    key: "showDiscountCode",
    value: function showDiscountCode(subscriptionId, chargeId, code, discountAmount, totalAmount) {
      if (!subscriptionId) {
        return false;
      }
      var $sub = this.getSubscription(subscriptionId);
      discountCode = this.maskDiscountCode(code);
      this.statusMessage('Discount' + (discountCode == code ? ' code &#8216;' + code + '&#8217;' : '') + ' successfully applied to subscription');
      $sub.find('[data-subscription-discount-code]').text(discountCode);
      if (chargeId) {
        var chargeSelector = this.getCharge(chargeId, false);
        var $upcoming = $(chargeSelector);
        $upcoming.find('[data-upcoming-order-discount-code]').text(discountCode);
        $upcoming.find('[data-upcoming-order-discount-amount]').text('-' + this.currency(discountAmount));
        $upcoming.find('.discount').show();
        if (typeof discountAmount !== 'undefined') {
          $upcoming.find('[data-upcoming-order-total]').text(this.currency(totalAmount));
        } else {
          this.getUpcomingOrders(true, chargeSelector);
        }
      }
    }
    // }}}
    // {{{ maskDiscountCode
  }, {
    key: "maskDiscountCode",
    value: function maskDiscountCode(code) {
      if (code.substring(0, 2) == 'CX') {
        code = '********';
      }
      return code;
    }
    // }}}
    // {{{ setSubscription
  }, {
    key: "setSubscription",
    value: function setSubscription(s, $sub, inactive) {
      inactive = typeof inactive !== 'undefined' && inactive ? true : false;
      if (s.next_charge_scheduled_at) {
        $sub.find('[data-subscription-shipment-date]').text(this.date(s.next_charge_scheduled_at));
      } else {
        $sub.find('.subscription-shipment-date').hide();
        $sub.find('.shipnow').hide();
      }
      $sub.find('[data-subscription-status]').text(s.status);
      $sub.find('[data-subscription-number]').text('#' + s.id);
      $sub.find('[data-subscription-frequency]').text(s.order_interval_frequency + ' ' + s.order_interval_unit + (parseInt(s.order_interval_frequency) > 1 ? 's' : ''));
      var cs = _typeof(currencySymbols[s.presentment_currency]) !== undefined ? currencySymbols[s.presentment_currency] : false;
      $sub.find('[data-subscription-price]').text(this.rcurrency(s.price, cs));
      $sub.find('[data-item-title]').text(s.product_title);
      $sub.find('[data-item-quantity]').text(s.quantity);
      $sub.find('[data-item-image]').attr('src', vegamour.imgSize(s.shopify_product.image.src, '110x'));
      if (s.charge && s.charge.discounts.length > 0) {
        $sub.find('[data-subscription-discount-code]').text(this.maskDiscountCode(s.charge.discounts[0].code));
      }
      var self = this;
      $sub.find('.edit-discount').unbind('click').click(function () {
        var close = self.modal('#subscriptions [data-subscription-id="' + s.id + '"] .discount.modal');
        $sub.find('.discount-input').unbind('keyup').keyup(function (e) {
          var keycode = parseInt(e.keyCode ? e.keyCode : e.which);
          if (keycode == 13) {
            self.submitDiscount(s.id, s.address_id, $sub.find('.discount-input').val(), close);
          }
        });
        $sub.find('.discount-submit').unbind('click').click(function () {
          self.submitDiscount(s.id, s.address_id, $sub.find('.discount-input').val(), close);
        });
      });
      $sub.find('.edit-address').unbind('click').click(function () {
        $('#address-select .address.selected').removeClass('selected');
        $('#address-select .address[data-address-id="' + s.address_id + '"]').addClass('selected');
        var close = self.modal('#address-select');
        $('#address-select .address').unbind('click').click(function () {
          if (!$(this).hasClass('selected')) {
            self.changeAddress(s.id, $(this));
            close();
          }
        });
        $('#address-select .manage-addresses').unbind('click').click(function () {
          close();
          $('a[data-section-link="profile"]').trigger('click');
        });
      });
      if (!inactive || vegamour.getCookie('cp_a', '').indexOf(s.address_id) !== -1) {
        this.getAddress(s.address_id, $sub);
        this.getUpsellProduct(s.id, s.shopify_product.handle);
      }
    }
    // }}}
    // {{{ reactivate
  }, {
    key: "reactivate",
    value: function reactivate(subscriptionId, immediately) {
      var _this5 = this;
      var clearDiscount = true;
      var $sub = this.getSubscription(subscriptionId);
      var addressId = $sub.attr('data-address-id');
      var address = this.getObj('addresses', addressId);
      if (typeof address.id !== 'undefined') {
        clearDiscount = false;
      }
      var target = '#subscriptions';
      this.wait(target);
      var query = vegamour.api.buildUrl('/subscription/' + subscriptionId + '/activate') + (typeof immediately !== 'undefined' && immediately ? '&immediately=1' : '') + (this.store !== 'int' ? '&process=true' : '') + (clearDiscount ? '&clear_discount=' + addressId : '');
      vegamour.debug(query);
      $.get(query).done(function (result) {
        if (result.data) {
          _this5.statusMessage('Subscription has been reactivated and reordered');
          _this5.getSubscriptions(true, target);
        } else {
          _this5.handleError(error);
        }
      })["catch"](function (error) {
        _this5.handleError(error);
      });
    }
    // }}}
    // {{{ manageSubscription
  }, {
    key: "manageSubscription",
    value: function manageSubscription(subscriptionId) {
      var self = this;
      var sub = this.getObj('subscriptions', subscriptionId);
      sub.shopify_product.variants.some(function (v) {
        if (typeof sub.external_variant_id !== 'undefined' && v.id == sub.external_variant_id.ecommerce) {
          var savings = parseInt(parseFloat(v.compare_at_price - parseFloat(v.price)) / parseFloat(v.compare_at_price) * 100);
          $('#manage [data-save-percent]').text(savings);
          return true;
        }
      });
      $('#manage').css('z-index', 10002);
      var close = this.modal('#manage');
      $('#manage .cancel-confirmation').css('display', 'none');
      $('#manage .skip').unbind('click').click(function () {
        self.skip(subscriptionId);
        close();
      });
      $('#manage .swap').unbind('click').click(function () {
        self.selectProduct(subscriptionId, true);
      });
      $('#manage .manage-cancel').unbind('click').click(function () {
        self.cancel(subscriptionId, close);
      });
    }
    // }}}
    // {{{ shipNow
  }, {
    key: "shipNow",
    value: function shipNow(subscriptionId) {
      var _this6 = this;
      var selector = this.getSubscription(subscriptionId, false);
      var target = selector + ' .subscription-shipment-date';
      this.wait(target);
      var $sub = $(selector);
      var chargeId = $sub.attr('data-charge-id');
      var query = vegamour.api.buildUrl('/subscription/' + subscriptionId + '/ship_now'); // + (this.store !== 'int' ? '&process=true' : '');
      vegamour.debug(query);
      $.get(query).done(function (result) {
        _this6.done(target);
        if (result.data) {
          var shipDate = _this6.date(result.data.formatted_next_charge_scheduled_at);
          $sub.find('.shipnow').hide();
          $sub.find('[data-subscription-shipment-date]').text(shipDate);
          _this6.setObj('subscriptions', result.data, subscriptionId);
          _this6.getUpcomingOrders(true, _this6.getChargeFromSubscription(subscriptionId, false));
          _this6.statusMessage('Your item will be shipped on ' + shipDate);
        } else {
          _this6.handleError(error);
        }
      })["catch"](function (error) {
        _this6.handleError(error);
      });
    }
    // }}}
    // {{{ cadence
  }, {
    key: "cadence",
    value: function cadence(subscriptionId, frequency, unit) {
      var _this7 = this;
      var selector = this.getSubscription(subscriptionId, false);
      frequency = parseInt(frequency);
      var u = unit.toLowerCase().replace('s', '');
      var query = vegamour.api.buildUrl('/subscription/' + subscriptionId + '/update') + '&order_interval_frequency=' + frequency + '&charge_interval_frequency=' + frequency + '&order_interval_unit=' + u;
      vegamour.debug(query);
      var target = selector + ' .subscription-details [data-subscription-frequency]';
      this.wait(target);
      $.get(query).done(function (result) {
        _this7.done(target);
        if (result.success) {
          var cadence = frequency + ' ' + unit + (frequency > 1 && unit.indexOf('s') === -1 ? 's' : '');
          var $sub = $(selector);
          $(target).text(cadence);
          _this7.statusMessage('Subscription will now ship every ' + cadence.toLowerCase());
          var _s = _this7.getObj('subscriptions', subscriptionId);
          _s.order_interval_frequency = frequency;
          _s.order_interval_unit = unit;
          _this7.setObj('subscriptions', _s, subscriptionId);
        } else {
          _this7.handleError(result.error);
        }
      })["catch"](function (error) {
        _this7.handleError(error);
      });
    }
    // }}}
    // {{{ selectCadence
  }, {
    key: "selectCadence",
    value: function selectCadence(subscriptionId, options) {
      var self = this;
      var s = this.getObj('subscriptions', subscriptionId);
      var $sub = this.getSubscription(subscriptionId);
      var $cadence = $('#cadence');
      $cadence.find('[data-cadence-items]').html($sub.find('.line-items').html());
      $cadence.find('[data-cadence-options]').html('');
      for (var _i = 0; _i < options.length; _i++) {
        var o = options[_i].split(' ');
        var frequency = o[0];
        var _unit = o[1].toLowerCase().replace('s', '');
        var selected = frequency == s.order_interval_frequency && _unit == s.order_interval_unit;
        var option = '<div class="cadence-option' + (selected ? ' selected original' : '') + '" data-frequency="' + frequency + '" data-unit="' + _unit + '">' + options[_i] + '</div>';
        $cadence.find('[data-cadence-options]').append(option);
      }
      var close = self.modal('#cadence');
      $cadence.find('.cadence-option').unbind('click').click(function () {
        $(this).parent().find('.selected').removeClass('selected');
        $(this).addClass('selected');
      });
      $cadence.find('.cadence-cta .btn-primary').unbind('click').click(function () {
        $selected = $cadence.find('[data-cadence-options] .selected');
        if ($selected.hasClass('original')) {
          self.statusMessage('Please select a new subscription frequency if you would like to update delivery schedule', 5);
        } else {
          self.cadence(subscriptionId, $selected.attr('data-frequency'), $selected.attr('data-unit'));
          close();
        }
      });
      $cadence.find('.cadence-cta .btn-secondary').unbind('click').click(function () {
        self.skip(subscriptionId);
        close();
      });
    }
    // }}}
    // {{{ skip
  }, {
    key: "skip",
    value: function skip(subscriptionId) {
      var _this8 = this;
      var sub = this.getObj('subscriptions', subscriptionId);
      if (typeof sub['id'] === 'undefined') {
        this.errorMessage('Please contact customer support to skip next shipment');
      } else {
        var self = this;
        var date = moment(sub.next_charge_scheduled_at).add(parseInt(sub.order_interval_frequency), sub.order_interval_unit + 's');
        var dateYMD = this.date(date, 'YYYY-MM-DD');
        var createdAt = this.date(sub.created_at, 'YYYY-MM-DD');
        var shipDate = this.date(date);
        var selector = this.getSubscription(subscriptionId, false);
        var _target2 = selector + ' .subscription-shipment-date';
        var query = vegamour.api.buildUrl('/subscription/' + subscriptionId + '/postpone') + '&date=' + dateYMD + '&created=' + createdAt + '&frequency=' + sub.order_interval_frequency + '&unit=' + sub.order_interval_unit;
        this.wait(_target2);
        vegamour.debug(query);
        $.get(query).done(function (result) {
          _this8.done(_target2);
          if (result.success) {
            var $sub = $(selector);
            $sub.find('[data-subscription-shipment-date]').text(shipDate);
            $sub.find('a.shipnow').show().unbind('click').click(function () {
              self.shipNow(subscriptionId);
            });
            self.setObj('subscriptions', result.data, subscriptionId);
            _this8.getUpcomingOrders(true, _this8.getChargeFromSubscription(subscriptionId, false));
            $('#manage').hide();
            $('body').removeClass('modal-open');
            self.statusMessage('Next shipment has been changed to ' + shipDate);
          } else {
            self.errorMessage(result.error);
          }
        })["catch"](function (error) {
          self.handleError(error);
        });
      }
    }
    // }}}
    // {{{ swap
  }, {
    key: "swap",
    value: function swap(subscriptionId, variantId, frequency) {
      var _this9 = this;
      if (!frequency) {
        this.errorMessage('Unable to swap for selected product');
      }
      var f = frequency.split(' ');
      var subscriptionSelector = this.getSubscription(subscriptionId, false);
      var chargeSelector = this.getChargeFromSubscription(subscriptionId, false);
      var target = subscriptionSelector + ',' + chargeSelector;
      this.wait(target);
      var sub = this.getObj('subscriptions', subscriptionId);
      var qs = '&external_variant_id=' + variantId + '&order_interval_frequency=' + f[0] + '&charge_interval_frequency=' + f[0] + '&order_interval_unit=' + f[1] + '&date=' + sub.next_charge_scheduled_at + '&price=true&currency=' + sub.presentment_currency;
      var query = vegamour.api.buildUrl('/subscription/' + subscriptionId + '/update') + qs;
      vegamour.debug(query);
      $.get(query).done(function (result) {
        if (result.success) {
          $('#manage').hide();
          $('body').removeClass('modal-open');
          _this9.statusMessage('Subscription product has been updated');
          _this9.getSubscriptions(true, target);
        } else {
          _this9.handleError(result.error);
        }
      })["catch"](function (error) {
        _this9.handleError(error);
      });
    }
    // }}}
    // {{{ selectProduct
  }, {
    key: "selectProduct",
    value: function selectProduct(subscriptionId, swap) {
      swap = typeof swap !== 'undefined' && swap;
      var self = this;
      var config = {
        arrows: true,
        prevArrow: '<div class="slider-arrow previous"></div>',
        nextArrow: '<div class="slider-arrow next"></div>',
        slidesToShow: this.isPhone ? 1 : 4,
        slidesToScroll: this.isPhone ? 1 : 4
      };
      $('#product-select').removeClass('swap add').addClass(swap ? 'swap' : 'add').show();
      $c1 = $('#product-select .carousels .carousel-1');
      if (!$c1.hasClass('slick-initialized')) {
        $c1.slick(config);
      }
      var close = false;
      if (swap) {
        close = function close() {
          $('#product-select').hide();
        };
        $('#product-select .close-button').unbind('click').click(close);
        $('.site-overlay').click(close);
      } else {
        close = this.modal('#product-select');
      }
      $('.carousel-select').unbind('click').click(function () {
        var index = $(this).data('select');
        $('#product-select .carousel').hide();
        $('#product-select .carousel-' + index).show();
        var $c = $('#product-select .carousels .carousel-' + index);
        if (!$c.hasClass('slick-initialized')) {
          $c.slick(config);
        }
        $('#product-select .carousel-select.selected').removeClass('selected');
        $('#product-select .carousel-select[data-select="' + index + '"]').addClass('selected');
      });
      if (swap) {
        $('#product-select .swap-product-cta').unbind('click').click(function () {
          var frequency = $(this).closest('.select-product').attr('data-subscription-frequency');
          self.swap(subscriptionId, $(this).closest('.select-product').attr('data-subscription-variant-id'), frequency);
          close();
        });
      } else {
        $('#product-select .add-product > div').unbind('click').click(function () {
          var frequency = $(this).hasClass('add-subscription-cta') ? $(this).closest('.select-product').attr('data-subscription-frequency') : false;
          self.addMore(subscriptionId, $(this).closest('.select-product').attr('data-product-id'), $(this).closest('.select-product').attr('data-' + (frequency ? 'subscription' : 'onetime') + '-variant-id'), frequency);
          close();
        });
      }
    }
    // }}}
    // {{{ cancel
  }, {
    key: "cancel",
    value: function cancel(subscriptionId, close) {
      var s = this.getObj('subscriptions', subscriptionId);
      var address = this.getObj('addresses', s.address_id);
      var isCancelFlow = function isCancelFlow(type, value) {
        var str = $('[data-cancel-flow-' + type + ']').data('cancel-flow-' + type);
        if (!type || !value || !str) {
          return false;
        }
        return str.split(',').map(function (item) {
          return item.trim();
        }).includes(value);
      };
      if (isCancelFlow('state', address.province) || isCancelFlow('country', address.country_code)) {
        var $sub = this.getSubscription(subscriptionId);
        var reasons = this.cancelFlowReasons();
        var self = this;
        var reasonHTML = '';
        reasons.forEach(function (r, i) {
          reasonHTML += '<div class="reason"><input type="radio" name="reason" id="reason_' + i + '" value="' + r.reason + '" /><label for="reason_' + i + '">' + r.reason + '</label>';
          if (r.reason.toLowerCase() == 'other') {
            reasonHTML += ' <input type="text" name="other" id="reason-other" size="30" />';
          }
          reasonHTML += '</div>';
        });
        var mclose = close; // close action for subscription management

        var sub = this.getObj('subscriptions', subscriptionId);
        var annualShipments = (sub.order_interval_unit == 'day' ? 365 : 12) / sub.order_interval_frequency;
        var savings = 0;
        sub.shopify_product.variants.some(function (v) {
          if (typeof sub.external_variant_id !== 'undefined' && v.id == sub.external_variant_id.ecommerce) {
            savings = parseFloat(v.compare_at_price) - parseFloat(v.price);
            return true;
          }
        });
        annualSavings = Math.round(savings * annualShipments);
        var closeCancelFlow = function closeCancelFlow() {
          $('.cancel-flow').hide();
          $('.site-overlay').unbind('click').click(close);
        };
        $('.cancel-close').unbind('click').click(function () {
          closeCancelFlow();
        });
        $('.cancel-reasons').html(reasonHTML).find('input[type="radio"]').unbind('click').click(function () {
          var rid = parseInt($(this).attr('id').replace('reason_', ''));
          if (reasons[rid].incentive) {
            $('#manage').css('z-index', 1038);
            $('.cancel-flow').css('z-index', 1039);
            $('.cancel-incentive-description').html(reasons[rid].incentive);
            $('.cancel-incentive-description').find('[data-annual-savings]').text(annualSavings);
            var closeCancel = function closeCancel() {
              $('.cancel-incentive').hide();
              $('.cancel-flow').css('z-index', 10003);
              $('#manage').css('z-index', 10002);
              $('.site-overlay').unbind('click').click(closeCancelFlow);
            };
            self.modal('.cancel-incentive', closeCancel);
            $('.cancel-incentive-cta').find('.btn').html(reasons[rid].cta).unbind('click').click(function () {
              closeCancel();
              closeCancelFlow();
              close();
              if (reasons[rid].action == 'link') {
                if (screen.width <= 400) {
                  window.location.href = reasons[rid].url;
                } else {
                  self.popup(reasons[rid].url, 'Concierge', 350, 600);
                }
              } else if (reasons[rid].action == 'skip') {
                self.selectCadence(subscriptionId, ['30 days', '60 days', '90 days']);
              } else if (reasons[rid].action == 'code') {
                var selector = self.getSubscription(subscriptionId, false);
                var _$sub = $(selector);
                var addressId = _$sub.attr('data-address-id');
                if (!addressId) {
                  return false;
                }
                self.submitDiscount(subscriptionId, addressId, reasons[rid].code, close);
              }
            });
          }
        });
        this.modal('.cancel-flow', closeCancelFlow);
        $('.cancel-confirm').unbind('click').click(function () {
          var reason = '';
          if ($('input[name="reason"]:checked').length > 0) {
            reason = $('input[name="reason"]:checked').val();
            if (reason.toLowerCase() == 'other') {
              var other = $('#reason-other').val();
              reason = other.length <= 3 ? '' : other;
            }
          }
          var comments = $('#cancel-comments').val();
          if (reason.length === 0) {
            alert('Please share your reason for leaving');
          } else {
            closeCancelFlow();
            close();
            var selector = self.getSubscription(subscriptionId, false);
            var _$sub2 = $(selector);
            _$sub2.addClass('disabled');
            var chargeId = _$sub2.attr('data-charge-id');
            if (chargeId) {
              $('.upcoming-order[data-id="' + chargeId + '"]').addClass('disabled');
            }
            self.cancelFlow(subscriptionId, false, reason, comments);
          }
        });
      } else {
        $('.cancel-confirmation').css('display', 'flex');
      }
    }
    // }}}
    // {{{ cancelFlow
  }, {
    key: "cancelFlow",
    value: function cancelFlow(subscriptionId, close, reason, comments) {
      var _this10 = this;
      var selector = this.getSubscription(subscriptionId, false);
      var $sub = $(selector);
      this.wait(selector);
      if (typeof reason === 'undefined' || !reason) {
        reason = 3;
      }
      var query = vegamour.api.buildUrl('/subscription/' + subscriptionId + '/cancel') + '&address_id=' + $sub.attr('data-address-id') + '&reason=' + encodeURIComponent(reason);
      if (typeof comments !== 'undefined' && comments) {
        query += '&comments=' + encodeURIComponent(comments);
      }
      vegamour.debug(query);
      $.get(query).done(function (result) {
        _this10.done(selector);
        if (result.success) {
          var $iSubs = $('.inactive-subscriptions .subscription-list');
          var subHTML = $sub.find('.subscription-container').html();
          var chargeId = $sub.attr('data-charge-id');
          if (chargeId) {
            $('.upcoming-order[data-id="' + chargeId + '"]').remove();
          }
          $sub.slideUp();
          $iSubs.find('.subscription:last-of-type').remove();
          $iSubs.prepend('<div class="subscription" data-subscription-id="' + subscriptionId + '"><div class="subscription-container">' + subHTML + '</div></div>');
          var $iSub = $iSubs.find('.subscription[data-subscription-id="' + subscriptionId + '"] .subscription-container');
          $iSub.find('[data-subscription-status]').text('CANCELLED');
          $iSub.append('<div class="subscription-cta"><a class="btn btn-primary sl reactivate">Reactivate and Save</a></i>');
          $iSub.find('a.reactivate').click(function () {
            this.reactivate(s.id, true);
            // insert above
            $sub.hide();
          });
          _this10.statusMessage('Your subscription has been cancelled');
          if (close) {
            close();
          }
        } else {
          _this10.handleError(result.error);
          $('.cancel-confirmation').css('display', 'flex');
        }
      })["catch"](function (error) {
        _this10.handleError(error);
        $('.cancel-confirmation').css('display', 'flex');
      });
    }
    // }}}
    // {{{ cancelFlowReasons
  }, {
    key: "cancelFlowReasons",
    value: function cancelFlowReasons() {
      return [{
        'reason': 'This product is too expensive',
        'incentive': 'Did you know you\'re <strong>saving nearly $<span data-annual-savings></span> USD each year</strong> when you stick to your current subscription?<br><br>We want you to succeed in reaching your hair goals and don\'t want costs to get in the way of your progress. We\'d like to offer you <strong>30% off your next two shipments*</strong> to keep you on your path to achieving ultimate hair wellness.',
        'cta': 'Come Back and Save 30%',
        'action': 'code',
        'code': 'CX30PERX2'
      }, {
        'reason': 'A subscription doesn\'t fit my needs',
        'incentive': 'Are you sure you want your subscription to end? As a valued subscriber, we want to give you <strong>25% off your next shipment*</strong>, so you can keep enjoying all your benefits and perks (and keep your hair wellness routine going).',
        'cta': 'Unlock 25% Off Now',
        'action': 'code',
        'code': 'CX25PERX1'
      }, {
        'reason': 'This product didn\'t work for me',
        'incentive': 'Good things take time–that\'s why we\'re offering you <strong>25% off your next three orders*</strong> so you can turn hair wellness into a habit and see visible results in as soon as 90 days.',
        'cta': 'Claim my Offer',
        'action': 'code',
        'code': 'CX25PERX3'
      }, {
        'reason': 'I would rather buy at Sephora or Amazon',
        'incentive': 'Please, keep in mind that our best deals are only available on Vegamour.com – and as always, free shipping & surprise gifts. Bonus: We\'re offering you <strong>25% off your next shipment.*</strong> As a valued customer, we want to make sure you are getting the best value possible.',
        'cta': 'Get 25% Off',
        'action': 'code',
        'code': 'CX25PERX1'
      }, {
        'reason': 'Purchased as a gift',
        'incentive': '<h4>The Gift That Keeps On Giving</h4><br />Thank you for choosing to share Vegamour; we appreciate you! Continue to spread the gift of hair wellness with your friends and you\'ll both receive $15 off your next order! It\'s a win-win.<br /><br />Use Code: <input type="text" size="12" class="code-copy" value="GIFT25GET25" />',
        'cta': 'Get 25% Off Now',
        'action': 'code',
        'code': 'GIFT25GET25'
      }, {
        'reason': 'I have too much of this product',
        'incentive': 'Not using as much product as you thought?<br /><br />Instead of canceling, you can skip your next shipment or customize your delivery schedule so you don\'t lose all your benefits and perks.',
        'cta': 'Move my Next Order',
        'action': 'skip'
      }, {
        'reason': 'I prefer a different brand',
        'incentive': 'Are you sure you want to leave? Our best advice: consistency is key to unlocking visible results. That\'s why we\'re offering you <strong>25% off your next two orders*</strong> to keep your hair wellness ritual going.',
        'cta': 'Unlock 25% Off',
        'action': 'code',
        'code': 'CX25PERX2'
      }, {
        'reason': 'I had a poor experience with Vegamour',
        'incentive': 'We value your hair wellness journey and want to be the best partners we can be. Our Senior Customer Experience Manager would like the opportunity to sort out what went wrong. <strong>Please schedule a call by clicking below.</strong>',
        'cta': 'Let\'s Connect',
        'action': 'link',
        'url': 'https://calendly.com/vegamour/concierge'
      }, {
        'reason': 'Other',
        'incentive': false
      }];
    }
    // }}}
    // {{{ addMore
  }, {
    key: "addMore",
    value: function addMore(subscriptionId, productId, variantId, frequency) {
      var _this11 = this;
      var s = this.getObj('subscriptions', subscriptionId);
      vegamour.debug(s);
      var data = {
        'external_product_id': productId,
        'external_variant_id': variantId,
        'next_charge_scheduled_at': s.next_charge_scheduled_at.substring(0, 10),
        'currency': this.currencyIso
      };
      if (frequency) {
        var f = frequency.split(' ');
        data.order_interval_frequency = f[0];
        data.charge_interval_frequency = f[0];
        data.order_interval_unit = f[1];
      }
      var subscriptionSelector = this.getSubscription(subscriptionId, false);
      var chargeSelector = this.getChargeFromSubscription(subscriptionId, false);
      this.wait(chargeSelector);
      var query = vegamour.api.buildUrl('/subscription/' + s.address_id + '/' + (frequency ? 'create' : 'onetime'));
      vegamour.debug(query, data);
      $.post(query, data).done(function (result) {
        vegamour.debug(data);
        if (result.success) {
          _this11.statusMessage('Product has been added to your ' + (frequency ? 'subscription list' : 'next order'));
          if (frequency) {
            _this11.getSubscriptions(true, subscriptionSelector + ',' + chargeSelector);
          } else {
            _this11.getUpcomingOrders(true, chargeSelector);
          }
        } else {
          _this11.handleError(result.error);
        }
      })["catch"](function (error) {
        _this11.handleError(error);
      });
    }
    // }}}
    // {{{ isNextChargeDateToday
  }, {
    key: "isNextChargeDateToday",
    value: function isNextChargeDateToday(subscription) {
      if (typeof subscription.next_charge_scheduled_at === 'undefined' || !subscription.next_charge_scheduled_at) {
        return false;
      }
      var chargeString = subscription.next_charge_scheduled_at.split('T')[0];
      return chargeString <= this.today();
    }
    // }}}
    // {{{ getProduct
  }, {
    key: "getProduct",
    value: function getProduct(handle) {
      return this.ajax('/products/' + handle + '.js');
    }
    // }}}
    // {{{ getUpcomingOrders
  }, {
    key: "getUpcomingOrders",
    value: function getUpcomingOrders(validate, target) {
      var _this12 = this;
      var subscriptionCustomerId = this.getSubscriptionCustomerId();
      if (!subscriptionCustomerId) {
        return false;
      }
      target = typeof target === 'undefined' || !target ? '#upcoming-orders' : target;
      this.wait(target);
      var self = this;
      var query = vegamour.api.buildUrl('/charge/' + subscriptionCustomerId + '/queued') + '&cache=0';
      vegamour.debug(query);
      $.get(query).done(function (result) {
        if (result.success) {
          var $upcoming = $('.upcoming-orders');
          if (result.data.length) {
            if (validate) {
              // Try again if nothing changed
              var upcomingOrders = _this12.getObj('upcomingOrders');
              if (upcomingOrders.length > 0) {
                var orderHash = function orderHash(orders) {
                  var hash = '';
                  orders.forEach(function (o) {
                    hash += o.id + o.address_id + o.scheduled_at + o.total_line_items_price + o.total_price;
                    o.line_items.forEach(function (i) {
                      hash += i.purchase_item_id + i.quantity;
                    });
                  });
                  return hash;
                };
                if (orderHash(upcomingOrders) == orderHash(result.data)) {
                  setTimeout(function () {
                    self.getUpcomingOrders(true, target);
                  }, 1000);
                  return false;
                }
              }
            }
            _this12.done(target);
            console.log('📦 Upcoming orders loaded');
            vegamour.debug(result.data);
            _this12.setObj('upcomingOrders', result.data);
            $('.upcoming-orders > div:not([data-template])').remove();
            var $template = $('.upcoming-orders [data-template]');
            var itemHTML = $template.find('.item').html();
            var orderHTML = $template.html();
            var cancelMessage = 'Your subscription has been cancelled';
            result.data.forEach(function (u) {
              if (u.line_items.length == 1 && u.line_items[0].purchase_item_id == _this12.cancelId) {
                _this12.statusMessage(cancelMessage);
                return;
              }
              paymentMethodId = '';
              var address = _this12.getObj('addresses', u.address_id);
              if (typeof address.payment_method_id !== 'undefined') {
                paymentMethodId = address.payment_method_id;
              }
              $upcoming.append('<div class="upcoming-order" data-id="' + u.id + '" data-address-id="' + u.address_id + '" data-payment-method-id="' + paymentMethodId + '">' + orderHTML + '</div>');
              var $order = $upcoming.find('.upcoming-order[data-id="' + u.id + '"]');
              $order.find('.item').remove();
              $order.find('[data-upcoming-order-date]').text(self.date(u.scheduled_at));
              u.shipping_address.id = u.address_id;
              self.setShippingAddress(u.shipping_address);
              $order.find('[data-address-line]').html(self.getAddressFormat(u.shipping_address).line);
              var cs = _typeof(currencySymbols[u.currency]) !== undefined ? currencySymbols[u.currency] : false;
              $order.find('[data-upcoming-order-subtotal]').text(self.currency(u.total_line_items_price, cs));
              var tax = self.currency(u.total_tax, cs);
              var shipping = self.currency(u.shipping_lines[0].price, cs);
              if (u.shipping_address.country_code != self.domesticCountry) {
                $order.find('[data-intl]').show();
                tax = shipping = 'TBD';
              }
              if (parseFloat(u.total_discounts) > 0) {
                $order.find('[data-upcoming-order-discount-code]').text(_this12.maskDiscountCode(u.discounts[0].code));
                $order.find('[data-upcoming-order-discount-amount]').text('-' + self.currency(u.total_discounts, cs));
              } else {
                $order.find('.discount').hide();
              }
              $order.find('[data-upcoming-order-tax]').text(tax);
              $order.find('[data-upcoming-order-shipping]').text(shipping);
              $order.find('[data-upcoming-order-total]').text(self.currency(u.total_price, cs));
              u.line_items.forEach(function (i, n) {
                if (i.purchase_item_id == _this12.cancelId) {
                  _this12.statusMessage(cancelMessage);
                  var utarget = '.upcoming-order[data-id="' + u.id + '"]';
                  _this12.wait(utarget);
                  setTimeout(function () {
                    self.getUpcomingOrders(true, utarget);
                  }, 3000);
                } else {
                  $order.find('.line-items').append('<div class="item" data-item-index="' + n + '">' + itemHTML + '</div>');
                  var $item = $order.find('.item[data-item-index="' + n + '"]');
                  $item.find('[data-upcoming-order-item-image]').html('<img src="' + vegamour.imgSize(i.images.original, '110x') + '" />');
                  $item.find('[data-upcoming-order-item-title]').text(i.title);
                  $item.find('[data-upcoming-order-item-quantity]').text(i.quantity);
                  if (i.purchase_item_type == 'onetime' || typeof i.type !== 'undefined' && i.type.toLowerCase() == 'onetime') {
                    $item.addClass('onetime');
                  }
                  if (i.purchase_item_type == 'subscription') {
                    var $sub = _this12.getSubscription(i.purchase_item_id);
                    if ($sub) {
                      $sub.attr('data-charge-id', u.id);
                      var $shipDate = $sub.find('.subscription-shipment-date');
                      if (!$shipDate.is(':visible')) {
                        $shipDate.find('[data-subscription-shipment-date]').text(self.date(u.scheduled_at));
                        $shipDate.show();
                        if (u.scheduled_at > _this12.today()) {
                          $sub.find('.shipnow').show();
                        }
                      }
                    }
                  }
                }
              });
              var remaining = 4 - u.line_items.length % 4;
              for (var y = 1; y <= remaining; y++) {
                $order.find('.line-items').append('<div class="addmore"><div class="plus">+</div><div class="addmore-text">Add More And Save</div></div>');
              }
              if (_this12.isMobile) {
                var piv = setInterval(function () {
                  var ph = parseInt($order.find('.item:first-of-type img').height());
                  if (ph > 0) {
                    $order.find('.plus').css('height', ph + 'px');
                    clearInterval(piv);
                  }
                }, 250);
              }
              $order.find('.addmore').click(function () {
                var subscriptionId = $('.subscription[data-charge-id="' + u.id + '"]').attr('data-subscription-id');
                self.selectProduct(subscriptionId);
              });
            });
            _this12.setPaymentMethods();
            $(target).slideDown();
          } else {
            _this12.done(target);
            $(target).hide();
          }
          $('#home .loading').hide();
        } else {
          _this12.handleError(result.error);
        }
      })["catch"](function (error) {
        _this12.handleError(error);
      });
    }
    // }}}
    // {{{ getCustomer
  }, {
    key: "getCustomer",
    value: function getCustomer(customerId) {
      var _this13 = this;
      isShopify = typeof customerId === 'undefined' || !customerId;
      if (isShopify) {
        customerId = this.getCustomerId();
      }
      var target = '#profile';
      this.wait(target);
      var query = vegamour.api.buildUrl('/customer' + (isShopify ? '' : '/' + customerId) + '/get') + '&cache=0';
      vegamour.debug(query);
      $.get(query).done(function (result) {
        if (!result.success) {
          if (!isShopify) {
            return _this13.getCustomer();
          } else if (result.error == 'Customer not found') {
            return _this13.createCustomer(customerId);
          } else {
            _this13.handleError(result.error);
          }
        } else {
          _this13.done(target);
          data = result.data;
          _this13.getPaymentMethods(data.id);
          _this13.setCustomer(data);
          _this13.subscriptionCustomerId = data.id;
          for (var prop in data) {
            if ($(target + ' [data-id="' + prop + '"]').length) {
              $(target + ' [data-id="' + prop + '"]').val(data[prop]);
            }
          }
          var addressList = vegamour.getCookie('cp_a', '');
          if (addressList) {
            addressList.split('|').some(function (a, i) {
              if (i == 0) {
                if (a != data.id) {
                  vegamour.setCookie('cp_a', data.id);
                  return true;
                }
              } else if (parseInt(a) == a) {
                _this13.getAddress(a);
              }
            });
          } else {
            vegamour.setCookie('cp_a', data.id);
          }
          var self = _this13;
          var updateCallback = function updateCallback(data) {
            self.statusMessage('Your customer profile has been updated');
            _this13.setCustomer(data);
          };
          $('.customer-update').click(function () {
            var formData = self.processForm($(this).closest('.form'));
            if (formData) {
              self.updateCustomer(data.id, formData, updateCallback);
            }
          });
          self.paymentMethodCTA();
          $('.add-shipping-address').click(function (e) {
            self.modalTriggerElement = e.target;
            self.editAddress();
          });
          if (!data.has_valid_payment_method) {
            _this13.setCustomerPaymentWarning(data.reason_payment_method_not_valid);
          }
          if (isShopify) {
            var setAddress = function setAddress(data) {
              _this13.setShippingAddress(data[data.length - 1]);
            };
            _this13.getAddresses(data.id, setAddress);
            _this13.getUpcomingOrders();
          }
          console.log('🧑 Customer loaded');
          vegamour.debug(data);
        }
      })["catch"](function (error) {
        _this13.handleError(error);
      });
    }
    // }}}
    // {{{ setCustomer
  }, {
    key: "setCustomer",
    value: function setCustomer(data) {
      data.phone = this.getPhoneFormat(data.phone);
      this.customer = data;
      this.subscriptionCustomerId = data.id;
      $('[data-subscription-customer-id]').attr('data-subscription-customer-id', data.id);
      $('[data-customer-first-name]').text(data.first_name);
      $('[data-customer-last-name]').text(data.first_name);
      $('[data-customer-email]').text(data.email);
      $('[data-customer-phone]').text(data.phone);
      $('.customer-details [data-id="first_name"]').val(data.first_name);
      $('.customer-details [data-id="last_name"]').val(data.last_name);
      $('.customer-details [data-id="email"]').val(data.email);
      $('.customer-details [data-id="phone"]').val(data.phone);
    }
    // }}}
    // {{{ getPaymentMethods
  }, {
    key: "getPaymentMethods",
    value: function getPaymentMethods(customerId) {
      var _this14 = this;
      customerId = typeof customerId === 'undefined' ? this.getSubscriptionCustomerId() : customerId;
      var query = vegamour.api.buildUrl('/customer/' + customerId + '/payment_methods') + '&cache=0';
      vegamour.debug(query);
      $.get(query).done(function (result) {
        if (!result.success) {
          _this14.handleError(result.error);
        } else {
          _this14.setObj('paymentMethods', result.data);
          _this14.setPaymentMethods();
          console.log('💳 Payment methods loaded');
          vegamour.debug(result.data);
          if (result.data.length > 0) {
            setTimeout(function () {
              var defaultPaymentMethodId = 0;
              result.data.forEach(function (payment) {
                if (payment["default"]) {
                  defaultPaymentMethodId = payment.id;
                }
              });
              if (!defaultPaymentMethodId) {
                defaultPaymentMethodId = result.data[result.data.length - 1].id;
              }
              var addresses = _this14.getObj('addresses');
              if (addresses.length > 0) {
                addresses.forEach(function (address) {
                  if (address.payment_method_id == null) {
                    var updateCallback = function updateCallback(data) {
                      _this14.setShippingAddress(data);
                    };
                    vegamour.debug('Adding payment method ' + defaultPaymentMethodId + ' to address ' + address.id);
                    _this14.updateAddress(address.id, {
                      'payment_method_id': defaultPaymentMethodId
                    }, updateCallback);
                  }
                });
              }
            }, 1500);
          }
        }
      })["catch"](function (error) {
        _this14.handleError(error);
      });
    }
    // }}}
    // {{{ setPaymentMethods
  }, {
    key: "setPaymentMethods",
    value: function setPaymentMethods() {
      var _this15 = this;
      var paymentMethods = this.getObj('paymentMethods');
      if ($.isEmptyObject(paymentMethods)) {
        return false;
      }
      var $paymentMethodSelector = $('select[data-id="payment_method_id"]');
      $paymentMethodSelector.find('option').remove();
      $('.payment-methods > div:not([data-template])').remove();
      paymentMethods.forEach(function (p) {
        var method = p.payment_type == 'PAYPAL' ? 'PayPal' : p.payment_details.brand == 'american_express' ? 'AMEX' : p.payment_details.brand.charAt(0).toUpperCase() + p.payment_details.brand.slice(1);
        if (p.payment_details.last4) {
          method += ' ending in ' + p.payment_details.last4;
        }
        //if (p.payment_details.exp_month) {
        //    method += ' [' + p.payment_details.exp_month + '/' + p.payment_details.exp_year.toString().substring(2,4) + ']';
        //}

        $('[data-payment-method-id="' + p.id + '"] [data-payment-method]').html(method);
        $paymentMethodSelector.append($('<option>', {
          value: p.id,
          text: method + (p["default"] ? ' (Default)' : '')
        }));
        var self = _this15;
        $('[data-payment-method-id="' + p.id + '"] .edit-payment-method').unbind('click').click(function (e) {
          if (p.processor_name == 'shopify_payments') {
            self.errorMessage('Please contact customer service to update the address for this payment method');
          } else {
            self.modalTriggerElement = e.target;
            self.editAddress(p);
          }
        });
      });
    }
    // }}}
    // {{{ updatePaymentMethod
  }, {
    key: "updatePaymentMethod",
    value: function updatePaymentMethod(paymentMethodId, data) {
      var _this16 = this;
      var query = vegamour.api.buildUrl('/customer/' + this.getSubscriptionCustomerId() + '/payment_methods/' + paymentMethodId + '/update');
      vegamour.debug(query, data);
      $.post(query, data).done(function (result) {
        vegamour.debug(result);
        if (!result.success) {
          _this16.handleError(result.error);
        } else {
          var _data = result.data;
          _this16.statusMessage('Payment method has been updated');
          _this16.getPaymentMethods();
        }
      })["catch"](function (error) {
        _this16.handleError(error);
      });
    }
    // }}}
    // {{{ removePaymentMethod
  }, {
    key: "removePaymentMethod",
    value: function removePaymentMethod(customerId, paymentMethodId) {
      var _this17 = this;
      var query = vegamour.api.buildUrl('/customer/' + customerId + '/payment_methods/' + paymentMethodId + '/remove');
      vegamour.debug(query);
      $.get(query).done(function (result) {
        vegamour.debug(result);
        if (!result.success) {
          _this17.handleError(result.error);
        } else {
          _this17.statusMessage('Payment method has been removed');
          _this17.getPaymentMethods();
        }
      })["catch"](function (error) {
        _this17.handleError(error);
      });
    }
    // }}}
    // {{{ createCustomer
  }, {
    key: "createCustomer",
    value: function createCustomer(customerId) {
      var _this18 = this;
      this.done('#subscriptions, #upcoming-orders');
      var query = vegamour.api.buildUrl('/shopify/customer');
      vegamour.debug(query);
      target = '#profile';
      this.wait(target);
      $.get(query).done(function (result) {
        // Get Shopify customer data
        if (result.success) {
          vegamour.debug(result.data);
          var shopCustomer = result.data;
          if (!shopCustomer.default_address.address1) {
            _this18.done(target);
            _this18.errorMessage('Please come back after you have completed a purchase', 15);
            setTimeout(function () {
              window.location = '/';
            }, 10000);
          } else {
            var customerData = {
              'first_name': shopCustomer.first_name,
              'last_name': shopCustomer.last_name,
              'email': shopCustomer.email,
              'address1': shopCustomer.default_address.address1,
              'address2': shopCustomer.default_address.address2,
              'company': shopCustomer.default_address.company,
              'city': shopCustomer.default_address.city,
              'province': shopCustomer.default_address.province,
              'zip': shopCustomer.default_address.zip,
              'country_code': shopCustomer.default_address.country_code
            };
            if (shopCustomer.phone) {
              customerData.phone = shopCustomer.phone;
            }
            // Add customer to recharge
            var _query = vegamour.api.buildUrl('/customer/add');
            vegamour.debug(_query, customerData);
            $.post(_query, customerData).done(function (result) {
              if (result.success) {
                vegamour.debug(result.data);
                var _subCustomer = result.data;
                // Add default shipping address
                var _query2 = vegamour.api.buildUrl('/address/' + _subCustomer.id + '/add');
                vegamour.debug(_query2, customerData);
                $.post(_query2, customerData).done(function (result) {
                  if (result.success) {
                    _this18.done(target);
                    vegamour.debug(result.data);
                    _this18.setShippingAddress(result.data);
                    _this18.getCustomer(_subCustomer.id);
                  } else {
                    _this18.handleError(result.error);
                  }
                })["catch"](function (error) {
                  _this18.handleError(error);
                });
              } else {
                _this18.handleError(result.error);
              }
            })["catch"](function (error) {
              _this18.handleError(error);
            });
          }
        } else {
          _this18.handleError(result.error);
        }
      })["catch"](function (error) {
        _this18.handleError(error);
      });
    }
    // }}}
    // {{{ checkAddresses
  }, {
    key: "checkAddresses",
    value: function checkAddresses(subscriptionCustomerId) {
      var _this19 = this;
      $.get(vegamour.api.buildUrl('/address/' + subscriptionCustomerId + '/list')).done(function (result) {
        if (result.success) {
          if (result.data.length) {
            _this19.setShippingAddress(result.data[0]);
          } else {
            _this19.createDefaultShipAddress(subscriptionCustomerId);
          }
        } else {
          _this19.handleError(result.error);
        }
      })["catch"](function (error) {
        _this19.handleError(error);
      });
    }
    // }}}
    // {{{ createDefaultShipAddress
  }, {
    key: "createDefaultShipAddress",
    value: function createDefaultShipAddress(subscriptionCustomerId) {
      var _this20 = this;
      $.get(vegamour.api.buildUrl('/shopify/customer') + '&id=' + this.getCustomerId()).done(function (result) {
        // Get Shopify customer data
        if (result.success) {
          var shopCustomer = result.data;
          var customerData = {
            'first_name': shopCustomer.first_name,
            'last_name': shopCustomer.first_name,
            'email': shopCustomer.email,
            'phone': shopCustomer.phone,
            'address1': shopCustomer.default_address.address1,
            'address2': shopCustomer.default_address.address2,
            'company': shopCustomer.default_address.company,
            'city': shopCustomer.default_address.city,
            'province': shopCustomer.default_address.province,
            'zip': shopCustomer.default_address.zip,
            'country_code': shopCustomer.default_address.country_code
          };
          // Add default shipping address to recharge
          var query = vegamour.api.buildUrl('/address/' + subscriptionCustomerId + '/add');
          vegamour.debug(query, customerData);
          $.post(query, customerData).done(function (result) {
            if (result.success) {
              _this20.setShippingAddress(result.data);
              _this20.getCustomer(subCustomer.id);
            } else {
              _this20.handleError(result.error);
            }
          })["catch"](function (error) {
            _this20.handleError(error);
          });
        } else {
          _this20.handleError(result.error);
        }
      })["catch"](function (error) {
        _this20.handleError(error);
      });
    }
    // }}}
    // {{{ updateCustomer
  }, {
    key: "updateCustomer",
    value: function updateCustomer(customerId, data, callback) {
      var _this21 = this;
      var target = '.customer-details';
      this.wait(target);
      if (data.phone.length) {
        data.phone = this.getPhoneFormat(data.phone, true);
      } else {
        delete data.phone;
      }
      var query = vegamour.api.buildUrl('/customer/' + customerId + '/update');
      vegamour.debug(query, data);
      $.post(query, data).done(function (result) {
        _this21.done(target);
        if (result.success) {
          if (typeof callback !== 'undefined' && callback) {
            callback(result.data);
          }
        } else {
          _this21.handleError(result.error);
        }
      })["catch"](function (error) {
        _this21.handleError(error);
      });
      // Post silently to Shopify and do not error - not the end of the world if this fails
      query = vegamour.api.buildUrl('/shopify/customer/update');
      vegamour.debug(query, data);
      $.post(query, data).done(function (result) {
        if (!result.success) {
          delete data.phone;
          vegamour.debug(query, data);
          $.post(query, data);
        }
      });
    }
    // }}}
    // {{{ setCustomerPaymentWarning
  }, {
    key: "setCustomerPaymentWarning",
    value: function setCustomerPaymentWarning(reason) {
      this.errorMessage('Payment method invalid' + (reason ? ': ' + reason : '') + '. Please update your billing information', 1000);
    }
    // }}}
    // {{{ paymentMethodCTA
  }, {
    key: "paymentMethodCTA",
    value: function paymentMethodCTA() {
      var customerHash = $('[data-subscription-customer-hash]').attr('data-subscription-customer-hash');
      var self = this;
      $('.add-payment-method').unbind('click').click(function () {
        if (self.store !== 'int' && customerHash.length) {
          var paymentUrl = 'https://checkout.rechargeapps.com/customer_portal_payment_source_form/' + customerHash + '/payment_source?t=1&show_full_billing_info_form=1&public_redirect=1';
          var paymentWindow = screen.width <= 640 ? window.open(paymentUrl, '_blank') : popup(paymentUrl, 'payment', 520, 625);
          var piv = setInterval(function () {
            if (paymentWindow.closed) {
              clearInterval(piv);
              self.getPaymentMethods();
            }
          }, 1000);
        } else {
          self.errorMessage('Please contact customer service to update your payment method');
        }
      });
    }
    // }}}
    // {{{ getAddresses
  }, {
    key: "getAddresses",
    value: function getAddresses(customerId, callback) {
      var _this22 = this;
      var query = vegamour.api.buildUrl('/address/' + customerId + '/list') + '&cache=0';
      vegamour.debug(query);
      $.get(query).done(function (result) {
        if (result.success) {
          console.log('🌐 Addresses loaded');
          vegamour.debug(result.data);
          if (typeof callback !== 'undefined' && callback) {
            callback(result.data);
          }
        } else {
          _this22.handleError(result.error);
        }
      })["catch"](function (error) {
        _this22.handleError(error);
      });
    }
    // }}}
    // {{{ getAddress
  }, {
    key: "getAddress",
    value: function getAddress(addressId, $sub) {
      var _this23 = this;
      var address = this.getObj('addresses', addressId);
      if (address && typeof address.address1 === 'undefined') {
        // currently querying
        return;
      }
      if (!address) {
        this.setObj('addresses', null, addressId);
        var query = vegamour.api.buildUrl('/address/' + addressId + '/get');
        vegamour.debug(query);
        $.get(query).done(function (result) {
          if (result.success) {
            console.log('🌐 Address loaded');
            vegamour.debug(result.data);
            _this23.setShippingAddress(result.data);
          } else {
            _this23.handleError(result.error);
          }
        })["catch"](function (error) {
          _this23.handleError(error);
        });
      } else if ($sub !== 'undefined') {
        $('[data-address-id="' + addressId + '"]').attr('data-payment-method-id', address.payment_method_id).find('[data-address-line]').html(this.getAddressFormat(address).line);
      }
    }
    // }}}
    // {{{ getAddressFormat
  }, {
    key: "getAddressFormat",
    value: function getAddressFormat(address) {
      var intl = address.country_code !== this.domesticCountry;
      return {
        'line': address.address1 + (address.address2 ? ', ' + address.address2 : '') + '<span class="break-mobile">, </span>' + address.city + ', ' + address.province + ' ' + address.zip + (intl ? '<span class="break-mobile"> </span>' + address.country_code : ''),
        'html': address.first_name + ' ' + address.last_name + '<br />' + address.address1 + (address.address2 ? ', ' + address.address2 : '') + '<br />' + address.city + ', ' + address.province + ' ' + address.zip + (intl ? '<br />' + address.country_code : '') + '<br />' + this.getPhoneFormat(address.phone)
      };
    }
    // }}}
    // {{{ getPhoneFormat
  }, {
    key: "getPhoneFormat",
    value: function getPhoneFormat(number, e164) {
      if (typeof number === 'undefined' || number === null) {
        return '';
      }
      number = number.replace(/[^0-9+]/g, '');
      if (typeof e164 !== 'undefined' && e164) {
        // e.164 Format
        if (!number[0].includes('+')) {
          number = (number[0].includes('1') ? '+' : '+1') + number;
        }
      } else {
        // Human readable
        if (number.length == 12 && number.substring(0, 2) == '+1') {
          number = number.replace('+1', '');
        }
        if (number.length == 10) {
          var parts = number.match(/^(\d{3})(\d{3})(\d{4})$/);
          number = '(' + parts[1] + ') ' + parts[2] + '-' + parts[3];
        }
      }
      return number;
    }
    // }}}
    // {{{ setShippingAddress
  }, {
    key: "setShippingAddress",
    value: function setShippingAddress(address) {
      var self = this;
      var formattedAddress = this.getAddressFormat(address);
      address.line = formattedAddress.line;
      address.html = formattedAddress.html;
      address.phone = this.getPhoneFormat(address.phone);
      if (typeof address.payment_method_id !== 'undefined') {
        this.setObj('addresses', address, address.id);
      }
      var addressSelector = '[data-address-id="' + address.id + '"]';
      var profileAddressSelector = '#profile .shipping-address' + addressSelector;
      if ($(profileAddressSelector).length === 0) {
        var html = '<div class="shipping-address" data-address-id="' + address.id + '">' + $('.shipping-address[data-template]').html() + '</div>';
        $('[data-shipping-addresses]').append(html);
        $('#address-select .addresses').append('<div class="address" data-address-id="' + address.id + '"><div data-address-html></div><div data-payment-method></div><div class="address-cta btn btn-secondary">Select</div></div>');
      }
      $(addressSelector).find('[data-address-html]').html(address.html);
      $(addressSelector).find('[data-address-line]').html(address.line);
      if (typeof address.payment_method_id !== 'undefined' && address.payment_method_id) {
        $(addressSelector).attr('data-payment-method-id', address.payment_method_id);
        this.setPaymentMethods();
        $(profileAddressSelector).find('.divider, .payment-method').show();
      } else {
        $(profileAddressSelector).find('.divider, .payment-method').hide();
      }
      var num = 0;
      $('.shipping-addresses [data-address-id]').each(function () {
        num++;
        if ($(this).attr('data-address-id') == address.id) {
          $(this).find('[data-shipping-address-num]').text(num);
          return false;
        }
      });
      $(profileAddressSelector).find('.remove-shipping-address').unbind('click').click(function () {
        if (confirm('Are you sure you would like to remove this shipping address?')) {
          self.removeAddress(address.id);
        }
      });
      $(profileAddressSelector).find('.edit-shipping-address').unbind('click').click(function (e) {
        self.editAddress(address);
        self.modalTriggerElement = e.target;
      });
      var addressList = vegamour.getCookie('cp_a', '');
      if (addressList.indexOf(address.id) === -1) {
        vegamour.setCookie('cp_a', addressList + '|' + address.id, 1);
      }
    }
    // }}}
    // {{{ getDefaultShippingAddress
  }, {
    key: "getDefaultShippingAddress",
    value: function getDefaultShippingAddress() {
      var defaultAddressId = $('#profile .shipping-address[data-address-id]').first().attr('data-address-id');
      return this.getObj('addresses', defaultAddressId);
    }
    // }}}
    // {{{ changeAddress
  }, {
    key: "changeAddress",
    value: function changeAddress(subscriptionId, $addressObj) {
      var _this24 = this;
      var addressId = $addressObj.attr('data-address-id');
      var target = '#profile, [data-address-id="' + addressId + '"] [data-address-line]';
      this.wait(target);
      $.get(vegamour.api.buildUrl('/subscription/' + subscriptionId + '/update_address/' + addressId)).done(function (result) {
        _this24.done(target);
        if (result.success) {
          var $sub = _this24.getSubscription(subscriptionId);
          $sub.attr('data-address-id', addressId);
          $sub.find('[data-address-line]').html(_this24.getAddressFormat(_this24.getObj('addresses', addressId)).line);
          _this24.statusMessage('Subscription address has been updated');
        } else {
          _this24.handleError(result.error);
        }
      })["catch"](function (error) {
        _this24.handleError(error);
      });
    }
    // }}}
    // {{{ setAddressSelector
  }, {
    key: "setAddressSelector",
    value: function setAddressSelector(type) {
      var self = this;
      var list = vegamour.country[type + 'List']();
      var $select = $('#address-form select[data-id="' + (type == 'state' ? 'province' : type == 'country' ? 'country_code' : type) + '"]');
      for (var abbr in list) {
        $select.append($('<option>', {
          value: type == 'country' ? abbr : list[abbr],
          text: list[abbr]
        }));
      }
      if (type == 'country') {
        $select.change(function () {
          var v = $(this).val();
          if (v != '') {
            if (v == self.domesticCountry) {
              $('#address-form .province').hide().val('');
              $('#address-form .state').val('').show();
              $('#address-form .province-label').text('State');
            } else {
              $('#address-form .state').hide().val('');
              $('#address-form .province').val('').show();
              $('#address-form .province-label').text('Province');
            }
          }
        });
      }
    }
    // }}}
    // {{{ editAddress
  }, {
    key: "editAddress",
    value: function editAddress(data) {
      var self = this;
      var isAdd = typeof data === 'undefined';
      var isPaymentMethod = false;
      if (isAdd) {
        $('#address-form [data-form-action]').text('Add');
        $('#address-form [data-form-cta-action]').text('Add New');
        $('#address-form [data-id]').val('');
        var geo = vegamour.geolocation.getLocationData();
        if (geo) {
          var intl = geo.country.code !== this.domesticCountry;
          $('#address-form .' + (intl ? 'state' : 'province')).hide();
          $('#address-form .' + (intl ? 'province' : 'state')).val(geo.state).show();
          $('#address-form .province-label').text(intl ? 'Province' : 'State');
          $('#address-form [data-id="country_code"]').val(geo.country.code);
        }
      } else {
        isPaymentMethod = typeof data.payment_type !== 'undefined';
        fieldData = isPaymentMethod ? data.billing_address : data;
        for (var prop in fieldData) {
          var $field = $('#address-form [data-id="' + prop + '"]');
          if ($field.length) {
            $field.val(fieldData[prop]);
          }
          if (prop == 'country_code') {
            $field.trigger('change');
          }
        }
        $('#address-form [data-id="default"]').val(1).prop('checked', isPaymentMethod && data["default"]);
        $('#address-form [data-form-action]').text('Edit');
        $('#address-form [data-form-cta-action]').text('Update');
      }
      if (isPaymentMethod) {
        $('#address-form .address').hide();
        $('#address-form .payment-method').show();
      } else {
        $('#address-form .payment-method').hide();
        $('#address-form .address').show();
        var paymentMethods = this.getObj('paymentMethods');
        if (paymentMethods.length > 0) {
          $('#address-form .payment-method-id').show();
        } else {
          $('#address-form .payment-method-id').hide();
        }
      }
      $('#address-form [data-form-type]').text(isPaymentMethod ? 'Payment Method' : 'Shipping');
      var close = this.modal('#address-form');
      $('#address-form .update-address').unbind('click').click(function () {
        formData = self.processForm($('#address-form .form'));
        if (formData) {
          close();
          var updateCallback = function updateCallback(data) {
            self.statusMessage('Your customer ' + (isPaymentMethod ? 'payment method' : 'shipping') + ' address has been ' + (isAdd ? 'added' : 'updated'));
            if (isPaymentMethod) {
              self.setCustomer(data);
            } else {
              self.setShippingAddress(data);
            }
          };
          if (isPaymentMethod) {
            self.updatePaymentMethod(data.id, formData, updateCallback);
          } else if (isAdd) {
            self.addAddress(self.customer.id, formData, updateCallback);
          } else {
            self.updateAddress(data.id, formData, updateCallback);
          }
        }
      });
    }
    // }}}
    // {{{ addAddress
  }, {
    key: "addAddress",
    value: function addAddress(customerId, data, callback) {
      var _this25 = this;
      var target = '.shipping-addresses';
      this.wait(target);
      var query = vegamour.api.buildUrl('/address/' + customerId + '/add');
      vegamour.debug(query, data);
      $.post(query, data).done(function (result) {
        _this25.done(target);
        if (result.success) {
          vegamour.setCookie('cp_a', vegamour.getCookie('cp_a', '') + '|' + result.data.id, 1);
          if (typeof callback !== 'undefined' && callback) {
            callback(result.data);
          }
        } else {
          _this25.handleError(result.error);
        }
      })["catch"](function (error) {
        _this25.handleError(error);
      });
    }
    // }}}
    // {{{ updateAddress
  }, {
    key: "updateAddress",
    value: function updateAddress(addressId, data, callback) {
      var _this26 = this;
      var target = '.shipping-addresses';
      this.wait(target);
      var query = vegamour.api.buildUrl('/address/' + addressId + '/update');
      vegamour.debug(query, data);
      $.post(query, data).done(function (result) {
        _this26.done(target);
        if (result.success) {
          if (typeof callback !== 'undefined' && callback) {
            callback(result.data);
          }
        } else {
          _this26.handleError(result.error);
        }
      })["catch"](function (error) {
        _this26.handleError(error);
      });
    }
    // }}}
    // {{{ removeAddress
  }, {
    key: "removeAddress",
    value: function removeAddress(addressId, callback) {
      var _this27 = this;
      var addressUse = $('#subscriptions [data-address-id="' + addressId + '"]').length;
      if (addressUse > 0) {
        this.errorMessage('This address is currently being used by ' + addressUse + ' of your active subscriptions', 10);
        return false;
      }
      $address = $('.shipping-address[data-address-id="' + addressId + '"]');
      $address.remove();
      var addressList = vegamour.getCookie('cp_a', '');
      if (addressList.indexOf(addressId) !== -1) {
        vegamour.setCookie('cp_a', addressList.replace('|' + addressId, ''), 1);
      }
      var target = '.shipping-addresses';
      this.wait(target);
      $.get(vegamour.api.buildUrl('/address/' + addressId + '/remove')).done(function (result) {
        _this27.done(target);
        callback(result.data);
      })["catch"](function (error) {
        _this27.handleError(error);
      });
    }
    // }}}
    // {{{ initOrders
  }, {
    key: "initOrders",
    value: function initOrders() {
      var self = this;
      $('.order-link').click(function (e) {
        e.preventDefault();
        $('#order [data-order-name]').text($(this).text());
        self.ajax($(this).attr('href'), self.displayOrder);
      });
      $('.order-cta .reorder').click(function () {
        var items = [];
        $(this).closest('.order').find('.line-items .item').each(function () {
          var handle = $(this).data('handle');
          if (handle) {
            items.push(handle);
          }
        });
        self.reorder(items);
      });
      $('.order-cta .subscribe').click(function () {
        var orderSub = {};
        $(this).closest('.order').find('.line-items .item[data-subscription-variant-id]').each(function () {
          var f = $(this).data('subscription-frequency');
          if (typeof orderSub[f] === 'undefined') {
            orderSub[f] = [];
          }
          orderSub[f][$(this).data('subscription-variant-id')] = {
            'title': $(this).find('.item-title').html(),
            'image': $(this).find('.item-image').html(),
            'quantity': $(this).find('.item-quantity').text(),
            'price': $(this).data('subscription-price'),
            'compare': $(this).data('subscription-compare')
          };
        });
        if ($.isEmptyObject(orderSub)) {
          self.errorMessage('Product(s) not available for subscription');
          return false;
        }
        orderSub = Object.keys(orderSub).sort().reduce(function (acc, key) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, orderSub[key]));
        }, {});
        $('#subscribe .product-cadence-list').html('');
        var icon = $('#subscribe .product-cadence-icon').html();
        var totalPrice = 0;
        var totalCompare = 0;
        var c = 0;
        var data = {};
        for (var cadence in orderSub) {
          $('#subscribe .product-cadence-list').append('<div class="product-cadence" data-cadence="' + cadence + '"><div class="product-cadence-title">' + icon + ' Ships every <span>' + cadence + 's</span></div><div class="products"></div></div>');
          var $cadence = $('#subscribe [data-cadence="' + cadence + '"] .products');
          var cad = cadence.split(' ');
          for (var variantId in orderSub[cadence]) {
            var item = orderSub[cadence][variantId];
            var quantity = parseInt(item.quantity.replace('X', ''));
            $cadence.append('<div class="product" data-variant-id="' + variantId + '" data-quantity="' + quantity + '"><div class="product-image"></div><div class="product-title"></div></div>');
            var $product = $cadence.find('.product[data-variant-id="' + variantId + '"]');
            $product.find('.product-image').html(item.image);
            $product.find('.product-title').html(item.title);
            totalPrice += parseFloat(item.price);
            totalCompare += parseFloat(item.compare);
            data['charge_interval_frequency_' + c] = cad[0];
            data['order_interval_frequency_' + c] = cad[0];
            data['order_interval_unit_' + c] = cad[1];
            data['external_variant_id_' + c] = variantId;
            data['quantity_' + c] = quantity;
            data['next_charge_scheduled_at_' + c] = self.today();
            c++;
          }
        }
        data['currency'] = self.currencyIso;
        var address = self.getDefaultShippingAddress();
        $('#subscribe [data-subscribe-address]').html(address.html).attr('data-address-id', address.id);
        $('#subscribe [data-subscribe-total]').text(self.rcurrency(totalPrice / 100));
        $('#subscribe [data-subscribe-savings]').text(self.rcurrency((totalCompare - totalPrice) / 100));
        var close = self.modal('#subscribe');
        $('#subscribe .subscribe-cta .btn.confirm').unbind('click').click(function () {
          if ($(this).closest('.modal.processing').length) {
            return;
          }
          ;
          self.wait();
          $('#subscribe').addClass('processing');
          var query = vegamour.api.buildUrl('/subscription/' + address.id + '/create_bulk');
          vegamour.debug(query, data);
          $.post(query, data).done(function (result) {
            self.done();
            if (result.success) {
              $('#subscribe').removeClass('processing').addClass('confirmation');
              $('.subscribe-cta .btn.confirmation').unbind('click').click(close);
              self.getSubscriptions(true);
            } else {
              self.handleError(result.error);
              close();
            }
          })["catch"](function (error) {
            self.done();
            self.handleError(error);
            close();
          });
        });
        $('#upgrade .upgrade-cta .btn.confirmation').unbind('click').click(function () {
          close();
        });
      });
    }
    // }}}
    // {{{ displayOrder
  }, {
    key: "displayOrder",
    value: function displayOrder(html) {
      $('#order .order-container').html(html);
      $('.account-section').hide();
      $('[data-section-link="orders"]').parent().parent().find('.active').removeClass('active');
      $('[data-section-link="orders"]').parent().addClass('active');
      $('#order').show();
      window.scrollTo(0, 0);
    }
    // }}}
    // {{{ reorder
  }, {
    key: "reorder",
    value: function reorder(items) {
      if (items.length === 0) {
        this.errorMessage('Order item(s) are not currently avaliable for sale');
      } else {
        this.wait('#orders');
        var num = items.length;
        items.forEach(function (handle, i) {
          setTimeout(function () {
            vegamour.quickView.quickAdd(handle, false, false, false);
          }, i * 2000);
        });
        this.statusMessage('Adding product' + (num > 1 ? 's' : '') + ' to cart and redirecting to checkout', 20);
        setTimeout(function () {
          window.location.href = vegamour.cart.buildCheckoutUrl();
        }, num * 2000 + 1000);
      }
    }
    // }}}
    // {{{ getUpsellProduct
  }, {
    key: "getUpsellProduct",
    value: function getUpsellProduct(subscriptionId, productHandle) {
      var self = this;
      var $sub = self.getSubscription(subscriptionId);
      var $current = $sub.find('.line-items .item:first-of-type');
      var $upsell = $sub.find('.subscription-upsell');
      var colWidth = parseInt($('.row > .content').width()) - 735;
      $upsell.find('.upsell-title').css('width', colWidth + 'px');
      var productCallback = function productCallback(data) {
        if (typeof data['product'] !== 'undefined') {
          var upsellImg = '<img src="' + vegamour.imgSize(data.product.featured_image, '162x') + '" />';
          var variantId = false;
          var price = 0;
          var compare = 0;
          var savings = 0;
          $upsell.attr('data-product-id', data.product.id);
          $upsell.attr('data-subscription-frequency', data.product.selling_plan_groups[0].selling_plans[0].options[0].value.replace('(s)', '').toLowerCase());
          $upsell.find('[data-upsell-title]').text(data.product.title);
          $upsell.find('[data-upsell-image]').html(upsellImg);
          data.product.variants.some(function (variant) {
            if (variant.title.toLowerCase().indexOf('subscription') !== -1) {
              variantId = variant.id;
              price = self.rcurrency(variant.price / 100);
              compare = self.rcurrency(variant.compare_at_price / 100);
              savings = self.rcurrency((variant.compare_at_price - variant.price) / 100);
              return true;
            }
          });
          $upsell.find('[data-upsell-price]').text(price);
          $upsell.find('[data-upsell-compare]').text(compare);
          $upsell.find('[data-upsell-savings]').text(savings);
          if (variantId) {
            $upsell.find('.upsell-cta .btn').unbind('click').click(function () {
              var frequency = $upsell.attr('data-subscription-frequency') || false;
              if ($upsell.attr('data-upgrade')) {
                $('#upgrade [data-product-current-image]').html($current.find('.item-image').html().replace('110x.', '166x.'));
                $('#upgrade [data-product-current-title]').html($current.find('.item-title').html()).remove('.item-quantity');
                $('#upgrade [data-product-upgrade-image]').html(upsellImg);
                $('#upgrade [data-product-upgrade-title]').text(data.product.title);
                $('#upgrade [data-upgrade-price]').text(price);
                $('#upgrade [data-upgrade-compare]').text(compare);
                $('#upgrade [data-upgrade-savings]').text(savings);
                var close = self.modal('#upgrade');
                $('#upgrade .upgrade-cta .btn.confirm').unbind('click').click(function () {
                  if ($(this).closest('.modal.processing').length) {
                    return;
                  }
                  ;
                  self.wait();
                  $('#upgrade').addClass('processing');
                  var qs = '';
                  if (frequency) {
                    var f = frequency.split(' ');
                    var sub = self.getObj('subscriptions', subscriptionId);
                    qs = '&external_variant_id=' + variantId + '&charge_interval_frequency=' + f[0] + '&order_interval_frequency=' + f[0] + '&order_interval_unit=' + f[1] + '&date=' + sub.next_charge_scheduled_at + '&price=true';
                  }
                  var subscriptionSelector = self.getSubscription(subscriptionId, false);
                  var chargeSelector = self.getChargeFromSubscription(subscriptionId, false);
                  var target = subscriptionSelector + ',' + chargeSelector;
                  var query = vegamour.api.buildUrl('/subscription/' + subscriptionId + '/update') + qs;
                  vegamour.debug(query);
                  self.wait(target);
                  $.get(query).done(function (result) {
                    vegamour.debug(result);
                    self.done();
                    if (result.success) {
                      $('#upgrade').removeClass('processing').addClass('confirmation');
                      self.getSubscriptions(true, target);
                    } else {
                      self.handleError(result.error);
                      close();
                    }
                  })["catch"](function (error) {
                    self.done();
                    self.handleError(error);
                    close();
                  });
                });
                $('#upgrade .upgrade-cta .btn.confirmation').unbind('click').click(function () {
                  close();
                });
              } else {
                self.addMore(subscriptionId, data.product.id, variantId, frequency);
                $upsell.slideUp();
              }
            });
          } else {
            $upsell.hide();
          }
        }
      };
      var upsellCallback = function upsellCallback(data) {
        if (typeof data['products'] !== 'undefined' && data['products'].length) {
          subProducts = '';
          $('.subscription-items [data-product-handle]').each(function () {
            subProducts += '|' + $(this).attr('data-product-handle');
          });
          var upsellHandle = false;
          for (i = 0; i < data.products.length; i++) {
            if (subProducts.indexOf(data.products[i]) === -1) {
              upsellHandle = data.products[i];
              break;
            }
          }
          if (!upsellHandle) {
            $upsell.parent().hide();
            return false;
          }
          var pos = upsellHandle.indexOf('|u');
          if (pos !== -1) {
            upsellHandle = upsellHandle.substring(0, pos);
            $upsell.attr('data-upgrade', 'true');
            $upsell.find('[data-upsell-action]').text('Upgrade');
            $upsell.find('.upsell-cta .btn').text('Upgrade My Subscription');
          }
          self.ajax('/products/' + upsellHandle + '?view=json', productCallback);
        } else {
          $upsell.parent().hide();
        }
      };
      var errorCallback = function errorCallback(error) {
        $sub.find('.subscription-upsell-container').hide();
      };
      this.ajax('/products/' + productHandle + '?view=metafields&namespace=recommendation&type=json', upsellCallback, errorCallback);
    }
    // }}}
    // {{{ checkCancelActions()
  }, {
    key: "checkCancelActions",
    value: function checkCancelActions() {
      if (window.location.search.indexOf('subscription_action') === -1) {
        return false;
      }
      var subscriptionId = vegamour.getParam('subscription_id');
      var action = vegamour.getParam('subscription_action');
      var option = vegamour.getParam('option');
      var s = this.getObj('subscriptions', subscriptionId);
      console.log('Incentive action: ' + action);
      if (!subscriptionId || !action || !s) {
        return false;
      }
      if (action == 'skip') {
        this.skip(subscriptionId);
      } else if (action == 'frequency') {
        this.selectCadence(subscriptionId, ['30 days', '60 days', '90 days']);
      } else if (action == 'discount') {
        this.applyIncentiveDiscount(subscriptionId);
      } else if (action == 'interval') {
        if (!option) {
          return false;
        }
        var frequency = option.match(/\d+/g);
        if (!frequency) {
          return false;
        }
        unit = option.replace(frequency, '');
        this.cadence(subscriptionId, frequency, unit);
      }
      this.clearQS();
      return true;
    }
    // }}}
    // {{{ setStoreCurrency()
  }, {
    key: "setStoreCurrency",
    value: function setStoreCurrency(currency) {
      var $selectedCountry = $('.localization-selector .country-selection').first();
      if (currency.length === 0 || $selectedCountry.length === 0 || $selectedCountry.data('currency') == currency) {
        return false;
      }
      var $country = $('.localization-selector .country-selector [data-currency="' + currency + '"]').first();
      if ($country.length > 0) {
        this.statusMessage('Redirecting to local currency (' + currency + ')', 10);
        $country.trigger('click');
      }
    }
    // }}}
    // {{{ modalOpenedAccessibilityAdjustments
  }, {
    key: "modalOpenedAccessibilityAdjustments",
    value: function modalOpenedAccessibilityAdjustments($modalContainer) {
      return false;
      $modalContainer.attr('aria-hidden', false);
      $('body').attr('aria-hidden', true);
      $('body').attr('tabindex', -1);
      $modalContainer.attr('tabindex', 0);
      $modalContainer.focus();
      $modalContainer.children(":first").focus();
      $modalContainer.on("focusout", function (e) {
        if ($.contains($modalContainer[0], e.relatedTarget) == false) {
          $modalContainer.children(":first").focus();
        }
      });
    }
    // }}}
    // {{{ modalClosedAccessibilityAdjustments
  }, {
    key: "modalClosedAccessibilityAdjustments",
    value: function modalClosedAccessibilityAdjustments($modalContainer) {
      return false;
      $modalContainer.attr('aria-hidden', true);
      $('body').attr('aria-hidden', false);
      $('body').attr('tabindex', 0);
      $modalContainer.attr('tabindex', -1);
      $modalContainer.off("focusin", "**");
      var modalTrigger = this.modalTriggerElement;
      if (modalTrigger) modalTrigger.focus();
    }
    // }}}
    // {{{ modal
  }, {
    key: "modal",
    value: function modal(selector, close) {
      var self = this;
      var $selector = $(selector);
      if (typeof close === 'undefined') {
        close = function close() {
          $selector.removeClass('processing, confirmation').hide();
          $('body').removeClass('modal-open');
          self.modalClosedAccessibilityAdjustments($selector);
        };
      }
      $('.site-overlay').unbind('click').click(close);
      $selector.find('.close-button').unbind('click').click(close);
      $('body').addClass('modal-open');
      $selector.removeClass('processing').show();
      self.modalOpenedAccessibilityAdjustments($selector);
      return close;
    }
    // }}}
    // {{{ clearQS
  }, {
    key: "clearQS",
    value: function clearQS() {
      history.pushState({}, document.title, '/account' + (vegamour.isDebug ? '?vdebug' : ''));
    }
    // }}}
    // {{{ wait
  }, {
    key: "wait",
    value: function wait(target) {
      $('body').css('cursor', 'progress');
      if (typeof target !== 'undefined') {
        $(target).addClass('disabled').find('.loading').show();
      }
    }
    // }}}
    // {{{ done
  }, {
    key: "done",
    value: function done(target) {
      if (typeof target !== 'undefined') {
        $(target).removeClass('disabled').find('.loading').hide();
      }
      $('body').css('cursor', 'default');
    }
    // }}}
    // {{{ getObj
  }, {
    key: "getObj",
    value: function getObj(module, id) {
      var data = false;
      if (!this[module].length) {
        return data;
      }
      if (typeof id !== 'undefined') {
        this[module].some(function (s) {
          if (s.id == id) {
            data = s;
            return true;
          }
        });
      } else {
        data = this[module];
      }
      return data;
    }
    // }}}
    // {{{ setObj
  }, {
    key: "setObj",
    value: function setObj(module, data, id) {
      var _this28 = this;
      var set = false;
      if (typeof id !== 'undefined') {
        if (id) {
          var len = this[module].length;
          if (len > 0) {
            this[module].some(function (s, i) {
              if (s.id == id) {
                _this28[module][i] = data;
                set = true;
                return true;
              }
            });
          }
          if (!set) {
            this[module][len] = {
              'id': id
            };
            set = true;
          }
        }
      } else {
        this[module] = data;
        set = true;
      }
      return set;
    }
    // }}}
    // {{{ currency
  }, {
    key: "currency",
    value: function currency(amount, _currency) {
      _currency = typeof _currency === 'undefined' || !_currency ? this.currencySign : _currency;
      amount = amount * 1 == 0 ? 'FREE' : _currency + parseFloat(amount).toFixed(2);
      return amount;
    }
    // }}}
    // {{{ rcurrency
  }, {
    key: "rcurrency",
    value: function rcurrency(amount, currency) {
      currency = typeof currency === 'undefined' || !currency ? this.currencySign : currency;
      amount = amount * 1 == 0 ? 'FREE' : currency + parseInt(amount);
      return amount;
    }
    // }}}
    // {{{ date
  }, {
    key: "date",
    value: function date(_date, format) {
      if (!_date) {
        return '';
      }
      if (_typeof(_date) !== 'object') {
        _date = moment(_date);
      }
      if (typeof format === 'undefined') {
        format = 'MMMM Do, YYYY';
      }
      return _date.format(format);
    }
    // }}}
    // {{{ today
  }, {
    key: "today",
    value: function today() {
      var today = new Date();
      return today.toISOString().split('T')[0];
    }
    // }}}
    // {{{ ajax
  }, {
    key: "ajax",
    value: function ajax(url, callback, errorCallback) {
      var _this29 = this;
      $.get(url).done(function (result) {
        if (url.indexOf('json') !== -1) {
          result = JSON.parse(result);
        }
        if (typeof callback !== 'undefined') {
          callback(result);
        }
      })["catch"](function (error) {
        if (typeof errorCallback !== 'undefined') {
          errorCallback(error);
        } else {
          _this29.handleError(error);
        }
      });
    }
    // }}}
    // {{{ initQuickActions
  }, {
    key: "initQuickActions",
    value: function initQuickActions() {
      var params = new URLSearchParams(window.location.search);
      var action = params.get('action');
      var hash = params.get('hash');
      var subscriptionId = params.get('subscription_id');
      var variantId = params.get('variant_id');
      var discountCode = params.get('discount_code');
      var showError = function showError() {
        $('.quick-actions-processing').hide();
        $('.quick-actions-error').css('display', 'flex');
        document.title = $('.quick-actions-error h2').text();
      };
      if (!action || !hash || !subscriptionId || !variantId) {
        showError();
        return false;
      }
      document.title = $('.quick-actions-processing h2').text();
      var query = window.vegamourOptions.backend.api + '/subscription/' + action + '?hash=' + hash + '&subscription_id=' + subscriptionId + '&variant_id=' + variantId;
      if (discountCode) {
        query += '&discount_code=' + discountCode;
      }
      vegamour.debug(query);
      $.get(query).done(function (result) {
        vegamour.debug(result);
        if (result.success) {
          if (action == 'add') {
            $('.quick-actions-success h1').text($('.quick-actions-success h1').data('add'));
          }
          if (typeof result.data.shopify_product !== 'undefined') {
            $('.quick-actions-success-product-image').html('<img src="' + vegamour.imgSize(result.data.shopify_product.image.src, '150x') + '" />');
            $('.quick-actions-success-product-title').html(result.data.shopify_product.title);
          }
          var date = result.data.next_charge_scheduled_at.split('-');
          $('.quick-actions-success-ship-date').html('Ships on ' + date[1] + '/' + date[2] + '/' + date[0]);
          $('.quick-actions-processing').hide();
          $('.quick-actions-success').css('display', 'flex');
          document.title = $('.quick-actions-success h1').text();
        } else {
          if (result.error.indexOf('applied') !== -1) {
            $('.quick-actions-error-message').text(result.error);
          }
          showError();
          return false;
        }
      })["catch"](function (error) {
        showError();
        return false;
      });
      return true;
    }
    // }}}
    // {{{ popup
  }, {
    key: "popup",
    value: function popup(url, title, w, h) {
      var left = screen.width / 2 - w / 2;
      var top = screen.height / 2 - h / 2;
      return window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
    }
    // }}}
  }]);
  return VegamourAccount;
}(Events);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourBlogBanners = /*#__PURE__*/function () {
  function VegamourBlogBanners() {
    var _this = this;
    _classCallCheck(this, VegamourBlogBanners);
    $(document).ready(function () {
      _this.init();
    });
  }
  _createClass(VegamourBlogBanners, [{
    key: "init",
    value: function init() {
      if ($('#shopify-section-template-article').length === 0) {
        return;
      }
      this.initBlogBanners();
      this.initBoughtTogether();
      this.initArticlesCta();
      this.initProductImageCta();
    }
  }, {
    key: "initBlogBanners",
    value: function initBlogBanners() {
      if ($("#test-css").length > 0) {
        $("#test-css").remove();
      } else {
        return;
      }
      var banner = $('.blog-banner-image');
      $(banner).each(function (index) {
        var _this2 = this;
        var insertBanner = function insertBanner(selector, before) {
          var isVisible = $(selector).length > 0 ? $(_this2).show() : $(_this2).hide();
          return before ? $(_this2).insertBefore(selector).addClass('start-banner') : $(_this2).insertAfter(selector).addClass('end-banner');
        };
        switch (index) {
          case 0:
            insertBanner('.section-content:first', true);
            break;
          case 1:
            insertBanner('.rte:last', false);
            break;
          case 2:
            insertBanner('.blog-banner-custom', false);
            break;
        }
      });
    }
  }, {
    key: "initProductImageCta",
    value: function initProductImageCta() {
      var pattern = '/products/';
      var starRatings = [];
      $('.article-body .rte a').each(function () {
        var _this3 = this;
        var link = $(this).attr('href').split('?')[0];
        if (link.indexOf('/products/') !== -1 && $(this).find('img').length === 1 && $(this).closest('.product-bought-together').length === 0) {
          $.getJSON(link + '.js').done(function (product) {
            var round = function round(p) {
              return window.vegamourOptions.currency.sign + Math.round(p / 100);
            };

            $(_this3).parent().addClass('blog-product-cta');

            var price = product.price_min;
            product.variants.some(function (v) {
              if (v.title.toLowerCase().indexOf('subscription') !== -1) {
                price = v.price;
                return true;
              }
            });

            console.log('[Okendo Debug] 1. Product Fetched:', product.id, product.title);

            var htmlString = '<div class="product-image-cta" data-id="' + product.id + '"><div class="product-info"><div class="product-title"><a href="' + $(_this3).attr('href') + '">' + product.title + '</a></div><div class="product-price"><div class="okendo okendo-stars"><div data-oke-star-rating data-oke-reviews-product-id="shopify-' + product.id + '"></div></div>' + (product.compare_at_price_max > product.price_min ? '<div class="compare">' + round(product.compare_at_price_max) + '</div>' : '') + '<div class="price">' + round(price) + '</div></div></div><div class="product-cta"><a data-handle="' + product.handle + '" data-id="' + product.id + '" href="javascript: void(0);" class="js-quick-view btn btn-primary">Add To Bag</a></div></div>';

            var $insertedContent = $(htmlString);
            $(_this3).after($insertedContent);
            vegamour.quickView.initQuickView();

            var targetStarDiv = $insertedContent.find('[data-oke-star-rating]')[0];
            console.log('[Okendo Debug] 2. Target DOM Element Inserted:', targetStarDiv);

            var initOkendoWidget = function() {
              if (!targetStarDiv) {
                console.error('[Okendo Debug] ERROR: Target DOM not found for product:', product.id);
                return;
              }

              console.log('[Okendo Debug] 3. Attempting to initialize Okendo for:', product.id);

              if (window.okeWidgetApi && typeof window.okeWidgetApi.initWidget === 'function') {
                window.okeWidgetApi.initWidget(targetStarDiv);
                console.log('[Okendo Debug] 4. SUCCESS: initWidget called. CSS 렌더링 상태를 확인하라.');
              } else if (window.okeWidgetApi && typeof window.okeWidgetApi.initAll === 'function') {
                window.okeWidgetApi.initAll();
                console.warn('[Okendo Debug] 4. WARNING: initAll called as fallback.');
              } else {
                console.error('[Okendo Debug] ERROR: window.okeWidgetApi is missing entirely.');
              }
            };

            if (window.okeWidgetApi) {
              console.log('[Okendo Debug] API ready immediately.');
              initOkendoWidget();
            } else {
              console.log('[Okendo Debug] API not ready, binding okendo-widgets-ready event.');
              document.addEventListener('okendo-widgets-ready', initOkendoWidget, { once: true });
            }

          }).catch(function (error) {
            console.error('[Okendo Debug] ERROR: Product fetch failed:', error);
          });
        }
      });
    }
  }, {
    key: "initBoughtTogether",
    value: function initBoughtTogether() {
      if (!vegamour.isMobile()) {
        return;
      }
      var $slick2 = $('.product-bought-together-items--blog');
      $slick2.slick({
        arrows: false,
        variableWidth: true,
        infinite: false
      });
      VegamourImage.resizeImages();
    }
  }, {
    key: "initArticlesCta",
    value: function initArticlesCta() {
      var ctaPositionId = "#heading-3";
      var ctaSelector = ".js-article-cta";
      $("h2:not([id]),h3:not([id])").attr("id", function (i, attr) {
        return "heading-" + i;
      });
      $(ctaSelector).insertBefore(ctaPositionId);
    }
  }]);
  return VegamourBlogBanners;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VegamourProductRecharge = /*#__PURE__*/function (_Events) {
  _inherits(VegamourProductRecharge, _Events);
  var _super = _createSuper(VegamourProductRecharge);
  function VegamourProductRecharge(product) {
    var _this;
    _classCallCheck(this, VegamourProductRecharge);
    _this = _super.call(this);
    _this.product = product;
    _this.activeVariant = null;
    _this.decimals = window.vegamourOptions.currency.round ? 0 : 2;
    _this.isClone = false;
    return _this;
  }
  _createClass(VegamourProductRecharge, [{
    key: "clone",
    value: function clone() {
      var recharge = new VegamourProductRecharge(this.product);
      recharge.isClone = true;
      return recharge;
    }
  }, {
    key: "div",
    value: function div() {
      return $('[data-recharge-widget-product-id="' + this.product.id + '"]');
    }
  }, {
    key: "isOneTimeSelected",
    value: function isOneTimeSelected() {
      return this.div().find('[data-recharge-option-input-one-time]:checked').length > 0;
    }
  }, {
    key: "isSubscriptionSelected",
    value: function isSubscriptionSelected() {
      return this.div().find('[data-recharge-option-input-subscription]:checked').length > 0;
    }
  }, {
    key: "getProductId",
    value: function getProductId() {
      return this.product.id;
    }
  }, {
    key: "getCurrentVariantId",
    value: function getCurrentVariantId() {
      var variant = this.getCurrentVariant();
      if (!variant) {
        return null;
      }
      if (this.isSubscriptionSelected() && variant.subscription) {
        return variant.subscription.id;
      }
      return variant.oneTime.id;
    }
  }, {
    key: "getCurrentVariantId2",
    value: function getCurrentVariantId2(subscription) {
      var variant = this.getCurrentVariant();
      if (!variant) {
        return null;
      }
      if (subscription) {
        return variant.subscription.id;
      }
      return variant.oneTime.id;
    }
  }, {
    key: "getVariantById",
    value: function getVariantById(id) {
      var result = null;
      this.getProcessedOneTimeVariants().forEach(function (variant) {
        if (!result && variant.oneTime.id == id) {
          result = variant;
        }
      });
      return result;
    }
  }, {
    key: "getVariantByIdOldWay",
    value: function getVariantByIdOldWay(id) {
      var result = null;
      this.getProcessedOneTimeVariants().forEach(function (variant) {
        if (!result && variant.oneTime.id == id) {
          result = variant;
        }
      });
      return result;
    }
  }, {
    key: "setActiveVariant",
    value: function setActiveVariant(id) {
      this.activeVariant = id;
      return this;
    }
  }, {
    key: "getCurrentVariant",
    value: function getCurrentVariant() {
      var _this2 = this;
      if (this.isMultiPicker()) {
        if (this.activeVariant) {
          return this.getVariantById(this.activeVariant);
        }
        var variants = this.getProcessedOneTimeVariants();
        if (variants.length > 0) {
          return variants[0];
        }
        return null;
      }
      var result = null;
      this.product.variants.forEach(function (variant) {
        if (!result && !_this2.isSubscription(variant.title)) {
          var subscriptionVersion = _this2.getSubscriptionVersion();
          if (subscriptionVersion && !subscriptionVersion.hidden) {
            result = {
              oneTime: variant,
              subscription: subscriptionVersion
            };
          }
        }
      });
      if (!result) {
        this.product.variants.forEach(function (variant) {
          if (!result && !variant.hidden) {
            result = {
              oneTime: variant,
              subscription: null
            };
          }
        });
      }
      if (result) {
        return this.getProcessedOneTimeVariant(result);
      }
      return result;
    }
  }, {
    key: "currentVariantHasSubscription",
    value: function currentVariantHasSubscription() {
      var variant = this.getCurrentVariant();
      return variant && variant.subscription !== null;
    }
  }, {
    key: "isSubscription",
    value: function isSubscription(title) {
      title = title.toLowerCase();
      return title.indexOf('subscription') !== -1 || title.indexOf(window.vegamourTranslations.products.subscription_widget.subscription.toLowerCase().replace(':', '')) !== -1;
    }
  }, {
    key: "getSubscriptionVersion",
    value: function getSubscriptionVersion() {
      var _this3 = this;
      var result = null;
      this.product.variants.forEach(function (variant) {
        if (_this3.isSubscription(variant.title)) {
          result = variant;
        }
      });
      return result;
    }
  }, {
    key: "init",
    value: function init() {
      var _this4 = this;
      this.div().find('[data-recharge-option-input]').on('click, change', function (e) {
        _this4.div().find('.subscription-widget-option').removeClass('active');
        if (_this4.div().find('[data-recharge-option-input]:checked').val() === 'subscription') {
          _this4.div().find('[data-recharge-option-subscription]').addClass('active');
        } else {
          _this4.div().find('[data-recharge-option-one-time]').addClass('active');
        }
        if (vegamour.product) {
          vegamour.product.refreshBarV2();
        }
        if ($('klarna-placement').length) {
          var price = _this4.div().find('.active .subscription-widget-price-value').text().replace(/\D/g, '');
          if (price.length > 0) {
            $('klarna-placement').attr('data-purchase-amount', price);
            window.Klarna.OnsiteMessaging.refresh();
          }
        }
      });
      this.initEvents();
      this.initSwitch();
      this.div().data('recharge', this);
      var defaultOption = this.product["default"];
      if (vegamour.getParam('option')) {
        defaultOption = vegamour.getParam('option');
      }
      if (defaultOption === 'subscription' && this.currentVariantHasSubscription()) {
        this.switchToSubscription();
      } else {
        this.switchToOneTime();
      }
      var currentVariant = this.getCurrentVariant();
      if (typeof $('.variant-picker-thumb').first().data('variant-id') !== 'undefined') {
        this.product.defaultVariant = $('.variant-picker-thumb').first().data('variant-id');
      }
      if (this.product.defaultVariant) {
        var defaultVariant = this.getVariantById(this.product.defaultVariant);
        if (defaultVariant) {
          currentVariant = defaultVariant;
        }
      }
      if (vegamour.getParam('variant')) {
        var selectedVariant = this.getVariantById(vegamour.getParam('variant'));
        if (selectedVariant) {
          currentVariant = selectedVariant;
        }
      }
      if (currentVariant) {
        this.activeVariant = currentVariant.oneTime.id;
        this.emit('variantChange');
      }
      this.refresh();
    }
  }, {
    key: "initEvents",
    value: function initEvents() {
      var _this5 = this;
      this.on('variantChange', function () {
        if (!_this5.activeVariant || !vegamour.product) {
          return;
        }
        var currentVariant = _this5.getCurrentVariant();
        if (currentVariant) {
          vegamour.product.setCurrentVariantById(currentVariant.oneTime.id);
          vegamour.product.refreshBarV2();
        }
      });
      this.on('userVariantChange', function () {
        var currentVariant = _this5.getCurrentVariant();
        if (!currentVariant) {
          return;
        }
        var url = vegamour.appendParamsToLocation({
          variant: currentVariant.oneTime.id
        });
        window.history.replaceState({
          path: url
        }, '', url);
      });
      this.on('productInitialized', function () {
        var currentVariant = _this5.getCurrentVariant();
        if (currentVariant) {
          vegamour.product.setCurrentVariantById(currentVariant.oneTime.id);
          vegamour.product.refreshBarV2();
        }
        _this5.refresh();
      });
      vegamour.on('shippingRatesReady, easylocationReady, geolocationReady', function () {
        _this5.refresh();
      });
    }
  }, {
    key: "isVariantOneTime",
    value: function isVariantOneTime(variant) {
      var isOneTime = false;
      variant.options.forEach(function (option) {
        if (option.toLowerCase().indexOf('one-time') > -1 || option.toLowerCase().indexOf('order') > -1) {
          isOneTime = true;
        }
      });
      return isOneTime;
    }
  }, {
    key: "getVariantSubscriptionFromOneTime",
    value: function getVariantSubscriptionFromOneTime(oneTime) {
      var result = null;
      var options = oneTime.options;
      this.product.variants.forEach(function (variant) {
        if (result) {
          return;
        }
        var subscriptionFound = false;
        var variantFound = true;
        var optionsFound = 0;
        variant.options.forEach(function (option) {
          if (option.toLowerCase().indexOf('one-time') > -1 || option.toLowerCase().indexOf('order') > -1) {
            variantFound = false;
          } else if (option.toLowerCase().indexOf('subscription') > -1) {
            subscriptionFound = true;
            optionsFound++;
          } else {
            var found = false;
            options.forEach(function (opt) {
              if (option.toLowerCase().trim() === opt.toLowerCase().trim()) {
                found = true;
                optionsFound++;
              }
            });
            if (!found) {
              variantFound = false;
            }
          }
        });
        if (variantFound && subscriptionFound && optionsFound === options.length) {
          result = variant;
        }
      });
      return result;
    }
  }, {
    key: "getVariantSubscriptionFromOneTimeOldVersion",
    value: function getVariantSubscriptionFromOneTimeOldVersion(oneTime) {
      if (!oneTime.options || oneTime.options.length === 0 || oneTime.options[0].toLowerCase().indexOf('- one-time') === -1) {
        return null;
      }
      var subscriptionName = oneTime.options[0].substr(0, oneTime.options[0].toLowerCase().indexOf('- one-time')).trim();
      var result = null;
      this.product.variants.forEach(function (variant) {
        if (result) {
          return;
        }
        var option = variant.options[0];
        if (option.toLowerCase().indexOf('- one-time') === -1 && option.toLowerCase().indexOf(subscriptionName.toLowerCase()) > -1) {
          result = variant;
        }
      });
      return result;
    }
  }, {
    key: "getOneTimeVariants",
    value: function getOneTimeVariants() {
      var _this6 = this;
      var result = [];
      this.product.variants.forEach(function (variant) {
        if (_this6.isVariantOneTime(variant)) {
          var subscription = _this6.getVariantSubscriptionFromOneTime(variant);
          if (!subscription) {
            subscription = _this6.getVariantSubscriptionFromOneTimeOldVersion(variant);
          }
          if (!subscription && !variant.hidden || subscription && !subscription.hidden) {
            result.push({
              oneTime: variant,
              subscription: subscription
            });
          }
        }
      });
      if (result.length === 0) {
        return this.getOneTimeVariantsOldVersion();
      }
      return result;
    }
  }, {
    key: "getOneTimeVariantsOldVersion",
    value: function getOneTimeVariantsOldVersion() {
      var result = [];
      this.product.variants.forEach(function (variant) {
        if (!variant.hidden) {
          result.push({
            oneTime: variant,
            subscription: null
          });
        }
      });
      return result;
    }
  }, {
    key: "getProcessedOneTimeVariants",
    value: function getProcessedOneTimeVariants() {
      var _this7 = this;
      var result = [];
      this.getOneTimeVariants().forEach(function (variant) {
        result.push(_this7.getProcessedOneTimeVariant(variant));
      });
      return result;
    }
  }, {
    key: "getProcessedOneTimeVariant",
    value: function getProcessedOneTimeVariant(variant) {
      var oneTime = Object.assign({}, variant.oneTime);
      var subscription = variant.subscription ? Object.assign({}, variant.subscription) : null;
      var productMetafield = variant.oneTime.metafields.product_page.product;
      var title = oneTime.title;
      var description = false;
      var oneTimeDiscountPercentage = null;
      var oneTimeCustomPrice = this.product.custom.oneTime.price ? parseFloat(this.product.custom.oneTime.price) : null;
      var oneTimeCustomDiscount = this.product.custom.oneTime.discount ? parseFloat(this.product.custom.oneTime.discount) : null;
      if (oneTime.layout && oneTime.layout.label) {
        title = oneTime.layout.label;
      }
      if (oneTime.layout && oneTime.layout.description) {
        description = oneTime.layout.description;
      }
      if (variant.oneTime.comparePrice) {
        oneTimeCustomPrice = parseFloat(variant.oneTime.comparePrice);
      }
      if (productMetafield && productMetafield.custom && productMetafield.custom.price) {
        oneTimeCustomPrice = parseFloat(productMetafield.custom.price);
      }
      if (productMetafield && productMetafield.custom && productMetafield.custom.discount) {
        oneTimeCustomDiscount = parseFloat(productMetafield.custom.discount);
      }
      if (oneTimeCustomPrice && !isNaN(oneTimeCustomPrice)) {
        oneTimeDiscountPercentage = (1 - parseFloat(variant.oneTime.price) / oneTimeCustomPrice) * 100;
      }
      if (oneTimeCustomDiscount && !isNaN(oneTimeCustomDiscount)) {
        oneTimeDiscountPercentage = oneTimeCustomDiscount;
      }
      oneTime.processed = {
        title: title,
        description: description,
        discount: {
          price: oneTimeCustomPrice,
          discount: oneTimeCustomDiscount,
          percentage: oneTimeDiscountPercentage
        }
      };
      if (subscription) {
        var isSubscriptionCustomPercentage = true;
        var subscriptionDiscountPercentage = (1 - parseFloat(variant.subscription.price) / parseFloat(variant.oneTime.price)) * 100;
        if (this.product.custom.oneTime.price) {
          isSubscriptionCustomPercentage = true;
          subscriptionDiscountPercentage = (1 - parseFloat(variant.subscription.price) / parseFloat(this.product.custom.oneTime.price)) * 100;
        }
        if (oneTimeCustomPrice) {
          isSubscriptionCustomPercentage = true;
          subscriptionDiscountPercentage = (1 - parseFloat(variant.subscription.price) / oneTimeCustomPrice) * 100;
        }
        if (this.product.custom.subscription.discount) {
          isSubscriptionCustomPercentage = true;
          subscriptionDiscountPercentage = this.product.custom.subscription.discount;
        }
        if (productMetafield && productMetafield.custom && productMetafield.custom.subscription_discount) {
          subscriptionDiscountPercentage = productMetafield.custom.subscription_discount;
        }
        subscription.processed = {
          discount: {
            price: parseFloat(oneTimeCustomPrice ? oneTimeCustomPrice : variant.oneTime.price),
            percentage: subscriptionDiscountPercentage,
            percentageIsCustom: isSubscriptionCustomPercentage
          },
          shipping: {
            unit: {
              original: this.getUnit(variant),
              formatted: this.getUnitString(variant)
            },
            frequency: {
              original: this.getFrequency(variant),
              formatted: this.getFrequencyString(variant)
            }
          }
        };
      }
      return {
        oneTime: oneTime,
        subscription: subscription
      };
    }
  }, {
    key: "isMultiPicker",
    value: function isMultiPicker() {
      if (typeof this._isMultipicker !== 'undefined') {
        return this._isMultipicker;
      }
      this._isMultipicker = this.getOneTimeVariants().length > 1;
      return this._isMultipicker;
    }
  }, {
    key: "initSwitch",
    value: function initSwitch() {
      if (!this.isMultiPicker()) {
        return;
      }
      switch (this.product.layout.type) {
        case 'buttons':
          this.initSwitchButtons();
          break;
        case 'thumbs':
          this.initSwitchThumbs();
          break;
        default:
          this.initSwitchThumbs();
        // this.initSwitchSelect();
      }
      $('body').addClass('has-multipicker');
    }
  }, {
    key: "initSwitchButtons",
    value: function initSwitchButtons() {
      var _this8 = this;
      var firstVariantId = null;
      var $wrap = $('<div class="product-section-variant-picker-buttons"></div>');
      if (this.product.layout.label) {
        $wrap.append('<div class="variant-picker-title">' + this.product.layout.label + '</div>');
      }
      $wrap.append('<div class="variant-picker-buttons"></div>');
      this.getProcessedOneTimeVariants().forEach(function (variant) {
        var $button = $('<a class="variant-picker-button" data-variant-id="' + variant.oneTime.id + '"></a>');
        if (variant.oneTime.layout.label3) {
          $button.addClass('has-header');
          $button.append('<span class="variant-picker-button-header">' + variant.oneTime.layout.label3 + '</span>');
        }
        $button.append('<span class="variant-picker-button-body"><span class="variant-picker-button-label">' + variant.oneTime.processed.title + '</span></span>');
        if (variant.oneTime.layout.label2) {
          $button.find('.variant-picker-button-body').append('<span class="variant-picker-button-footer">' + variant.oneTime.layout.label2 + '</span>');
        }
        if (firstVariantId === null) {
          firstVariantId = variant.oneTime.id;
          $button.addClass('active');
        }
        $wrap.find('.variant-picker-buttons').append($button);
        $button.on('click', function (e) {
          e.preventDefault();
          _this8.div().find('[data-recharge-variant-picker]').find('.variant-picker-button').removeClass('active');
          $button.addClass('active');
          _this8.activeVariant = variant.oneTime.id;
          _this8.emit('variantChange');
          _this8.emit('userVariantChange');
          _this8.refresh();
        });
      });
      this.div().find('[data-recharge-variant-picker]').append($wrap);
      this.activeVariant = firstVariantId;
      this.emit('variantChange');
    }
  }, {
    key: "initSwitchThumbs",
    value: function initSwitchThumbs() {
      var _this9 = this;
      var firstVariantId = null;
      var $wrap = $('<div class="product-section-variant-picker-thumbs"></div>');

      // 조건문을 지우고, 라벨이 없으면 기본값('Size: ')을 넣고 텍스트 컨테이너를 항상 생성합니다.
      var labelText = this.product.layout.label ? this.product.layout.label + ': ' : 'Size: ';
      $wrap.append('<div class="variant-picker-title">' + labelText + '<span class="variant-picker-thumb-selected-qv"></span></div>');

      $wrap.append('<div class="variant-picker-thumbs"></div>');

      this.getProcessedOneTimeVariants().forEach(function (variant) {
        var $button = $('<a class="variant-picker-thumb" data-variant-id="' + variant.oneTime.id + '" data-thumb="' + variant.oneTime.options[1] + '"></a>');

        /*            if (variant.oneTime.layout.thumb_url) {
                        $button.append('<span class="variant-picker-thumb-img"><img src="'+ variant.oneTime.layout.thumb_url + '" class="img-fluid variant-picker-thumb-icon"/></span>');
                    }*/

        if (variant.oneTime.layout.label3) {
          $button.addClass('has-header');
          $button.append('<span class="variant-picker-thumb-header">' + variant.oneTime.layout.label3 + '</span>');
        }

        console.log('log', variant)

        // 1. 이미지 URL 설정
        var imageUrl = variant.oneTime.layout.thumb_url || variant.oneTime.image;
        var imgHtml = imageUrl ? '<img src="' + imageUrl + '" class="img-fluid variant-picker-thumb-icon"/>' : '';

        // 2. 타이틀 텍스트 설정

        // Single || Jumbo
        // Full || Travel

        const processed_title = variant.oneTime.processed.title;

        // 여기서 "One-Time / "을 제거합니다.
        let title = processed_title.replace('One-Time / ', '');

        let badgeHtml = '';
        if (title.includes('Single') || title.includes('Jumbo')) {
          title = title.includes('Single') ? '1-Month Supply' : '3-Month Supply';
          // 3. BEST SELLER 배지 (3-Month 옵션에만 렌더링)
          badgeHtml = title.includes('3-Month') ? '<div class="best-seller-badge">BEST SELLER</div>' : '';
        }

        // 4. [구조 변경] 텍스트 영역 (타이틀 + 가격)을 따로 묶음
        var footerText = variant.oneTime.layout.label2 ? '<span class="variant-picker-thumb-footer">' + variant.oneTime.layout.label2 + '</span>' : '';
        var textWrapper = '<span class="variant-picker-thumb-text"><span class="variant-picker-thumb-label">' + title + '</span>' + footerText + '</span>';

        // 5. [구조 변경] 이미지 영역을 따로 묶음
        var imgWrapper = '<span class="variant-picker-thumb-img">' + imgHtml + '</span>';

        // 6. 버튼에 최종 HTML 삽입 (배지 + 바디[이미지 + 텍스트])
        $button.append(badgeHtml + '<span class="variant-picker-thumb-body">' + imgWrapper + textWrapper + '</span>');

        // 첫 번째 Variant 초기화 처리
        if (firstVariantId === null) {
          firstVariantId = variant.oneTime.id;
          $button.addClass('active');
          // 초기 로드 시 선택된 Variant 텍스트 표시
          setTimeout(() => {
            let text = variant.oneTime.processed.title;
            // 1. "One-Time / " 문자열 제거
            text = text.replace('One-Time / ', '');

            if (text.includes(' / ')) {
              text = text.split(' / ')[1];
            }

            $('.variant-picker-thumb-selected-qv').text(text);
          }, 0);
        }

        $wrap.find('.variant-picker-thumbs').append($button);

        if (variant.oneTime.layout.description) {
          $wrap.append('<div class="variant-picker-description variant-picker-description-' + variant.oneTime.id + '">' + variant.oneTime.layout.description + '</div>');
        }

        $button.on('click', function (e) {
          e.preventDefault();
          _this9.div().find('[data-recharge-variant-picker]').find('.variant-picker-thumb').removeClass('active');
          $button.addClass('active');
          _this9.activeVariant = variant.oneTime.id;

          // [추가된 부분] 사용자가 옵션을 클릭하면 위의 타이틀 옆에 선택한 옵션 이름을 띄워줌
          let text = variant.oneTime.processed.title;
          if (text.includes(' / ')) {
            text = text.split(' / ')[1];
          }
          $('.variant-picker-thumb-selected-qv').text(text);

          $('.variant-picker-description').removeClass('active');
          $('.variant-picker-description-' + e.currentTarget.dataset.variantId).addClass('active');
          _this9.emit('variantChange');
          _this9.emit('userVariantChange');
          _this9.refresh();
        });
      });
      this.div().find('[data-recharge-variant-picker]').append($wrap);
      this.activeVariant = firstVariantId;
      $('.variant-picker-description-' + firstVariantId).addClass('active');
      this.emit('variantChange');
    }
  }, {
    key: "initSwitchSelect",
    value: function initSwitchSelect() {
      var _this10 = this;
      var firstVariantId = null;
      var $wrap = $('<div class="product-section-variant-picker-select"></div>');
      if (this.product.layout.label) {
        $wrap.append('<div class="variant-picker-title">' + this.product.layout.label + '</div>');
      }
      $wrap.append('<div class="vegamour-select-v2"></div>');
      var $select = $('<select></select>');
      this.getProcessedOneTimeVariants().forEach(function (variant) {
        if (firstVariantId === null) {
          firstVariantId = variant.oneTime.id;
        }
        $select.append('<option value="' + variant.oneTime.id + '">' + variant.oneTime.processed.title + '</option>');
      });
      $select.on('change', function (e) {
        _this10.activeVariant = $select.val();
        _this10.emit('variantChange');
        _this10.emit('userVariantChange');
        _this10.refresh();
      });
      $wrap.find('.vegamour-select-v2').append($select);
      this.div().find('[data-recharge-variant-picker]').append($wrap);
      vegamour.renderSelects();
      this.activeVariant = firstVariantId;
      this.emit('variantChange');
    }
  }, {
    key: "getSubscriptionVariantWithOptions",
    value: function getSubscriptionVariantWithOptions(options) {
      var result = null;
      this.product.variants.forEach(function (variant) {
        if (result) {
          return;
        }
        var variantFound = true;
        var optionsFound = 0;
        variant.options.forEach(function (option) {
          if (option.toLowerCase().indexOf('subscription') > -1) {
            optionsFound++;
          } else {
            var found = false;
            options.forEach(function (opt) {
              if (option.toLowerCase().trim() === opt.toLowerCase().trim()) {
                found = true;
                optionsFound++;
              }
            });
            if (!found) {
              variantFound = false;
            }
          }
        });
        if (variantFound && optionsFound === options.length) {
          result = variant;
        }
      });
      return result;
    }
  }, {
    key: "switchToOneTime",
    value: function switchToOneTime() {
      this.div().find('[data-recharge-option-input-one-time]').click();
      $('#product_bar_is_subscription').prop('checked', false);
    }
  }, {
    key: "switchToSubscription",
    value: function switchToSubscription() {
      this.div().find('[data-recharge-option-input-subscription]').click();
      $('#product_bar_is_subscription').prop('checked', true);
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var variant = this.getCurrentVariant();
      if (!variant) {
        return;
      }
      this.refreshOneTime(variant);
      this.refreshSubscription(variant);
      if (this.product.callout.show && this.currentVariantHasSubscription()) {
        this.div().find('[data-recharge-callout]').show();
        this.div().find('[data-recharge-callout-text]').html(this.product.callout.text);
      } else {
        this.div().find('[data-recharge-callout]').hide();
      }
      if (variant.oneTime.image && $('.product-gallery-images').length > 0) {
        $('.product-gallery-images').find('.product-gallery-image').each(function (i, image) {
          var $image = $(image);
          var src = $image.find('img').attr('src');
          if (!src) {
            src = $image.find('img').attr('data-src');
          }
          if (src && src.indexOf(variant.oneTime.image) > -1 && $('.product-gallery-images').hasClass('initialized')) {
            $('.product-gallery-images').slick('slickGoTo', 0);
          }
        });
      }
      if (this.isMultiPicker()) {
        this.refreshMultiPicker(variant);
      }
    }
  }, {
    key: "refreshMultiPicker",
    value: function refreshMultiPicker(variant) {
      switch (this.product.layout.type) {
        case 'buttons':
        case 'thumbs':
          this.div().find('.variant-picker-thumb').removeClass('active');
          this.div().find('.variant-picker-thumb[data-variant-id="' + variant.oneTime.id + '"]').addClass('active');
          break;
        case 'buttons_green':
          this.div().find('.variant-picker-button').removeClass('active');
          this.div().find('.variant-picker-button[data-variant-id="' + variant.oneTime.id + '"]').addClass('active');
          break;
        default:
          if (this.div().find('.product-section-variant-picker-select select').val() != variant.oneTime.id) {
            this.div().find('.product-section-variant-picker-select select').val(variant.oneTime.id).trigger('change');
          }
      }
    }
  }, {
    key: "refreshOneTime",
    value: function refreshOneTime(variant) {
      var price = parseFloat(variant.oneTime.price).toFixed(this.decimals);
      var original = variant.oneTime.processed.discount.price ? variant.oneTime.processed.discount.price.toFixed(this.decimals) : false;
      this.div().find('[data-recharge-one-time-price-now]').attr('data-discount-product-price', price).html(window.vegamourOptions.currency.sign + price);
      if (original) {
        this.div().find('[data-recharge-one-time-price-old]').attr('data-discount-original-price', original).html(window.vegamourOptions.currency.sign + original);
        if (price != original) {
          this.div().find('[data-recharge-one-time-price-old]').show();
        }
      } else {
        this.div().find('[data-recharge-one-time-price-old]').hide();
      }
      if (variant.oneTime.processed.discount.percentage) {
        this.div().find('[data-recharge-one-time-off]').html(' - ' + window.vegamourTranslations.products.subscription_widget.callout_save + ' ' + Math.floor(variant.oneTime.processed.discount.percentage) + '%');
      } else {
        this.div().find('[data-recharge-one-time-off]').html('');
      }
    }
  }, {
    key: "refreshSubscription",
    value: function refreshSubscription(variant) {
      if (!variant.subscription || typeof LoopOnstore !== 'undefined' && LoopOnstore.isActive()) {
        this.div().find('[data-recharge-option-subscription]').hide();
        this.div().find('.product-section-subscription-widget').addClass('only-one-time');
        this.switchToOneTime();
        return;
      } else {
        this.div().find('[data-recharge-option-subscription]').show();
        this.div().find('.product-section-subscription-widget').removeClass('only-one-time');
      }
      var price = parseFloat(variant.subscription.price).toFixed(this.decimals);
      var original = parseFloat(variant.subscription.processed.discount.price).toFixed(this.decimals);
      if (variant.subscription.processed.discount.price && variant.subscription.processed.discount.price > variant.subscription.price) {
        this.div().find('[data-recharge-subscription-price-old]').attr('data-discount-original-price', original).html(window.vegamourOptions.currency.sign + original);
        this.div().find('[data-recharge-subscription-off]').html(Math.floor(variant.subscription.processed.discount.percentage) + '%');
      } else {
        this.div().find('[data-recharge-subscription-price-old]').html('');
      }
      this.div().find('[data-recharge-subscription-price-now]').attr('data-discount-product-price', price).html(window.vegamourOptions.currency.sign + price);
      var freeSubscriptionShipping = vegamour.shippingRates.getSubscriptionFreeShippingThreshold();
      if (freeSubscriptionShipping !== null) {
        if (freeSubscriptionShipping > 0) {
          this.div().find('[data-recharge-free-subscription-shipping]').hide();
        } else {
          this.div().find('[data-recharge-free-subscription-shipping]').show();
        }
      }
      var frequency = this.getFrequencyPrefixString(variant);
      if (this.getFrequencyString(variant)) {
        frequency += ' ' + this.getFrequencyString(variant);
      }
      this.div().find('[data-recharge-subscription-shipping]').html('Deliver ' + frequency + ' ' + this.getUnitString(variant) + '. Skip or cancel anytime.');
    }
  }, {
    key: "getUnitString",
    value: function getUnitString(variant) {
      var frequency = this.getFrequency(variant);
      var unit = this.getUnit(variant).toLowerCase();
      switch (unit) {
        case 'days':
        case 'day':
          return frequency > 1 ? 'days' : 'day';
        case 'months':
        case 'month':
          return frequency > 1 ? 'months' : 'month';
        default:
          return unit;
      }
    }
  }, {
    key: "getFrequencyPrefixString",
    value: function getFrequencyPrefixString(variant) {
      var frequency = this.getFrequency(variant);
      if (frequency > 1) {
        return 'once every';
      }
      return 'once a';
    }
  }, {
    key: "getFrequencyString",
    value: function getFrequencyString(variant) {
      var frequency = this.getFrequency(variant);
      if (frequency > 1) {
        return frequency;
      }
      return '';
    }
  }, {
    key: "getFrequency",
    value: function getFrequency(variant) {
      var productMetafield = variant.oneTime.metafields.product_page.product;
      var frequency = parseInt(this.product.subscription.frequency);
      if (productMetafield && productMetafield.subscription && productMetafield.subscription.frequency) {
        frequency = parseInt(productMetafield.subscription.frequency);
      }
      return frequency;
    }
  }, {
    key: "getUnit",
    value: function getUnit(variant) {
      var productMetafield = variant.oneTime.metafields.product_page.product;
      var unit = '';
      if (typeof this.product.subscription !== 'undefined' && typeof this.product.subscription.unit !== 'undefined') {
        unit = this.product.subscription.unit;
      }
      if (productMetafield && productMetafield.subscription && productMetafield.subscription.unit) {
        unit = productMetafield.subscription.unit;
      }
      return unit;
    }
  }, {
    key: "getProperties",
    value: function getProperties() {
      return this.product.properties;
    }
  }, {
    key: "getProperty",
    value: function getProperty(name) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var result = defaultValue;
      this.product.properties.forEach(function (property) {
        if (property.name === name) {
          result = property.value;
        }
      });
      return result;
    }
  }, {
    key: "isCbd",
    value: function isCbd() {
      return !!this.getProperty('contains_cbd', false);
    }
  }, {
    key: "isCbdEdible",
    value: function isCbdEdible() {
      return !!this.getProperty('contains_cbd_edible', false);
    }
  }, {
    key: "isHazmat",
    value: function isHazmat() {
      return !!this.getProperty('contains_hazmat', false);
    }
  }, {
    key: "isProposition65",
    value: function isProposition65() {
      return !!this.getProperty('proposition_65', false);
    }
  }, {
    key: "isCustomSave",
    value: function isCustomSave() {
      var variant = this.getCurrentVariant();
      if (!variant.subscription) {
        return false;
      }
      return variant.subscription.processed.discount.percentageIsCustom;
    }
  }, {
    key: "isCustomSubscription",
    value: function isCustomSubscription() {
      if (!this.isMultiPicker()) {
        return false;
      }
      var variant = this.getCurrentVariant();
      return !!variant.subscription;
    }
  }, {
    key: "getCustomSubscription",
    value: function getCustomSubscription() {
      var variant = this.getCurrentVariant();
      if (!variant || !variant.subscription) {
        return null;
      }
      // variantId를 id로 수정
      return variant.subscription.id + ',' + this.getSubscriptionId() + ',' + this.getShippingUnit() + ',' + this.getShippingFrequency();
    }
  }, {
    key: "isOnlyOneTime",
    value: function isOnlyOneTime() {
      // Dont add this to regular products, only multi variants because some of them are only one-time
      if (!this.isMultiPicker()) {
        return false;
      }
      return !this.currentVariantHasSubscription();
    }
  }, {
    key: "isCustomTitle",
    value: function isCustomTitle() {
      var variant = this.getCurrentVariant();
      var productMetafield = variant.oneTime.metafields.product_page.product;
      if (productMetafield && productMetafield.custom_title) {
        return true;
      }
      if (this.product.custom.title.enable) {
        return true;
      }
      return false;
    }
  }, {
    key: "getCustomTitle",
    value: function getCustomTitle() {
      var variant = this.getCurrentVariant();
      var productMetafield = variant.oneTime.metafields.product_page.product;
      if (productMetafield && productMetafield.custom_title) {
        return variant.oneTime.metafields.product_page.product.custom_title;
      }
      return this.product.custom.title.text;
    }
  }, {
    key: "getCustomSave",
    value: function getCustomSave() {
      if (this.isCustomSave()) {
        var variant = this.getCurrentVariant();
        return variant.subscription.processed.discount.percentage;
      }
      return null;
    }
  }, {
    key: "getCartLimit",
    value: function getCartLimit() {
      var variant = this.getCurrentVariant();
      var productMetafield = variant.oneTime.metafields.product_page.product;
      if (productMetafield && productMetafield.cart_limit) {
        return variant.oneTime.metafields.product_page.product.cart_limit;
      }
      return this.product.cartLimit;
    }
  }, {
    key: "getSellingPlanId",
    value: function getSellingPlanId() {
      return this.product.subscription.selling_plan_id;
    }
  }, {
    key: "getSubscriptionId",
    value: function getSubscriptionId() {
      return this.product.subscription.id;
    }
  }, {
    key: "getShippingUnit",
    value: function getShippingUnit() {
      return this.getUnit(this.getCurrentVariant());
    }
  }, {
    key: "getShippingFrequency",
    value: function getShippingFrequency() {
      return this.getFrequency(this.getCurrentVariant());
    }
  }, {
    key: "getProductCartData",
    value: function getProductCartData(isOneTime, quantity) {
      var data = {
        id: this.getCurrentVariantId2(!isOneTime),
        quantity: quantity ? quantity : 1,
        properties: {
          _cart_limit: this.getCartLimit(),  // 언더스코어 추가
          is_subscription: !isOneTime,
          is_one_time_purchase: isOneTime,
        }
      };
      if (this.isCbd()) {
        data.properties._contains_cbd = 1;
      }
      if (this.isCbdEdible()) {
        data.properties._contains_cbd_edible = 1;
      }
      if (this.isHazmat()) {
        data.properties._contains_hazmat = 1;
      }
      if (this.isProposition65()) {
        data.properties._proposition_65 = 1;
      }
      if (this.isCustomTitle()) {
        data.properties._custom_title = this.getCustomTitle();
      }
      if (this.isCustomSave()) {
        data.properties._custom_save = this.getCustomSave();
      }
      if (isOneTime) {
        if (this.isCustomSubscription()) {
          data.properties._custom_subscription = this.getCustomSubscription();
        }
        if (this.isOnlyOneTime()) {
          data.properties._only_onetime = 1;
        }

        // 👇 장바구니 업그레이드 버튼을 위해 아래 두 줄을 추가합니다.
        data.properties._shipping_interval_frequency = this.getShippingFrequency() || '30';
        data.properties._shipping_interval_unit_type = this.getShippingUnitType() || 'day';
      } else {
        data.selling_plan = this.getSellingPlanId();
        data.properties._shipping_interval_frequency = this.getShippingFrequency() || '30';
        data.properties._shipping_interval_unit_type = this.getShippingUnitType() || 'day';
      }

      console.log('Product cart data:', data);

      return data;
    }
  }, {
    key: "getVariantOneTimeDiscountPercentage",
    value: function getVariantOneTimeDiscountPercentage(id) {
      var variant = this.getVariantById(id);
      if (!variant) {
        return null;
      }
      if (variant.oneTime && variant.oneTime.processed && variant.oneTime.processed.discount && variant.oneTime.processed.discount.percentage > 0) {
        return variant.oneTime.processed.discount.percentage;
      }
      return null;
    }
  }, {
    key: "getVariantSubscriptionDiscountPercentage",
    value: function getVariantSubscriptionDiscountPercentage(id) {
      var variant = this.getVariantById(id);
      if (!variant) {
        return null;
      }
      if (variant.subscription && variant.subscription.processed && variant.subscription.processed.discount && variant.subscription.processed.discount.percentage > 0) {
        return variant.subscription.processed.discount.percentage;
      }
      return null;
    }
  }, {
    key: "getOneTimeDiscountPercentage",
    value: function getOneTimeDiscountPercentage() {
      return this.getVariantOneTimeDiscountPercentage(this.getCurrentVariantId());
    }
  }, {
    key: "getSubscriptionDiscountPercentage",
    value: function getSubscriptionDiscountPercentage() {
      return this.getVariantSubscriptionDiscountPercentage(this.getCurrentVariantId());
    }
  }]);
  return VegamourProductRecharge;
}(Events);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VegamourProduct = /*#__PURE__*/function (_Events) {
  _inherits(VegamourProduct, _Events);
  var _super = _createSuper(VegamourProduct);
  function VegamourProduct(data) {
    var _this;
    _classCallCheck(this, VegamourProduct);
    _this = _super.call(this);
    _this.data = data;
    _this.currentVariant = null;
    _this.init();
    return _this;
  }
  _createClass(VegamourProduct, [{
    key: "init",
    value: function init() {
      window.vegamour.debug('Product object created');
      var self = this;
      this.initEvents();
      if (vegamourOptions.expressCart) {
        $('[data-product-id="' + this.data.id + '"] [data-cart-add]').on('click', function (e) {
          var _this2 = this;
          e.preventDefault();
          if (typeof $(this).attr('disabled') !== 'undefined') {
            return false;
          }
          $(this).addClass('loading').attr('disabled', 'disabled');
          $('[data-cart-add-bar]').addClass('loading').attr('disabled', 'disabled');
          self.submit(function () {
            $(_this2).removeClass('loading').removeAttr('disabled');
            $('[data-cart-add-bar]').removeClass('loading').removeAttr('disabled');
          });
        });
      }
      var $form = this.form();
      if ($form && $form.length > 0) {
        $form.find('[data-single-option-selector], select[data-index]').on('change', function (e) {
          self.currentVariant = self.getVariantByOption($(this).data('index'), $(this).val());
          self.emit('variantChange');
          var price = self.currentVariant.price * 0.01;
          $('.rc_option__one-time .subscription-widget-price-value').text(price.toFixed(2));
          if (self.currentVariant.title.includes('Travel')) {
            $('.subscription-widget-callout').hide();
            $('.rc_option__recurring').hide().removeClass('active').find('input').prop('disabled', true);
            $('.rc_option__one-time').addClass('active').find('input').prop('checked', true);
            $('.next').click();
          } else {
            $('.subscription-widget-callout').show();
            $('.rc_option__recurring').show().find('input').prop('disabled', false);
            $('.previous').click();
          }
        });
        var $checkedVariant = $('select[data-single-option-selector]');
        if ($checkedVariant.length > 0) {
          self.currentVariant = self.getVariantByOption($checkedVariant.data('index'), $checkedVariant.val());
          self.emit('variantChange');
        }
      }
      this.initVariants();
      this.initMobile();
      this.initFancybox();
      this.initGallery();
      this.initTabs();
      this.initRecharge();
      this.initBuy();
      this.initFaq();
      this.initBoughtTogether();
      this.initOpinions();
      this.initIngredients();
      this.initGeo();
      this.initDiscover();
      this.onFlickityChange();
      this.initKitModuleSlider();
      this.initResultsSlider();
      this.initAnchorScroll();
      this.refreshGeo();
      this.initSMS();

      /* Product V4 */
      if (this.isThemeV4()) {
        this.initV4();
      }
    }
  }, {
    key: "initV4",
    value: function initV4() {
      var self = this;
      this.recalcV4Positions();
      try {
        new ResizeObserver(this.recalcV4Positions).observe(document.querySelector('#header-container'));
      } catch (e) {
        console.log(e);
      }
      this.initV4SectionNav();
      this.initV4Accordion();
      this.initV4Scroll();
      this.initV4BundleSave();
      this.initV4Kit();
      this.initV4Ingredients();
      this.initV4Testimonials();
      this.initV4Tested();
      this.initV4Review();
      this.initClaimsTab();
    }
  }, {
    key: "initV4SectionNav",
    value: function initV4SectionNav() {
      var $sectionNav = $('.section-nav');
      var self = this;
      $sectionNav.on('click', 'li', function () {
        window.clickedV4Nav = true;
        $(this).addClass('active').siblings('.active').removeClass('active');

        // Scroll to the section
        var $target = $($(this).data('target'));
        self.scroll($target.offset().top - $('#header-container').height() - $sectionNav.height());
        setTimeout(function () {
          window.clickedV4Nav = false;
        }, 1000);
      });
    }
  }, {
    key: "initV4Testimonials",
    value: function initV4Testimonials() {
      var $blockTestimonials = $(".product-block-testimonials");
      if ($blockTestimonials.data('count') > 1) {
        var slick = $blockTestimonials.slick({
          arrows: true,
          prevArrow: '<div class="v4-arrow previous" tabindex="0" role="button"><p class="visually-hidden">Go to previous slide</p></div>',
          nextArrow: '<div class="v4-arrow next" tabindex="0" role="button"><p class="visually-hidden">Go to next slide</p></div>'
        });
        var $dots = $blockTestimonials.closest('.product-section').find('.carousel-dots');
        $dots.find('button').click(function (e) {
          e.preventDefault();
          if (!$(this).hasClass('active')) {
            $(this).siblings('.active').removeClass('active');
            $(this).addClass('active');
            $blockTestimonials.slick('slickGoTo', $(this).data('item'));
          }
        });
        slick.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
          $dots.find('button.active').removeClass('active');
          $dots.find('button[data-item=' + nextSlide + ']').addClass('active');
        });
        var $blockTestimonialTabBtnsArr = $('.product-block-testimonials-tab-btn');
        if ($blockTestimonialTabBtnsArr.length > 0) {
          $blockTestimonialTabBtnsArr.each(function (i, btn) {
            $(btn).on('click', function () {
              var $btn = $(btn);
              var goToSlideNumber = $btn[0].dataset.goToSlide;
              $blockTestimonials.slick('slickGoTo', goToSlideNumber);
              $('.product-block-testimonials-tab-btn--selected').removeClass('product-block-testimonials-tab-btn--selected');
              $btn.addClass('product-block-testimonials-tab-btn--selected');
            });
          });
          $blockTestimonials.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var nextSlideEl = $("[data-slide-number=\"".concat(nextSlide, "\"]"))[0];
            var productHandle = nextSlideEl.dataset.productHandle;
            $('.product-block-testimonials-tab-btn--selected').removeClass('product-block-testimonials-tab-btn--selected');
            $(".product-block-testimonials-tab-btn[data-go-to-product='".concat(productHandle, "']")).addClass('product-block-testimonials-tab-btn--selected');
          });
        }
      }
    }
  }, {
    key: "initV4Tested",
    value: function initV4Tested() {
      $('.circleBarProgress').each(function () {
        var $bar = $(this).find('.circleBar');
        var $val = $(this).find('span');
        var perc = parseInt($val.text(), 10);
        $({
          p: 0
        }).animate({
          p: perc
        }, {
          duration: 3000,
          easing: 'swing',
          step: function step(p) {
            $bar.css({
              transform: 'rotate(' + (45 + p * 1.8) + 'deg)'
            });
            $val.text(p | 0);
          }
        });
      });
    }
  }, {
    key: "initV4Review",
    value: function initV4Review() {
      if (window.location.search.indexOf('showReviewForm') !== -1) {
        $('body').css('visibility', 'hidden');
        var $link = $('.oke-w-reviews-writeReview a');
        if ($link.length) {
          window.location = $link.attr('href');
        } else {
          setTimeout(this.initV4Review, 50);
        }
      }
    }
  }, {
    key: "initV4Accordion",
    value: function initV4Accordion() {
      /**
       *  First accourdian will be defaulted to open position
       *  When the user selects another accordion, the previous selected will collapse
       */
      var $accordionProduct = $('.theme-v4 .accordion');
      var self = this;
      $accordionProduct.on('click', '.accordion-header', function (e) {
        var $btnToggle = $(this).find('.accordion-button');
        var isExpanded = $btnToggle.attr('aria-expanded');
        var targetSelector = $btnToggle.data('vgTarget');
        var $accordionCollapse = $(targetSelector);
        if (isExpanded === 'true') {
          // Expanded => Collapsed
          $btnToggle.attr('aria-expanded', false);
          $btnToggle.parent().removeClass('opened');
          $accordionCollapse.slideUp();
        } else {
          // Collapse all other expanded siblings
          var $accordionItem = $btnToggle.closest('.accordion-item');
          $accordionItem.siblings().each(function () {
            var $btn = $(this).find('.accordion-button');
            if ($btn.attr('aria-expanded') === 'true') {
              $btn.addClass('collapsed');
              $(this).find('.accordion-collapse').slideUp().addClass('collapse');
              $btn.attr('aria-expanded', false);
              $btn.parent().removeClass('opened');
            }
          });

          // Collapsed => Expanded
          $btnToggle.attr('aria-expanded', true);
          $btnToggle.parent().addClass('opened');
          $accordionCollapse.slideDown();
          setTimeout(function () {
            var newTop = $accordionItem.offset().top - $('#shopify-section-header').height() - $('.section-nav').height();
            if ($(window).scrollTop() > newTop) {
              self.scroll(newTop);
            }
          }, 450);
        }
        $btnToggle.toggleClass('collapsed');
        $accordionCollapse.toggleClass('collapse');
      });
    }
  }, {
    key: "initV4Scroll",
    value: function initV4Scroll() {
      var _this3 = this;
      var $section = $('.product-container-v4').next();
      if (!$section.length) {
        return;
      }
      var $info = $('.product-info-v4');
      var infoTop = $info.offset().top;
      var pad = $info.innerHeight() - $info.height();
      var infoHeight = $info.find('.inner').height() + pad;
      $(window).on('scroll', function () {
        var isSticky = $(window).scrollTop() + window.innerHeight < $section.offset().top;
        if (!_this3.isMobile()) {
          if (isSticky) {
            $info.addClass('fixed');
            if ($(window).height() >= infoHeight + infoTop) {
              $info.css('top', infoTop + 'px');
            } else {
              if ($(window).scrollTop() + window.innerHeight >= infoTop + infoHeight + 55) {
                $info.css('top', 'auto');
                $info.css('bottom', '0');
              } else {
                $info.removeClass('fixed');
                $info.css('top', '0');
              }
            }
          } else {
            $info.removeClass('fixed');
            $info.css('top', 'auto');
          }
        }
        $('body').toggleClass('info-sticky', isSticky);
        if (window.clickedV4Nav) {
          return;
        }

        // Monitor scrolling section & change the active status of the sticky nav
        if (!_this3.posY) {
          return;
        }
        var y = $(window).scrollTop();
        var n = _this3.posY.length;
        var activeI = 0;
        var offset = $('.product-section-nav').height() + $('#header').height();
        for (i = n - 1; i >= 0; i--) {
          if (y >= _this3.posY[i] - offset) {
            activeI = i;
            break;
          }
        }
        $('.section-nav li').removeClass('active').eq(activeI).addClass('active');
        if (_this3.isMobile()) {
          var scroll = 0;
          $('.section-nav li').each(function () {
            if ($(this).hasClass('active')) {
              $('.section-nav').scrollLeft(scroll);
            } else {
              scroll += $(this).width();
            }
          });
        }
      });
    }
  }, {
    key: "recalcV4Positions",
    value: function recalcV4Positions() {
      var _this4 = this;
      setTimeout(function () {
        var $s = $('.js-slider').not('.slick-initialized');
        if ($s.length && $s[0].slick) {
          $s.slick('resize');
        }
      }, 20);
      setTimeout(function () {
        _this4.posY = [];
        $('.section-nav li').each(function (index, element) {
          var $section = $($(element).data('target'));
          var y = $section.offset().top;
          $(element).attr('data-y', y);
          _this4.posY[index] = y;
        });
      }, 30);
    }
  }, {
    key: "initV4BundleSave",
    value: function initV4BundleSave() {
      var $bundleSaveItems = $(".product-bundle-save-items");
      $bundleSaveItems.slick({
        prevArrow: '<div class="v4-arrow previous" tabindex="0" role="button"><p class="visually-hidden">Go to previous slide</p></div>',
        nextArrow: '<div class="v4-arrow next" tabindex="0" role="button"><p class="visually-hidden">Go to next slide</p></div>',
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });
    }
  }, {
    key: "initV4Kit",
    value: function initV4Kit() {
      var _this5 = this;
      var $kitItems = $(".product-kit .product-kit-items");
      var $carousel = $('.product-kit-carousel');
      $kitItems.slick({
        prevArrow: '<div class="v4-arrow previous" tabindex="0" role="button"><p class="visually-hidden">Go to previous slide</p></div>',
        nextArrow: '<div class="v4-arrow next" tabindex="0" role="button"><p class="visually-hidden">Go to next slide</p></div>',
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1
      });

      // Thumbnails in the main layout
      $('.product-kit').on('click', '.btn-learn-more', function (e) {
        e.preventDefault();
        $('.loop-product-link').unbind('click').click(function (e) {
          e.preventDefault();
          window.location.href = $(this).attr('href');
        });
        var $this = $(e.currentTarget);
        var $item = $this.closest('.product-kit-item');
        _this5.v4_KitRefreshPopupPositions($item.index() - 1);
        $carousel.hide().fadeIn().css({
          visibility: 'visible'
        });
        setTimeout(function () {
          $('body').addClass('kit-carousel-open');
        }, 200);
        return false;
      });

      // Carousel
      var itemCount = $carousel.data('count');
      $carousel.on('click', '.btn-carousel-arrow', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $this = $(e.currentTarget);
        var direction = $this.data('direction');
        var currentIndex = $carousel.data('currentIndex');
        if (direction == 'next' && currentIndex < itemCount - 1) {
          _this5.v4_KitRefreshPopupPositions(currentIndex + 1);
        } else if (direction == 'prev' && currentIndex > 0) {
          _this5.v4_KitRefreshPopupPositions(currentIndex - 1);
        }
        return false;
      }).on('click', '.btn-close-kit-carousel', function () {
        $('body').removeClass('kit-carousel-open');
        $carousel.fadeOut();
      }).on('click', '.product-kit-carousel-item', function (e) {
        var $this = $(e.currentTarget);
        if ($this.hasClass('current')) {
          return false;
        }
        _this5.v4_KitRefreshPopupPositions($this.data('index'));
      });
      $('.product-kit-carousel-overlay').on('click', function (e) {
        $carousel.fadeOut();
      });
      $(window).on('resize', function () {
        _this5.v4_KitRefreshPopupPositions();
      });
    }
  }, {
    key: "initSMS",
    value: function initSMS() {
      var self = this;
      $(document).ready(function () {
        $('.subscription-selection').click(function (e) {
          if (e.target.nodeName != 'A' && !$(this).hasClass('selected')) {
            var $sel = $(this).find('input[type="radio"]');
            $(this).parent().find('.selected').removeClass('selected');
            $(this).addClass('selected');
            $sel.prop('checked', true);
            $('klarna-placement').attr('data-purchase-amount', $(this).find('[data-price]').first().attr('data-price'));
            //$('.product-gallery-image:first-of-type a').attr('href', $sel.data('image'));
            //self.swapImage('.product-gallery-image:first-of-type img', $sel.data('image'));
          }
        });
      });
    }
  }, {
    key: "getSMS",
    value: function getSMS() {
      if ($('.subscription-multiple-selector').is(':visible')) {
        return $('.subscription-multiple-selector input[type="radio"]:checked');
      }
      return false;
    }
  }, {
    key: "swapImage",
    value: function swapImage(selector, newSrc) {
      var $sel = $(selector);
      if ($sel.length === 0) return;
      var curSrc = $sel.attr('src');
      $sel.attr('src', newSrc);
      //$sel.attr('data-largesrc', newSrc);
      $sel.attr('srcset', $sel.attr('srcset').replaceAll(curSrc, newSrc));
    }
  }, {
    key: "v4_KitRefreshPopupPositions",
    value: function v4_KitRefreshPopupPositions(currentIndex) {
      var $carousel = $('.product-kit-carousel');
      if (typeof currentIndex !== 'undefined') {
        $carousel.data('currentIndex', currentIndex);
      } else {
        currentIndex = $carousel.data('currentIndex');
      }

      // Recalculate position of each carousel item
      var style = $carousel.attr('style');
      $carousel.find('.current').removeClass('current');
      var $currentItem = $carousel.find('.product-kit-carousel-item').eq(currentIndex).addClass('current');
      var ratio = 1;
      var marginX = 20;
      var width_active = 300;
      var height_active = 0;
      $carousel.css({
        position: "absolute",
        visibility: "hidden",
        display: "block"
      });
      if (!this.isMobile()) {
        ratio = 0.8;
        marginX = 0;
        width_active = $currentItem.width();
      }
      height_active = $currentItem.height();
      $carousel.attr('style', style);
      $carousel.find('.product-kit-carousel-item').each(function (index, element) {
        var posX = 0;
        if (index == currentIndex) {
          posX = window.innerWidth / 2 - width_active / 2;
        } else if (index > currentIndex) {
          posX = window.innerWidth / 2 + width_active / 2 + marginX + (marginX + width_active) * (index - currentIndex - 1);
        } else {
          posX = window.innerWidth / 2 - width_active / 2 - (marginX + width_active) * (currentIndex - index);
        }
        var posY = window.innerHeight / 2 - height_active / 2 - 100;
        if (posY < 30) {
          posY = 30;
        }
        element.setAttribute('style', 'left: ' + posX + 'px; top: ' + posY + 'px');
      });
    }
  }, {
    key: "initV4Ingredients",
    value: function initV4Ingredients() {
      var $section = $('.product-section-ingredients');
      $section.find('.trigger-popup').click(function () {
        $.fancybox({
          href: '#hidden-ingredients',
          maxWidth: 880,
          maxHeight: 'auto',
          padding: 30,
          backFocus: false,
          hideScrollbar: false,
          fitToView: true,
          width: 'auto',
          height: 'auto',
          autoScale: true,
          autoSize: false,
          autoDimensions: true,
          closeClick: false,
          openEffect: 'none',
          closeEffect: 'none',
          'beforeLoad': function beforeLoad() {
            document.getElementsByTagName('html')[0].classList.add('fancybox-active');
          },
          'afterShow': function afterShow() {},
          'afterClose': function afterClose() {
            $('#quick-view').remove();
            document.getElementsByTagName('html')[0].classList.remove('fancybox-active');
          }
        });
      });
      var options = {
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 1,
        dots: this.isMobile(),
        draggable: this.isMobile(),
        swipe: this.isMobile(),
        infinite: false,
        arrows: false
      };
      var slider = $('.product-ingredients-items');
      var $slick = $(slider).slick(options);
      this.resizeImagesAfterSlick($slick);
      $section.find('.product-ingredients-titles').on('click mouseenter', function () {
        if (!$(this).hasClass('selected')) {
          var $selectedIngredient = $('#ingredients').find('.selected');
          $selectedIngredient.removeClass('selected');
          $selectedIngredient.attr('aria-selected', false);
          $(this).addClass('selected');
          $(this).attr('aria-selected', true);
          $slick.slick('slickGoTo', $(this).data('id') - 1);
        }
      });
    }
  }, {
    key: "initEvents",
    value: function initEvents() {
      var _this6 = this;
      this.on('variantChange', function () {
        console.info('⚡ Product variant changed');
        if (!_this6.currentVariant) {
          return;
        }
        if (_this6.currentVariant.available) {
          $('[data-product-id="' + _this6.data.id + '"] [data-cart-add]').removeClass('sold-out').removeAttr('disabled');
          $('[data-cart-add-bar]').removeClass('sold-out').removeAttr('disabled');
        } else {
          $('[data-product-id="' + _this6.data.id + '"] [data-cart-add]').addClass('sold-out').attr('disabled', 'disabled');
          $('[data-cart-add-bar]').addClass('sold-out').attr('disabled', 'disabled');
        }
        _this6.updateQuantity();
        var $thumbOptions = $('.product-section-variant-picker-thumbs, .product-section-variant-picker-select');
        if ($thumbOptions.length) {
          var notSelected = [];
          var selected = $(_this6)[0].currentVariant.option2;
          $('.vegamour-select-v2-item').each(function () {
            var variant = $(this).text();
            if (selected != variant && !notSelected.includes(variant)) {
              notSelected[notSelected.length] = variant;
            }
          });
          _this6.filterGallery(notSelected);
        }
        $('.product-gallery-images').slick('slickGoTo', 0);
      });
      vegamour.on('easylocationReady, geolocationReady', function () {
        _this6.refreshGeo();
      });
      var self = this;
      var initMobile = this.isMobile();
      $(window).on('resize orientationchange', function () {
        var isMobile = self.isMobile();
        if (initMobile && !isMobile || !initMobile && isMobile) {
          location.reload();
        }
      });
    }
  }, {
    key: "filterGallery",
    value: function filterGallery(notSelected) {
      if (notSelected.length === 0) return;
      var $slider = $('.product-gallery-images');
      var $sliderThumb = $('.product-gallery-navigation');
      var hide = '';
      notSelected.forEach(function (s) {
        if (hide.length > 0) {
          hide += ',';
        }
        hide += '[data-thumb*="' + s + '"]';
      });
      $slider.slick('slickUnfilter');
      $slider.slick('slickFilter', 'div:not(' + hide + ')');
      var showThumb = 'a:not(' + hide + ')';
      $sliderThumb.find(hide).hide();
      $sliderThumb.find(showThumb).show();
      $slider.slick('getSlick').$slides.each(function (index) {
        var $slide = $(this);
        var oldIndex = $(this).data('slick-index');
        $slide.attr('data-slick-index', index);
        $sliderThumb.find('[data-index="' + oldIndex + '"]').attr('data-new-index', index);
      });
      $sliderThumb.find('[data-new-index]').each(function () {
        $(this).attr('data-index', $(this).data('new-index'));
      });
    }
  }, {
    key: "getVariantByOption",
    value: function getVariantByOption(option, value) {
      var result = null;
      this.data.variants.forEach(function (variant) {
        if (typeof variant[option] !== 'undefined' && variant[option] == value) {
          result = variant;
        }
      });
      return result;
    }
  }, {
    key: "getVariantById",
    value: function getVariantById(id) {
      var result = null;
      this.data.variants.forEach(function (variant) {
        if (variant.id == id) {
          result = variant;
        }
      });
      return result;
    }
  }, {
    key: "setCurrentVariantById",
    value: function setCurrentVariantById(id) {
      this.currentVariant = this.getVariantById(id);
      this.emit('variantChange');
    }
  }, {
    key: "form",
    value: function form() {
      return $('form[data-product-id="' + this.data.id + '"]');
    }
  }, {
    key: "formData",
    value: function formData() {
      function getFormData($form) {
        var unindexedArray = $form.serializeArray();
        var indexedArray = {};
        $.map(unindexedArray, function (n, i) {
          indexedArray[n['name']] = n['value'];
        });
        return indexedArray;
      }
      return getFormData(this.form());
    }
  }, {
    key: "submit",
    value: function submit(callback) {
      var data = {
        id: this.getProductId(),
        quantity: this.getQuantity(),
        properties: {
          _cart_limit: this.getCartLimit()
        }
      };
      if (this.isCbd()) {
        data.properties._contains_cbd = 1;
      }
      if (this.isCbdEdible()) {
        data.properties._contains_cbd_edible = 1;
      }
      if (this.isHazmat()) {
        data.properties._contains_hazmat = 1;
      }
      if (this.isProposition65()) {
        data.properties._proposition_65 = 1;
      }
      if (this.isCustomTitle()) {
        data.properties._custom_title = this.getCustomTitle();
      }
      if (this.isCustomSave()) {
        data.properties._custom_save = this.getCustomSave();
      }
      if (this.isOneTimeSelected()) {
        if (this.isCustomSubscription()) {
          data.properties._custom_subscription = this.getCustomSubscription();
        }
        if (this.isOnlyOneTime()) {
          data.properties._only_onetime = 1;
        }

        // 👇 아래 두 줄 추가
        data.properties._shipping_interval_frequency = this.getShippingFrequency() || '30';
        data.properties._shipping_interval_unit_type = this.getShippingUnitType() || 'day';

        // 👇 커스텀 배송비 로직용 태그 (one-time)
        data.properties._is_subscription = 'false';
        data.properties._is_one_time_purchase = 'true';

        // One-Time item
        vegamour.cart.express.open();
        vegamour.cart.loader(true);
        vegamour.cart.add(data, function () {
          vegamour.cart.loader(false);
          if (typeof callback === 'function') {
            callback();
          }
        });
      } else {
        // Subscription item
        var sms = this.getSMS();
        if (sms) {
          data.id = sms.val();
          data.selling_plan = sms.data('selling-plan');
          data.properties._cart_limit = sms.data('cart-limit');
          data.properties._custom_save = sms.data('custom-save');
          // 👇 마지막 할당 시 기본값 강제 적용
          data.properties._shipping_interval_frequency = sms.data('subscription-frequency') || '30';
          data.properties._shipping_interval_unit_type = sms.data('subscription-unit') || 'day';
        } else {
          data.selling_plan = this.getSellingPlanId();
          // 👇 마지막 할당 시 기본값 강제 적용
          data.properties._shipping_interval_frequency = this.getShippingFrequency() || '30';
          data.properties._shipping_interval_unit_type = this.getShippingUnitType() || 'day';
        }

        // 👇 커스텀 배송비 로직용 태그 (subscription)
        data.properties._is_subscription = 'true';
        data.properties._is_one_time_purchase = 'false';

        console.log('Fixed data:', data);

        vegamour.cart.express.open();
        vegamour.cart.loader(true);
        vegamour.cart.add(data, function () {
          vegamour.cart.loader(false);
          if (typeof callback === 'function') {
            callback();
          }
        });
      }
    }
  }, {
    key: "isProposition65",
    value: function isProposition65() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isProposition65();
      }
      return parseInt(this.formData()['properties[_proposition_65]']) === 1;
    }
  }, {
    key: "isCbd",
    value: function isCbd() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isCbd();
      }
      return parseInt(this.formData()['properties[_contains_cbd]']) === 1;
    }
  }, {
    key: "isCbdEdible",
    value: function isCbdEdible() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isCbdEdible();
      }
      return parseInt(this.formData()['properties[_contains_cbd_edible]']) === 1;
    }
  }, {
    key: "isHazmat",
    value: function isHazmat() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isHazmat();
      }
      return parseInt(this.formData()['properties[_contains_hazmat]']) === 1;
    }
  }, {
    key: "isCustomTitle",
    value: function isCustomTitle() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isCustomTitle();
      }
      return typeof this.formData()['properties[_custom_title]'] !== 'undefined';
    }
  }, {
    key: "isCustomSave",
    value: function isCustomSave() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isCustomSave();
      }
      return false;
    }
  }, {
    key: "getCustomSave",
    value: function getCustomSave() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getCustomSave();
      }
      return null;
    }
  }, {
    key: "isCustomSubscription",
    value: function isCustomSubscription() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isCustomSubscription();
      }
      return false;
    }
  }, {
    key: "isOnlyOneTime",
    value: function isOnlyOneTime() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isOnlyOneTime();
      }
      return false;
    }
  }, {
    key: "getCustomSubscription",
    value: function getCustomSubscription() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getCustomSubscription();
      }
      return null;
    }
  }, {
    key: "getCustomTitle",
    value: function getCustomTitle() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getCustomTitle();
      }
      return this.formData()['properties[_custom_title]'];
    }
  }, {
    key: "getShippingUnitType",
    value: function getShippingUnitType() {
      if (this.isRechargeActive()) {
        var val = this.getRecharge().getShippingUnit();
        if (val) return val;
      }
      // 값이 없을 경우 기본값 'Day' (또는 'Days') 반환
      return this.formData()['properties[_shipping_interval_unit_type]'] || this.formData()['properties[shipping_interval_unit_type]'] || 'Day';
    }
  }, {
    key: "getShippingFrequency",
    value: function getShippingFrequency() {
      if (this.isRechargeActive()) {
        var freq = this.getRecharge().getShippingFrequency();
        if (freq) return freq;
      }
      // 값이 없을 경우 기본값 30 반환
      return this.formData()['properties[_shipping_interval_frequency]'] || this.formData()['properties[shipping_interval_frequency]'] || '30';
    }
  }, {
    key: "getSellingPlanId",
    value: function getSellingPlanId() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getSellingPlanId();
      }
      return this.formData()['selling_plan'];
    }
  }, {
    key: "getSubscriptionId",
    value: function getSubscriptionId() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getSubscriptionId();
      }
      return this.formData()['properties[subscription_id]'];
    }
  }, {
    key: "getQuantity",
    value: function getQuantity() {
      return parseInt(this.formData().quantity);
    }
  }, {
    key: "getCartLimit",
    value: function getCartLimit() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getCartLimit();
      }
      var cartLimit = this.form().find('[data-cart-add]').attr('data-cart-limit');
      if (typeof cartLimit === 'undefined' || !cartLimit) {
        cartLimit = null;
      }
      return cartLimit;
    }
  }, {
    key: "isRechargeActive",
    value: function isRechargeActive() {
      return this.form().find('.recharge-subscription-widget-v2').length > 0 && typeof this.getRecharge() !== 'undefined';
    }
  }, {
    key: "getRecharge",
    value: function getRecharge() {
      return this.form().find('.recharge-subscription-widget-v2').data('recharge');
    }
  }, {
    key: "getProductId",
    value: function getProductId() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getCurrentVariantId();
      }
      var productId = this.formData().id;
      if ($('[data-single-option-selector]:checked').length > 0) {
        if (this.currentVariant !== null) {
          productId = this.currentVariant.id;
        }
      } else {
        if ($('select[data-single-option-selector]').length > 0) {
          if (this.isOneTimeSelected()) {
            productId = $('select[data-single-option-selector] option:selected').data('variant-id');
          } else {
            productId = $('select[data-single-option-selector] option:selected').data('discount-variant-id');
          }
        }
      }
      if (this.isOneTimeSelected()) {
        var variantTitle = $('select[data-single-option-selector] option:selected').text().trim();

        // Get One-Time product based on variant title
        // it is always "xxxxxx - One-Time"
        $('select[data-single-option-selector] option').each(function () {
          var oneTime = $(this).text().split('-');
          if (oneTime.length > 1) {
            if (variantTitle === oneTime[0].trim()) {
              productId = $(this).data('variant-id');
            }
          }
        });
      }
      return productId;
    }
  }, {
    key: "isOneTimeSelected",
    value: function isOneTimeSelected() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isOneTimeSelected();
      }
      var formData = this.formData();
      return typeof formData['autodeliver_' + this.data.id] === 'undefined' || formData['autodeliver_' + this.data.id] === 'onetime';
    }
  }, {
    key: "playPause",
    value: function playPause() {
      $(".custom_video").not(this).each(function () {
        $(this).get(0).pause();
      });
      this[this.paused ? "play" : "pause"]();
    }
  }, {
    key: "initFancybox",
    value: function initFancybox() {
      var $thumbOptions = $('.product-section-variant-picker-thumbs');
      if ($thumbOptions.length) {
        $('[data-fancybox3]').fancybox3({
          afterLoad: function afterLoad(instance, current) {
            var pixelRatio = window.devicePixelRatio || 1;
            if (pixelRatio > 1.5) {
              current.width = current.width / pixelRatio;
              current.height = current.height / pixelRatio;
            }
          },
          keyboard: true,
          buttons: ['zoom', 'slideShow', 'fullScreen', 'thumbs', 'share', 'close']
        });
      } else {
        $('[data-fancybox3="images"]').fancybox3({
          afterLoad: function afterLoad(instance, current) {
            var pixelRatio = window.devicePixelRatio || 1;
            if (pixelRatio > 1.5) {
              current.width = current.width / pixelRatio;
              current.height = current.height / pixelRatio;
            }
          },
          keyboard: true,
          buttons: ['zoom', 'slideShow', 'fullScreen', 'thumbs', 'share', 'close']
        });
      }
    }
  }, {
    key: "initGallery",
    value: function initGallery() {
      var self = this;
      var $firstImage = $('.product-gallery-image img');
      var $containerGallery = $('.product-gallery');
      var $thumbOptions = $('.product-section-variant-picker-thumbs');
      if ($firstImage.length === 0) {
        return;
      }
      $firstImage.on('load', function () {
        $('.product-gallery-loader').hide();
      });
      if ($firstImage[0].complete) {
        $firstImage.trigger('load');
      }
      $('.product-gallery-images').on('init', function (event, slick) {
        $('.product-gallery-images').show();
        $('.product-gallery-navigation').show();
      });
      var options = {
        infinite: false,
        prevArrow: '<a class="v4-arrow previous" tabindex="0" role="button"><p class="visually-hidden">Go to previous slide</p></a>',
        nextArrow: '<a class="v4-arrow next" tabindex="0" role="button"><p class="visually-hidden">Go to next slide</p></a>'
      };
      if (this.isMobile()) {
        options.variableWidth = true;
        options.dots = this.isThemeV4();
        options.centerMode = true;
      }
      var slick = $('.product-gallery-images').slick(options);
      if ($thumbOptions.length) {
        var optionsThumb = {
          slidesToShow: 8,
          slidesToScroll: 1,
          asNavFor: '.product-gallery-images',
          infinite: false,
          arrows: false,
          vertical: true,        // 세로 방향 슬라이드 활성화
          verticalSwiping: true, // 세로 스와이프 활성화
          slidesToShow: 5,       // 한 번에 보여줄 썸네일 개수 (조절 가능)
        };
        var $slickThumb = $('.product-gallery-navigation').slick(optionsThumb);
      }
      slick.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $containerGallery.find('video.custom_video').trigger('pause');
        if ($thumbOptions.length) {
          $('.product-gallery-navigation a').removeClass('active');
        }
        $('.product-gallery-navigation a[data-index="' + currentSlide + '"]').removeClass('active');
        $('.product-gallery-navigation a[data-index="' + nextSlide + '"]').addClass('active');
      });
      slick.on('afterChange', function (event, slick, currentSlide) {
        if ($thumbOptions.length) {
          var activeSlideIndex = $(".product-gallery-images .slick-slide.slick-active").data('index');
          $('.product-gallery-navigation a').removeClass('active');
          var $currentSlide = $(".product-thumbnail[data-index='".concat(activeSlideIndex, "']"));
          $currentSlide.addClass('active');
          $currentSlide.attr('aria-selected', true);
        }
      });
      slick.on('swipe', function (event, slick, direction) {
        $containerGallery.find('video.custom_video').trigger('pause');
      });
      $('.custom_video').on("click", function () {
        self.playPause.call(this);
      });
      $('.product-gallery-navigation a').on('click', function (e) {
        e.preventDefault();
        var $selectedThumbnail = $('.product-gallery-navigation a');
        if (!$thumbOptions.length) {
          slick.slick('slickGoTo', $(this).data('index'));
          $selectedThumbnail.attr('aria-selected', false);
          $(this).attr('aria-selected', true);
        } else {
          slick.slick('slickGoTo', parseInt($(this).data('index')));
          $selectedThumbnail.removeClass('active');
          $(this).addClass('active');
        }
      }).each(function (i) {
        if (self.isThemeV4()) {
          return;
        }
        var $img = $(this).find('img');
        var addMargin = function addMargin() {
          var img = $img[0];
          $img.css({
            'margin-top': '-' + (img.height - img.width) / 2 + 'px'
          });
        };
        $img.on('load', function () {
          addMargin();
        });
      });
      $('.product-gallery-images').addClass('initialized');
    }
  }, {
    key: "initKitModuleSlider",
    value: function initKitModuleSlider() {
      var options = {
        slidesToShow: 4,
        arrows: true,
        prevArrow: '<a class="v4-arrow previous" tabindex="0" role="button"><p class="visually-hidden">Go to previous slide</p></a>',
        nextArrow: '<a class="v4-arrow next" tabindex="0" role="button"><p class="visually-hidden">Go to next slide</p></a>',
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 640,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1
          }
        }]
      };
      var $slick = $('.kit-products-module__items').slick(options);
      this.resizeImagesAfterSlick($slick);
      $(window).on('resize orientationchange', function () {
        $slick.slick('setPosition');
      });
    }
  }, {
    key: "initResultsSlider",
    value: function initResultsSlider() {
      var slides = 2;
      if ($('.product-section').length && $('.product-section').closest('.shopify-section').attr('id').replace('shopify-section-product-', '') == 'ageless') {
        slides = 1;
      }
      var options = {
        slidesToShow: slides,
        slidesToScroll: slides,
        prevArrow: '<a class="product-results-arrow previous" tabindex="0" role="button"><p class="visually-hidden">Go to previous slide</p></a>',
        nextArrow: '<a class="product-results-arrow next" tabindex="0" role="button"><p class="visually-hidden">Go to next slide</p></a>'
      };
      var slider = $('.product-results-images');
      var before = $('.product-results-before');
      var $slick = $(before).length > 1 ? $(slider).slick(options) : null;
      this.resizeImagesAfterSlick($slick);
    }
  }, {
    key: "initTabs",
    value: function initTabs() {
      $('.product-info-tabs-header-item').on('click', function (e) {
        e.preventDefault();
        $('.product-info-tabs-header-item').removeClass('active');
        $('.product-info-tabs-content-item').removeClass('active');
        $(this).addClass('active');
        $('.product-info-tabs-content-item[data-index="' + $(this).data('index') + '"]').addClass('active');
      });
    }
  }, {
    key: "initRecharge",
    value: function initRecharge() {
      var productId = $('[data-product-form]').data('product-id');
      var $subscriptionWidget = $('[data-recharge-subscription-widget="' + productId + '"]');
      var $widgetContainer = $('[data-recharge-widget-product-id="' + productId + '"]');
      if ($widgetContainer.length > 0 && $subscriptionWidget.length > 0) {
        $('[data-recharge-subscription-widget-loader="' + productId + '"]').hide();
        $subscriptionWidget.find('.inner').append($widgetContainer);
        if (this.form().data('recharge-default') === 'subscription') {
          this.form().find('[data-input-subscription]').trigger('click');
        } else if (this.form().data('recharge-default') === 'one_time') {
          this.form().find('[data-input-one-time]').trigger('click');
        }
        if (typeof LoopOnstore !== 'undefined' && LoopOnstore.isActive()) {
          this.form().find('[data-input-one-time]').trigger('click');
          this.form().find('.subscription-widget-option-subscription').hide();
        }
        $subscriptionWidget.find('input:checked').trigger('click');
        $subscriptionWidget.show();
        $widgetContainer.show();
        if (this.isThemeV4()) {
          this.initBarV4();
        } else {
          this.initBar();
        }
      }
    }
  }, {
    key: "initBar",
    value: function initBar() {
      var self = this;
      var $input = $('.product-info-recharge .subscription-widget-radio-container input');
      $input.on('change', function () {
        self.changeBar($(this).val());
      });
      $('.product-info-buy .quantity').on('change', function (e) {
        $('.product-bar-qty .quantity').val($(this).val());
      });
      $('.product-bar-recharge-selected').on('click', function (e) {
        e.preventDefault();
        $('.product-bar-recharge').toggleClass('show');
      });
      var $increase = $('.product-bar-qty .increase');
      var increaseTipped = Tipped.create($increase, {
        showOn: false,
        hideOn: 'click',
        hideOnClickOutside: true
      });
      var lastTimeShown = false;
      $(window).scroll(function () {
        if (Tipped.visible($increase)) {
          increaseTipped.hide();
        }
        if ($('.product-info-buy').length > 0) {
          if ($(window).scrollTop() > $('.product-info-buy').offset().top) {
            $('body').addClass('show-product-bar');
            if (!lastTimeShown) {
              lastTimeShown = true;
              vegamour.emit('productBarShow');
            }
          } else {
            $('body').removeClass('show-product-bar');
            if (lastTimeShown) {
              lastTimeShown = false;
              vegamour.emit('productBarHide');
            }
          }
        }
      });
      $increase.on('click', function (e) {
        e.preventDefault();
        if (typeof $(this).attr('disabled') !== 'undefined') {
          increaseTipped.show();
          return false;
        }
        $('.product-info-buy .increase').click();
      });
      $('.product-bar-qty .decrease').on('click', function (e) {
        e.preventDefault();
        $('.product-info-buy .decrease').click();
      });
      $('.product-bar [data-cart-add-bar]').on('click', function (e) {
        e.preventDefault();
        if ($('.product-info-recharge .subscription-widget-radio-container input:checked').val() === 'autodeliver') {
          $('.product-info-recharge [data-subscription-terms] input').prop('checked', true);
        }
        $('[data-cart-add]').click();
      });
      this.changeBar($input.val());
      this.refreshBar();
    }
  }, {
    key: "changeBar",
    value: function changeBar(value) {
      var $item = $('[data-input-value="' + value + '"]');
      var $selected = $('.product-bar-recharge-selected');
      $selected.find('.product-bar-recharge-type').html($item.find('.product-bar-recharge-item-type').html());
      $selected.find('.product-bar-recharge-price').html($item.find('.product-bar-recharge-item-price').html());
    }
  }, {
    key: "changeBarV2",
    value: function changeBarV2(variantId, type) {
      var $item = $('.product-bar-recharge-item[data-variant-id="' + variantId + '"][data-variant-type="' + type + '"]');
      var $selected = $('.product-bar-recharge-selected');
      $selected.find('.product-bar-recharge-type').html($item.find('.product-bar-recharge-item-type').html());
      $selected.find('.product-bar-recharge-price').html($item.find('.product-bar-recharge-item-price').html());
    }
  }, {
    key: "refreshBar",
    value: function refreshBar() {
      if (this.isRechargeActive()) {
        return this.refreshBarV2();
      }
      $('.product-bar-recharge-items').html('');
      this.form().find('.product-info-recharge .subscription-widget-option').each(function () {
        var $option = $(this);
        var $oldPrice = $option.find('.subscription-widget-price-old');
        var $price = $option.find('.subscription-widget-price-value');
        var $item = $('<div class="product-bar-recharge-item"></div>');
        $item.append('<div class="product-bar-recharge-item-type">' + $option.find('.subscription-widget-info label').text().trim() + '</div>');
        $item.append('<div class="product-bar-recharge-item-price"></div>');
        if ($oldPrice.text().trim()) {
          $item.find('.product-bar-recharge-item-price').append('<div class="product-price-old">' + $oldPrice.text().trim() + '</div>');
        }
        $item.find('.product-bar-recharge-item-price').append('<div class="product-price"><strong>' + $price.text().trim() + '</strong> ' + window.vegamourOptions.currency["short"] + '</div>');
        $item.attr('data-input-value', $option.find('.subscription-widget-radio-container input').val());
        $item.on('click', function () {
          var $input = $option.find('.subscription-widget-radio-container input');
          $input.trigger('click');
          if ($input.val() === 'autodeliver') {
            $('.product-info-recharge [data-subscription-terms] input').prop('checked', true);
          }
        });
        $('.product-bar-recharge-items').append($item);
      });
      this.changeBar($('.product-info-recharge .subscription-widget-radio-container input:checked').val());
    }
  }, {
    key: "getBarV2Item",
    value: function getBarV2Item(variantId, item, type) {
      var _this7 = this;
      var $item = $('<div class="product-bar-recharge-item" data-variant-id="' + variantId + '" data-variant-type="' + type + '"></div>');
      var title = type === 'onetime' ? 'One-Time Purchase' : 'Subscribe & Save';
      if (type === 'subscription') {
        title += ' ' + ($('.subscription-widget-callout-save-2 [data-recharge-subscription-off]').first() ? $('.subscription-widget-callout-save-2 [data-recharge-subscription-off]').first().text() : $('[data-recharge-subscription-off]').first().text());
      } else {
        var $oneTimeDiscount = $('.one-time-discount').first();
        title += ' ' + ($oneTimeDiscount.find('[data-one-time-discount]').is(':visible') ? $oneTimeDiscount.html() : $oneTimeDiscount.find('[data-recharge-one-time-off]').html());
      }
      $item.append('<div class="product-bar-recharge-item-type">' + title + '</div>');
      $item.append('<div class="product-bar-recharge-item-price"></div>');
      var price = $('[data-recharge-' + (type === 'onetime' ? 'one-time' : 'subscription') + '-price-now]').first().text();
      var original = $('[data-recharge-' + (type === 'onetime' ? 'one-time' : 'subscription') + '-price-old]').first().text();
      if (original != price) {
        $item.find('.product-bar-recharge-item-price').append('<div class="product-price-old">' + original + '</div>');
      }
      $item.find('.product-bar-recharge-item-price').append('<div class="product-price"><strong>' + price + '</strong> ' + window.vegamourOptions.currency["short"] + '</div>');
      $item.on('click', function (e) {
        e.preventDefault();
        var recharge = _this7.getRecharge();
        recharge.activeVariant = variantId;
        recharge.emit('variantChange');
        if (type === 'onetime') {
          recharge.switchToOneTime();
        } else {
          recharge.switchToSubscription();
        }
        $('.product-bar-recharge').removeClass('show');

        //recharge.refresh();
      });
      return $item;
    }
  }, {
    key: "refreshBarV2",
    value: function refreshBarV2() {
      var _this8 = this;
      var recharge = this.getRecharge();
      if (!recharge) {
        return;
      }
      var $items = $('.product-bar-recharge-items');
      $items.html('');
      var variants = recharge.getProcessedOneTimeVariants();
      if (variants.length === 0) {
        var variant = recharge.getCurrentVariant();
        if (variant) {
          variants = [variant];
        }
      }
      if (variants.length === 0) {
        console.error('refreshBarV2 empty variants');
        return;
      }
      variants.forEach(function (variant) {
        $items.append(_this8.getBarV2Item(variant.oneTime.id, variant.oneTime, 'onetime'));
        if (variant.subscription) {
          $items.append(_this8.getBarV2Item(variant.oneTime.id, variant.subscription, 'subscription'));
        }
      });
      var variantId = recharge.getCurrentVariant().oneTime.id;
      var type = 'onetime';
      if (recharge.isSubscriptionSelected()) {
        type = 'subscription';
      }
      $('.product-bar-recharge-item[data-variant-type=' + type + ']').hide();
      if ($('.recharge-subscription-widget-v2').hasClass('discount-applied')) {
        $('.product-bar-recharge').addClass('discount-applied');
      } else {
        $('.product-bar-recharge').removeClass('discount-applied');
      }
      this.changeBarV2(variantId, type);
    }
  }, {
    key: "updateRechargeWidget",
    value: function updateRechargeWidget() {
      return;
      var productId = $('[data-product-form]').data('product-id');
      var $widget = $('.subscription-widget-option-subscription.' + productId);
      if ($widget.hasClass('price-updated')) {
        return;
      }
      var value = $('#recurring-time-price_' + productId).text();
      if (value.trim() === '') {
        return;
      }
      value = value.replace(/[^0-9.]/g, "");
      value = value.split('.');
      $widget.find('.subscription-widget-price-value').text('$' + value[0] + '.' + value[1]);
      $widget.addClass('price-updated');
      this.refreshBar();
      clearInterval(this._rechargeWidgetInterval);
    }
  }, {
    key: "initBarV4",
    value: function initBarV4() {
      var self = this;
      var $input = $('.product-info-recharge .subscription-widget-radio-container input');
      var recharge = this.getRecharge();

      // One-time prices
      var onetimePriceOld = $('.product-info-recharge [data-recharge-one-time-price-old]').html();
      var onetimePriceNow = $('.product-info-recharge [data-recharge-one-time-price-now]').html();
      $('.product-info-buy-onetime [data-recharge-one-time-price-old]').html(onetimePriceOld);
      $('.product-info-buy-onetime [data-recharge-one-time-price-now]').html(onetimePriceNow);
      $('.product-bar [data-recharge-one-time-price-old]').html(onetimePriceOld);
      $('.product-bar [data-recharge-one-time-price-now]').html(onetimePriceNow);

      // Subscription prices
      var ssPriceOld = $('.product-info-recharge [data-recharge-subscription-price-old]').html();
      var ssPriceNow = $('.product-info-recharge [data-recharge-subscription-price-now]').html();
      $('.product-bar [data-recharge-subscription-price-old]').html(ssPriceOld);
      $('.product-bar [data-recharge-subscription-price-now]').html(ssPriceNow);

      // Subscription discount percent
      var discountPercent = $('.product-info-recharge [data-recharge-subscription-off]').html();
      $('.product-bar [data-recharge-subscription-off]').html(discountPercent);

      // Terms
      var htmlTerms = $('.product-info-recharge .subscription-widget-terms').html();
      $('.product-bar .subscription-widget-terms').html(htmlTerms);
      $('.product-bar input[type="checkbox"]').on('change', function (e) {
        if (e.currentTarget.checked) {
          recharge.switchToSubscription();
        } else {
          recharge.switchToOneTime();
        }
      });
      $('.product-info-recharge [data-recharge-option-input]').on('change', function (e) {
        if (e.currentTarget.value == 'subscription') {
          recharge.switchToSubscription();
        } else {
          recharge.switchToOneTime();
        }
      });
      $('.product-info-buy .quantity').on('change', function (e) {
        $('.product-bar-qty .quantity').val($(this).val());
      });
      var $increase = $('.product-bar-qty .increase');
      var increaseTipped = Tipped.create($increase, {
        showOn: false,
        hideOn: 'click',
        hideOnClickOutside: true
      });
      $(window).scroll(function () {
        if (Tipped.visible($increase)) {
          increaseTipped.hide();
        }
        if ($('.product-info-buy').length > 0) {
          var $scrollTop = $(window).scrollTop();
          var $viewPortHeight = $(window).height();
          var $scrollPosition = $viewPortHeight + $scrollTop;
          var $pageHeight = $(document).height();
          var pageBottomOffset = 30;
          if ($scrollPosition >= $pageHeight - pageBottomOffset) {
            $('body').removeClass('show-product-bar');
          } else if ($scrollTop > $('.product-info-buy').offset().top) {
            $('body').addClass('show-product-bar');
          } else {
            $('body').removeClass('show-product-bar');
          }
        }
      });
      $increase.on('click', function (e) {
        e.preventDefault();
        if (typeof $(this).attr('disabled') !== 'undefined') {
          increaseTipped.show();
          return false;
        }
        $('.product-info-buy .increase').click();
      });
      $('.product-bar-qty .decrease').on('click', function (e) {
        e.preventDefault();
        $('.product-info-buy .decrease').click();
      });
      $('.product-bar [data-cart-add-bar]').on('click', function (e) {
        e.preventDefault();
        if ($('.product-info-recharge .subscription-widget-radio-container input:checked').val() === 'autodeliver') {
          $('.product-info-recharge [data-subscription-terms] input').prop('checked', true);
        }
        $('[data-cart-add]').click();
      });
    }
  }, {
    key: "initBuy",
    value: function initBuy() {
      var _this9 = this;
      var doNotAllowOverQuantity = true;
      var $increaseButton = $('.product-info-buy-qty .increase');
      var $decreaseButton = $('.product-info-buy-qty .decrease');
      var $quantity = $('.product-info-buy-qty .quantity');
      var increaseTipped = Tipped.create($increaseButton, function () {
        return $increaseButton.data('content');
      }, {
        showOn: false,
        hideOn: 'click',
        hideOnClickOutside: true,
        cache: false
      });
      $increaseButton.on('click', function (e) {
        e.preventDefault();
        if (typeof $increaseButton.attr('disabled') !== 'undefined') {
          $increaseButton.data('content', 'You can\'t purchase more than ' + _this9.getBuyQuantityLimit() + ' item(s) per order.');
          increaseTipped.show();
          return false;
        }
        _this9.updateBuyQuantity(_this9.getBuyQuantity() + 1);
      });
      $decreaseButton.on('click', function (e) {
        e.preventDefault();
        if (typeof $decreaseButton.attr('disabled') !== 'undefined') {
          return false;
        }
        _this9.updateBuyQuantity(_this9.getBuyQuantity() - 1);
      });
      $decreaseButton.attr('disabled', 'disabled');
      $('.product-bar-qty .decrease').attr('disabled', 'disabled');
      $quantity.on('change', function (e) {
        _this9.updateQuantity();
      });
      if ($('form[data-has-sub]').length > 0) {
        var self = this;
        $('.product-info-buy-onetime-selection').click(function () {
          var _this10 = this;
          var selectType = function selectType(type) {
            $(_this10).closest('form').find('.subscription-widget-option').find('input[type="radio"]:checked').prop('checked', false);
            var sms = false;
            if (type == 'subscription' && self.isRechargeActive()) {
              sms = self.getSMS();
            }
            if (sms) {
              sms.prop('checked', true);
            } else {
              $(_this10).closest('form').find('.subscription-widget-option-' + type).find('input[type="radio"]').prop('checked', true);
            }
          };
          selectType('one-time');
          $(this).closest('form').find('.product-info-buy-button button').trigger('click');
          selectType('subscription');
        });
        $('[data-recharge-perks]').click(function () {
          $('.subscription-widget-perks-container').show();
        });
        $('.subscription-widget-perks-container').click(function () {
          $(this).hide();
        });
      }
    }
  }, {
    key: "updateQuantity",
    value: function updateQuantity() {
      var doNotAllowOverQuantity = true;
      var $quantity = $('.product-info-buy-qty .quantity');
      var $increaseButton = $('.product-info-buy-qty .increase');
      var $decreaseButton = $('.product-info-buy-qty .decrease');
      var value = this.getBuyQuantity();
      var limit = this.getBuyQuantityLimit();
      if (value !== $quantity.val()) {
        $quantity.val(value);
      }
      if (doNotAllowOverQuantity && limit && value >= limit) {
        $quantity.val(limit);
        $('.product-bar-qty .increase').attr('disabled', 'disabled');
        $increaseButton.attr('disabled', 'disabled');
      } else {
        $('.product-bar-qty .increase').removeAttr('disabled');
        $increaseButton.removeAttr('disabled');
      }
      if (this.getBuyQuantity() > 1) {
        $('.product-bar-qty .decrease').removeAttr('disabled');
        $decreaseButton.removeAttr('disabled');
      } else {
        $('.product-bar-qty .decrease').attr('disabled', 'disabled');
        $decreaseButton.attr('disabled', 'disabled');
      }
    }
  }, {
    key: "getBuyQuantityLimit",
    value: function getBuyQuantityLimit() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getCartLimit();
      }
      var limit = $('.product-info-buy-button button').data('cart-limit');
      if (typeof limit !== 'undefined') {
        limit = parseInt(limit);
      } else {
        limit = null;
      }
      return limit;
    }
  }, {
    key: "getBuyQuantity",
    value: function getBuyQuantity() {
      var quantity = $('.product-info-buy-qty .quantity').val();
      if (!quantity) {
        quantity = 1;
      }
      quantity = parseInt(quantity);
      if (quantity < 1) {
        quantity = 1;
      }
      return quantity;
    }
  }, {
    key: "updateBuyQuantity",
    value: function updateBuyQuantity(quantity) {
      $('.product-info-buy-qty .quantity').val(quantity).trigger('change');
    }
  }, {
    key: "initGeo",
    value: function initGeo() {
      vegamour.country.getLocation();
    }
  }, {
    key: "initFaq",
    value: function initFaq() {
      $('.product-faq-item').each(function () {
        var _this11 = this;
        var $faq = $(this);
        $faq.find('.product-faq-item-question, .product-faq-item-show').on('click', function (e) {
          e.preventDefault();
          var $answer = $(_this11).find('.product-faq-item-answer');
          if ($answer.is(':visible')) {
            $answer.slideUp(200);
          } else {
            $answer.slideDown(200);
          }
        });
      });
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      return this.isThemeV4() ? $(window).width() <= 1024 : vegamour.isMobile();
    }
  }, {
    key: "isThemeV4",
    value: function isThemeV4() {
      return document.body.classList.contains('theme-v4');
    }
  }, {
    key: "initMobile",
    value: function initMobile() {
      if (!this.isMobile()) {
        return;
      }
      $('.product-gallery').appendTo($('.product-gallery-mobile'));
      $('.product-gallery-mobile').addClass('initialized');
    }
  }, {
    key: "resizeImagesAfterSlick",
    value: function resizeImagesAfterSlick($slick) {
      VegamourImage.resizeImages();
    }
  }, {
    key: "initBoughtTogether",
    value: function initBoughtTogether() {
      if (!this.isMobile()) {
        return;
      }
      var $slick = $('.product-bought-together-items');
      $slick.slick({
        arrows: false,
        variableWidth: true,
        infinite: false
      });
      this.resizeImagesAfterSlick($slick);
    }
  }, {
    key: "initOpinions",
    value: function initOpinions() {
      var $slick = $('.product-opinions-items');
      if ($slick.hasClass('count-0')) {
        return;
      }
      $slick.slick({
        arrows: false,
        autoplay: this.isThemeV4(),
        autoplaySpeed: 4000,
        dots: !this.isThemeV4(),
        slidesToShow: 1,
        responsive: this.isThemeV4() ? false : [{
          breakpoint: 3000,
          settings: 'unslick'
        }, {
          breakpoint: 641,
          settings: {
            slidesToShow: 1
          }
        }]
      });
      if (this.isThemeV4()) {
        var $dots = $slick.closest('.product-section').find('.carousel-dots-logos');
        $dots.find('div').click(function (e) {
          e.preventDefault();
          if (!$(this).hasClass('active')) {
            $(this).siblings('.active').removeClass('active');
            $(this).addClass('active');
            $slick.slick('slickGoTo', $(this).data('item'));
          }
        });
        $slick.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
          $dots.find('div.active').removeClass('active');
          $dots.find('div[data-item=' + nextSlide + ']').addClass('active');
        });
      }
      this.resizeImagesAfterSlick($slick);
    }
  }, {
    key: "initIngredients",
    value: function initIngredients() {
      if (!this.isMobile()) {
        return;
      }
      if (this.isThemeV4()) {
        return;
      }
      var $slick = $('.product-ingredients-items');
      $slick.each(function () {
        var infinite = !$(this).closest('.product-section-block').hasClass('product-section-science');
        $(this).slick({
          arrows: false,
          centerMode: true,
          variableWidth: true,
          infinite: infinite
        });
      });
      this.resizeImagesAfterSlick($slick);
    }
  }, {
    key: "initDiscover",
    value: function initDiscover() {
      if (!this.isMobile()) {
        return;
      }
      var $slick = $('.product-discover-items');
      $slick.slick({
        prevArrow: '<a class="product-arrow previous" tabindex="0" role="button"><p class="visually-hidden">Go to previous slide</p></a>',
        nextArrow: '<a class="product-arrow next" tabindex="0" role="button"><p class="visually-hidden">Go to next slide</p></a>',
        variableWidth: true,
        infinite: false
      });
      this.resizeImagesAfterSlick($slick);
    }

    /* for videos on pdp with old design */
  }, {
    key: "onFlickityChange",
    value: function onFlickityChange() {
      var $container = $('[data-template="product"]');
      var $carousel = $container.find('[data-carousel-main]');
      $carousel.on('change.flickity', function (event, index) {
        $carousel.find('video.custom_video').trigger('pause');
      });
    }
  }, {
    key: "initVariants",
    value: function initVariants() {
      var $variantSelector = $('[data-single-option-selector]');
      if ($variantSelector.length === 0) {
        return;
      }
      $variantSelector.on('change', function () {
        var $this = $(this);
        var $option = $($this[0].options[$this[0].selectedIndex]);
        $('[data-variant-selector]').removeClass('active');
        $('[data-variant-selector="' + $option.data('variant-id') + '"]').addClass('active');
      });
      $('[data-variant-selector]').on('click', function (e) {
        var $this = $(this);
        e.preventDefault();
        $.each($('[data-single-option-selector]')[0].options, function (i) {
          var option = $variantSelector[0].options[i];
          if ($this.data('variant-selector') === $(option).data('variant-id')) {
            $('[data-single-option-selector]').val(option.value).trigger('change');
          }
        });
      });
      $('[data-variant-selector="' + $($variantSelector[0].options[$variantSelector[0].selectedIndex]).data('variant-id') + '"]').addClass('active');
    }
  }, {
    key: "initAnchorScroll",
    value: function initAnchorScroll() {
      var _this12 = this;
      if ($('#reviews').length === 0 || !window.location.hash) {
        return;
      }
      this.scroll(this.calcTop());
      $(window).on('load', function () {
        _this12.scroll(_this12.calcTop());
      });
    }
  }, {
    key: "scroll",
    value: function scroll(to, callback) {
      $('html, body').animate({
        scrollTop: to
      }, 0, callback);
    }
  }, {
    key: "calcTop",
    value: function calcTop() {
      var offset = 0;
      switch (window.location.hash.replace('#', '')) {
        case 'reviews':
        case 'ingredients':
          offset = 150;
          break;
        default:
          offset = 80;
          break;
      }
      return $(window.location.hash).offset().top - offset;
    }
  }, {
    key: "refreshGeo",
    value: function refreshGeo() {
      var geo = vegamour.geolocation.getLocationData();
      if (!geo || geo.state !== 'California') {
        $('[data-modal-subscription-terms-ca]').hide();
        $('[data-modal-subscription-terms-all]').show();
      } else {
        $('[data-modal-subscription-terms-ca]').show();
        $('[data-modal-subscription-terms-all]').hide();
      }
      if (!geo || geo.country.code === 'US') {
        $('[data-int-disclaimer]').hide();
      } else {
        $('[data-int-disclaimer]').show();
      }
    }
  }, {
    key: "initClaimsTab",
    value: function initClaimsTab() {
      var tabBtns = $('.clinically-tested-block-testimonials-tab-btn');
      if (tabBtns.length > 0) {
        tabBtns.each(function (i, tab) {
          tab.addEventListener('click', function (e) {
            var tabId = e.target.dataset.claimTabId;
            $('.product-tested-item-container--show').removeClass('product-tested-item-container--show');
            $("[data-claim-tab-panel-id=\"".concat(tabId, "\"]")).addClass('product-tested-item-container--show');
            $('.clinically-tested-block-testimonials-tab-btn--selected').removeClass('clinically-tested-block-testimonials-tab-btn--selected');
            $(e.target).addClass('clinically-tested-block-testimonials-tab-btn--selected');
          });
        });
      }
    }
  }]);
  return VegamourProduct;
}(Events);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VegamourQuickView = /*#__PURE__*/function (_Events) {
  _inherits(VegamourQuickView, _Events);
  var _super = _createSuper(VegamourQuickView);
  function VegamourQuickView() {
    var _this;
    _classCallCheck(this, VegamourQuickView);
    _this = _super.call(this);
    _this.init();
    return _this;
  }
  _createClass(VegamourQuickView, [{
    key: "init",
    value: function init() {
      var self = this;
      if (vegamourOptions.expressCart) {
        $("body").on("click", "#quick-view [data-cart-add]", function (e) {
          var _this2 = this;
          e.preventDefault();
          if (typeof $(this).attr('disabled') !== 'undefined') {
            return false;
          }
          $(this).addClass('loading').attr('disabled', 'disabled');
          $('[data-cart-add-bar]').addClass('loading').attr('disabled', 'disabled');
          self.submitQuickView(function () {
            $(_this2).removeClass('loading').removeAttr('disabled');
            $('[data-cart-add-bar]').removeClass('loading').removeAttr('disabled');
          });
        });
      }
      $(document).ready(function () {
        self.initQuickView();
        self.initQuickViewV3();
        self.initQuickAdd();
        self.addIosClass();
        self.initModal();
      });
    }
  }, {
    key: "addIosClass",
    value: function addIosClass() {
      if (this.isIOS()) {
        $('html').addClass('ios');
      }
    }
  }, {
    key: "isIOS",
    value: function isIOS() {
      return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
    }
  }, {
    key: "initQuickView",
    value: function initQuickView() {
      var self = this;
      if ($('body').hasClass('quick-view-drawer')) {
        return false;
      }
      $('.js-quick-view').unbind('click').click(function () {
        if ($('.quick-view-wrap').length == 0) {
          $("body").append('<div class="quick-view-overlay"></div><div class="quick-view-wrap"><button class="quick-view-close-btn icon-ionicons_svg_md-close"></button><div id="quick-view" class="loading"><div class="vegamour-loader"></div></div></div>');
          $('.quick-view-close-btn').click(function () {
            $('.quick-view-wrap').remove();
            $('.quick-view-overlay').remove();
            var $modalContainer = $('.fancybox-wrap');
            if ($modalContainer) modalClosedAccessibilityAdjustments($modalContainer);
            document.getElementsByTagName('html')[0].classList.remove('fancybox-active');
          });
        }
        var product_handle = $(this).data('handle');
        var productId = $(this).data('id');
        document.getElementsByTagName('html')[0].classList.add('fancybox-active');
        $('#quick-view').addClass(product_handle);
        $('.quick-view-wrap').show();
        $.get(window.Shopify.routes.root + 'products/' + product_handle + '?view=quick-popup', function (productView) {
          $('#quick-view').html(productView);
          self.initRechargeOnQuickView(productId);
          var recharge = vegamour.getRecharge(productId);
          if (!recharge) {
            vegamour.initRecharge();
          } else {
            recharge.init();
          }
          $('#quick-view form').find('[data-recharge-option-input-subscription]').trigger('click');
          $('#quick-view').removeClass('loading');
          vegamour.cart.discounts.setDiscountDisplay();
          $('#quick-view').show();
          var $modalContainer = $('.fancybox-wrap');
          if ($modalContainer) modalOpenedAccessibilityAdjustments($modalContainer);
        });
      });
    }
  }, {
    key: "setSlideVisibility",
    value: function setSlideVisibility($slider) {
      // Set the first and part of last slides visible

      var visibleSlides = $slider.find('.slick-slide[aria-hidden="false"]');
      $(visibleSlides).each(function () {
        $(this).css('opacity', 1);
      });
      $(visibleSlides).first().prev().css('opacity', 0);
    }
  }, {
    key: "initQuickViewV3",
    value: function initQuickViewV3() {
      var self = this;
      if (!$('body').hasClass('quick-view-drawer')) {
        return false;
      }
      $(".js-quick-view, .js-quick-view-v3").unbind('click').click(function () {
        if ($('#quick-view').length == 0) {
          $("body").append('<div id="quick-view" class="loading"><div class="vegamour-loader"></div></div>');
        }
        var product_handle = $(this).data('handle');
        var productId = $(this).data('id');
        var productThumbPreselected = $(".variant-picker-thumb-selected").text();
        $('#quick-view').addClass(product_handle);
        $.get(window.Shopify.routes.root + 'products/' + product_handle + '?view=quick-popup-v3', function (productView) {
          $('#quick-view').html(productView);
          self.initRechargeOnQuickView(productId);
          var recharge = vegamour.getRecharge(productId);
          if (!recharge) {
            vegamour.initRecharge();
          } else {
            recharge.init();
          }
          $('#quick-view form').find('[data-recharge-option-input-subscription]').trigger('click');
          $('#quick-view').removeClass('loading');

          // update fancybox dimensions
          $.fancybox.update();
          setTimeout(function () {
            $.fancybox.update();
          }, 1000);

          //    Slick
          var $slick = $('.js-quick-view-gallery');
          var settings = {
            dots: true,
            arrows: true,
            prevArrow: '<svg class="prevArrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.00036 14.7082L14 7.7089L6.99964 0.70821" stroke="#573C2A" stroke-width="2"/></svg>',
            nextArrow: '<svg class="nextArrow" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.00036 14.7082L14 7.7089L6.99964 0.70821" stroke="#573C2A" stroke-width="2"/></svg>',
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '0px'
          };
          $slick.not('.slick-initialized').slick(settings);
          self.resizeImagesAfterSlick($slick);
          //    End: Slick

          $(".variant-picker-thumb-selected").text($(".variant-picker-thumb.active").attr("data-thumb"));
          if (productThumbPreselected) {
            $(".variant-picker-thumb[data-thumb='".concat(productThumbPreselected, "']")).click();
            $(".variant-picker-thumb-selected-qv").text(productThumbPreselected);
          }
          var $button = $(".variant-picker-thumb");
          $button.on('click', function (e) {
            e.preventDefault();
            $button.removeClass('active');
            $(e.currentTarget).addClass('active');
            $(".variant-picker-thumb-selected-qv").text(e.currentTarget.dataset.thumb);
          });
          self.initQuantityButtons();
        });
        $.fancybox({
          href: '#quick-view',
          maxWidth: 880,
          maxHeight: 'auto',
          padding: 30,
          backFocus: false,
          hideScrollbar: false,
          fitToView: true,
          width: 'auto',
          height: 'auto',
          autoScale: true,
          autoSize: false,
          autoDimensions: true,
          closeClick: false,
          openEffect: 'none',
          closeEffect: 'none',
          'beforeLoad': function beforeLoad() {
            document.getElementsByTagName('html')[0].classList.add('fancybox-active');
          },
          'afterShow': function afterShow() {},
          'afterClose': function afterClose() {
            $('#quick-view').remove();
            document.getElementsByTagName('html')[0].classList.remove('fancybox-active');
          }
        });
      });
    }
  }, {
    key: "initQuickAdd",
    value: function initQuickAdd() {
      var self = this;
      $('.js-quick-add, .js-quick-subscribe').each(function () {
        if (!$(this).hasClass('js-initialized')) {
          var handle = $(this).data('handle');
          if (handle) {
            $(this).click(function (e) {
              e.preventDefault();
              var data = $(this).data();
              self.quickAdd(data.handle, $(this).hasClass('js-quick-subscribe'), $(this).data());
            }).addClass('js-initialized');
          }
        }
      });
    }
  }, {
    key: "initModal",
    value: function initModal() {
      $('[data-toggle="modal"]').each(function () {
        var targetModal = $(this.dataset.target);
        if (!targetModal.hasClass('show')) {
          targetModal.hide(200);
        }
        targetModal.find('[data-dismiss="modal"]').each(function (closeBtn) {
          $(closeBtn.target).click(function () {
            targetModal.hide(200);
          });
        });
        targetModal.click(function (e) {
          if (e.target === targetModal[0]) {
            targetModal.hide(200);
          }
        });
        targetModal.find('modal-dialog').click(function (e) {
          e.stopPropagation();
        });
        $(this).click(function () {
          targetModal.show();
        });
      });
    }
  }, {
    key: "quickAdd",
    value: function quickAdd(productHandle, isSub, properties, showCart) {
      isSub = typeof isSub === 'undefined' ? false : isSub;
      showCart = typeof showCart === 'undefined' ? true : showCart;
      if (typeof productHandle === 'undefined' || !productHandle) {
        return false;
      }
      $.getJSON(window.Shopify.routes.root + 'products/' + productHandle + '.js', function (product) {
        variant = false;
        product.variants.some(function (v) {
          var variantIsSub = v.option1.toLowerCase().indexOf('subscription') !== -1;
          if (v.available && (isSub && variantIsSub || !isSub && !variantIsSub)) {
            variant = v;
            return true;
          }
        });
        if (!variant) {
          variant = product.variants[0];
        }
        var prop = {};
        var prod = {
          'id': variant.id.toString(),
          'quantity': 1
        };
        if (isSub) {
          var sellingPlan = product.selling_plan_groups[0].selling_plans[0];
          var sellingPlanOption = sellingPlan.options[0].value.toLowerCase().replace('(s)', '').split(' ');
          prod['selling_plan'] = sellingPlan.id;
          prop['_shipping_interval_frequency'] = parseInt(sellingPlanOption[0]); // _ 추가
          prop['_shipping_interval_unit_type'] = sellingPlanOption[1]; // _ 추가
        }
        product.tags.forEach(function (tag) {
          var tagName = 'cart-limit-';
          if (tag.indexOf(tagName) !== -1) {
            prop['_cart_limit'] = parseInt(tag.replace(tagName, '')); // _ 추가
          }
        });
        if (product.compare_at_price_max > product.price) {
          prop['_custom_save'] = (1 - product.price / product.compare_at_price_max) * 100; // _ 추가
        }
        $.get(window.Shopify.routes.root + 'products/' + productHandle + '?view=metafields&namespace=global&type=json', function (meta) {
          var addToProp = function addToProp(attr, value) {
            attr = attr.replace(/[A-Z]/g, function (m) {
              return '_' + m.toLowerCase();
            });
            // ⭐ 이 부분 중요! 기존 속성명 앞에 _ 를 붙여줍니다.
            if (attr.indexOf('_') !== 0) {
              attr = '_' + attr;
            }
            prop[attr] = value;
          };
          meta = JSON.parse(meta);
          if (meta) {
            for (var attr in meta) {
              if (attr.indexOf('contains') !== -1) {
                addToProp(attr, meta[attr]);
              }
            }
          }
          if (typeof properties !== 'undefined' && properties && !$.isEmptyObject(properties)) {
            for (var _attr in properties) {
              if (_attr.indexOf('handle') === -1) {
                addToProp(_attr, properties[_attr]);
              }
            }
          }
          if (!$.isEmptyObject(prop)) {
            prod['properties'] = prop;
          }
          console.log(prod);
          vegamour.cart.add(prod);
          if (showCart && vegamourOptions.expressCart) {
            vegamour.cart.express.show();
          }
        });
      });
    }
  }, {
    key: "initQuantityButtons",
    value: function initQuantityButtons() {
      var $qtyInput = $('input.js-qty-input');
      $('.btnqty').on('click', function () {
        var qty = parseInt($qtyInput.val());
        if ($(this).hasClass('qtyplus')) {
          qty++;
        } else {
          if (qty > 1) {
            qty--;
          }
        }
        qty = isNaN(qty) ? 1 : qty;
        $qtyInput.val(qty);
      });
    }
  }, {
    key: "resizeImagesAfterSlick",
    value: function resizeImagesAfterSlick($slick) {
      VegamourImage.resizeImages();
    }
  }, {
    key: "initRechargeOnQuickView",
    value: function initRechargeOnQuickView(quickViewProductId) {
      var _this3 = this;
      var productId = quickViewProductId;
      var $subscriptionWidget = $('[data-recharge-subscription-widget="' + productId + '"]');
      var $widgetContainer = $('[data-recharge-widget-product-id="' + productId + '"]');
      if ($widgetContainer.length > 0 && $subscriptionWidget.length > 0) {
        $('[data-recharge-subscription-widget-loader="' + productId + '"]').hide();
        $subscriptionWidget.find('.inner').append($widgetContainer);
        $('#quick-view form').find('[data-input-subscription]').trigger('click');
        if (typeof LoopOnstore !== 'undefined' && LoopOnstore.isActive()) {
          this.form().find('[data-input-one-time]').trigger('click');
          this.form().find('.subscription-widget-option-subscription').hide();
        }
        $subscriptionWidget.find('input:checked').trigger('click');
        $subscriptionWidget.show();
        $widgetContainer.show();
      }
      this._rechargeWidgetInterval = setInterval(function () {
        _this3.updateRechargeWidgetQuickView(productId);
      }, 25);
    }
  }, {
    key: "updateRechargeWidgetQuickView",
    value: function updateRechargeWidgetQuickView(quickViewProductId) {
      return;
      var productId = quickViewProductId;
      var $widget = $('.subscription-widget-option-subscription.' + productId);
      if ($widget.hasClass('price-updated')) {
        return;
      }
      var value = $('#recurring-time-price_' + productId).text();
      if (value.trim() === '') {
        return;
      }
      value = value.replace(/[^0-9.]/g, "");
      value = value.split('.');
      $widget.find('.subscription-widget-price-value').text('$' + value[0] + '.' + value[1]);
      $widget.addClass('price-updated');
      clearInterval(this._rechargeWidgetInterval);
    }
  }, {
    key: "submitQuickView",
    value: function submitQuickView(callback) {
      var data = {
        id: this.getProductId(),
        quantity: this.getQuantity(),
        properties: {
          _cart_limit: this.getCartLimit()
        }
      };
      if (this.isCbd()) {
        data.properties._contains_cbd = 1;
      }
      if (this.isCbdEdible()) {
        data.properties._contains_cbd_edible = 1;
      }
      if (this.isHazmat()) {
        data.properties._contains_hazmat = 1;
      }
      if (this.isProposition65()) {
        data.properties._proposition_65 = 1;
      }
      if (this.isCustomTitle()) {
        data.properties._custom_title = this.getCustomTitle();
      }
      if (this.isCustomSave()) {
        data.properties._custom_save = this.getCustomSave();
      }
      if (this.isOneTimeSelected()) {
        if (this.isCustomSubscription()) {
          data.properties._custom_subscription = this.getCustomSubscription();
        }
        if (this.isOnlyOneTime()) {
          data.properties._only_onetime = 1;
        }

        // 👇 아래 두 줄 추가
        data.properties._shipping_interval_frequency = this.getShippingFrequency() || '30';
        data.properties._shipping_interval_unit_type = this.getShippingUnitType() || 'day';

        // 👇 커스텀 배송비 로직용 태그 (one-time)
        data.properties._is_subscription = 'false';
        data.properties._is_one_time_purchase = 'true';

        // One-Time item
        vegamour.cart.express.open();
        vegamour.cart.loader(true);
        vegamour.cart.add(data, function () {
          vegamour.cart.loader(false);
          if (typeof callback === 'function') {
            callback();
          }
        });
        $('.quick-view-close-btn').click();
      } else {
        // Subscription item
        data.selling_plan = this.getSellingPlanId();
        // 👇 마지막 할당 시 기본값 강제 적용
        data.properties._shipping_interval_frequency = this.getShippingFrequency() || '30';
        data.properties._shipping_interval_unit_type = this.getShippingUnitType() || 'day';

        // 👇 커스텀 배송비 로직용 태그 (subscription)
        data.properties._is_subscription = 'true';
        data.properties._is_one_time_purchase = 'false';

        vegamour.cart.express.open();
        vegamour.cart.loader(true);
        vegamour.cart.add(data, function () {
          vegamour.cart.loader(false);
          if (typeof callback === 'function') {
            callback();
          }
        });
        $('.quick-view-close-btn').click();
      }
    }
  }, {
    key: "isProposition65",
    value: function isProposition65() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isProposition65();
      }
      return parseInt(this.formData()['properties[_proposition_65]']) === 1;
    }
  }, {
    key: "isCbd",
    value: function isCbd() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isCbd();
      }
      return parseInt(this.formData()['properties[_contains_cbd]']) === 1;
    }
  }, {
    key: "isCbdEdible",
    value: function isCbdEdible() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isCbdEdible();
      }
      return parseInt(this.formData()['properties[_contains_cbd_edible]']) === 1;
    }
  }, {
    key: "isHazmat",
    value: function isHazmat() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isHazmat();
      }
      return parseInt(this.formData()['properties[_contains_hazmat]']) === 1;
    }
  }, {
    key: "isCustomTitle",
    value: function isCustomTitle() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isCustomTitle();
      }
      return typeof this.formData()['properties[_custom_title]'] !== 'undefined';
    }
  }, {
    key: "isCustomSave",
    value: function isCustomSave(){
      if (this.isRechargeActive()) {
        return this.getRecharge().isCustomSave();
      }
      // 기존에 무조건 false를 반환하던 것을 폼 데이터에 해당 속성이 있는지 확인하도록 변경
      return typeof (this.formData()['properties[_custom_save]'] || this.formData()['properties[custom_save]']) !== 'undefined';
    }
  }, {
    key: "getCustomSave",
    value: function getCustomSave() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getCustomSave();
      }
      // 폼 데이터에서 할인율 값을 올바르게 읽어오도록 변경
      return this.formData()['properties[_custom_save]'] || this.formData()['properties[custom_save]'] || null;
    }
  }, {
    key: "isCustomSubscription",
    value: function isCustomSubscription() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isCustomSubscription();
      }
      return false;
    }
  }, {
    key: "isOnlyOneTime",
    value: function isOnlyOneTime() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isOnlyOneTime();
      }
      return false;
    }
  }, {
    key: "getCustomSubscription",
    value: function getCustomSubscription() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getCustomSubscription();
      }
      return null;
    }
  }, {
    key: "getCustomTitle",
    value: function getCustomTitle() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getCustomTitle();
      }
      return this.formData()['properties[_custom_title]'];
    }
  }, {
    key: "getShippingUnitType",
    value: function getShippingUnitType() {
      if (this.isRechargeActive()) {
        var val = this.getRecharge().getShippingUnit();
        if (val) return val;
      }
      // 값이 없을 경우 기본값 'Day' 반환
      return this.formData()['properties[_shipping_interval_unit_type]'] || this.formData()['properties[shipping_interval_unit_type]'] || 'Day';
    }
  }, {
    key: "getShippingFrequency",
    value: function getShippingFrequency() {
      if (this.isRechargeActive()) {
        var freq = this.getRecharge().getShippingFrequency();
        if (freq) return freq;
      }
      return this.formData()['properties[_shipping_interval_frequency]'] ||
        this.formData()['properties[shipping_interval_frequency]'] || '30';
    }
  }, {
    key: "getSubscriptionId",
    value: function getSubscriptionId() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getSubscriptionId();
      }
      return this.formData()['properties[subscription_id]'];
    }
  }, {
    key: "getSellingPlanId",
    value: function getSellingPlanId() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getSellingPlanId();
      }
      return this.formData()['selling_plan'];
    }
  }, {
    key: "getQuantity",
    value: function getQuantity() {
      return parseInt(this.formData().quantity);
    }
  }, {
    key: "getCartLimit",
    value: function getCartLimit() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getCartLimit();
      }
      var cartLimit = $('#quick-view form').find('[data-cart-add]').attr('data-cart-limit');
      if (typeof cartLimit === 'undefined' || !cartLimit) {
        cartLimit = null;
      }
      return cartLimit;
    }
  }, {
    key: "isRechargeActive",
    value: function isRechargeActive() {
      return this.form().find('.recharge-subscription-widget-v2').length > 0 && typeof this.getRecharge() !== 'undefined';
    }
  }, {
    key: "getRecharge",
    value: function getRecharge() {
      return this.form().find('.recharge-subscription-widget-v2').data('recharge');
    }
  }, {
    key: "getProductId",
    value: function getProductId() {
      if (this.isRechargeActive()) {
        return this.getRecharge().getCurrentVariantId();
      }
      var productId = $('#quick-view form').data('product-id');
      if ($('#quick-view [data-single-option-selector]:checked').length > 0) {
        if (this.currentVariant !== null) {
          productId = this.currentVariant.id;
        }
      } else {
        if ($('#quick-view select[data-single-option-selector]').length > 0) {
          if (this.isOneTimeSelected()) {
            productId = $('#quick-view select[data-single-option-selector] option:selected').data('variant-id');
          } else {
            productId = $('#quick-view select[data-single-option-selector] option:selected').data('discount-variant-id');
          }
        }
      }
      if (this.isOneTimeSelected()) {
        var variantTitle = $('select[data-single-option-selector] option:selected').text().trim();

        // Get One-Time product based on variant title
        // it is always "xxxxxx - One-Time"
        $('select[data-single-option-selector] option').each(function () {
          var oneTime = $(this).text().split('-');
          if (oneTime.length > 1) {
            if (variantTitle === oneTime[0].trim()) {
              productId = $(this).data('variant-id');
            }
          }
        });
      }
      return productId;
    }
  }, {
    key: "isOneTimeSelected",
    value: function isOneTimeSelected() {
      if (this.isRechargeActive()) {
        return this.getRecharge().isOneTimeSelected();
      }
      var formData = this.formData();
      var productId = $('#quick-view form').data('product-id');
      return typeof formData['autodeliver_' + productId] === 'undefined' || formData['autodeliver_' + productId] === 'onetime';
    }
  }, {
    key: "form",
    value: function form() {
      return $('#quick-view form');
    }
  }, {
    key: "formData",
    value: function formData() {
      function getFormData() {
        var $form = $('#quick-view form');
        var unindexedArray = $form.serializeArray();
        var indexedArray = {};
        $.map(unindexedArray, function (n, i) {
          indexedArray[n['name']] = n['value'];
        });
        return indexedArray;
      }
      return getFormData(this.form());
    }
  }]);
  return VegamourQuickView;
}(Events);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourGifts = /*#__PURE__*/function () {
  function VegamourGifts() {
    _classCallCheck(this, VegamourGifts);
    this.gifts = [];
    this.tierCookie = '_gt';
    this.giftsCleared = false;
  }
  _createClass(VegamourGifts, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.clearInactiveGifts();
      var giftJSON = this.getGifts();
      if (giftJSON) {
        giftJSON.forEach(function (gift) {
          var giftObj = new VegamourGift(gift);
          if (giftObj.isActive()) {
            _this.gifts.push(giftObj);
          }
        });
        if (this.gifts.length > 0) {
          this.initEvents();
        }
        this.subtotal = 0;
      }
    }
  }, {
    key: "initEvents",
    value: function initEvents() {
      var _this2 = this;
      vegamour.cart.on('firstUpdate', function () {
        if (vegamour.cart.isUpgrading) {
          return;
        }
        var giftsLimit = [];
        var giftsApply = [];
        _this2.gifts.forEach(function (gift) {
          if (gift.getOverLimitTiers().length > 0) {
            giftsLimit.push(gift);
          }

          // First time update on /cart page in case of redirect
          if ($('#cart-v2').length > 0 && gift.getNotAppliedTiers().length > 0) {
            giftsApply.push(gift);
          }
        });
        _this2.limitGifts(giftsLimit);
        _this2.applyGifts(giftsApply);
        _this2.check(true);
      });
      this.isCheckoutAdjuster = window.location.search.indexOf('view=gift') > -1;
      var self = this;
      if (this.isCheckoutAdjuster) {
        vegamour.cart.on('firstUpdate', function () {
          if ($('#cartUpdating').length) {
            $('#cartUpdating').show();
          }
          setTimeout(function () {
            self.applyGiftsAtCheckout();
          }, 2000);
        });
      } else {
        vegamour.cart.on('update', function () {
          _this2.setTiersCookie();
        });
      }
      vegamour.cart.on('fetchEnd', function () {
        if (vegamour.cart.getSubtotal() != _this2.cartSubtotal) {
          _this2.check();
        }
      });
    }
  }, {
    key: "getGifts",
    value: function getGifts() {
      return typeof vegamourOptions.gifts !== 'undefined' && !$.isEmptyObject(vegamourOptions.gifts) ? vegamourOptions.gifts : false;
    }
  }, {
    key: "check",
    value: function check() {
      if (vegamour.cart.isUpgrading || this.gifts.length === 0) {
        vegamour.cart.express.loader(false);
        return false;
      }
      var giftsLimit = [];
      var giftsApply = [];
      var giftsRemove = [];
      this.gifts.forEach(function (gift) {
        if (gift.getNotAppliedTiers().length > 0) {
          giftsApply.push(gift);
        } else if (gift.getOverLimitTiers().length > 0) {
          giftsLimit.push(gift);
        } else if (gift.getTiersToRemove().length > 0) {
          giftsRemove.push(gift);
        }
      });
      this.limitGifts(giftsLimit);
      this.applyGifts(giftsApply);
      this.removeGifts(giftsRemove);
      if (giftsLimit.length + giftsApply.length + giftsRemove.length > 0) {
        console.log('🎁 Updating applicable gifts');
      } else {
        vegamour.cart.express.loader(false);
      }
    }
  }, {
    key: "getTierData",
    value: function getTierData(encode) {
      encode = typeof encode !== 'undefined' ? encode : false;
      var gt = [];
      if (this.gifts !== 'undefined' && this.gifts.length) {
        var self = this;
        this.gifts.forEach(function (gift) {
          if (gift.isApplicable(false)) {
            var g = [];
            for (var t = 1; t <= 3; t++) {
              var tier = gift.options['tier' + t];
              if (tier.product.variantId !== null) {
                g.push(self.getTierObj(gift, tier, 1, encode));
              }
            }
            if (!$.isEmptyObject(g)) {
              var code = gift.options.discount.enable && gift.options.discount.code.length ? gift.options.discount.code : false;
              var appliesTo = gift.options.appliesTo.charAt(0);
              gt.push({
                d: code,
                a: appliesTo,
                gs: g
              });
            }
          }
        });
      }
      return gt;
    }
  }, {
    key: "getTierObj",
    value: function getTierObj(gift, tier, encode) {
      var amount = gift.getTierValue(tier);
      if (encode) {
        amount = amount.toString(16);
      }
      var multiple = tier.multiple;
      var p = [tier.product.variantId];
      if (typeof tier.product2 !== 'undefined' && tier.product2.variantId !== null) {
        p[p.length] = tier.product2.variantId;
      }
      if (typeof tier.product3 !== 'undefined' && tier.product3.variantId !== null) {
        p[p.length] = tier.product3.variantId;
      }
      if (typeof tier.product4 !== 'undefined' && tier.product4.variantId !== null) {
        p[p.length] = tier.product4.variantId;
      }
      return {
        a: amount,
        m: multiple,
        v: p
      };
    }
  }, {
    key: "setTiersCookie",
    value: function setTiersCookie() {
      var giftTiers = this.getTierData(true);
      if (giftTiers.length) {
        var tc = vegamour.getCookie(this.tierCookie);
        tc = typeof tc !== 'undefined' && tc.length > 0 ? JSON.parse(decodeURIComponent(tc)) : {};
        tc.now = Math.round(Date.now() / 1000);
        tc.g = giftTiers;
        tc = encodeURIComponent(JSON.stringify(tc));
        vegamour.setDomainCookie(this.tierCookie, tc, 1);
      }
    }
  }, {
    key: "applyGiftsAtCheckout",
    value: function applyGiftsAtCheckout() {
      var cartRedirect = true;
      var checkout = function checkout() {
        setTimeout(function () {
          vegamour.cart.checkout();
        }, 500);
      };
      var p = vegamour.getParam('p');
      if (p !== null) {
        var dp = parseInt(p, 16);
        if (dp.toString(16) === p) {
          vegamour.cart.cart.total_price = dp;
          vegamour.cart.unbind('itemAdded').unbind('itemChanged').unbind('itemRemoved').on('updateStart', function () {
            cartRedirect = false;
          }).on('fetchEnd', function () {
            this.fetch = function () {};
            checkout();
          }).gifts.check();
        }
      }
      if (cartRedirect) {
        vegamour.cart.unbind('fetchEnd');
        checkout();
      }
    }
  }, {
    key: "limitGifts",
    value: function limitGifts(gifts) {
      if (gifts.length === 0) {
        return;
      }
      var items = [];
      var cartGifts = [];
      $('.express-cart-item[data-type="gift"]').each(function () {
        cartGifts[cartGifts.length] = parseInt($(this).attr('data-id'));
      });
      gifts.forEach(function (gift) {
        gift.getOverLimitTiers().forEach(function (tier) {
          var max = tier.multiple;
          var giftList = cartGifts.slice(0, max);
          if (cartGifts.includes(tier.product.variantId)) {
            items.push({
              id: tier.product.variantId,
              quantity: giftList.includes(tier.product.variantId) ? 1 : 0
            });
          }
          if (typeof tier.product2 !== 'undefined' && tier.product2.variantId && cartGifts.includes(tier.product2.variantId)) {
            items.push({
              id: tier.product2.variantId,
              quantity: giftList.includes(tier.product2.variantId) ? 1 : 0
            });
          }
          if (typeof tier.product3 !== 'undefined' && tier.product3.variantId && cartGifts.includes(tier.product3.variantId)) {
            items.push({
              id: tier.product3.variantId,
              quantity: giftList.includes(tier.product3.variantId) ? 1 : 0
            });
          }
          if (typeof tier.product4 !== 'undefined' && tier.product4.variantId && cartGifts.includes(tier.product4.variantId)) {
            items.push({
              id: tier.product4.variantId,
              quantity: giftList.includes(tier.product4.variantId) ? 1 : 0
            });
          }
        });
      });
      vegamour.cart.changeMultipleQuantities(items);
    }
  }, {
    key: "applyGifts",
    value: function applyGifts(gifts) {
      if (gifts.length === 0) {
        return;
      }
      var items = [];
      var savedGifts = vegamour.cookie.get('g');
      var addItem = function addItem(variantId) {
        items.push({
          id: variantId,
          quantity: 1,
          properties: {
            cart_limit: 1,
            gift: 1
          }
        });
      };
      var cartItems = [];
      if (vegamour.cart.cart.items.length > 0) {
        vegamour.cart.cart.items.forEach(function (item) {
          cartItems.push(item.id);
        });
      }
      gifts.forEach(function (gift) {
        gift.getNotAppliedTiers().forEach(function (tier) {
          var c = 0;
          if (tier.select && savedGifts) {
            if (savedGifts.includes(tier.product.variantId)) {
              if (!cartItems.includes(tier.product.variantId)) {
                addItem(tier.product.variantId);
              }
              c++;
            }
            if (c < tier.multiple && typeof tier.product2 !== 'undefined' && tier.product2.variantId && savedGifts.includes(tier.product2.variantId)) {
              if (!cartItems.includes(tier.product2.variantId)) {
                addItem(tier.product2.variantId);
              }
              c++;
            }
            if (c < tier.multiple && typeof tier.product3 !== 'undefined' && tier.product3.variantId && savedGifts.includes(tier.product3.variantId)) {
              if (!cartItems.includes(tier.product3.variantId)) {
                addItem(tier.product3.variantId);
              }
              c++;
            }
            if (c < tier.multiple && typeof tier.product4 !== 'undefined' && tier.product4.variantId && savedGifts.includes(tier.product4.variantId)) {
              if (!cartItems.includes(tier.product4.variantId)) {
                addItem(tier.product4.variantId);
              }
              c++;
            }
          }
          if (c < tier.multiple) {
            if (!cartItems.includes(tier.product.variantId)) {
              addItem(tier.product.variantId);
            }
            c++;
            if (c < tier.multiple && typeof tier.product2 !== 'undefined' && tier.product2.variantId) {
              if (!cartItems.includes(tier.product2.variantId)) {
                addItem(tier.product2.variantId);
              }
              c++;
            }
            if (c < tier.multiple && typeof tier.product3 !== 'undefined' && tier.product3.variantId) {
              if (!cartItems.includes(tier.product3.variantId)) {
                addItem(tier.product3.variantId);
              }
              c++;
            }
            if (c < tier.multiple && typeof tier.product4 !== 'undefined' && tier.product4.variantId) {
              if (!cartItems.includes(tier.product4.variantId)) {
                addItem(tier.product4.variantId);
              }
              c++;
            }
          }
        });
        console.log('🎁 Applying gift', gift);
      });
      if (items.length) {
        vegamour.cart.addMultiple(items);
      }
    }
  }, {
    key: "removeGifts",
    value: function removeGifts(gifts) {
      if (gifts.length === 0) {
        return;
      }
      var items = [];
      gifts.forEach(function (gift) {
        gift.getTiersToRemove().forEach(function (tier) {
          items.push({
            id: tier.product.variantId,
            quantity: 0
          });
          if (typeof tier.product2 !== 'undefined' && tier.product2.variantId) {
            items.push({
              id: tier.product2.variantId,
              quantity: 0
            });
          }
          if (typeof tier.product3 !== 'undefined' && tier.product3.variantId) {
            items.push({
              id: tier.product3.variantId,
              quantity: 0
            });
          }
          if (typeof tier.product4 !== 'undefined' && tier.product4.variantId) {
            items.push({
              id: tier.product4.variantId,
              quantity: 0
            });
          }
        });
        console.log('🎁 Removing gift', gift);
      });
      vegamour.cart.changeMultipleQuantities(items);
    }
  }, {
    key: "clearInactiveGifts",
    value: function clearInactiveGifts() {
      if (!this.giftsCleared) {
        var inactive = [];
        var activeGifts = [];
        var active = false;
        var gifts = this.getGifts();
        if (gifts && typeof vegamour.cart.items !== 'undefined' && vegamour.cart.items.length > 0) {
          gifts.forEach(function (gift) {
            for (var i = 1; i <= 3; i++) {
              if (gift['tier' + i].product.variantId) {
                activeGifts[activeGifts.length] = gift['tier' + i].product.variantId;
              }
              if (typeof gift['tier' + i].product2 !== 'undefined' && gift['tier' + i].product2.variantId) {
                activeGifts[activeGifts.length] = gift['tier' + i].product2.variantId;
              }
              if (typeof gift['tier' + i].product3 !== 'undefined' && gift['tier' + i].product3.variantId) {
                activeGifts[activeGifts.length] = gift['tier' + i].product3.variantId;
              }
              if (typeof gift['tier' + i].product4 !== 'undefined' && gift['tier' + i].product4.variantId) {
                activeGifts[activeGifts.length] = gift['tier' + i].product4.variantId;
              }
            }
          });
          $.each(vegamour.cart.items, function (i) {
            var item = vegamour.cart.items[i].data;
            if (item.price === 0) {
              if (activeGifts.length && JSON.stringify(activeGifts).indexOf(item.id) > -1) {
                active = true;
              } else {
                inactive.push({
                  id: item.id,
                  quantity: 0,
                  properties: {
                    cart_limit: 1
                  }
                });
              }
            }
          });
          if (inactive.length > 0) {
            console.log('🎁 Removing inactive gifts');
            vegamour.cart.changeMultipleQuantities(inactive);
          }
        }
        if (inactive.length > 0 && !active) {
          var cv = vegamour.getCookie(this.tierCookie);
          if (typeof cv !== 'undefined') {
            vegamour.setDomainCookie(this.tierCookie, '', 1);
          }
        }
      }
      this.giftsCleared = true;
    }
  }, {
    key: "setRemoved",
    value: function setRemoved(variantId) {
      this.gifts.forEach(function (gift) {
        gift.setVariantIdRemoved(variantId);
      });
    }
  }, {
    key: "setGiftLabels",
    value: function setGiftLabels(multiple) {
      if (typeof window.vegamourOptions.gifts === 'undefined' || window.vegamourOptions.gifts.length === 0) {
        return;
      }
      var giftId = $('#express-cart').attr('data-gift-id');
      var gift = {};
      window.vegamourOptions.gifts.some(function (data) {
        if (!giftId || giftId && data.id == giftId) {
          gift = data;
          return true;
        }
      });
      if (typeof multiple === 'undefined') {
        var cartTier = $('#express-cart').attr('data-select-gift-tier');
        if (cartTier) {
          var _multiple = typeof gift['tier' + cartTier].multiple !== 'undefined' ? parseInt(gift['tier' + cartTier].multiple) : 1;
        }
      }
      if (typeof multiple !== 'undefined' && multiple) {
        if (multiple > 1) {
          $('[data-gift-plural] span').show();
          $('[data-gift-select-count]').text(multiple);
        } else {
          $('[data-gift-plural] span').hide();
        }
      }
      $('.change-gift').unbind('click').click(function () {
        $('.express-cart-body').animate({
          scrollTop: $('.express-cart-items').height()
        });
      });
      if (gift.icon) {
        $('.gift-svg:not(.icon-svg)').each(function () {
          $(this).hide();
          $(this).before(gift.icon);
          $(this).prev().addClass('gift-svg icon-svg');
          $(this).remove();
        });
      }
      var labelDefault = 'gift';
      var label = gift.label.toLowerCase();
      if (label == labelDefault) {
        return;
      }
      var labelSelectors = ['[data-gift-plural]', '.type-gift', '.change-gift', '[data-goal-gift]', '.gift-item-heading p'];
      var capitalize = function capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
      };
      labelSelectors.forEach(function (selector) {
        $(selector).each(function () {
          $(this).html($(this).html().replace(' ' + labelDefault, ' ' + label).replace(labelDefault.toUpperCase(), label.toUpperCase()).replace(capitalize(labelDefault), capitalize(label)));
        });
      });
    }
  }]);
  return VegamourGifts;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourGift = /*#__PURE__*/function () {
  function VegamourGift(options) {
    _classCallCheck(this, VegamourGift);
    this.options = options;
  }
  _createClass(VegamourGift, [{
    key: "isTier1OverLimit",
    value: function isTier1OverLimit(tier) {
      return this.countTier1() > tier.multiple;
    }
  }, {
    key: "isTier2OverLimit",
    value: function isTier2OverLimit(tier) {
      return this.countTier2() > tier.multiple;
    }
  }, {
    key: "isTier3OverLimit",
    value: function isTier3OverLimit(tier) {
      return this.countTier3() > tier.multiple;
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return !!this.options.enable && this.options.tier1.product.variantId !== null;
    }
  }, {
    key: "limit",
    value: function limit() {
      if (this.isApplied() && this.count() > 1) {
        console.info('⚡ Limiting ' + this.constructor.name + ' product to 1');
        this.changeQuantity(1);
      }
    }
  }, {
    key: "getTierValue",
    value: function getTierValue(tier) {
      return tier.amount.enable && ('' + tier.amount.value).trim() !== '' ? parseFloat(tier.amount.value.toString().replace(',', '.')) * 100 : 0;
    }
  }, {
    key: "isApplicable",
    value: function isApplicable(checkDiscountCode) {
      var _this = this;
      if (!this.options.enable) {
        return false;
      }
      var applicable = false;
      if ((typeof checkDiscountCode === 'undefined' || checkDiscountCode) && this.options.discount.enable) {
        var discountCode = vegamour.cart.discounts.getActiveDiscountCode();
        if (discountCode.length === 0) {
          discountCode = vegamour.cart.discounts.getDiscountCookie();
        }
        if (discountCode != this.options.discount.code) {
          var tc = vegamour.getCookie('_gt');
          if (typeof tc !== 'undefined' && tc.length > 0) {
            tc = JSON.parse(decodeURIComponent(tc));
            if (typeof tc['b'] !== 'undefined' && tc.b.length) {
              tc.b.forEach(function (bmsm) {
                bmsm = JSON.stringify(bmsm);
                if (discountCode.length > 0 && bmsm.indexOf('"' + discountCode + '"') > -1 && bmsm.indexOf('"' + _this.options.discount.code + '"') > -1) {
                  discountCode = _this.options.discount.code;
                }
              });
            }
          }
        }
        if (!discountCode || discountCode != this.options.discount.code) {
          return false;
        }
      }
      if (this.options.utm.enable) {
        var utm = vegamour.cart.getUTMAttributes();
        if (!utm || typeof utm === 'undefined' || typeof utm.utm_campaign === 'undefined' || utm.utm_campaign.toUpperCase() !== this.options.utm.campaign) {
          return false;
        }
      }
      if (!vegamour.cart.cart.items.length) {
        return false;
      }
      var self = this;
      vegamour.cart.cart.items.some(function (item) {
        if (self.isApplicableOnItem(item)) {
          applicable = true;
          return true;
        }
      });
      return applicable;
    }
  }, {
    key: "isApplicableOnItem",
    value: function isApplicableOnItem(item) {
      if (!this.options.tag.enable && this.options.appliesTo === 'all') {
        return true;
      }
      if (item.price === 0) {
        return false;
      }
      var variants = vegamour.cart.variants(item.product_id);
      if (!variants) {
        return false;
      }
      var original = variants.original;
      var isSubscriptionItem = item.properties.subscription_id || item.selling_plan_allocation || false;
      if (this.options.appliesTo === 'subscription' && !isSubscriptionItem || this.options.appliesTo === 'one_time' && isSubscriptionItem) {
        return false;
      }
      if (this.options.tag.enable) {
        var tags = this.options.tag.list.split(',').map(function (elem) {
          return elem.trim();
        });
        var tagFound = false;
        tags.forEach(function (tag) {
          if (original.tags.indexOf(tag) > -1) {
            tagFound = true;
          }
        });
        if (!tagFound) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "isTierApplicable",
    value: function isTierApplicable(tier) {
      if (!tier.product.id || tier.product.price > 0) {
        return false;
      }
      return vegamour.cart.getSubtotal() >= this.getTierValue(tier);
    }
  }, {
    key: "isTier1Applicable",
    value: function isTier1Applicable() {
      return this.isTierApplicable(this.options.tier1) && this.isApplicable();
    }
  }, {
    key: "isTier2Applicable",
    value: function isTier2Applicable() {
      return this.isTierApplicable(this.options.tier2) && this.isApplicable();
    }
  }, {
    key: "isTier3Applicable",
    value: function isTier3Applicable() {
      return this.isTierApplicable(this.options.tier3) && this.isApplicable();
    }
  }, {
    key: "isApplied",
    value: function isApplied() {
      if (this.isTier3Applicable()) {
        return this.isTier3Applied() && this.isTier2Applied() && this.isTier1Applied();
      }
      if (this.isTier2Applicable()) {
        return this.isTier2Applied() && this.isTier1Applied();
      }
      if (this.isTier1Applicable()) {
        return this.isTier1Applied();
      }
      return true;
    }
  }, {
    key: "isTierApplied",
    value: function isTierApplied(tier) {
      var count = 0;
      vegamour.cart.cart.items.forEach(function (item) {
        if (tier.product && item.id == tier.product.variantId || typeof tier.product2 !== 'undefined' && item.id == tier.product2.variantId || typeof tier.product3 !== 'undefined' && item.id == tier.product3.variantId || typeof tier.product4 !== 'undefined' && item.id == tier.product4.variantId) {
          count++;
        }
      });
      var applied = count >= tier.multiple;
      if (applied && tier.select) {
        this.initGiftSelection(tier);
      } else if ($('[data-select-gift-tier="' + tier.tier + '"]').length > 0) {
        this.hideGiftSelection();
      }
      return applied;
    }
  }, {
    key: "isTier1Applied",
    value: function isTier1Applied() {
      return this.isTierApplied(this.options.tier1);
    }
  }, {
    key: "isTier2Applied",
    value: function isTier2Applied() {
      return this.isTierApplied(this.options.tier2);
    }
  }, {
    key: "isTier3Applied",
    value: function isTier3Applied() {
      return this.isTierApplied(this.options.tier3);
    }
  }, {
    key: "initGiftSelection",
    value: function initGiftSelection(tier, force) {
      var self = this;
      var cartTier = $('#express-cart').attr('data-select-gift-tier');
      if (cartTier && parseInt(cartTier) == tier.tier && (typeof force === 'undefined' || !force)) {
        return;
      }
      $('#express-cart').attr('data-gift-id', this.options.id);
      var select = tier.multiple;
      vegamour.cart.gifts.setGiftLabels(tier.multiple);
      var template = $('.express-cart-select-gift-item').first().html();
      cleared = false;
      var selectHtml = '';
      var _loop = function _loop() {
        var index = i > 1 ? i : '';
        if (_typeof(tier['product' + index]) !== undefined) {
          var p = tier['product' + index];
          if (p.handle) {
            if (!cleared) {
              $('.express-cart-select-gift-list').html('');
              cleared = true;
            }
            selected = $('.express-cart-item[data-id="' + p.variantId + '"]').length > 0;
            $('.express-cart-select-gift-list').append('<div class="express-cart-select-gift-item' + (selected ? ' selected' : '') + '" data-item="' + i + '" data-item-id="' + p.variantId + '">' + template + '</div>');
            var $item = $('.express-cart-select-gift-item[data-item="' + i + '"]');
            $item.find('.gift-item-image img').attr('src', vegamour.imgSize(p.image, '75x'));
            $item.find('.gift-item-title').text(p.title);
            $item.unbind('click').click(function () {
              if (!$(this).hasClass('selected')) {
                var giftCount = $('.express-cart-item[data-type="gift"]').length;
                var updateGiftSelection = function updateGiftSelection() {
                  self.initGiftSelection(tier, true);
                };
                var addGift = function addGift() {
                  vegamour.cart.add({
                    id: $item.attr('data-item-id'),
                    quantity: 1,
                    properties: {
                      cart_limit: 1,
                      gift: 1
                    }
                  }, updateGiftSelection);
                };
                vegamour.cart.emit('updateStart');
                if (giftCount && giftCount >= select) {
                  var variantId = 0;
                  $('.express-cart-item[data-type="gift"]').each(function () {
                    variantId = parseInt($(this).attr('data-id'));
                  });
                  $.ajax({
                    url: window.Shopify.routes.root + 'cart/change.js?v2',
                    type: 'post',
                    dataType: 'json',
                    data: {
                      id: variantId,
                      quantity: 0
                    }
                  }).done(function (cart) {
                    console.log('Gift removed');
                    //vegamour.cart.emit('itemRemoved');
                    addGift();
                  });
                } else {
                  addGift();
                }
              }
            });
          }
        }
      };
      for (var i = 1; i <= 4; i++) {
        _loop();
      }
      $('.express-cart-select-gift').show();
      $('.express-cart-gift-announcement').css('display', 'flex');
      $('#express-cart').attr('data-select-gift-tier', tier.tier);
      $('.express-cart-gift-announcement, .change-gift').unbind('click').click(function () {
        $('.express-cart-body').animate({
          scrollTop: $('.express-cart-items').height()
        });
      });
      vegamour.cart.express.setDiscountPosition();
      var giftList = [];
      $('.express-cart-item[data-type="gift"]').each(function () {
        giftList[giftList.length] = parseInt($(this).attr('data-id'));
      });
      vegamour.cookie.set({
        'g': giftList
      });
    }
  }, {
    key: "hideGiftSelection",
    value: function hideGiftSelection() {
      if ($('#express-cart[data-gift-id="' + this.options.id + '"]').length > 0) {
        $('#express-cart').removeAttr('data-select-gift-tier');
        $('.express-cart-gift-announcement').hide();
        $('.express-cart-select-gift').hide();
        vegamour.cart.express.setDiscountPosition();
      }
    }
  }, {
    key: "getNotAppliedTiers",
    value: function getNotAppliedTiers() {
      var result = [];
      if (this.isTier1Applicable() && !this.isTier1Applied() && !this.isTier1Removed()) {
        result.push(this.options.tier1);
      }
      if (this.isTier2Applicable() && !this.isTier2Applied() && !this.isTier2Removed()) {
        result.push(this.options.tier2);
      }
      if (this.isTier3Applicable() && !this.isTier3Applied() && !this.isTier3Removed()) {
        result.push(this.options.tier3);
      }
      return result;
    }
  }, {
    key: "getOverLimitTiers",
    value: function getOverLimitTiers() {
      var result = [];
      if (this.isTier1Applied() && this.isTier1OverLimit(this.options.tier1)) {
        result.push(this.options.tier1);
      }
      if (this.isTier2Applied() && this.isTier2OverLimit(this.options.tier2)) {
        result.push(this.options.tier2);
      }
      if (this.isTier3Applied() && this.isTier3OverLimit(this.options.tier3)) {
        result.push(this.options.tier3);
      }
      return result;
    }
  }, {
    key: "getTiersToRemove",
    value: function getTiersToRemove() {
      var result = [];
      if (this.isTier1Applied() && !this.isTier1Applicable()) {
        result.push(this.options.tier1);
      }
      if (this.isTier2Applied() && !this.isTier2Applicable()) {
        result.push(this.options.tier2);
      }
      if (this.isTier3Applied() && !this.isTier3Applicable()) {
        result.push(this.options.tier3);
      }
      return result;
    }
  }, {
    key: "countTier",
    value: function countTier(tier) {
      var count = 0;
      vegamour.cart.cart.items.forEach(function (item) {
        if (item.id == tier.product.variantId || typeof tier.product2 !== 'undefined' && item.id == tier.product2.variantId || typeof tier.product3 !== 'undefined' && item.id == tier.product3.variantId || typeof tier.product4 !== 'undefined' && item.id == tier.product4.variantId) {
          count += item.quantity;
        }
      });
      return count;
    }
  }, {
    key: "countTier1",
    value: function countTier1() {
      return this.countTier(this.options.tier1);
    }
  }, {
    key: "countTier2",
    value: function countTier2() {
      return this.countTier(this.options.tier2);
    }
  }, {
    key: "countTier3",
    value: function countTier3() {
      return this.countTier(this.options.tier3);
    }
  }, {
    key: "changeQuantity",
    value: function changeQuantity(quantity) {
      console.info('⚡ Changing quantity of ' + this.constructor.name + ' product to ' + quantity);
      var item = vegamour.cart.getItemById(this.variantId);
      if (item) {
        item.quantity(quantity);
      }
    }
  }, {
    key: "getItemsString",
    value: function getItemsString() {
      var items = '';
      vegamour.cart.items.forEach(function (item) {
        if (!item.isGift()) {
          items += item.getId() + '_' + item.getQuantity() + ';';
        }
      });
      return items;
    }
  }, {
    key: "setVariantIdRemoved",
    value: function setVariantIdRemoved(variantId) {
      if (!window.localStorage) {
        return;
      }
      if (this.options.tier1.product.variantId == variantId || typeof this.options.tier1.product2 !== 'undefined' && variantId == this.options.tier1.product2.variantId || typeof this.options.tier1.product3 !== 'undefined' && variantId == this.options.tier1.product3.variantId || typeof this.options.tier1.product4 !== 'undefined' && variantId == this.options.tier1.product4.variantId) {
        window.localStorage.setItem('gift_' + this.options.id + '_tier1_removed', this.getItemsString());
      }
      if (this.options.tier2.product.variantId == variantId || typeof this.options.tier2.product2 !== 'undefined' && variantId == this.options.tier2.product2.variantId || typeof this.options.tier2.product3 !== 'undefined' && variantId == this.options.tier2.product3.variantId || typeof this.options.tier2.product4 !== 'undefined' && variantId == this.options.tier2.product4.variantId) {
        window.localStorage.setItem('gift_' + this.options.id + '_tier2_removed', this.getItemsString());
      }
      if (this.options.tier3.product.variantId == variantId || typeof this.options.tier3.product2 !== 'undefined' && variantId == this.options.tier3.product2.variantId || typeof this.options.tier3.product3 !== 'undefined' && variantId == this.options.tier3.product3.variantId || typeof this.options.tier3.product4 !== 'undefined' && variantId == this.options.tier3.product4.variantId) {
        window.localStorage.setItem('gift_' + this.options.id + '_tier3_removed', this.getItemsString());
      }
    }
  }, {
    key: "isTierRemoved",
    value: function isTierRemoved(nth) {
      var result = false;
      if (window.localStorage) {
        result = window.localStorage.getItem('gift_' + this.options.id + '_tier' + nth + '_removed') === this.getItemsString();
      }
      return result;
    }
  }, {
    key: "isTier1Removed",
    value: function isTier1Removed() {
      return this.isTierRemoved(1);
    }
  }, {
    key: "isTier2Removed",
    value: function isTier2Removed() {
      return this.isTierRemoved(2);
    }
  }, {
    key: "isTier3Removed",
    value: function isTier3Removed() {
      return this.isTierRemoved(3);
    }
  }]);
  return VegamourGift;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourCartItem = /*#__PURE__*/function () {
  function VegamourCartItem(data, index) {
    _classCallCheck(this, VegamourCartItem);
    this.index = index;
    this.data = data;
    if (!this.data.properties) {
      this.data.properties = {};
    }
    this.appended = false;
    this.currentDiv = null;
    this.selectorTemplate = '#cart-v2-item-template';
  }
  _createClass(VegamourCartItem, [{
    key: "appendTo",
    value: function appendTo(container) {
      container.append(this.div());
      this.appended = true;
    }
  }, {
    key: "image",
    value: function image(size) {
      var src = this.data.image;
      if (this.isSubscription()) {
        var originalSrc = this.getOriginalImageByDiscountId(this.data.id);
        if (originalSrc) {
          src = originalSrc;
        }
      }
      return vegamour.imgSize(src, size);
    }
  }, {
    key: "getOriginalImageByDiscountId",
    value: function getOriginalImageByDiscountId(id) {
      var variants = this.getVariants();
      if (!variants) {
        return null;
      }
      var src = null;
      variants.original.variants.forEach(function (variant) {
        if (variant.discount_id == id && variant.image) {
          src = variant.image;
        }
      });
      return src;
    }
  }, {
    key: "removeSubscriptionButton",
    value: function removeSubscriptionButton() {
      this.div().find('[data-item-subscription]').remove();
      this.div().find('[data-item-info]').remove();
    }
  }, {
    key: "div",
    value: function div() {
      if (this.currentDiv !== null && this.currentDiv.length > 0) {
        return this.currentDiv;
      }
      var self = this;
      var $div = $($(this.selectorTemplate).html());
      var isSubscription = this.isSubscription();
      var isLoop = typeof LoopOnstore !== 'undefined' && LoopOnstore.isActive();
      var isGift = this.isGift();
      type = 'onetime';
      if (isLoop) {
        type = 'loop';
      } else if (isGift) {
        type = 'gift';
      } else if (isSubscription) {
        type = 'subscription';
      }
      $div.attr('data-type', type);
      $div.attr('data-id', this.data.id);
      $div.find('[data-item-image]').attr('src', this.image(vegamour.isMobile() ? '78x' : '100x'));
      $div.find('[data-item-name]').text(this.isCustomTitle() ? this.getCustomTitle() : this.data.product_title);
      $div.find('[data-item-price]').html(vegamour.cart.displayPrice(this.data.price));
      $div.find('[data-item-type]').append(isGift ? 'FREE GIFT' : isSubscription ? 'Ships <span data-item-ship-duration>monthly</span><br />(SAVE <span data-item-discount>0</span>%)' : 'One time purchase');
      if (isSubscription) {
        $div.find('[data-item-type]').css('padding-left', vegamour.isMobile() ? '15px' : '20px');
        $div.find('[data-subscription-icon]').css('display', 'inline-block');
      }
      $div.find('[data-item-info]').html(isSubscription ? 'Change or cancel anytime' : isGift ? '' : 'Save <span data-item-discount>0</span>% and receive <span data-item-ship-duration>monthly</span>');
      if ($div.find('[data-item-quantity] option[value="' + this.data.quantity + '"]').length === 0) {
        $div.find('[data-item-quantity]').append(new Option(this.data.quantity, this.data.quantity, true, true));
      }
      $div.find('[data-item-quantity]').val(this.data.quantity);
      $div.find('[data-item-quantity]').on('change', function () {
        self.quantity($(this).val());
      });
      $div.find('[data-item-remove]').on('click', function (e) {
        e.preventDefault();
        self.remove();
      });
      $div.find('[data-item-subscription] a').on('click', function (e) {
        e.preventDefault();
        self.upgrade();
      });
      if (isSubscription || isGift) {
        $div.find('[data-item-subscription]').remove();
      }
      if (isGift) {
        $div.find('.cart-item-quantity').html(this.data.quantity);
      }
      this.currentDiv = $div;
      return $div;
    }
  }, {
    key: "remove",
    value: function remove(callback) {
      this.quantity(0, callback);
    }
  }, {
    key: "quantity",
    value: function quantity(value, callback) {
      var _this = this;
      value = parseInt(value);
      console.info('⚡ Changing item #', this.getId(), 'quantity to', value, '(line #' + (this.index + 1) + ')');
      if (value > 0 && this.constructor.isLimitExceeded(this.data, value)) {
        this.div().find('[data-item-quantity]').val(this.data.quantity);
        var error = this.constructor.showLimitExceeded(this.data);
        if (typeof callback === 'function') {
          callback(error);
        }
        return;
      }
      vegamour.cart.lastCart = vegamour.cart.cart;
      vegamour.cart.emit('updateStart');
      var isGift = this.isGift();
      $.ajax({
        url: window.Shopify.routes.root + 'cart/change.js?v2',
        type: 'post',
        dataType: 'json',
        data: {
          id: this.data.variant_id,
          quantity: value
        }
      }).done(function (cart) {
        vegamour.cart.afterChange(cart, function () {
          if (typeof callback === 'function') {
            callback();
          }
          if (value === 0) {
            if (isGift) {
              vegamour.cart.gifts.setRemoved(_this.data.variant_id);
            }
            vegamour.cart.emit('itemRemoved', _this.data);
          } else {
            var additional = {};
            if (value > _this.data.quantity) {
              additional.added = value - _this.data.quantity;
            } else {
              additional.removed = _this.data.quantity - value;
            }
            vegamour.cart.emit('itemChanged', _this.data, additional);
          }
        }, true);
      }).fail(function (err) {
        if (typeof callback === 'function') {
          callback(err);
        }
        vegamour.cart.emit('error', err);
      });
    }
  }, {
    key: "refresh",
    value: function refresh() {
      if (vegamour.cart._freeze) {
        return;
      }
      var isSubscription = this.isSubscription();
      var variants = this.getVariants();
      var recharge = this.getRecharge();
      var discount = parseFloat(variants.original.discount_percentage);
      if (recharge) {
        var rechargeDiscount = recharge.getSubscriptionDiscountPercentage();
        if (rechargeDiscount) {
          discount = Math.floor(rechargeDiscount);
        }
      }
      if (this.data.properties._custom_save) {
        discount = parseFloat(this.data.properties._custom_save);
      }
      discount = Math.floor(discount);
      if (!variants) {
        return;
      }
      if (variants.subscription_id || variants.selling_plan_id || variants.original._shipping_interval_frequency) {
        this.div().find('[data-item-discount]').text(discount);
      } else {
        this.removeSubscriptionButton();
      }
      if (this.data.properties._only_onetime) {
        this.removeSubscriptionButton();
      }
      if (typeof LoopOnstore !== 'undefined' && LoopOnstore.isActive()) {
        this.removeSubscriptionButton();
      }
      if (this.isGift()) {
        this.div().find('[data-item-name]').addClass('no-link').on('click', function (e) {
          return e.preventDefault();
        });
      } else {
        this.div().find('[data-item-name]').attr('href', variants.original.url);
      }
      var title = variants.original.title;
      if (this.isCustomTitle()) {
        title = this.getCustomTitle();
      }
      this.div().find('[data-item-name]').text(title);
      var shipDuration = 'monthly';
      if ((this.data.selling_plan_allocation || this.data.properties.subscription_id) && (this.data.properties._shipping_interval_frequency !== '1' || this.data.properties._shipping_interval_unit_type !== 'Months')) {
        shipDuration = 'every ' + this.data.properties._shipping_interval_frequency + ' ' + this.data.properties._shipping_interval_unit_type;
      }
      this.div().find('[data-item-ship-duration]').text(shipDuration);
    }
  }, {
    key: "upgrade",
    value: function upgrade() {
      var properties = {
        _shipping_interval_frequency: this.getShippingFrequency(),     // _ 추가
        _shipping_interval_unit_type: this.getShippingUnitType()       // _ 추가
      };
      var selling_plan = this.getSellingPlanId();
      if (this.data.properties.cart_limit) {
        properties._cart_limit = this.data.properties.cart_limit;      // _ 추가
      }
      if (this.isCbd()) {
        properties._contains_cbd = 1;                                  // _ 추가
      }
      if (this.isCbdEdible()) {
        properties._contains_cbd_edible = 1;                           // _ 추가
      }
      if (this.isHazmat()) {
        properties._contains_hazmat = 1;                               // _ 추가
      }
      if (this.isProposition65()) {
        properties._proposition_65 = 1;                                // _ 추가
      }
      if (this.isCustomTitle()) {
        properties._custom_title = this.getCustomTitle();              // _ 추가
      }
      if (this.isCustomSave()) {
        properties._custom_save = this.getCustomSave();                // _ 추가
      }
      // 👇 커스텀 배송비 로직용 태그 (upgrade -> subscription)
      properties._is_subscription = 'true';
      properties._is_one_time_purchase = 'false';
      var subID = this.getSubscriptionVariantId();
      var data = {
        quantity: this.getQuantity(),
        id: this.getSubscriptionVariantId(),
        properties: properties
      };
      if (selling_plan) {
        data.selling_plan = selling_plan;
      }
      if (subID) {
        vegamour.cart.emit('updateStart');
        vegamour.cart.freeze();
        vegamour.cart.isUpgrading = true;
        this.remove(function () {
          vegamour.cart.emit('updateStart');
          vegamour.cart.add(data, function () {
            vegamour.cart.isUpgrading = false;
            vegamour.cart.unfreeze();
          });
        });
      } else {
        console.error('Could not find subscription variant ID');
      }
    }
  }, {
    key: "getVariants",
    value: function getVariants() {
      if (this._variants) {
        return this._variants;
      }
      this._variants = vegamour.cart.variants(this.data.product_id);
      return this._variants;
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.data.id;
    }
  }, {
    key: "getSubscriptionVariantId",
    value: function getSubscriptionVariantId() {
      var variants = this.getVariants();
      var options = this.data.variant_options;
      var variantId = null;
      if (options.length === 1 && options[0].toLowerCase() === 'one-time') {
        $.each(variants.variants, function (i) {
          if (variants.variants[i].option.trim().toLowerCase() === 'subscription') {
            variantId = variants.variants[i].id;
          }
        });
        return variantId;
      }

      // For products having two options
      if (options.length === 2 && (options[0].toLowerCase() === 'one-time' || options[1].toLowerCase())) {
        var typeIndex = options[0].toLowerCase() === 'one-time' ? 0 : 1;
        var sizeIndex = Math.abs(typeIndex - 1);
        $.each(variants.variants, function (i) {
          var variantOptions = variants.variants[i].options;
          if (variantOptions[typeIndex].trim().toLowerCase() === 'subscription' && variantOptions[sizeIndex].trim().toLowerCase() === options[sizeIndex].trim().toLowerCase()) {
            variantId = variants.variants[i].id;
          }
        });
        return variantId;
      }
    }
  }, {
    key: "getQuantity",
    value: function getQuantity() {
      return parseInt(this.data.quantity);
    }
  }, {
    key: "getCartLimit",
    value: function getCartLimit() {
      var cartLimit = this.getVariants().original.cart_limit;
      if (parseInt(cartLimit) > 0) {
        return parseInt(cartLimit);
      }
      return null;
    }
  }, {
    key: "getSellingPlanId",
    value: function getSellingPlanId() {
      return this.getVariants().selling_plan_id;
    }
  }, {
    key: "getShippingUnitType",
    value: function getShippingUnitType() {
      if (this.data.properties.custom_subscription) {
        var customSubscription = this.data.properties.custom_subscription.split(',');
        return customSubscription[2];
      }
      //NOTE: do not add underscore
      return this.getVariants().original.shipping_interval_unit_type;
    }
  }, {
    key: "getShippingFrequency",
    value: function getShippingFrequency() {
      if (this.data.properties.custom_subscription) {
        var customSubscription = this.data.properties.custom_subscription.split(',');
        return customSubscription[3];
      }
      //NOTE: do not add underscore
      return this.getVariants().original.shipping_interval_frequency;
    }
  }, {
    key: "getSubscriptionId",
    value: function getSubscriptionId() {
      if (this.data.properties.custom_subscription) {
        var customSubscription = this.data.properties.custom_subscription.split(',');
        return customSubscription[1];
      }
      return this.getVariants().subscription_id;
    }
  }, {
    key: "isProposition65",
    value: function isProposition65() {
      return parseInt(this.getVariants().original.proposition_65) === 1;
    }
  }, {
    key: "isCbd",
    value: function isCbd() {
      return parseInt(this.getVariants().original.contains_cbd) === 1;
    }
  }, {
    key: "isCbdEdible",
    value: function isCbdEdible() {
      return parseInt(this.getVariants().original.contains_cbd_edible) === 1;
    }
  }, {
    key: "isHazmat",
    value: function isHazmat() {
      return parseInt(this.getVariants().original.contains_hazmat) === 1;
    }
  }, {
    key: "isOneTimeOnly",
    value: function isOneTimeOnly() {
      var isOneTimeOnly = true;
      var variants = this.getVariants();
      if (variants) {
        $.each(variants.variants, function (i) {
          if (variants.variants[i].option.trim().toLowerCase() === 'subscription') {
            isOneTimeOnly = false;
          }
        });
      } else {
        isOneTimeOnly = false;
      }
      return isOneTimeOnly;
    }
  }, {
    key: "isSubscription",
    value: function isSubscription() {
      return typeof this.data['selling_plan_allocation'] !== 'undefined';
    }
  }, {
    key: "isGift",
    value: function isGift() {
      var variants = this.getVariants();
      return variants !== null ? this.getVariants().original.gift : this.data.price === 0;
    }
  }, {
    key: "isCustomTitle",
    value: function isCustomTitle() {
      return typeof this.data.properties['_custom_title'] !== 'undefined';
    }
  }, {
    key: "getCustomTitle",
    value: function getCustomTitle() {
      return this.data.properties['_custom_title'];
    }
  }, {
    key: "isCustomSave",
    value: function isCustomSave() {
      return typeof this.data.properties['_custom_save'] !== 'undefined';
    }
  }, {
    key: "getCustomSave",
    value: function getCustomSave() {
      return this.data.properties['_custom_save'];
    }
  }, {
    key: "isTravel",
    value: function isTravel() {
      return parseInt(this.getVariants().original.contains_travel_size) === 1;
    }
  }, {
    key: "getRecharge",
    value: function getRecharge() {
      var recharge = vegamour.cart.recharge.get(this.data.product_id);
      if (recharge) {
        var clone = recharge.clone();
        clone.setActiveVariant(this.data.variant_id);
        return clone;
      }
      return null;
    }
  }], [{
    key: "isLimitExceeded",
    value: function isLimitExceeded(data, quantity) {
      if (typeof data.properties !== 'undefined' && typeof data.properties.cart_limit !== 'undefined' && data.properties.cart_limit !== null) {
        var cartLimit = parseInt(data.properties.cart_limit);
        return quantity > cartLimit;
      }
      return false;
    }
  }, {
    key: "showLimitExceeded",
    value: function showLimitExceeded(data) {
      var cartLimit = parseInt(data.properties.cart_limit);
      var error = "Product cart limit applies for the specific product variant. You can't purchase more than ".concat(cartLimit, " item(s) per order.");
      vegamour.notify('warning', error, 'Product Limit');
      vegamour.cart.emit('error', error);
      return error;
    }
  }]);
  return VegamourCartItem;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VegamourExpressCartItem = /*#__PURE__*/function (_VegamourCartItem) {
  _inherits(VegamourExpressCartItem, _VegamourCartItem);
  var _super = _createSuper(VegamourExpressCartItem);
  function VegamourExpressCartItem(data, index) {
    var _this;
    _classCallCheck(this, VegamourExpressCartItem);
    _this = _super.call(this, data, index);
    _this.selectorTemplate = '#express-cart-item-template';
    return _this;
  }
  _createClass(VegamourExpressCartItem, [{
    key: "div",
    value: function div() {
      if (this.currentDiv !== null && this.currentDiv.length > 0) {
        return this.currentDiv;
      }
      var self = this;
      var $div = $($(this.selectorTemplate).html());
      var isSubscription = this.isSubscription();
      var isOneTimeOnly = !isSubscription && this.isOneTimeOnly();
      var isLoop = typeof LoopOnstore !== 'undefined' && LoopOnstore.isActive();
      var isGift = this.isGift();
      type = 'onetime';
      if (isLoop) {
        type = 'loop';
      } else if (isGift) {
        type = 'gift';
      } else if (isSubscription) {
        type = 'subscription';
      } else if (isOneTimeOnly) {
        type = 'onetimeonly';
      }
      $div.attr('data-type', type);
      $div.attr('data-id', this.data.id);
      $div.find('[data-item-image]').attr('src', this.image(vegamour.isMobile() ? '78x' : '100x'));
      $div.find('[data-item-name]').text(this.isCustomTitle() ? this.getCustomTitle() : this.data.product_title);
      if (this.data.discounted_price < this.data.price) {
        $div.find('[data-item-price]').html(vegamour.cart.displayPrice(this.data.discounted_price));
      } else {
        $div.find('[data-item-price]').html(vegamour.cart.displayPrice(this.data.price));
      }
      var giftIcon = '';
      if (isGift) {
        giftIcon = $('.gift-svg').first().prop('outerHTML');
      }
      $('.express-cart-item[data-type="gift"] [data-item-type] span').html($('.gift-item-heading').first().html()).remove('div');
      $div.find('[data-item-type]').append(isGift ? '<div class="type-gift">' + giftIcon + 'GIFT</div><div class="change-gift">Change Gift</div>' : isSubscription ? 'Ships <span data-item-ship-duration>monthly</span><br />(SAVE <span data-item-discount>0</span>%)' : 'One time purchase');
      if (isSubscription) {
        $div.find('[data-item-type]').css('padding-left', vegamour.isMobile() ? '15px' : '20px');
        $div.find('[data-subscription-icon]').css('display', 'inline-block');
      }
      $div.find('[data-item-info]').html(isSubscription ? 'Change or cancel anytime' : isGift ? '' : 'Save <span data-item-discount>0</span>% and receive <span data-item-ship-duration>monthly</span>');
      $div.find('[data-item-quantity]').val(this.data.quantity);
      $div.find('[data-item-quantity]').on('change', function () {
        self.quantity($(this).val());
      });
      if (isOneTimeOnly) {
        $div.find('[data-item-subscription], [data-item-info]').hide();
        if ($div.find('[express-cart-item-compare-price]').text().trim() == $div.find('[express-cart-item-price]').text().trim()) {
          $div.find('[express-cart-item-compare-price]').hide();
        }
      }
      $div.find('[data-input-quantity] .minus').click(function () {
        var $input = $(this).parent().find('input');
        var count = parseInt($input.val()) - 1;
        if (count > 0) {
          $input.val(count);
          $input.change();
        }
        return false;
      });
      $div.find('[data-input-quantity] .plus').click(function () {
        var $input = $(this).parent().find('input');
        $input.val(parseInt($input.val()) + 1);
        $input.change();
        return false;
      });
      if (isGift) {
        $div.find('[data-item-remove]').remove();
      } else {
        $div.find('[data-item-remove]').on('click', function (e) {
          e.preventDefault();
          self.remove();
        });
      }
      $div.find('[data-item-subscription] a').on('click', function (e) {
        e.preventDefault();
        self.upgrade();
      });
      if (isSubscription || isGift) {
        $div.find('[data-item-subscription]').remove();
      }
      if (isGift) {
        $div.find('.express-cart-item-quantity').hide();
      }
      this.currentDiv = $div;
      return $div;
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var _this2 = this;
      if (vegamour.cart._freeze) {
        return;
      }
      var isSubscription = this.isSubscription();
      var recharge = this.getRecharge();
      var item = this.data;
      var variants = this.getVariants();
      var discount = parseFloat(variants.original.discount_percentage);
      var price = item.price;
      var compare = false;
      variants.original.variants.some(function (variant) {
        if (variant.id == _this2.data.id) {
          if (variant.compare_at_price && (variant.compare_at_price > item.price || variant.compare_at_price > item.discounted_price)) {
            compare = variant.compare_at_price;
            price = item.discounted_price;
          } else if (item.price > item.discounted_price) {
            compare = price;
            price = item.discounted_price;
          }
          return true;
        }
      });
      this.div().find('[data-item-price]').html(vegamour.cart.displayPrice(price));
      if (compare && compare > price) {
        this.div().find('[data-item-compare]').html(vegamour.cart.displayPrice(compare)).show();
      } else {
        this.div().find('[data-item-compare]').text('').hide();
      }
      if (recharge) {
        var rechargeDiscount = recharge.getSubscriptionDiscountPercentage();
        if (rechargeDiscount) {
          discount = Math.floor(rechargeDiscount);
        }
      }
      if (this.data.properties._custom_save) {
        discount = parseFloat(this.data.properties._custom_save);
      }
      discount = Math.floor(discount);
      if (!variants) {
        return;
      }
      if (variants.subscription_id || variants.selling_plan_id || variants.original._shipping_interval_frequency) {
        this.div().find('[data-item-discount]').text(discount);
      } else {
        this.removeSubscriptionButton();
      }
      if (this.data.properties._only_onetime) {
        this.removeSubscriptionButton();
      }
      if (typeof LoopOnstore !== 'undefined' && LoopOnstore.isActive()) {
        this.removeSubscriptionButton();
      }
      if (this.isGift()) {
        this.div().find('[data-item-name]').addClass('no-link').on('click', function (e) {
          return e.preventDefault();
        });
      } else {
        this.div().find('[data-item-name]').attr('href', variants.original.url);
        this.div().find('[data-item-image]').parent().attr('href', variants.original.url);
      }
      var title = variants.original.title;
      if (this.isCustomTitle()) {
        title = this.getCustomTitle();
      }
      this.div().find('[data-item-name]').text(title);
      var shipDuration = 'monthly';
      if ((this.data.properties.subscription_id || this.data.selling_plan_allocation) && (this.data.properties._shipping_interval_frequency !== '1' || this.data.properties._shipping_interval_unit_type !== 'Months')) {
        shipDuration = 'every ' + this.data.properties._shipping_interval_frequency + ' ' + this.data.properties._shipping_interval_unit_type;
      }
      this.div().find('[data-item-ship-duration]').text(shipDuration);
    }
  }]);
  return VegamourExpressCartItem;
}(VegamourCartItem);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourCartRecharge = /*#__PURE__*/function () {
  function VegamourCartRecharge() {
    _classCallCheck(this, VegamourCartRecharge);
    this.rechargeProducts = [];
  }
  _createClass(VegamourCartRecharge, [{
    key: "add",
    value: function add(rechargeProduct) {
      if (!this.get(rechargeProduct.id)) {
        this.rechargeProducts.push(new VegamourProductRecharge(rechargeProduct));
      }
    }
  }, {
    key: "get",
    value: function get(productId) {
      var result = null;
      this.rechargeProducts.forEach(function (recharge) {
        if (!result && recharge.getProductId() == productId) {
          result = recharge;
        }
      });
      return result;
    }
  }, {
    key: "hasSubscriptionItem",
    value: function hasSubscriptionItem(items) {
      var hasSubscriptionItem = false;
      $.each(items, function (i) {
        if (items[i].isSubscription()) {
          hasSubscriptionItem = true;
        }
      });
      return hasSubscriptionItem;
    }
  }]);
  return VegamourCartRecharge;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VegamourCartDiscounts = /*#__PURE__*/function (_Events) {
  _inherits(VegamourCartDiscounts, _Events);
  var _super = _createSuper(VegamourCartDiscounts);
  function VegamourCartDiscounts() {
    var _this;
    _classCallCheck(this, VegamourCartDiscounts);
    _this = _super.call(this);
    _this.discount = [];
    _this.tierCookie = '_gt';
    _this.init();
    _this.locale = window.vegamourTranslations.cart.discounts;
    return _this;
  }
  _createClass(VegamourCartDiscounts, [{
    key: "init",
    value: function init() {
      var self = this;
      $(document).ready(function () {
        if (!self.isCheckoutAdjuster()) {
          self.setTiersCookie();
        }
        self.initDiscountActions();
      });
    }
  }, {
    key: "initDiscountActions",
    value: function initDiscountActions() {
      var self = this;
      $('[data-discount-code-apply], [data-discount-code-remove]').unbind('click').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        var discountCode = $(this).attr('data-discount-code-apply') || '';
        if (discountCode.length) {
          self.setDiscountCode(discountCode);
          if (vegamour.cart.getSubtotal() > 0) {
            vegamour.cart.express.show();
          }
        } else {
          self.removeDiscountCode();
        }
      });
    }
  }, {
    key: "setDiscountCode",
    value: function setDiscountCode(discountCode, setCookie) {
      if (typeof discountCode === 'undefined' || discountCode === null || discountCode.toString() != discountCode) {
        this.setDiscountDisplay();
        return false;
      }
      var discount = this.getDiscountCode(discountCode);
      if (!discount.active) {
        discountCode = '';
      }
      if (!this.isDiscountQuerying()) {
        if (this.discount.active != discountCode) {
          if (typeof setCookie === 'undefined' || setCookie) {
            var discountCodeCookie = '';
            if (discountCode.length) {
              discountCodeCookie = vegamour.getCookie('cart') + '|' + discountCode;
            }
            var discountCookie = vegamour.getCookie('_dc') || '';
            if (discountCode.length > 0 || discountCookie.length > 0) {
              var clearCookie = discountCode.length === 0 && discountCookie.length > 0;
              var newCookie = discountCookie.length === 0 && discountCode.length > 0;
              if (clearCookie || newCookie || discountCookie.indexOf(vegamour.getCookie('cart')) === -1 || discountCookie.indexOf(discountCode) === -1) {
                vegamour.setDomainCookie('_dc', discountCodeCookie, 15);
              }
            }
          }
          this.discount.active = discountCode;
          if (this.isCheckoutAdjuster()) {
            vegamour.cart.gifts.applyGiftsAtCheckout();
          } else {
            if (discount.valid) {
              vegamour.cart.refresh();
            }
            this.setDiscountDisplay();
          }
          console.log('💰 ' + this.locale.discount + ' ' + this.locale.code + ' ' + (discountCode.length ? '"' + discountCode + '" ' + (discount.valid ? this.locale.applied : this.locale.activated) : this.locale.removed));
          this.emit('discountReady');
        }
        vegamour.cart.gifts.check(true);
      }
      return discount;
    }
  }, {
    key: "isCheckoutAdjuster",
    value: function isCheckoutAdjuster() {
      return typeof vegamour.cart.gifts !== 'undefined' && typeof vegamour.cart.gifts.isCheckoutAdjuster !== 'undefined' ? vegamour.cart.gifts.isCheckoutAdjuster : false;
    }
  }, {
    key: "getDiscountCookie",
    value: function getDiscountCookie() {
      var discountCode = '';
      if (this.isCheckoutAdjuster()) {
        return vegamour.getParam('d');
      }
      var discountCodeCookie = vegamour.getCookie('_dc');
      if (typeof discountCodeCookie === 'string' && discountCodeCookie.length && (discountCodeCookie.indexOf(vegamour.getCookie('cart')) > -1 || discountCodeCookie.indexOf('NaN') > -1)) {
        discountCode = discountCodeCookie.substring(discountCodeCookie.indexOf('|') + 1);
      }
      return discountCode;
    }
  }, {
    key: "getDiscountCode",
    value: function getDiscountCode(discountCode) {
      var discount = false;
      if (typeof discountCode === 'undefined') {
        discountCode = '';
        if (typeof this.discount === 'undefined' || typeof this.discount.active === 'undefined') {
          var urlParams = new URLSearchParams(window.location.search) || false;
          discountCode = urlParams && urlParams.get('discount') || '';
          if (discountCode.length === 0) {
            discountCode = this.getDiscountCookie();
          }
        } else if (typeof this.discount.active !== 'undefined') {
          discountCode = this.discount.active;
        }
      }
      if (_typeof(this.discount[discountCode]) === 'object') {
        discount = this.discount[discountCode];
      }
      var subtotal = vegamour.cart.getSubtotal(false);
      if (!discount) {
        discount = {
          code: discountCode,
          displayCode: discountCode,
          valid: false,
          type: '',
          amount: 0,
          value: 0,
          display: '',
          compare: subtotal,
          subtotal: subtotal
        };
      }
      if (typeof discountCode !== 'undefined' && discountCode.length) {
        var bmsm = this.getBuyMoreSaveMore(discountCode);
        var originalCode = discountCode;
        if (bmsm && bmsm.code != discount.code) {
          discountCode = bmsm.code;
          if (typeof this.discount[discountCode] !== 'undefined') {
            discount = this.discount[discountCode];
          } else {
            discount.code = discountCode;
          }
          if (originalCode != discountCode) {
            return this.setDiscountCode(discountCode);
          }
          discount.displayCode = bmsm.display;
        }
        discount.bmsm = bmsm;
        if (this.isDiscountQuerying()) {
          return discount;
        } else if (typeof this.discount[discountCode] === 'undefined') {
          this.queryDiscountCode(discountCode);
          return discount;
        }
        discount.code = discountCode;
        var appliedDiscount = this.applyDiscountCode(discount);
        if (!appliedDiscount.active) {
          this.setInvalidDiscountCode(appliedDiscount);
          return discount;
        }
        discount = appliedDiscount;
        if (!appliedDiscount.valid) {
          this.setInvalidDiscountCode(appliedDiscount, false);
        }
      }
      this.discount[discountCode] = discount;
      return discount;
    }
  }, {
    key: "queryDiscountCode",
    value: function queryDiscountCode(code) {
      vegamour.cart.express.loader(true);
      this.discount.querying = true;
      var self = this;
      var query = {};
      if (vegamour.customer !== null && !isNaN(vegamour.customer.id)) {
        query.customerId = vegamour.customer.id;
      }
      $.getJSON(vegamour.api.buildUrl('/shopify/discount/' + code, query), function (data) {
        self.discount.querying = false;
        self.discount[code] = data.success ? data.discount : {};
        vegamour.cart.express.loader(false);
        if (data.success) {
          self.setDiscountCode(code);
        } else {
          self.setInvalidDiscountCode();
        }
      });
    }
  }, {
    key: "applyDiscountCode",
    value: function applyDiscountCode(discount) {
      discount.active = false;
      var d = typeof discount.shopify !== 'undefined' && discount.shopify !== null ? discount.shopify : false;
      if (!d) {
        discount.error = 'invalid';
        return discount;
      } else if (typeof d.error !== 'undefined') {
        discount.error = d.error.toLowerCase().indexOf('not found') > -1 ? 'invalid' : d.error;
        return discount;
      }
      d = d.price_rule;
      d.discount_type = d.target_type !== null && d.target_type === 'shipping_line' ? 'shipping' : d.value_type;
      d.prerequisite_subtotal_min = d.prerequisite_subtotal_range !== null && typeof d.prerequisite_subtotal_range['greater_than_or_equal_to'] !== 'undefined' ? d.prerequisite_subtotal_range['greater_than_or_equal_to'] : null;
      d.prerequisite_quantity_min = d.prerequisite_quantity_range !== null && typeof d.prerequisite_quantity_range['greater_than_or_equal_to'] !== 'undefined' ? d.prerequisite_quantity_range['greater_than_or_equal_to'] : null;
      d.applies_to_product_type = null;
      var itemCount = vegamour.cart.getItemsCount();
      var subtotal = vegamour.cart.getSubtotal(false);
      var date = new Date();
      if (d.starts_at !== null) {
        var start = new Date(d.starts_at);
        if (start.getTime() > date.getTime()) {
          discount.error = this.locale.not_started;
          return discount;
        }
      }
      if (d.ends_at !== null) {
        var end = new Date(d.ends_at);
        if (end.getTime() < date.getTime()) {
          discount.error = this.locale.expired;
          return discount;
        }
      }
      discount.active = true;
      discount.error = '';
      discount.applicable = subtotal;
      discount.type = d.discount_type;
      discount.amount = Math.abs(d.value);
      var amount = Math.abs(d.value);
      if (discount.type == 'fixed_amount' && vegamour.country) {
        discount.amount = vegamour.country.exchange(amount);
      }
      discount.once = d.once_per_customer;
      discount.appliesTo = typeof d['applies_to_product_type'] !== 'undefined' && d.applies_to_product_type !== null ? d.applies_to_product_type.toLowerCase() : 'all';
      var productRequirement = d.entitled_product_ids.length > 0;
      var variantRequirement = d.entitled_variant_ids.length > 0;
      var subRequirement = window.vegamourOptions.subscriptionDiscounts.toLowerCase().indexOf(discount.code.toLowerCase()) !== -1;
      var itemRequirement = productRequirement || variantRequirement || subRequirement;
      var isPercent = discount.type === 'percentage';
      if (itemRequirement || isPercent) {
        var valid = itemValid = typeValid = true;
        if (itemRequirement) {
          valid = false;
          discount.applicable = 0;
          itemCount = 0;
        }
        $.each(vegamour.cart.items, function (i) {
          var item = vegamour.cart.items[i];
          if (itemRequirement) {
            var isSubscription = item.isSubscription();
            var hasProduct = productRequirement && d.entitled_product_ids.includes(parseInt(item.data.product_id));
            var hasVariant = variantRequirement && d.entitled_variant_ids.includes(parseInt(item.data.variant_id));
            itemValid = !productRequirement && !variantRequirement || !productRequirement && hasVariant || !variantRequirement && hasProduct || variantRequirement && productRequirement && (hasProduct || hasVariant);
            typeValid = isSubscription || !subRequirement;
            if (itemValid && typeValid) {
              valid = true;
              discount.applicable += item.data.line_price;
              itemCount += item.data.quantity;
            }
          }
          if (isPercent && itemValid && typeValid) {
            var discountPrice = item.data.price - item.data.price * discount.amount / 100;
            vegamour.cart.items[i].data.discounted_price = vegamour.cart.express.items[i].data.discounted_price = discountPrice;
          }
        });
        if (!valid) {
          var showError = true;
          if (window.vegamourOptions.ignoreDiscountWarning !== '') {
            window.vegamourOptions.ignoreDiscountWarning.split(',').forEach(function (item) {
              item = parseInt(item.trim());
              if (d.entitled_collection_ids.indexOf(item) > -1 || d.entitled_product_ids.indexOf(item) > -1) {
                showError = false;
              }
            });
          }
          if (showError) {
            discount.error = this.locale.specific_products;
          }
        }
      }
      if (d.prerequisite_quantity_min !== null && itemCount < parseInt(d.prerequisite_quantity_min)) {
        discount.error = this.locale.minimum + ' ' + d.prerequisite_quantity_min + (itemRequirement ? ' ' + this.locale.qualifying : '') + ' ' + this.locale.items;
      }
      discount.minimum = false;
      if (d.prerequisite_subtotal_min !== null) {
        discount.minimum = parseFloat(d.prerequisite_subtotal_min);
        if (vegamour.country) {
          discount.minimum = Math.ceil(vegamour.country.exchange(discount.minimum));
        }
        if (discount.applicable < discount.minimum * 100) {
          discount.error = this.locale.cart + ' ' + (itemRequirement ? this.locale.qualifying + ' ' : '') + this.locale.total_minimum + ' ' + vegamour.cart.displayPrice(discount.minimum * 100);
        }
      }
      switch (discount.type) {
        case 'percentage':
          discount.value = discount.applicable * discount.amount / 100;
          discount.display = discount.amount + '%';
          break;
        case 'shipping':
          discount.value = 0;
          discount.display = this.locale.free_shipping;
          break;
        default:
          discount.value = discount.amount * 100;
          discount.display = window.vegamourOptions.currency.sign + (amount == discount.amount ? discount.amount : Math.round(discount.amount));
      }
      if (typeof discount.displayCode === 'undefined' || !discount.displayCode) {
        discount.displayCode = discount.code;
      }
      discount.compare = subtotal;
      discount.subtotal = discount.compare - discount.value;
      discount.valid = discount.error.length === 0;
      return discount;
    }
  }, {
    key: "isApplicableToOneTime",
    value: function isApplicableToOneTime(discount, productId) {
      if (typeof discount['shopify'] === 'undefined' || discount.shopify === false) {
        return false;
      }
      return discount.shopify.price_rule.entitled_product_ids.length === 0 || discount.shopify.price_rule.entitled_product_ids.includes(parseInt(productId));
    }
  }, {
    key: "isApplicableToSubscription",
    value: function isApplicableToSubscription(discount, productId) {
      if (typeof discount['recharge'] === 'undefined' || discount.recharge === false) {
        return false;
      }
      if (discount.recharge.applies_to === 'shopify_product_id' && discount.recharge.applies_to_id != productId) {
        return false;
      }
      if (discount.recharge.applies_to_product_type === 'ONETIME') {
        return false;
      }
      return true;
    }
  }, {
    key: "isDiscountQuerying",
    value: function isDiscountQuerying() {
      return typeof this.discount.querying !== 'undefined' && this.discount.querying;
    }
  }, {
    key: "getActiveDiscountCode",
    value: function getActiveDiscountCode(returnObj) {
      var discount = typeof this.discount === 'undefined' || typeof this.discount.active === 'undefined' || typeof this.discount[this.discount.active] === 'undefined' ? this.getDiscountCode() : this.discount[this.discount.active];
      return typeof returnObj !== 'undefined' && returnObj ? discount || false : this.discount.active || '';
    }
  }, {
    key: "setDiscountDisplay",
    value: function setDiscountDisplay() {
      var discount = this.getDiscountCode();
      vegamour.cart.checkStatusBar();
      if (discount.active) {
        var cs = window.vegamourOptions.currency.sign;
        for (var k in discount) {
          $sel = $('[data-discount-' + k + ']') || 0;
          if ($sel.length) {
            var v = discount[k];
            switch (k) {
              case 'code':
                v = discount.displayCode;
                break;
              case 'value':
              case 'compare':
                v = cs + Math.round(v / 100);
                if (k === 'compare') {
                  v = discount.valid && discount.value > 0 ? v : '';
                }
                break;
              case 'subtotal':
                v = cs + (v / 100).toFixed(2);
                break;
              default:
            }
            $sel.html(v);
          }
        }
        if (discount.valid) {
          vegamour.cart.express.showDiscountError('');
        }
      }
      if (!discount.valid) {
        $('[data-cart-subtotal]').attr('data-cart-subtotal', (vegamour.cart.cart.total_price / 100).toFixed(2)).html(vegamour.cart.displayPrice(vegamour.cart.cart.total_price));
        $('[data-discount-valid]').hide();
        $('[data-discount-invalid]').show();
      } else {
        $('[data-discount-valid]').show();
        $('[data-discount-invalid]').hide();
      }
      var notGWPOnly = discount.amount >= 1;
      $('[data-discount-applied]').each(function () {
        var v = $(this).data('discount-applied');
        if (discount.active && discount.applicable > 0 && notGWPOnly && (!v || v == discount.code)) {
          if ($(this).parent().hasClass('announcement-bar')) {
            $(this).css('display', 'flex');
          } else {
            $(this).show();
          }
        } else {
          $(this).hide();
        }
      });
      $('[data-not-discount-applied]').each(function () {
        var v = $(this).data('not-discount-applied');
        if (!discount.active || discount.applicable > 0 && (!v || v == discount.code)) {
          $(this).hide();
        } else {
          if ($(this).parent().hasClass('announcement-bar')) {
            $(this).css('display', 'flex');
          } else {
            $(this).show();
          }
        }
      });
      $('[data-discount]').each(function () {
        var v = $(this).data('discount');
        if (discount.active && (!v || v == discount.code)) {
          if ($(this).parent().hasClass('announcement-bar')) {
            $(this).css('display', 'flex');
          } else {
            $(this).show();
          }
        } else {
          $(this).hide();
        }
      });
      $('[data-not-discount]').each(function () {
        var v = $(this).data('not-discount');
        if (discount.active && (!v || v == discount.code)) {
          $(this).hide();
        } else {
          if ($(this).parent().hasClass('announcement-bar')) {
            $(this).css('display', 'flex');
          } else {
            $(this).show();
          }
        }
      });
      if (discount.appliesTo == 'subscription') {
        $('[data-discount-subscription]').show();
      } else {
        $('[data-discount-subscription]').hide();
      }
      this.setComparePrice(discount.valid);
      return true;
    }
  }, {
    key: "setComparePrice",
    value: function setComparePrice(valid) {
      if (vegamour.cart.items.length === 0 || typeof vegamour.cart.items[0]['_variants'] === 'undefined') {
        return false;
      }
      $.each(vegamour.cart.items, function (i) {
        var item = vegamour.cart.items[i].data;
        var variants = vegamour.cart.items[i].getVariants();
        var price = item.price;
        var compare = false;
        variants.original.variants.some(function (variant) {
          if (variant.id == item.id) {
            if (variant.compare_at_price && (variant.compare_at_price > item.price || variant.compare_at_price > item.discounted_price)) {
              compare = variant.compare_at_price;
              price = item.discounted_price;
            } else if (item.price > item.discounted_price) {
              compare = price;
              price = item.discounted_price;
            }
            return true;
          }
        });
        var $selector = $('[data-id=' + item.variant_id + ']');
        $selector.find('[data-item-price]').html(vegamour.cart.displayPrice(price));
        if (compare && compare > price) {
          $selector.find('[data-item-compare]').html(vegamour.cart.displayPrice(compare)).show();
        } else {
          $selector.find('[data-item-compare]').hide();
        }
      });
    }
  }, {
    key: "clearComparePrice",
    value: function clearComparePrice() {
      $.each(vegamour.cart.items, function (i) {
        vegamour.cart.items[i].data.discounted_price = vegamour.cart.items[i].data.price;
        vegamour.cart.express.items[i].data.discounted_price = vegamour.cart.express.items[i].data.price;
      });
    }
  }, {
    key: "setInvalidDiscountCode",
    value: function setInvalidDiscountCode(discount, remove) {
      remove = typeof remove === 'undefined' ? false : remove;
      var error = typeof discount !== 'undefined' ? discount.error : 'invalid';
      if (!vegamour.cart.firstTimeUpdate) {
        vegamour.cart.express.showDiscountError(error, !remove);
      }
      if (remove) {
        this.removeDiscountCode();
      }
    }
  }, {
    key: "removeDiscountCode",
    value: function removeDiscountCode() {
      this.clearComparePrice();
      this.setDiscountCode('');
      this.discount = {};
      vegamour.cart.express.removeDiscount();
    }
  }, {
    key: "getBuyMoreSaveMore",
    value: function getBuyMoreSaveMore(discountCode) {
      var _this2 = this;
      var bm = false;
      if (discountCode.length > 0 && window.vegamourOptions.buyMoreSaveMore.length > 0) {
        var subtotal = vegamour.cart.getSubtotal(false);
        var hasSubscription = vegamour.cart.recharge.hasSubscriptionItem(vegamour.cart.items);
        window.vegamourOptions.buyMoreSaveMore.forEach(function (bmsm) {
          var hasDiscount = bmsm.tier1.discount == discountCode || bmsm.tier2.discount == discountCode || bmsm.tier3.discount == discountCode;
          if (hasDiscount) {
            if (!bmsm.tier1.amount || !bmsm.tier2.amount) {
              console.log('Invalid BMSM campaign configuration: ' + bmsm.tier1.discount);
            } else {
              var display = bmsm.tier1.discount.toUpperCase();
              var code = '';
              var tiers = 2;
              var amounts = [];
              var subscription = [];
              var labels = [];
              var progress = 0;
              var tier3Subtotal = subtotal;
              if (bmsm.tier3.amount) {
                tiers = 3;
                amounts[3] = bmsm.tier3.amount;
                subscription[3] = bmsm.tier3.subscription;
                labels[3] = bmsm.tier3.label;
                if (typeof _this2.discount[bmsm.tier3.discount] !== 'undefined' && typeof _this2.discount[bmsm.tier3.discount].applicable !== 'undefined') {
                  _this2.applyDiscountCode(_this2.discount[bmsm.tier3.discount]);
                  tier3Subtotal = _this2.discount[bmsm.tier3.discount].applicable;
                }
                if (tier3Subtotal / 100 >= bmsm.tier3.amount && (hasSubscription || !subscription[3])) {
                  code = bmsm.tier3.discount;
                  progress = 3;
                  subtotal = tier3Subtotal;
                }
              }
              amounts[2] = bmsm.tier2.amount;
              subscription[2] = bmsm.tier2.subscription;
              labels[2] = bmsm.tier2.label;
              var tier2Subtotal = tier3Subtotal;
              if (typeof _this2.discount[bmsm.tier2.discount] !== 'undefined' && typeof _this2.discount[bmsm.tier2.discount].applicable !== 'undefined') {
                _this2.applyDiscountCode(_this2.discount[bmsm.tier2.discount]);
                tier2Subtotal = _this2.discount[bmsm.tier2.discount].applicable;
              }
              if (!code && tier2Subtotal / 100 >= bmsm.tier2.amount) {
                if (typeof _this2.discount[bmsm.tier2.discount] === 'undefined' || typeof _this2.discount[bmsm.tier2.discount].applicable === 'undefined' || _this2.discount[bmsm.tier2.discount].applicable / 100 >= bmsm.tier2.amount) {
                  if (hasSubscription || !subscription[2]) {
                    code = bmsm.tier2.discount;
                    progress = 2;
                    subtotal = tier2Subtotal;
                  }
                }
              }
              amounts[1] = bmsm.tier1.amount;
              subscription[1] = bmsm.tier1.subscription;
              labels[1] = bmsm.tier1.label;
              if (!code) {
                code = bmsm.tier1.discount;
              }
              if (typeof _this2.discount[bmsm.tier1.discount] !== 'undefined' && typeof _this2.discount[bmsm.tier1.discount].applicable !== 'undefined') {
                _this2.applyDiscountCode(_this2.discount[bmsm.tier1.discount]);
                subtotal = _this2.discount[bmsm.tier1.discount].applicable;
              }
              if (!progress && subtotal / 100 >= bmsm.tier1.amount) {
                progress = 1;
              }
              bm = {
                code: code,
                display: display,
                tiers: tiers,
                progress: progress,
                amounts: amounts,
                subscription: subscription,
                labels: labels,
                subtotal: subtotal
              };
            }
          }
        });
      }
      return bm;
    }
  }, {
    key: "setTiersCookie",
    value: function setTiersCookie() {
      var bmsmTiers = window.vegamourOptions.buyMoreSaveMore;
      if (bmsmTiers.length) {
        var tc = vegamour.getCookie(this.tierCookie);
        tc = typeof tc !== 'undefined' && tc.length > 0 ? JSON.parse(decodeURIComponent(tc)) : {};
        tc.now = Math.round(Date.now() / 1000);
        tc.b = bmsmTiers;
        tc = encodeURIComponent(JSON.stringify(tc));
        vegamour.setDomainCookie(this.tierCookie, tc, 1);
      }
    }
  }]);
  return VegamourCartDiscounts;
}(Events);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VegamourCart = /*#__PURE__*/function (_Events) {
  _inherits(VegamourCart, _Events);
  var _super = _createSuper(VegamourCart);
  function VegamourCart() {
    var _this;
    _classCallCheck(this, VegamourCart);
    _this = _super.call(this);
    _this.items = [];
    _this._variants = [];
    _this.express = new VegamourExpressCart();
    _this.recharge = new VegamourCartRecharge();
    _this.discounts = new VegamourCartDiscounts();
    _this.setCart(window.theme.cart);
    _this.lastCart = null;
    _this.selector = '#cart-v2';
    _this._freeze = false;
    _this.isUpgrading = false;
    _this.firstTimeUpdate = true;
    return _this;
  }
  _createClass(VegamourCart, [{
    key: "div",
    value: function div() {
      return $(this.selector);
    }
  }, {
    key: "init",
    value: function init() {
      var self = this;
      this.express.init();
      if (!vegamourOptions.cart) {
        return;
      }
      $(document).ready(function () {
        self.div().find('[data-cart-checkout]').removeAttr('href').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.checkout();
        });
      });
      this.initEvents();
      this.initRecommendations();
      this.initGifts();
      this.checkCartToken();
      if (!vegamourOptions.designMode && vegamourOptions.expressCart) {
        this.fetch();
      }
      if (vegamour.isDebug) {
        $('#express-cart-title').html('<button>Empty Cart</button>').click(function () {
          self.empty();
        });
      }
    }
  }, {
    key: "initRecommendations",
    value: function initRecommendations() {
      var _this2 = this;
      var $list = $('.recommend-products');
      if (!$list.length) return false;
      $list.slick({
        prevArrow: '<div class="v4-arrow previous" tabindex="0" role="button"><p class="visually-hidden">Go to previous slide</p></div>',
        nextArrow: '<div class="v4-arrow next" tabindex="0" role="button"><p class="visually-hidden">Go to next slide</p></div>',
        accessibility: false,
        responsive: [{
          breakpoint: 9999,
          settings: 'unslick'
        }, {
          breakpoint: 769,
          settings: {
            slidesToShow: 1
          }
        }]
      });
      var $dots = $list.closest('.product-section').find('.carousel-dots');
      $dots.find('button').click(function (e) {
        e.preventDefault();
        if (!$(this).hasClass('active')) {
          $(this).siblings('.active').removeClass('active');
          $(this).addClass('active');
          $list.slick('slickGoTo', $(this).data('item'));
        }
      });
      $list.on('beforeChange', function (e, slick, currentSlide, nextSlide) {
        $dots.find('button.active').removeClass('active');
        $dots.find('button[data-item=' + nextSlide + ']').addClass('active');
      });
      $list.on('click', '[data-recommendation-add]', function (e) {
        var $btn = $(e.currentTarget);
        var variantId = $btn.data('variantId');
        var data = {
          id: variantId,
          quantity: 1
        };
        var self = _this2;
        vegamour.cart.add(data, function () {
          self.express.open();
        });
      });
    }
  }, {
    key: "initEvents",
    value: function initEvents() {
      var _this3 = this;
      this.on('error', function (err) {
        console.error('❌ Error on cart', err);
        _this3.loader(false);
      });
      this.on('updateStart', function () {
        console.info('⚡ Cart update start');
        _this3.loader(true);
      });
      this.on('update', function () {
        console.info('⚡ Cart update');
        _this3.clear();
        _this3.refresh();
        _this3.div().removeClass('first-time-load');
        _this3.loader(false);
        if (_this3.firstTimeUpdate) {
          _this3.firstTimeUpdate = false;
          _this3.emit('firstUpdate');
        }
      });
      this.on('fetchStart', function () {
        console.info('⚡ Cart fetch start');

        //   self.loader(true);
      });
      this.on('fetchEnd', function () {
        _this3.discounts.setDiscountDisplay();
        console.info('⚡ Cart fetch end');
      });
      this.on('itemAdded', function (data) {
        console.info('🔥 Cart item added', data);
        if (typeof _learnq !== 'undefined' && typeof klaviyoItem !== 'undefined') {
          _learnq.push(['track', 'Added to Cart', klaviyoItem]);
        }
      });
      this.on('itemChanged', function () {
        console.info('🔥 Cart item changed');
      });
      this.on('itemRemoved', function () {
        console.info('🔥 Cart item removed');
      });
      vegamour.on('shippingRatesReady, easylocationReady, geolocationReady', function () {
        _this3.refresh();
        _this3.checkStatusBar();
        _this3.express.refresh();
      });
    }
  }, {
    key: "initGifts",
    value: function initGifts() {
      this.gifts = new VegamourGifts();
      this.gifts.init();
    }
  }, {
    key: "checkCartToken",
    value: function checkCartToken() {
      var cart_token = vegamour.getParam('cart_token');
      if (cart_token && cart_token.length === 32) {
        vegamour.setCookie('cart', cart_token, 14);
        var action = vegamour.getParam('action');
        if (action == 'checkout') {
          this.express.open();
          var self = this;
          setTimeout(function () {
            self.redirectToCheckout();
          }, 1500);
        } else if (action == 'cart') {
          this.express.open();
        }
      }
    }
  }, {
    key: "freeze",
    value: function freeze() {
      console.info('⚡ Cart freeze');
      this.loader(true);
      this._freeze = true;
    }
  }, {
    key: "unfreeze",
    value: function unfreeze() {
      console.info('⚡ Cart unfreeze');
      this._freeze = false;
      this.refresh();
      this.express.refresh();
      this.loader(false);
      this.express.loader(false);
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this._freeze) {
        return;
      }
      var self = this;
      this.itemsContainer().find('.cart-item').remove();
      $.each(self.items, function (i) {
        self.items[i].currentDiv = null;
      });
    }
  }, {
    key: "fetch",
    value: function fetch(callback) {
      this.emit('updateStart');
      this.emit('fetchStart');
      this.fetchWithVariants(callback);
    }
  }, {
    key: "afterChange",
    value: function afterChange(cart, callback, force) {
      var _this4 = this;
      var needsRefresh = false;
      cart.items.forEach(function (item) {
        if (!_this4.variants(item.product_id)) {
          needsRefresh = true;
        }
      });
      if (needsRefresh) {
        this.fetch(callback, force);
        return;
      }
      this.setCart(cart);
      if (typeof callback === 'function') {
        callback();
      }
      this.emit('update');
      this.emit('fetchEnd');
    }
  }, {
    key: "fetchWithVariants",
    value: function fetchWithVariants(callback) {
      var _this5 = this;
      $.ajax({
        url: window.Shopify.routes.root + 'cart?view=v2.json',
        type: 'get'
      }).done(function (data) {
        var json = JSON.parse(data);
        _this5._variants = json.products;
        _this5.emptyCartEnabled = json.enable_empty_cart;
        _this5.emptyCartRecommendations = json.empty_cart_product_recommendations;
        _this5.recommendations = json.recommendations;
        _this5.setCart(json.cart);
        _this5.setRecharge(json.recharge);
        _this5.emit('update');
        var brokenItem = false;
        _this5.items.forEach(function (item) {
          if (!brokenItem && item.getVariants() === null) {
            brokenItem = true;
            console.error('❌ Found broken product in cart', item);

            //vegamour.notify('warning', 'There was a problem with one of the products, we removed it from the cart.', 'Product Problem');

            item.remove(function () {
              if (typeof callback === 'function') {
                callback();
              }
            });
          }
        });
        if (brokenItem) {
          return;
        }
        if (typeof callback === 'function') {
          callback();
        }
        _this5.emit('fetchEnd');
      }).fail(function (err) {
        if (typeof callback === 'function') {
          callback(err);
        }
        _this5.emit('error', err);
        _this5.emit('fetchEnd');
      });
    }
  }, {
    key: "variants",
    value: function variants(productId) {
      for (var i = 0; i < this._variants.length; i++) {
        if (this._variants[i].id == productId) {
          return this._variants[i].data;
        }
      }
      return null;
    }
  }, {
    key: "refresh",
    value: function refresh() {
      if (this._freeze || this._variants.length === 0 && this.items.length > 0) {
        return;
      }
      var self = this;
      this.clear();
      $.each(this.items, function (i) {
        var item = self.items[i];
        item.appendTo(self.itemsContainer());
        item.refresh();
      });
      vegamour.renderSelects();
      var itemsCount = this.getItemsCount();
      $('[data-cart]').toggleClass('empty', !itemsCount);
      $('[data-cart-item-count]').html(itemsCount);
      $('[data-cart-item-' + (itemsCount === 1 ? 'p' : 's') + ']').hide();
      $('[data-cart-item-' + (itemsCount === 1 ? 's' : 'p') + ']').show();
      this.renderRecommendations();
      this.renderDependencies();
    }
  }, {
    key: "getItemsCount",
    value: function getItemsCount() {
      var _this6 = this;
      var quantity = 0;
      $.each(this.items, function (i) {
        quantity += _this6.items[i].getQuantity();
      });
      return quantity;
    }
  }, {
    key: "setCart",
    value: function setCart(cart) {
      var self = this;
      this.cart = cart;
      this.express.items = [];

      // Check existing items in case there is callback after quantity change/remove/add item
      $.each(this.items, function (i) {
        $.each(cart.items, function (j) {
          if (self.items[i].data.key == cart.items[j].key) {
            self.items[i].index = j;
          }
        });
      });
      this.items = [];
      $.each(this.cart.items, function (i) {
        self.items.push(new VegamourCartItem(self.cart.items[i], i));
        self.express.items.push(new VegamourExpressCartItem(self.cart.items[i], i));
      });
    }
  }, {
    key: "itemsContainer",
    value: function itemsContainer() {
      return this.div().find('.cart-items');
    }
  }, {
    key: "itemDiv",
    value: function itemDiv(id) {
      return this.div().find('.cart-item[data-id="' + id + '"]');
    }
  }, {
    key: "getItemById",
    value: function getItemById(id) {
      var result = null;
      this.items.forEach(function (item) {
        if (item.data.id == id) {
          result = item;
        }
      });
      return result;
    }
  }, {
    key: "getItemByHandle",
    value: function getItemByHandle(handle) {
      var result = null;
      this.items.forEach(function (item) {
        if (item.data.handle === handle) {
          result = item;
        }
      });
      return result;
    }
  }, {
    key: "add",
    value: function add(data, callback) {
      var _this7 = this;
      console.info('⚡ Adding item to cart');
      var item = this.getItemById(data.id);
      var quantity = parseInt(data.quantity);
      if (item !== null) {
        quantity = parseInt(item.data.quantity) + quantity;
      }
      if (VegamourCartItem.isLimitExceeded(data, quantity)) {
        var error = VegamourCartItem.showLimitExceeded(data);
        if (typeof callback === 'function') {
          callback(error);
        }
        return;
      }
      this.lastCart = this.cart;
      if (item !== null) {
        item.quantity(quantity, callback);
        return;
      }
      this.emit('updateStart');
      $.ajax({
        url: window.Shopify.routes.root + 'cart/add.js?v2',
        type: 'post',
        dataType: 'json',
        data: {
          items: [data]
        }
      }).done(function (cart) {
        _this7.fetch(function () {
          if (typeof callback === 'function') {
            callback();
          }
          _this7.emit('itemAdded', data);
        });
      }).fail(function (err) {
        if (typeof callback === 'function') {
          callback(err);
        }
        _this7.emit('error', err);
      });
    }
  }, {
    key: "loader",
    value: function loader(show) {
      if (this._freeze) {
        return;
      }
      if (show) {
        this.div().addClass('loading');
      } else {
        this.div().removeClass('loading');
      }
    }
  }, {
    key: "displayPrice",
    value: function displayPrice(price) {
      return price > 0 ? '<strong>' + window.vegamourOptions.currency.sign + Math.round(price / 100) + '</strong>' : '<span class="free">FREE</span>';
    }
  }, {
    key: "checkout",
    value: function checkout() {
      var _this8 = this;
      var attributes = vegamour.cart.getUTMAttributes();
      if (typeof attributes === 'undefined') {
        attributes = {};
      }
      var vdidAttributes = vegamour.cookie.getCookie();
      if (typeof vdidAttributes.d !== 'undefined') {
        attributes['Device ID'] = vdidAttributes.d;
      }
      if (typeof vdidAttributes.z !== 'undefined') {
        attributes['IP'] = vdidAttributes.z;
      }
      if (!$.isEmptyObject(attributes)) {
        $.ajax({
          type: 'POST',
          data: {
            attributes: attributes
          },
          url: window.Shopify.routes.root + 'cart/update.js',
          dataType: 'json',
          success: function success() {
            _this8.redirectToCheckout();
          }
        });
      } else {
        this.redirectToCheckout();
      }
    }
  }, {
    key: "redirectToCheckout",
    value: function redirectToCheckout() {
      if (this.items.length === 0) {
        return false;
      }
      window.location.href = this.buildCheckoutUrl();
    }
  }, {
    key: "buildCheckoutUrl",
    value: function buildCheckoutUrl() {
      if (this.items.length === 0) {
        return '';
      }
      var url = '/checkout';
      if (window.location.href.indexOf('global') > -1 && window.vegamourOptions.language != 'en') {
        url = '/' + window.vegamourOptions.language + url;
      }
      var discount = this.discounts.getActiveDiscountCode(true);
      if (discount && discount.valid) {
        url += '?discount=' + encodeURIComponent(discount.code);
      }
      return url;
    }
  }, {
    key: "getRecommendations",
    value: function getRecommendations() {
      var items = vegamour.cart.cart.items;
      items = items.sort(function (a, b) {
        return b.price - a.price;
      });
      var allRecommendations = vegamour.cart.recommendations;
      var recommendations = [];
      var addedRecommendations = [];
      items.forEach(function (item) {
        var variants = vegamour.cart.variants(item.product_id);
        if (variants.recommendations) {
          variants.recommendations.forEach(function (recommendation) {
            if (addedRecommendations.indexOf(recommendation) === -1 && addedRecommendations.length < 4) {
              allRecommendations.forEach(function (rec) {
                if (rec.id == recommendation) {
                  addedRecommendations.push(recommendation);
                  recommendations.push(rec);
                }
              });
            }
          });
        }
      });
      return recommendations;
    }
  }, {
    key: "renderRecommendations",
    value: function renderRecommendations() {
      var recommendations = this.getRecommendations();
      var $recommendations = $('.cart-recommendations');
      if ($recommendations.hasClass('slick-initialized')) {
        $recommendations.slick('unslick');
      }
      $recommendations.find('.cart-recommendation').remove();
      var self = this;
      $.each(recommendations, function (i) {
        var $div = $($('#cart-v2-item-recommendation-template').html());
        $div.find('[data-recommendation-name]').text(recommendations[i].name);
        $div.find('[data-recommendation-link]').attr('href', recommendations[i].url);
        $div.find('[data-recommendation-price]').html(self.displayPrice(recommendations[i].price));
        $div.find('[data-recommendation-image]').attr('src', recommendations[i].image_big);
        $recommendations.append($div);
      });
      if (vegamour.isMobile()) {
        $recommendations.slick({
          infinite: false,
          slidesToShow: 1,
          variableWidth: true,
          arrows: true,
          draggable: true
        });
      }
    }
  }, {
    key: "renderDependencies",
    value: function renderDependencies() {
      var self = this;
      $('[data-not-cart-product]').each(function () {
        if (self.getItemByHandle($(this).attr('data-not-cart-product'))) {
          $(this).hide();
        } else {
          $(this).show();
        }
      });
      $('[data-cart-product]').each(function () {
        if (self.getItemByHandle($(this).attr('data-cart-product'))) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }
  }, {
    key: "getSubtotal",
    value: function getSubtotal(applyDiscount) {
      var subtotal = this.cart.original_total_price;
      if (typeof applyDiscount === 'undefined' || applyDiscount) {
        var discount = this.discounts.getActiveDiscountCode(true);
        if (discount.valid && discount.subtotal > 0) {
          subtotal = discount.subtotal;
        }
      }
      return subtotal;
    }
  }, {
    key: "getFreeShippingAmount",
    value: function getFreeShippingAmount() {
      return vegamour.shippingRates.getFreeShippingThreshold() * 100;
    }
  }, {
    key: "getSubscriptionFreeShippingAmount",
    value: function getSubscriptionFreeShippingAmount() {
      return vegamour.shippingRates.getSubscriptionFreeShippingThreshold() * 100;
    }
  }, {
    key: "checkStatusBar",
    value: function checkStatusBar() {
      var _this9 = this;
      var discountCode = this.discounts.getActiveDiscountCode();
      var bmsm = this.discounts.getBuyMoreSaveMore(discountCode);
      if (bmsm && (!window.vegamourOptions.currency || window.vegamourOptions.currency["short"] === 'USD')) {
        this.updateStatusBar('bmsm', bmsm);
      } else {
        var gifts = this.gifts.getTierData();
        var minTier = bigNum = 99999;
        if (gifts.length) {
          var nextTier = 0;
          gifts.forEach(function (g) {
            if (!g.d || g.d == discountCode) {
              g.gs.forEach(function (t) {
                var amount = parseInt(t.a, 16);
                if (amount < minTier) {
                  nextTier = minTier;
                  minTier = amount;
                }
              });
            }
          });
        }
        if (minTier < bigNum) {
          var self = this;
          this.updateStatusBar('ship');
          setTimeout(function () {
            self.updateStatusBar('gift', minTier, true);
          }, 10);
        } else {
          this.updateStatusBar('ship', null, true);
          vegamour.on('geolocationReady', function () {
            _this9.updateStatusBar('ship', null, true);
          });
        }
      }
      var timers = $('[data-countdown]');
      if (timers.length) {
        var _self = this;
        timers.each(function () {
          _self.setCountdownTimer($(this));
        });
      }
    }
  }, {
    key: "updateStatusBar",
    value: function updateStatusBar(type, goal, override) {
      var types = ['ship', 'gift', 'bmsm'];
      if (!types.includes(type) || type === 'gift' && goal != parseInt(goal)) {
        return false;
      }
      var $goalSelector = $('[data-goal]');
      if (type === 'bmsm') {
        var $bmsmSelector = $('[data-bmsm]');
        $goalSelector.hide();
        $bmsmSelector.show();
        $ts = $('[data-bmsm-status-bar-goal-start]');
        $ts.html($('[data-bmsm-status-bar-goal]').html());
        $ts.find('[data-bmsm-' + (goal.progress == 0 ? 'money' : 'locked') + ']').hide();
        $ts.find('[data-bmsm-' + (goal.progress == 0 ? 'locked' : 'money') + ']').css('display', 'block');
        $('[data-bmsm-status-tiers-goal-start]').text(goal.labels[1]);
        $tm = $('[data-bmsm-status-bar-goal-mid]');
        $tm.html(goal.tiers < 3 ? '' : $('[data-bmsm-status-bar-goal]').html());
        if (goal.tiers >= 3) {
          $tm.find('[data-bmsm-' + (goal.progress >= 2 ? 'locked' : 'money') + ']').hide();
          $tm.find('[data-bmsm-' + (goal.progress < 2 ? 'locked' : 'money') + ']').css('display', 'block');
          $('[data-bmsm-status-tiers-goal-mid]').text(goal.labels[2]);
        }
        $te = $('[data-bmsm-status-bar-goal]');
        $te.find('[data-bmsm-' + (goal.progress == goal.tiers ? 'locked' : 'money') + ']').hide();
        $te.find('[data-bmsm-' + (goal.progress == goal.tiers ? 'money' : 'locked') + ']').css('display', 'block');
        $('[data-bmsm-status-tiers-goal]').text(goal.labels[goal.tiers]);
        var percent = 0;
        var subtotal = goal.subtotal / 100;
        var remaining = goal.amounts[1] - subtotal;
        var label = goal.labels[1];
        var hasSubscription = this.recharge.hasSubscriptionItem(this.items);
        $('[data-bmsm-subscription]').hide();
        if (goal.progress == goal.tiers) {
          percent = 100;
          $('[data-bmsm-remaining]').text('You\'re getting an extra ').show();
          $('[data-bmsm-text]').hide();
          label = (typeof goal.labels[3] !== 'undefined' ? goal.labels[3] : goal.labels[2]) + '!';
        } else {
          var hideRemaining = false;
          if (goal.progress >= 1) {
            if (goal.tiers == 2) {
              percent = Math.min(parseInt(subtotal / goal.amounts[2] * 100), 100);
              label = goal.labels[2];
              remaining = goal.amounts[2] - subtotal;
              $('[data-bmsm-remaining]').show();
              $('[data-bmsm-text]').show();
              if (goal.subscription[2]) {
                if (!hasSubscription) {
                  // && typeof goal.subscription[goal.progress] !== 'undefined' && goal.subscription[goal.progress]) {
                  $('[data-bmsm-subscription]').show();
                  percent = 50;
                }
                if (remaining < 0) {
                  hideRemaining = true;
                }
              }
            } else {
              if (goal.progress >= 2) {
                percent = 50 + parseInt((subtotal - goal.amounts[2]) / (goal.amounts[3] - goal.amounts[2]) * 100) / 2;
                label = goal.labels[3];
                remaining = goal.amounts[3] - subtotal;
              } else {
                percent = parseInt(subtotal / goal.amounts[2] * 100) / 2;
                label = goal.labels[2];
                remaining = goal.amounts[2] - subtotal;
              }
              if (goal.subscription[3]) {
                if (!hasSubscription && typeof goal.subscription[goal.progress] !== 'undefined' && goal.subscription[goal.progress]) {
                  $('[data-bmsm-subscription]').show();
                  percent = 66;
                }
                if (remaining < 0) {
                  hideRemaining = true;
                }
              }
            }
          }
          if (hideRemaining) {
            $('[data-bmsm-subscription-plus]').text('for');
            $('[data-bmsm-remaining]').hide();
            $('[data-bmsm-text]').hide();
          } else {
            $('[data-bmsm-subscription-plus]').text('+');
            $('[data-bmsm-remaining]').text(window.vegamourOptions.currency.sign + remaining).show();
            $('[data-bmsm-text]').show();
          }
        }
        $('[data-bmsm-amount]').text(label);
        $('[data-bmsm-status-bar-progress]').css('width', 'calc(' + percent + '% - ' + (percent > 80 ? vegamour.isMobile() ? '34' : '40' : vegamour.isMobile() ? '17' : '20') + 'px)');
      } else {
        var _subtotal = this.getSubtotal();
        if (typeof override !== 'undefined' && override) {
          $goalSelector.removeAttr('data-goal-type');
        }
        $goalSelector.each(function () {
          if (!$goalSelector.attr('data-goal-type')) {
            $goalSelector.attr('data-goal-type', type);
          }
        });
        if (type === 'ship') {
          goal = this.getFreeShippingAmount();
          if (goal == 0) {
            $('[data-goal-type=ship]').hide();
            return;
          } else {
            $('[data-goal-type=ship]').show();
          }
          var subscriptionGoal = this.getSubscriptionFreeShippingAmount();
          if (subscriptionGoal) {
            $('[data-recharge-free-subscription-shipping]').hide();
          }
          $('[data-free-shipping-amount]').text(window.vegamourOptions.currency.sign + parseInt(goal / 100));
          if (this.recharge.hasSubscriptionItem(this.items)) {
            goal = subscriptionGoal;
          }
          if (subscriptionGoal > 0) {
            $('[data-goal-ship-free-subscription]').hide();
            $('[data-goal-ship-no-free-subscription]').show();
          } else {
            $('[data-goal-ship-free-subscription]').show();
            $('[data-goal-ship-no-free-subscription]').hide();
          }
          if (_subtotal < goal) {
            $('[data-free-shipping]').hide();
            $('[data-not-free-shipping]').show();
            $('[data-free-shipping-progress-amount]').text(window.vegamourOptions.currency.sign + Math.ceil((goal - _subtotal) / 100));
          } else {
            $('[data-not-free-shipping]').hide();
            $('[data-free-shipping]').show();
          }
        } else if (type == 'gift') {
          if (_subtotal >= this.getFreeShippingAmount()) {
            $('[data-goal-ship][data-goal-completed]').show();
          }
        }
        var progress = goal - _subtotal;
        var isGoal = progress <= 0;
        var typeSelector = '[data-goal-type=' + type + ']';
        $(typeSelector + ' [data-goal-progress-amount]').html(this.displayPrice(progress)).show();
        if (!isGoal) {
          var _percent = Math.max(parseInt(_subtotal / goal * 100), 3);
          _percent = _percent > 3 ? _percent + '% - 10px' : _percent + '%';
          $(typeSelector + ' [data-goal-status-bar-progress]').css('width', 'calc(' + _percent + ')');
        }
        $(typeSelector).attr('data-goal-' + (isGoal ? 'completed' : 'progress'), '').removeAttr('data-goal-' + (!isGoal ? 'completed' : 'progress'));
        setTimeout(function () {
          $('[data-goal-earned], [data-goal-remaining]').each(function () {
            $(this).css('opacity', '0.01').show();
            $(this).children('span').each(function () {
              if ($(this).prevAll(':visible').length > 0) {
                $(this).find('[data-plus]').show();
              } else {
                $(this).find('[data-plus]').hide();
              }
            });
            $(this).css('opacity', '1');
          });
          if (isGoal) {
            $('[data-goal-earned]').show();
            $('[data-goal-remaining]').hide();
          } else {
            $('[data-goal-earned]').hide();
            $('[data-goal-remaining]').show();
          }
        }, 100);
        var iconSelector = '[data-goal-' + type + '][data-icon]';
        $(typeSelector).find(iconSelector + ':not(:has(svg, img))').each(function () {
          $(this).html($(iconSelector + ':has(svg, img)').first().html());
        });
      }
    }
  }, {
    key: "setCountdownTimer",
    value: function setCountdownTimer(div) {
      return new VegamourCountdown(div);
    }
  }, {
    key: "getUTMAttributes",
    value: function getUTMAttributes() {
      var shopifyCookieRegEx = /^_shopify_sa_p/;
      var utmRegEx = /^utm_/;
      var timestampRegEx = /^_shopify_sa_t/;
      var utmParams = {};
      var shopifyCookie = '';
      var timestamp = '';
      document.cookie.split(';').map(function (s) {
        return s.trim();
      }).forEach(function (s) {
        if (shopifyCookieRegEx.test(s)) {
          shopifyCookie = s;
        }
        if (timestampRegEx.test(s)) {
          timestamp = decodeURIComponent(s.split("=")[1]);
        }
        return;
      });
      var utmValuesFromCookie = shopifyCookie.split('=')[1];
      decodeURIComponent(utmValuesFromCookie).split('&').forEach(function (s) {
        var key = s.split('=')[0];
        var val = s.split('=')[1];
        if (utmRegEx.test(key)) {
          return utmParams[key] = val;
        }
        return;
      });
      if (!Object.keys(utmParams).length) {
        return undefined;
      }
      utmParams.utm_timestamp = timestamp;
      utmParams.utm_data_source = 'shopify_cookie';
      return utmParams;
    }
  }, {
    key: "changeMultipleQuantities",
    value: function changeMultipleQuantities(items, callback) {
      var _this10 = this;
      console.info('⚡ Change multiple quantities in cart');
      var updates = {};
      var added = [];
      var removed = [];
      var changed = [];
      items.forEach(function (data) {
        var item = _this10.getItemById(data.id);
        var quantity = parseInt(data.quantity);
        if (item !== null && quantity > parseInt(item.data.quantity)) {
          quantity = parseInt(item.data.quantity) + quantity;
        }
        if (VegamourCartItem.isLimitExceeded(data, quantity)) {
          var error = VegamourCartItem.showLimitExceeded(data);
        } else {
          updates[data.id] = quantity;
          if (item !== null) {
            if (quantity > 0) {
              changed.push(item);
            } else {
              removed.push(item);
            }
          } else if (quantity > 0) {
            added.push(item);
          }
        }
      });
      this.lastCart = this.cart;
      this.emit('updateStart');
      $.ajax({
        url: window.Shopify.routes.root + 'cart/update.js',
        type: 'post',
        dataType: 'json',
        data: {
          updates: updates
        }
      }).done(function () {
        _this10.fetch(function (err) {
          if (typeof callback === 'function') {
            callback(err);
          }
          added.forEach(function (data) {
            _this10.emit('itemAdded', data);
          });
          removed.forEach(function (data) {
            _this10.emit('itemRemoved', data);
          });
          changed.forEach(function (data) {
            _this10.emit('itemChanged', data);
          });
        }, true);
      }).fail(function (err) {
        if (typeof callback === 'function') {
          callback(err);
        }
        _this10.emit('error', err);
      });
    }
  }, {
    key: "addMultiple",
    value: function addMultiple(items, callback) {
      var _this11 = this;
      console.info('⚡ Add multiple products in cart');
      var updates = [];
      items.forEach(function (data) {
        var item = _this11.getItemById(data.id);
        var quantity = parseInt(data.quantity);
        if (item !== null) {
          data.quantity = parseInt(item.data.quantity) + quantity;
        }
        if (VegamourCartItem.isLimitExceeded(data, data.quantity)) {
          var error = VegamourCartItem.showLimitExceeded(data);
        } else {
          updates.push(data);
        }
      });
      this.lastCart = this.cart;
      this.emit('updateStart');
      $.ajax({
        url: window.Shopify.routes.root + 'cart/add.js',
        type: 'post',
        dataType: 'json',
        data: {
          items: updates
        }
      }).done(function () {
        _this11.fetch(function (err) {
          if (typeof callback === 'function') {
            callback(err);
          }
          updates.forEach(function (data) {
            _this11.emit('itemAdded', data);
          });
        }, true);
      }).fail(function (err) {
        if (typeof callback === 'function') {
          callback(err);
        }
        _this11.emit('error', err);
      });
    }
  }, {
    key: "empty",
    value: function empty(callback) {
      this.lastCart = this.cart;
      this.emit('updateStart');
      var self = this;
      $.ajax({
        url: window.Shopify.routes.root + 'cart/clear.js',
        type: 'post',
        dataType: 'json',
        data: {}
      }).done(function () {
        self.fetch(function (err) {
          if (typeof callback === 'function') {
            callback(err);
          }
        }, true);
      }).fail(function (err) {
        if (typeof callback === 'function') {
          callback(err);
        }
        self.emit('error', err);
      });
    }
  }, {
    key: "setRecharge",
    value: function setRecharge(data) {
      if (typeof data === 'undefined' || data.length === 0) {
        return;
      }
      console.log('💳 Setting up recharge products in cart data');
      data.forEach(function (recharge) {
        jQuery.globalEval($(recharge).html());
      });
      vegamour.initRecharge();
    }
  }]);
  return VegamourCart;
}(Events);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourExpressCart = /*#__PURE__*/function () {
  function VegamourExpressCart() {
    _classCallCheck(this, VegamourExpressCart);
    this.items = [];
    this.selector = '#express-cart';
  }
  _createClass(VegamourExpressCart, [{
    key: "div",
    value: function div() {
      return $(this.selector);
    }
  }, {
    key: "init",
    value: function init() {
      var self = this;
      if (!vegamourOptions.expressCart) {
        return;
      }
      $(document).ready(function () {
        self.div().find('[data-action="close"]').on('click', function (e) {
          e.preventDefault();
          vegamour.cart.emit('expressCartClosing');
          self.close();
        });
        self.div().find('[data-cart-checkout]').removeAttr('href').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          vegamour.cart.checkout();
        });
        $('#express-cart-overlay').on('click', function (e) {
          e.preventDefault();
          if (e.target == this) {
            vegamour.cart.emit('expressCartClosing');
            self.close();
          }
        });
        $('a[name="cart"], [data-cart-link]').on('click', function (e) {
          e.preventDefault();
          self.open();
        });

        /*
        self.div().find('.express-cart-empty').on('click', function (e) {
            self.close();
        });
        */

        self.resize();
        if (!vegamour.isMobile()) {
          $(window).resize(function () {
            self.resize();
          });
        }
        self.initDiscounts();
      });
      this.initEvents();
      if (window.location.search.indexOf('showCart') !== -1) {
        this.show();
      }
    }
  }, {
    key: "initEvents",
    value: function initEvents() {
      var _this = this;
      var self = this;
      var cc = false;
      vegamour.cart.on('updateStart', function () {
        _this.loader(true);
        if (cc) {
          clearTimeout(cc);
        }
      });
      vegamour.cart.on('update', function () {
        _this.refresh();
        if (vegamour.cart.gifts.gifts.length === 0) {
          _this.loader(false);
        }
      });
      vegamour.cart.on('fetchEnd', function () {
        var isCartPage = window.location.pathname.includes('/cart');
        if (vegamour.cart.items.length === 0 && _this.div().hasClass('opened') && isCartPage == false) {
          cc = setTimeout(function () {
            self.close();
          }, 1500);
        }
      });
    }
  }, {
    key: "initDiscounts",
    value: function initDiscounts() {
      var self = this;
      var $input = $('.express-cart-discount-code-apply input');
      $input.keyup(function (e) {
        if (e.which == 13) {
          self.submitDiscount($input);
        }
      });
      $('.express-cart-discount-code-apply-submit').click(function () {
        self.submitDiscount($input);
      });
    }
  }, {
    key: "removeDiscount",
    value: function removeDiscount() {
      this.showDiscountError('');
      $('[data-selector-type=redeem]').removeClass('disabled');
      $('.express-cart-discount-code-apply input').val('');
      $('.express-cart-discount-code-applied').hide();
      $('.express-cart-discount-code-apply').show();
      $('[data-bmsm]').hide();
      $('[data-goal]').show();
    }
  }, {
    key: "submitDiscount",
    value: function submitDiscount($input) {
      var self = this;
      var code = $input.val().toUpperCase();
      if (code.length === 0) {
        this.showDiscountError('missing');
        $input.keyup(function () {
          if ($(this).length > 0) {
            self.showDiscountError('');
            $(this).unbind('keyup');
          }
        });
      } else {
        this.showDiscountError('');
        vegamour.cart.discounts.setDiscountCode(code);
      }
    }
  }, {
    key: "showDiscountError",
    value: function showDiscountError(message, active) {
      var $discountInput = $('.express-cart-discount-code-apply-input #discount_code');
      $('.express-cart-discount-code-apply-error > div').hide();
      $('.express-cart-discount-code-applied-warning > div').hide();
      if (message.length === 0) {
        $('#discount_code').removeClass('error');
        $discountInput.attr('aria-invalid', false);
        $discountInput.attr('aria-errormessage', "");
      } else {
        active = typeof active === 'undefined' ? false : active;
        $discountInput.attr('aria-invalid', true);
        $discountInput.attr('aria-errormessage', 'discount-code-invalid');
        if (active) {
          $('#discount-code-warning').html('*' + message.replace('strong', 'span')).show();
        } else {
          $('#discount_code').addClass('error');
        }
        if (message === 'missing' || message === 'invalid') {
          $('#discount-code-' + message).show();
        } else {
          $('#discount-code-error').html(message).show();
        }
      }
    }
  }, {
    key: "toggleSelector",
    value: function toggleSelector(select) {
      if (!select.hasClass('selected') && !select.hasClass('disabled')) {
        var $parentDiv = $('.express-cart-discount-redeem');
        var $selector = $parentDiv.children('div.express-cart-' + select.data('selector-type'));
        var $notSelector = $parentDiv.children('div:not(.express-cart-' + select.data('selector-type') + ')');
        if ($selector.length) {
          select.parent().find('div.selected').removeClass('selected');
          select.addClass('selected');
          $notSelector.hide();
          $selector.show();
        }
      }
    }
  }, {
    key: "checkForChanges",
    value: function checkForChanges() {
      var _this2 = this;
      this.lastHeight = this.div().height();
      this.checkForChangesInterval = setInterval(function () {
        if (_this2.lastHeight != _this2.div().height()) {
          _this2.lastHeight = _this2.div().height();
          _this2.resize();
        }
      }, 100);
    }
  }, {
    key: "open",
    value: function open() {
      this.div().addClass('opened');
      $('body').addClass('express-cart-opened');
      this.resize();
      this.checkForChanges();
      var $cartContainer = $(this.div());
      modalOpenedAccessibilityAdjustments($cartContainer);
    }
  }, {
    key: "close",
    value: function close() {
      this.div().removeClass('opened');
      $('body').removeClass('express-cart-opened');
      vegamour.cart.unfreeze();
      clearInterval(this.checkForChangesInterval);
      var $cartContainer = $(this.div());
      modalClosedAccessibilityAdjustments($cartContainer);
    }
  }, {
    key: "show",
    value: function show() {
      this.open();
      var self = this;
      setTimeout(function () {
        self.close();
      }, 4000);
    }
  }, {
    key: "clear",
    value: function clear() {
      if (vegamour.cart._freeze) {
        return;
      }
      var self = this;
      this.itemsContainer().html('');
      $.each(self.items, function (i) {
        self.items[i].currentDiv = null;
      });
    }
  }, {
    key: "emptyCartSettingEnabledAndEmptyCart",
    value: function emptyCartSettingEnabledAndEmptyCart() {
      if (vegamour.cart.emptyCartEnabled === 'true' && this.items.length === 0 && document.querySelector('.empty-cart-setting-enabled')) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "showCartWithItems",
    value: function showCartWithItems() {
      var self = this;
      $.each(this.items, function (i) {
        var item = self.items[i];
        item.appendTo(self.itemsContainer());
        item.refresh();
      });
      vegamour.renderSelects();
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var emptyCartSettingEnabledAndEmptyCart = false;
      var emptyCartRecommendationsArr = vegamour.cart.emptyCartRecommendations;
      if (vegamour.cart._freeze || vegamour.cart._variants.length === 0 && this.items.length > 0) {
        return;
      }
      this.clear();
      if (this.emptyCartSettingEnabledAndEmptyCart()) {
        emptyCartSettingEnabledAndEmptyCart = true;
      } else {
        this.showCartWithItems();
      }
      this.setDiscountPosition();
      vegamour.cart.gifts.setGiftLabels();
      this.renderRecommendations(emptyCartRecommendationsArr, emptyCartSettingEnabledAndEmptyCart);
    }
  }, {
    key: "itemsContainer",
    value: function itemsContainer() {
      return this.div().find('.express-cart-items');
    }
  }, {
    key: "itemDiv",
    value: function itemDiv(id) {
      return this.div().find('.express-cart-item[data-id="' + id + '"]');
    }
  }, {
    key: "loader",
    value: function loader(show) {
      if (vegamour.cart._freeze) {
        return;
      }
      if (show) {
        this.div().addClass('loading');
      } else {
        this.div().removeClass('loading');
      }
    }
  }, {
    key: "resize",
    value: function resize() {
      if (!this.div().hasClass('opened')) {
        return;
      }
      var header = this.div().find('.express-cart-header').outerHeight();
      var notification = this.div().find('.express-cart-notification').filter(':visible').outerHeight() || 0;
      var progress = this.div().find('.express-cart-progress').filter(':visible').outerHeight() || 0;
      var footer = this.div().find('.express-cart-footer').outerHeight();
      //const empty = this.div().find('.express-cart-empty').outerHeight() || 0;
      var loopCreditBanner = $('.loop-onstore').filter(':visible').outerHeight() || 0;
      var cartHeight = this.div().innerHeight();
      var sumHeight = header + notification + progress + footer;
      var height = cartHeight - sumHeight - loopCreditBanner;
      this.div().find('.express-cart-body').css({
        height: height + 'px',
        maxHeight: height + 'px'
      });
      this.setDiscountPosition();
    }
  }, {
    key: "setDiscountPosition",
    value: function setDiscountPosition() {
      var $cartBodyElement = $('.express-cart-body');
      var $cartDiscountCodeElement = $('.express-cart-discount');
      var scrollHeight = Math.round($cartBodyElement.prop("scrollHeight"));
      var innerHeight = Math.round($cartBodyElement.innerHeight());
      var isScrollable = scrollHeight > innerHeight;
      var emptyCartShowing = this.emptyCartSettingEnabledAndEmptyCart();
      $cartBodyElement.css('paddingBottom', isScrollable || emptyCartShowing ? '0' : (vegamour.isMobile() ? '100' : '85') + 'px');
      $cartDiscountCodeElement.css('position', isScrollable || emptyCartShowing ? 'relative' : 'absolute');
      $cartDiscountCodeElement.css('visibility', 'visible');
    }
  }, {
    key: "renderRecommendations",
    value: function renderRecommendations(emptyCartRecommendationsArr, emptyCartSettingEnabledAndEmptyCart) {
      var recommendations;
      var self = this;
      if (emptyCartSettingEnabledAndEmptyCart) {
        recommendations = emptyCartRecommendationsArr;
      } else {
        recommendations = vegamour.cart.getRecommendations();
      }
      if (recommendations.length > 0) {
        $('.express-cart-recommendations').addClass('has-recommendations');
      } else {
        $('.express-cart-recommendations').removeClass('has-recommendations');
        self.setDiscountPosition();
        return;
      }
      var $recommendations = $('.express-cart-recommendations-items');
      if ($recommendations.hasClass('slick-initialized')) {
        $recommendations.slick('unslick');
      }
      $recommendations.find('.express-cart-recommendation').remove();
      $.each(recommendations, function (i) {
        var $div = $($('#express-cart-recommendation-template').html());
        $div.find('[data-recommendation-name]').html('<a href="' + recommendations[i].url + '">' + recommendations[i].name + '</a>');
        if (recommendations[i].compare_at_price > recommendations[i].price) {
          $div.find('[data-recommendation-compare]').html(vegamour.cart.displayPrice(recommendations[i].compare_at_price));
        }
        $div.find('[data-recommendation-price]').html("From ".concat(vegamour.cart.displayPrice(recommendations[i].price)));
        $div.find('[data-recommendation-image]').parent().html('<a href="' + recommendations[i].url + '"><img data-recommendation-image aria-hidden="true" src="' + recommendations[i].image + '" /><p class="visually-hidden">Go to ' + recommendations[i].name + '</p></a>');
        $div.find('[data-recommendation-add]').on('click', function (e) {
          e.preventDefault();
          var data = {
            id: recommendations[i].variant_id,
            quantity: 1,
            properties: {
              _cart_limit: recommendations[i].cart_limit
            }
          };
          if (parseInt(recommendations[i].contains_cbd) === 1) {
            data.properties._contains_cbd = 1; // ✅ properties 안으로 넣고 _ 추가
          }
          if (parseInt(recommendations[i].contains_cbd_edible) === 1) {
            data.properties._contains_cbd_edible = 1; // ✅ properties 안으로 넣고 _ 추가
          }
          if (parseInt(recommendations[i].proposition_65) === 1) {
            data.properties._proposition_65 = 1; // ✅ properties 안으로 넣고 _ 추가
          }
          if (recommendations[i].custom_save) {
            data.properties._custom_save = recommendations[i].custom_save; // ✅ _ 추가
          }
          vegamour.cart.add(data);
        });
        $recommendations.append($div);
      });
      $recommendations.slick({
        infinite: false,
        slidesToShow: 1,
        variableWidth: true,
        arrows: true,
        prevArrow: '<a class="express-cart-recommendation__arrow previous"><svg xmlns="http://www.w3.org/2000/svg" role="img" width="30.343" height="50" viewBox="0 0 30.343 50" aria-label="Go to previous slide"><path id="Icon_awesome-chevron-right" data-name="Icon awesome-chevron-right" d="M31.472,29.591,9.22,51.843a2.748,2.748,0,0,1-3.886,0l-2.6-2.6a2.748,2.748,0,0,1,0-3.882L20.369,27.648,2.733,9.93a2.748,2.748,0,0,1,0-3.882l2.6-2.6a2.748,2.748,0,0,1,3.886,0L31.472,25.7A2.748,2.748,0,0,1,31.472,29.591Z" transform="translate(32.277 52.648) rotate(180)" fill="currentColor"/></svg></a>',
        nextArrow: '<a class="express-cart-recommendation__arrow next"><svg xmlns="http://www.w3.org/2000/svg" role="img" width="30.343" height="50" viewBox="0 0 30.343 50" aria-label="Go to next slide"><path id="Icon_awesome-chevron-right" data-name="Icon awesome-chevron-right" d="M31.472,29.591,9.22,51.843a2.748,2.748,0,0,1-3.886,0l-2.6-2.6a2.748,2.748,0,0,1,0-3.882L20.369,27.648,2.733,9.93a2.748,2.748,0,0,1,0-3.882l2.6-2.6a2.748,2.748,0,0,1,3.886,0L31.472,25.7A2.748,2.748,0,0,1,31.472,29.591Z" transform="translate(-1.933 -2.648)" fill="currentColor"/></svg></a>',
        draggable: true
      });
      $recommendations.on('init', function () {
        setTimeout(function () {
          self.setDiscountPosition();
        }, 0);
      });
      $recommendations.on('setPosition', function () {
        setTimeout(function () {
          self.setDiscountPosition();
        }, 0);
      });
    }
  }]);
  return VegamourExpressCart;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourCollection = /*#__PURE__*/function () {
  function VegamourCollection() {
    _classCallCheck(this, VegamourCollection);
    this.init();
  }
  _createClass(VegamourCollection, [{
    key: "init",
    value: function init() {
      this.initSort();
      this.initMenu();
      this.initImages();
      this.initPromo();
      this.initThumbs();
      this.initFilters();
      this.refresh();
      $(document).ready(function () {
        $(window).scroll(function () {
          if ($('.block-collections').length > 0) {
            if ($(window).scrollTop() > 50) {
              $('body').addClass('sticky');
            } else {
              $('body').removeClass('sticky');
            }
          }
          $('.menu-category').css("top", $('.sticky-top').height() - 1);

          /* Back to top */
          /*
          let showAfter = $('.collection-grid').height();
          let showBottomPosition = $('#shopify-section-footer').height();
          if ($(window).scrollTop() > showAfter) {
              let $btn = $('.back-to-top');
              $btn.css({"display":"flex","bottom":`${showBottomPosition}px`}).fadeIn();
          } else {
              $('.back-to-top').fadeOut();
          }
          */
        });
        $('.back-to-top').click(function () {
          $('html, body').animate({
            scrollTop: 0
          }, 400);
          return false;
        });
      });
    }
  }, {
    key: "copyToClipboard",
    value: function copyToClipboard(element) {
      var $temporary = $("<input>");
      $("body").append($temporary);
      $temporary.val($(element).text()).select();
      document.execCommand("copy");
      $temporary.remove();
    }
  }, {
    key: "initThumbs",
    value: function initThumbs() {
      var $button = $(".variant-picker-thumb-body");
      $button.on('click', function (e) {
        e.preventDefault();
        $button.removeClass('active');
        $(e.currentTarget).addClass('active');
        $(".variant-picker-thumb-selected").text(e.currentTarget.dataset.thumbLabel);
      });
    }
  }, {
    key: "initSort",
    value: function initSort() {
      var sort = vegamour.getParam('sort_by');
      var $sort = $('[data-collection-sort]');
      if (sort) {
        $sort.val(sort).trigger('change');
      }
      $sort.on('change', function () {
        var value = $(this).val().trim();
        if (sort !== value) {
          window.location.href = vegamour.appendParamsToLocation({
            sort_by: value
          });
        }
      });
    }
  }, {
    key: "refresh",
    value: function refresh() {
      var sort = vegamour.getParam('sort_by');
      if (sort && sort !== 'best-selling') {
        $('.collection-grid-item, .collection-grid-promo').sort(function (a, b) {
          var weightA = 0;
          var weightB = 0;
          switch (sort) {
            case 'price-ascending':
              weightA = parseInt($(a).data('product-price'));
              weightB = parseInt($(b).data('product-price'));
              break;
            case 'price-descending':
              weightA = parseInt($(b).data('product-price'));
              weightB = parseInt($(a).data('product-price'));
              break;
          }
          if ($(a).hasClass('.collection-grid-promo')) {
            weightA = -1;
          }
          if ($(b).hasClass('.collection-grid-promo')) {
            weightB = -1;
          }
          return weightA < weightB ? -1 : weightA > weightB ? 1 : 0;
        }).appendTo($('.collection-grid-items'));
      }
      this.refreshPromo();
      $('.collection-grid').removeClass('loading');
    }
  }, {
    key: "refreshPromo",
    value: function refreshPromo() {
      $('.collection-grid-promo').each(function (i, promo) {
        var $promo = $(promo);
        var index = $promo.data('promo-index');
        var $item = $('.collection-grid-item, .collection-grid-promo').eq(index - 1);
        if ($item.length > 0) {
          $item.after($promo);
          $promo.show();
        } else {
          $promo.hide();
        }
      });
    }
  }, {
    key: "initMenu",
    value: function initMenu() {
      new VegamourCollectionMenu($('.collection-section-block-collections'));
    }
  }, {
    key: "initImages",
    value: function initImages() {
      $('.collection-grid-item-image').each(function (i, box) {
        var $box = $(box);
        var $img = $box.find('img');
        var image = $img.eq(0).data('image');
        if (!image) {
          $box.addClass('image-loaded');
          return;
        }
        if (!image.loaded) {
          image.on('loaded', function () {
            $box.addClass('image-loaded');
          });
        } else {
          $box.addClass('image-loaded');
        }
      });
    }
  }, {
    key: "initPromo",
    value: function initPromo() {
      var self = this;
      $('.collection-grid-promo').each(function (i, promo) {
        $(promo).appendTo($('.collection-grid-items'));
      });
      this.refreshPromo();
      $(".code-btn").click(function () {
        self.copyToClipboard('.code-btn');
      });
    }
  }, {
    key: "initFilters",
    value: function initFilters() {
      if ($('.collection-filters').length === 0) {
        return;
      }
      var promo = false;
      var mobile = $(window).width() <= 991;
      var setPage = function setPage(page) {
        page = typeof page === 'undefined' ? 1 : page;
        $('.pagination').find('.active').removeClass('active');
        $('.pagination').find('[data-page="' + page + '"]').addClass('active');
        $('.collection-grid-items').attr('data-page', page);
      };
      var initPagination = function initPagination(items, perPage) {
        items = typeof items === 'undefined' ? $('.collection-grid-item:not(.collection-grid-item-promo)').length : parseInt(items);
        perPage = parseInt(typeof perPage === 'undefined' ? $('.collection-grid-items').data('items-per-page') : perPage);
        var page = function page() {
          return parseInt($('.collection-grid-items').attr('data-page'));
        };
        if (items > perPage) {
          var pages = Math.ceil(items / perPage);
          var separator = '<span class="sep">/</span>';
          var pagination = '';
          if (page() > 1) {
            pagination += '<a href="javascript: void(0);" class="previous-page" title="« Previous" aria-label="« Previous">Previous Page</a>' + separator;
          }
          for (var p = 1; p <= pages; p++) {
            pagination += '<span data-page=' + p + (p == page() ? ' class="active"' : '') + ' title="' + p + '" aria-label="' + p + '">' + p + '</span>';
            if (p < pages || page() < pages) {
              pagination += separator;
            }
          }
          if (page() < pages) {
            pagination += '<a href="javascript: void(0);" class="next-page" title="Next »" aria-label="Next »">Next Page</a>';
          }
          $('.pagination').html(pagination).show();
          $('.pagination span:not(.active)').click(function () {
            setPage($(this).attr('data-page'));
            evaluateFilters();
          });
          if (page() > 1) {
            $('.previous-page').click(function () {
              setPage(page() - 1);
              evaluateFilters();
            });
          }
          if (page() < pages) {
            $('.next-page').click(function () {
              setPage(page() + 1);
              evaluateFilters();
            });
          }
        } else {
          $('.pagination').hide();
        }
      };
      var evaluateFilters = function evaluateFilters() {
        var filters = {};
        var $activeFilters = $('.collection-filters input[type="checkbox"]:checked');
        var totalItems = $('.collection-grid-item').length;
        var perPage = parseInt($('.collection-grid-items').data('items-per-page'));
        var page = parseInt($('.collection-grid-items').attr('data-page'));
        var start = (page - 1) * perPage + 1;
        var end = perPage * page;
        var hash = '';
        var sort = '';
        var activeItems = 0;
        var activeFilters = $activeFilters.length;
        if (activeFilters > 0) {
          var $filtersApplied = $('.filters-applied-filters');
          $filtersApplied.html('');
          var typeCount = 0;
          $activeFilters.each(function () {
            var type = $(this).data('filter-type');
            var value = $(this).attr('value');
            if (type == 'sort') {
              activeFilters--;
              sort = value;
            } else {
              var label = $(this).attr('aria-label');
              $filtersApplied.append('<div class="filter-applied" data-filter-value="' + value + '" alt="Remove ' + label + ' filter" title="Remove ' + label + ' filter">' + label + '</div>');
              if (typeof filters[type] === 'undefined') {
                filters[type] = [];
                typeCount++;
              }
              filters[type][filters[type].length] = value;
            }
          });
          $filtersApplied.find('.filter-applied').click(function () {
            var value = $(this).attr('data-filter-value');
            $('.collection-filters input[type="checkbox"][value="' + value + '"]').prop('checked', false);
            setPage();
            evaluateFilters();
          });
          if (promo) {
            $(promo['selector']).remove();
          }
          if (sort) {
            sortResults(sort);
          }
          var _c = 0;
          $('.collection-grid-item').each(function () {
            var tCount = 0;
            for (var type in filters) {
              var content = $(this).data('product-' + type);
              count = 0;
              if (content) {
                for (var i = 0; i < filters[type].length; i++) {
                  if (content.indexOf(filters[type][i] + ',') !== -1) {
                    count++;
                  }
                }
              }
              if (count > 0) {
                tCount++;
              }
            }
            if (tCount == typeCount) {
              activeItems++;
              if (activeItems >= start && activeItems <= end) {
                $(this).show();
                _c++;
                if (promo && promo['pos'] == _c) {
                  $(this).after(promo['html']);
                  $(promo['selector']).show();
                }
              } else {
                $(this).hide();
              }
            } else {
              $(this).hide();
            }
          });
          if (promo && _c < promo['pos']) {
            $('.collection-grid-items').append(promo['html']);
            $(promo['selector']).show();
          }
          if (activeFilters > 0) {
            initPagination(activeItems, perPage);
            $('.filters-no-results').css('display', activeItems > 0 ? 'none' : 'block');
            $('.filters-applied-title [data-plural]').css('display', activeFilters === 1 ? 'none' : 'inline-block');
            $('.filters-applied-num-results [data-plural]').css('display', activeItems === 1 ? 'none' : 'inline-block');
            $('.filters-applied [data-num-filters]').text(activeFilters);
            $('.filters-applied').addClass('active');
            $('[data-num-results]').text(activeItems);
          }
          for (var type in filters) {
            hash += (hash.length ? '|' : '') + type + '=' + filters[type].join(',');
          }
          if (sort) {
            hash += (hash.length > 0 ? '|' : '') + 'sort=' + sort;
          }
          window.location.hash = hash;
        }
        if (activeFilters === 0) {
          $('.filters-applied').removeClass('active');
          $('.filters-no-results').hide();
          $('.collection-grid-item').show();
          activeItems = 0;
          c = 0;
          if (promo) {
            $(promo['selector']).remove();
          }
          $('.collection-grid-item').each(function () {
            activeItems++;
            if (activeItems >= start && activeItems <= end) {
              $(this).show();
              c++;
              if (promo && promo['pos'] == c) {
                $(this).after(promo['html']);
                $(promo['selector']).show();
              }
            } else {
              $(this).hide();
            }
          });
          if (promo && c < promo['pos']) {
            $('.collection-grid-items').append(promo['html']);
            $(promo['selector']).show();
          }
          $('[data-num-results]').text('');
          initPagination();
          if (!hash) {
            history.pushState('', document.title, window.location.pathname + window.location.search);
          }
        }
        var h = $('.collection-section .collection-container').offset().top;
        if ($(window).scrollTop() > h) {
          window.scrollTo(0, h);
        }
      };
      var sortResults = function sortResults(type) {
        var desc = type.indexOf('-descending') !== -1;
        type = type.replace('-ascending', '').replace('-descending', '');
        var attr = 'data-product-' + type;
        $itemContainer = $('.collection-grid-items');
        var result = $itemContainer.find('.collection-grid-item').sort(function (a, b) {
          var contentA = parseInt($(a).attr(attr));
          var contentB = parseInt($(b).attr(attr));
          var sort = false;
          if (desc) {
            sort = contentA > contentB ? -1 : contentA < contentB ? 1 : 0;
          } else {
            sort = contentA < contentB ? -1 : contentA > contentB ? 1 : 0;
          }
          return sort;
        });
        $itemContainer.html(result);
      };
      var initURLFilters = function initURLFilters() {
        var hash = window.location.hash;
        if (hash && hash.indexOf('=') !== -1) {
          hash = decodeURIComponent(hash.replace('#', ''));
          hash = hash.split('|');
          var parts = '';
          var filters = '';
          for (var i = 0; i < hash.length; i++) {
            parts = hash[i].split('=');
            filters = parts[1].split(',');
            for (var n = 0; n < filters.length; n++) {
              $('.' + parts[0] + '-filter input[value="' + filters[n] + '"]').prop('checked', true);
            }
          }
          evaluateFilters();
        } else {
          initPagination();
        }
      };
      var initCheckboxes = function initCheckboxes() {
        $('.collection-filters input[type="checkbox"]').click(function () {
          if ($(this).attr('data-filter-type') == 'sort') {
            $(this).closest('.card-body').find('input[type="checkbox"][value!="' + $(this).attr('value') + '"]').prop('checked', false);
          }
          setPage();
          evaluateFilters();
        });
        $('.filters-applied-clear').click(function () {
          $('.collection-filters .card:not(.sort-filter) input[type="checkbox"]:checked').prop('checked', false);
          setPage();
          evaluateFilters();
        });
      };
      $(document).ready(function () {
        if (mobile) {
          var option = function option(value, label, checked) {
            checked = typeof checked !== 'undefined' ? checked : false;
            return '<li class="list-inline-item d-block"><div class="form-check"><label class="form-check-label"><input type="checkbox"' + (checked ? 'checked="checked"' : '') + ' name="sort[]" aria-label="' + label + '" value="' + value + '" data-filter-type="sort" class="form-check-input"> <span class="sort-title">' + label + '</span></label></div></li>';
          };
          var filtersSort = '<div class="sort-filter card active mt-3"><div class="card-header">Sort By</div><div class="card-body"><ul class="list-unstyled tags-list my-0 py-0">';
          $('#sortBy option').each(function (i) {
            var check = i == 0 && window.location.hash.indexOf('sort=') === -1;
            filtersSort += option($(this).attr('value'), $(this).text(), check);
          });
          filtersSort += '</ul></div></div>';
          var cta = '<a class="show-results btn btn-primary">Show <span data-num-results></span> results</a><div class="filters-applied-clear">Clear All</div>';
          $('.collection-filters').prepend('<div class="filters-title">' + $('.filters-mobile').html() + '</div>' + filtersSort).append(cta);
          $('.filters-mobile, .collection-filters .close-button, .collection-filters .show-results, .collection-filters .filters-applied-clear').click(function () {
            $('body').toggleClass('collection-filter-modal');
          });
          $('.card-header').click(function () {
            var hasActive = $(this).closest('.card').hasClass('active');
            $(this).closest('.collection-filters').find('.card.active').removeClass('active').find('.card-body').slideUp();
            if (!hasActive) {
              $(this).closest('.card').addClass('active').find('.card-body').slideDown();
            }
          });
        } else {
          $('#sortBy').change(function () {
            sortResults($(this).val());
            evaluateFilters();
          }).closest('form').unbind('submit');
        }
        if ($('.collection-grid-item-promo').length > 0) {
          promo = {
            'selector': '.collection-grid-item-promo'
          };
          promo['pos'] = parseInt($(promo['selector']).data('promo-position'));
          promo['html'] = '<div class="' + $(promo['selector']).attr('class') + '" data-promo-position="' + promo['pos'] + '">' + $(promo['selector']).html() + '</div>';
        }
        initCheckboxes();
        initURLFilters();
      });
    }
  }]);
  return VegamourCollection;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourCollectionMenu = /*#__PURE__*/function () {
  function VegamourCollectionMenu($div) {
    _classCallCheck(this, VegamourCollectionMenu);
    this._div = $div;
    this.init();
  }
  _createClass(VegamourCollectionMenu, [{
    key: "div",
    value: function div() {
      return this._div;
    }
  }, {
    key: "init",
    value: function init() {
      if (!vegamour.isMobile()) {
        return;
      }
      var $slick = this.div().find('.collection-collections-items');
      $slick.slick({
        arrows: false,
        variableWidth: true,
        infinite: false,
        swipeToSlide: true
      });
    }
  }]);
  return VegamourCollectionMenu;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourHeader = /*#__PURE__*/function () {
  function VegamourHeader() {
    _classCallCheck(this, VegamourHeader);
  }
  _createClass(VegamourHeader, [{
    key: "init",
    value: function init() {
      var _this = this;
      $(document).ready(function () {
        _this.initDrop();
        _this.initMobile();
        _this.initSticky();
        _this.isRedirected();
        _this.initLocalization();
      });
      this.initGeoBasedBannersController();
      this.setHeaderCSS();
      try {
        new ResizeObserver(this.setHeaderCSS).observe(document.querySelector('#header-container'));
      } catch (e) {
        console.log(e);
      }
      this.search = new VegamourSearch();
      this.search.init();
      this.announcements = new VegamourAnnouncements();
      this.announcements.init();
      this.testGeoPopUp = window.location.search.toLowerCase().indexOf('testgeopopup') > -1;
    }
  }, {
    key: "initDrop",
    value: function initDrop() {
      var self = this;
      $('.header-menu-item').each(function () {
        var $item = $(this),
          $link = $item.find('a'),
          $drop = $item.closest('.row').find('.header-drop.' + $link.data('menu') + '-menu');
        if ($drop.length > 0) {
          var mouseOnLink = false,
            mouseOnDrop = false;
          var _checkClose = function _checkClose() {
            var allowClose = !mouseOnLink && !mouseOnDrop;
            if (allowClose) {
              close();
            }
          };
          var checkClose = function checkClose() {
            setTimeout(_checkClose, 100);
          };
          var close = function close() {
            $drop.removeClass('show');
            $link.removeClass('opened');
            $('.header-overlay').hide();
          };
          var open = function open() {
            mouseOnLink = true;
            $drop.addClass('show');
            $link.addClass('opened');
            if (!$drop.hasClass('mini-menu')) {
              self.search.closeSearch();
              $('.header-overlay').show();
            }
          };
          $link.mouseenter(function () {
            open();
          }).click(function (e) {
            if ($(this).parent().prev().length > 0) {
              e.preventDefault();
              if ($drop.hasClass('show')) {
                close();
              } else {
                open();
              }
            }
          }).mouseleave(function () {
            mouseOnLink = false;
            checkClose();
          });
          $drop.mouseenter(function () {
            mouseOnDrop = true;
            checkClose();
          }).mouseleave(function () {
            mouseOnDrop = false;
            checkClose();
          });
        }
      });
    }
  }, {
    key: "initMobile",
    value: function initMobile() {
      var self = this;
      $('.header-mobile-toggle').click(function (e) {
        e.preventDefault();
        if ($('body').hasClass('show-header-mobile')) {
          $(this).removeClass('open');
          self.closeMobileMenu();
        } else {
          var offset = $('#header-v2 .header-bar-mobile').outerHeight() + document.getElementById('announcements').offsetHeight;
          offset = Math.ceil(offset);
          $('#header-v2 .header-mobile').scrollTop(0);
          $('#header-v2 .header-mobile').css({
            'top': offset + 'px',
            'height': 'calc(100vh - ' + offset + 'px)'
          });
          if ($('html').hasClass('ios')) {
            $('#header-v2 .header-mobile').css('padding-bottom', '100px');
          }
          $(this).addClass('open');
          self.openMobileMenu();
          window.mobileMenuTriggerElement = e.currentTarget;
        }
      });
      $('.header-mobile-menu-item').each(function () {
        var $item = $(this),
          $link = $item.find('> a'),
          $menu = $item.find('.header-mobile-submenu');
        if ($menu.length > 0) {
          $link.click(function (e) {
            e.preventDefault();
            var isHeaderV2 = $(this).closest('#header-v2').length; // Remove after test

            if ($menu.hasClass('show')) {
              if (isHeaderV2) {
                $menu.removeClass('show').slideUp(200);
              } else {
                $menu.removeClass('show');
              }
              $item.removeClass('opened');
              $link.attr('aria-expanded', false);
            } else {
              if (isHeaderV2) {
                var $container = $(this).parent().parent();
                $container.find('.show').slideUp().removeClass('show');
                $container.find('.opened').removeClass('opened');
                $menu.addClass('show').slideDown(200);
                if ($menu.closest('.mobile-menu-items-bottom').length) {
                  $('.header-mobile').animate({
                    scrollTop: 200
                  }, 200);
                }
              } else {
                $menu.addClass('show');
              }
              $item.addClass('opened');
              $link.attr('aria-expanded', true);
            }
          });
        }
      });
      $('.header-mobile-close').click(function (e) {
        e.preventDefault();
        self.closeMobileMenu();
        if (window.mobileMenuTriggerElement) window.mobileMenuTriggerElement.focus();
      });
      $('#footer .footer-link').click(function () {
        if ($(this).hasClass('opened')) {
          $(this).removeClass('opened').find('.link-list').slideUp(200);
        } else {
          $(this).parent().find('.opened').removeClass('opened').find('.link-list').slideUp(200);
          $(this).addClass('opened').find('.link-list').slideDown(200);
        }
      });
    }
  }, {
    key: "initSticky",
    value: function initSticky() {
      var $header = $('#header');
      var isSticky = typeof $header.attr('data-is-sticky') !== 'undefined';
      if (isSticky) {
        $('#header-container').addClass('sticky-top');
      }
    }
  }, {
    key: "openMobileMenu",
    value: function openMobileMenu() {
      $('body').addClass('show-header-mobile');
    }
  }, {
    key: "closeMobileMenu",
    value: function closeMobileMenu() {
      $('body').removeClass('show-header-mobile');
    }
  }, {
    key: "isRedirected",
    value: function isRedirected() {
      var geo = vegamour.geolocation.getLocationData();
      if (!geo || !geo.country.code) {
        var self = this;
        setTimeout(function () {
          self.isRedirected();
        }, 100);
        return false;
      }
      console.log('🌎 ' + geo.country.name);
      this.initRedirectModal(geo);
    }
  }, {
    key: "initRedirectModal",
    value: function initRedirectModal(geo) {
      if (window.location.pathname.indexOf('blogs/') !== -1) {
        return false;
      }
      var code = geo.country.code;
      var redirects = window.vegamourOptions.redirects;
      var url = country = false;
      if (!$.isEmptyObject(redirects.country)) {
        for (var isoCode in redirects.country) {
          if (isoCode.toUpperCase() == code) {
            url = redirects.country[code].trim();
          }
        }
      }
      if (redirects.domain.length > 0 && redirects.except.length > 0) {
        if (!redirects.except.includes(code)) {
          url = redirects.domain;
        }
      }
      if (url) {
        if (url.indexOf('https://') === -1) {
          url = 'https://' + url;
        }
        url += window.location.pathname + window.location.search;
        this.openLocalizationModal('#redirectModal', geo, url);
      }
    }
  }, {
    key: "openLocalizationModal",
    value: function openLocalizationModal(selector, geo, url) {
      if (!localStorage.getItem('geoip-popup')) {
        var isDomestic = window.vegamourOptions.backend.store == 'main';
        $('.domestic-title').html('<ul><li>' + window.vegamourOptions.redirects.domestic.replaceAll(',', '</li><li>') + '</li></ul>');
        $(selector).modal('show');
        localStorage.setItem('geoip-popup', 'showed');
        $(window).on('shown.bs.modal', function () {
          $('#redirectModal').unbind('click');
          $(selector).find(isDomestic ? '.domestic-url' : '.intl-url').click(function (e) {
            e.preventDefault();
            $(selector).modal('hide');
          });
          $(selector).find(isDomestic ? '.intl-url' : '.domestic-url').attr('href', url);
          $('body, .sticky-top').css({
            'padding-right': '0',
            'margin-right': '0'
          });
          setTimeout(function () {
            $('#redirectModal .close').css('visibility', 'visible').click(function (e) {
              $(selector).modal('hide');
            });
            $('#redirectModal').click(function (e) {
              if (e.target === this) {
                $(selector).modal('hide');
              }
            });
          }, 5000);
        });
        $(window).on('hidden.bs.modal', function () {
          $('body, .sticky-top').css({
            'padding-right': '',
            'margin-right': ''
          });
        });
      }
    }
  }, {
    key: "initLocalization",
    value: function initLocalization() {
      var $trigger = $('.localization-trigger');
      var $modal = $('#localization-modal');
      var $closeBtns = $('.btn-cancel, .localization-modal-overlay');
      var $select = $('#country-select');
      var $countryInput = $('#country_code_input');

      // 1. 트리거 클릭 시 모달창 열기
      $trigger.on('click', function (e) {
        e.preventDefault();
        $modal.fadeIn(250);
      });

      // 2. 오버레이 배경이나 CANCEL 버튼 클릭 시 모달창 닫기
      $closeBtns.on('click', function (e) {
        e.preventDefault();
        $modal.fadeOut(250);
      });

      // 3. 셀렉트 박스에서 국가 변경 시 숨겨진 input 값 업데이트
      $select.on('change', function () {
        $countryInput.val($(this).val());
      });
    }
  }, {
    key: "initLocalizationSelector",
    value: function initLocalizationSelector(type) {
      var $sel = $('.localization-selector');
      if ($sel.find('[data-' + type + ']').length) {
        $sel.find('.' + type).click(function () {
          $sel.children(':not(.' + type + ')').removeClass('opened');
          $(this).toggleClass('opened');
        });
        $sel.find('[data-' + type + ']').click(function (e) {
          e.stopPropagation();
          $sel.find('.' + type + '-selection').html(type == 'language' ? $(this).text() : $(this).find('div:first-of-type').text() + ' ' + $(this).find('div:last-of-type').text());
          $(this).closest('form').parent().removeClass('opened');
          var $form = $sel.find('#' + (type == 'currency' ? type : 'localization') + '_form');
          var $field = $sel.find('[name=' + type + (type != 'currency' ? '_code' : '') + ']');
          $field.val($(this).data(type));
          $form.first().submit();
        });
      } else {
        // $sel.find('.' + type).remove();
        // $sel.find('.divider').remove();
      }
    }
  }, {
    key: "showGeoSpecificBanner",
    value: function showGeoSpecificBanner($slider, geo) {
      var self = this;
      var containsGeoSpecificBanner = false;
      $slider.find('.carousel-cell').each(function (i) {
        var countriesList = $(this).data('logic-country-list');
        var isLogicCountryReverse = $(this).data('logic-country-reverse');
        var shouldShowSlide = false;
        if ($.trim(countriesList) != '' || countriesList != undefined) {
          shouldShowSlide = self.shouldShowSlide(countriesList, geo, isLogicCountryReverse);
        }
        if (shouldShowSlide) {
          $(this).removeClass('hide-carousel-cell');
          containsGeoSpecificBanner = true;
          return;
        }
      });
      return containsGeoSpecificBanner;
    }
  }, {
    key: "showDefaultBanner",
    value: function showDefaultBanner($slider) {
      $slider.find('.carousel-cell').each(function (i) {
        var countriesList = $(this).data('logic-country-list');
        if ($.trim(countriesList) === '' || countriesList === undefined) {
          $(this).removeClass('hide-carousel-cell');
          return;
        }
      });
    }
  }, {
    key: "initGeoBasedBanners",
    value: function initGeoBasedBanners(geo) {
      var $headerSlider = $('.header-slider');
      var $geoBannerExists = $headerSlider.find('[data-header-slider]').data('enable-geo-based-banners');
      if ($geoBannerExists === false) {
        return false;
      }
      if (!geo) {
        this.showDefaultBanner($headerSlider);
        return false;
      }
      var outputCountrySpecificSlide = this.showGeoSpecificBanner($headerSlider, geo);
      if (outputCountrySpecificSlide == false) {
        this.showDefaultBanner($headerSlider);
      }
    }
  }, {
    key: "shouldShowSlide",
    value: function shouldShowSlide(countriesList, geo, isLogicCountryReverse) {
      try {
        var user_country = geo.country_name.toLowerCase();
        var isCountryOnList = countriesList.toLowerCase().split(",").includes(user_country);
        if (isLogicCountryReverse && isCountryOnList === false) {
          return true;
        } else {
          return !isLogicCountryReverse && isCountryOnList !== false;
        }
      } catch (error) {
        console.error('Error checking country list:', error);
        return false;
      }
    }
  }, {
    key: "setHeaderCSS",
    value: function setHeaderCSS() {
      var $css = $('#header-css');
      var html = ':root { --header-offset: ' + $('#header-container').height() + 'px; }';
      if ($css.length == 0) {
        $css = $('<style id="header-css">' + html + '</style>');
        $('body').append($css);
      } else {
        $css.html(html);
      }
    }
  }, {
    key: "initGeoBasedBannersController",
    value: function initGeoBasedBannersController() {
      var _this2 = this;
      vegamour.on('geolocationReady', function (geo) {
        if (document.readyState != 'loading') {
          _this2.initGeoBasedBanners(geo);
        } else {
          document.addEventListener('DOMContentLoaded', function () {
            this.initGeoBasedBanners(geo);
          });
        }
      });
    }
  }]);
  return VegamourHeader;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VegamourSearch = /*#__PURE__*/function (_Events) {
  _inherits(VegamourSearch, _Events);
  var _super = _createSuper(VegamourSearch);
  function VegamourSearch() {
    _classCallCheck(this, VegamourSearch);
    return _super.call(this);
  }
  _createClass(VegamourSearch, [{
    key: "init",
    value: function init() {
      var _this = this;
      $(document).ready(function () {
        _this.initSearch();
        _this.initMobile(); // delete after test + function
      });
    }
  }, {
    key: "initSearch",
    value: function initSearch() {
      var self = this;
      $('.header-search-open').click(function (e) {
        e.preventDefault();
        $('#header .header-bar-desktop').addClass('search-open'); // delete after test
        $('body').addClass('search-open');
      });
      $('.header-search-close, .header-overlay').click(function (e) {
        e.preventDefault();
        self.closeSearch();
        $('body').removeClass('search-open');
      });
    }
  }, {
    key: "initMobile",
    value: function initMobile() {
      var self = this;
      $('.header-mobile-search-open').click(function (e) {
        e.preventDefault();
        $('body').addClass('show-header-mobile-search');
        $('body').addClass('search-open');
      });
      $('.header-mobile-search-close').click(function (e) {
        e.preventDefault();
        self.closeSearch();
      });
    }
  }, {
    key: "closeSearch",
    value: function closeSearch() {
      $('#header .header-bar-desktop').removeClass('search-open'); // delete after test
      $('body').removeClass('show-header-mobile-search'); // delete after test
      $('body').removeClass('search-open');
    }
  }]);
  return VegamourSearch;
}(Events);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourAnnouncement = /*#__PURE__*/function () {
  function VegamourAnnouncement($div, $cache, id) {
    _classCallCheck(this, VegamourAnnouncement);
    this.Log = {
      Red: 'color:red;font-weight:bold',
      Blue: 'color:#007eff;font-weight:bold',
      Green: 'color:green;font-weight:bold',
      Brown: 'color:#573C2A;font-weight:bold',
      Purple: 'color:#e400ff;font-weight:bold',
      Orange: 'color:#ff9800;font-weight:bold',
      Reset: 'color:#aaaaaa;font-weight:normal'
    };
    this.resetLog();
    this.index = null;
    this.lastRender = null;
    this.removed = false;
    this.lastRemoved = false;
    this.divId = id;
    this.$cache = $cache;
    this.$cache.data('announcement', this);
    this.$cache.attr('data-announcement-div-id', id);
    this.$div = $div;
    this.$div.data('announcement', this);
    this.$div.attr('data-announcement-div-id', id);
  }
  _createClass(VegamourAnnouncement, [{
    key: "cache",
    value: function cache() {
      return this.$cache;
    }
  }, {
    key: "div",
    value: function div() {
      return this.$div;
    }
  }, {
    key: "cloneDiv",
    value: function cloneDiv() {
      var $clone = this.$cache.clone();
      $clone.data('announcement', this);
      return $clone;
    }
  }, {
    key: "data",
    value: function data() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var data = this.$cache.data() ? this.$cache.data() : {};
      if (key) {
        return _typeof(data[key] !== 'undefined') ? data[key] : defaultValue;
      }
      return data;
    }
  }, {
    key: "resetLog",
    value: function resetLog() {
      this.isAlreadyLoggedToConsole = {
        country: false,
        state: false,
        utm: false,
        utmContains: false,
        discount: false,
        product: false,
        styles: false
      };
    }
  }, {
    key: "isPersistent",
    value: function isPersistent() {
      var persist = vegamour.session.get('announcement-persist');
      return this.getUniqueId() && persist && persist.id === this.getUniqueId();
    }
  }, {
    key: "isRemoved",
    value: function isRemoved() {
      return this.removed;
    }
  }, {
    key: "setRemoved",
    value: function setRemoved() {
      this.removed = true;
    }
  }, {
    key: "getLastRemoved",
    value: function getLastRemoved() {
      return this.lastRemoved;
    }
  }, {
    key: "setLastRemoved",
    value: function setLastRemoved(removed) {
      this.lastRemoved = removed;
    }
  }, {
    key: "setIndex",
    value: function setIndex(index) {
      this.index = index;
      this.$cache.attr('data-announcement-index', '' + index);
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      return this.index;
    }
  }, {
    key: "setLastRender",
    value: function setLastRender(render) {
      this.lastRender = render;
    }
  }, {
    key: "getLastRender",
    value: function getLastRender() {
      return this.lastRender;
    }
  }, {
    key: "getDivId",
    value: function getDivId() {
      return this.divId;
    }
  }, {
    key: "getBackgroundColor",
    value: function getBackgroundColor() {
      return this.data('colorBackground');
    }
  }, {
    key: "getUniqueId",
    value: function getUniqueId() {
      return this.data('id');
    }
  }, {
    key: "getUtmCampaign",
    value: function getUtmCampaign() {
      return this.data('logicUtmCampaign');
    }
  }, {
    key: "getUtmContains",
    value: function getUtmContains() {
      return this.data('logicUtmContains');
    }
  }, {
    key: "getUtmAll",
    value: function getUtmAll() {
      return !!this.data('logicUtmAll', false);
    }
  }, {
    key: "isUtmCampaignReversed",
    value: function isUtmCampaignReversed() {
      return !!this.data('logicUtmReverse', false);
    }
  }, {
    key: "getGeoCountryList",
    value: function getGeoCountryList() {
      var toLowerCase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this.makeList(this.data('logicCountryList'), toLowerCase);
    }
  }, {
    key: "isGeoCountryListReversed",
    value: function isGeoCountryListReversed() {
      return !!this.data('logicCountryReverse');
    }
  }, {
    key: "isGeoCountryConditionMet",
    value: function isGeoCountryConditionMet() {
      var countryList = this.getGeoCountryList(true);
      if (countryList.length === 0) {
        return true;
      }
      var geo = vegamour.geolocation.getLocationData();
      if (!geo) {
        return false;
      }
      var countryOnList = countryList.indexOf(geo.country.name.toLowerCase()) > -1;
      var countryReverse = this.isGeoCountryListReversed();
      var countryConditionMet = !countryReverse && countryOnList || countryReverse && !countryOnList;
      if (!this.isAlreadyLoggedToConsole.country) {
        if (!countryConditionMet) {
          this.console(this.getTitle(), '%chidden%c based on GEO Country. Customer country is "%c' + geo.country.name + '%c", but should %c' + (countryReverse ? 'NOT ' : '') + '%cbe one of the following: ' + this.getGeoCountryList().join(', '), this.Log.Red, this.Log.Reset, this.Log.Purple, this.Log.Reset, this.Log.Red, this.Log.Reset);
        } else {
          this.console(this.getTitle(), '%cshown%c based on GEO Country. Customer country is "%c' + geo.country.name + '%c" and should %c' + (countryReverse ? 'NOT ' : '') + '%cbe one of the following: ' + this.getGeoCountryList().join(', '), this.Log.Green, this.Log.Reset, this.Log.Purple, this.Log.Reset, this.Log.Red, this.Log.Reset);
        }
        this.isAlreadyLoggedToConsole.country = true;
      }
      return countryConditionMet;
    }
  }, {
    key: "isGeoStateConditionMet",
    value: function isGeoStateConditionMet() {
      var stateList = this.getGeoStateList(true);
      if (stateList.length === 0) {
        return true;
      }
      var geo = vegamour.geolocation.getLocationData();
      if (!geo) {
        return false;
      }
      var stateOnList = stateList.indexOf(geo.state.toLowerCase()) > -1;
      var stateReverse = this.isGeoStateListReversed();
      var stateConditionMet = !stateReverse && stateOnList || stateReverse && !stateOnList;
      if (!this.isAlreadyLoggedToConsole.state) {
        if (!stateConditionMet) {
          this.console(this.getTitle(), '%chidden%c based on GEO State. Customer state is "%c' + geo.state + '%c", but should %c' + (stateReverse ? 'NOT ' : '') + '%cbe one of the following: ' + this.getGeoStateList().join(', '), this.Log.Red, this.Log.Reset, this.Log.Blue, this.Log.Reset, this.Log.Red, this.Log.Reset);
        } else {
          this.console(this.getTitle(), '%cshown%c based on GEO State. Customer state is "%c' + geo.state + '%c" and should %c' + (stateReverse ? 'NOT ' : '') + '%cbe one of the following: ' + this.getGeoStateList().join(', '), this.Log.Green, this.Log.Reset, this.Log.Blue, this.Log.Reset, this.Log.Red, this.Log.Reset);
        }
        this.isAlreadyLoggedToConsole.state = true;
      }
      return stateConditionMet;
    }
  }, {
    key: "isUtmConditionMet",
    value: function isUtmConditionMet() {
      var utmCampaign = this.getUtmCampaign();
      var utmContains = this.getUtmContains();
      if (utmCampaign && !this.isUtmCampaignConditionMet()) {
        return false;
      }
      if (utmContains && !this.isUtmContainsUrlConditionMet()) {
        return false;
      }
      return true;
    }
  }, {
    key: "isUtmCampaignConditionMet",
    value: function isUtmCampaignConditionMet() {
      var utmCampaign = this.getUtmCampaign();
      var utm = vegamour.cart.getUTMAttributes();
      var utmExists = utm && typeof utm !== 'undefined' && typeof utm.utm_campaign !== 'undefined';
      if (!utmExists) {
        if (!this.isAlreadyLoggedToConsole.utm) {
          this.console(this.getTitle(), '%chidden%c because UTM attributes are not present', this.Log.Red, this.Log.Reset);
          this.isAlreadyLoggedToConsole.utm = true;
        }
        return false;
      }
      var utmReverse = this.isUtmCampaignReversed();
      var utmIsFine = false;
      utmCampaign.toLowerCase().split(',').forEach(function (campaign) {
        if (utm.utm_campaign.toLowerCase() === campaign) {
          utmIsFine = true;
        }
      });
      var utmConditionMet = !utmReverse && utmIsFine || utmReverse && !utmIsFine;
      if (!this.isAlreadyLoggedToConsole.utm) {
        if (!utmConditionMet) {
          this.console(this.getTitle(), '%chidden%c based on UTM params', this.Log.Red, this.Log.Reset);
        } else {
          this.console(this.getTitle(), '%cshown%c based on UTM params', this.Log.Green, this.Log.Reset);
        }
        this.isAlreadyLoggedToConsole.utm = true;
      }
      return utmConditionMet;
    }
  }, {
    key: "isUtmContainsUrlConditionMet",
    value: function isUtmContainsUrlConditionMet() {
      var utmContains = this.getUtmContains();
      var utmAll = this.getUtmAll();
      var utmContainsCount = 0;
      var contains = '';
      var url = window.location.search.toLowerCase();
      var lp = vegamour.getCookie('_shopify_sa_p');
      var utmContainsList = utmContains.toLowerCase().split(',');
      utmContainsList.forEach(function (contain) {
        if (url.indexOf(contain.trim()) > -1 || lp && decodeURIComponent(lp).toLowerCase().indexOf(contain.trim()) > -1) {
          contains += (contains.length > 0 ? ', ' : utmAll ? 'ALL: ' : 'ANY: ') + contain.trim();
          utmContainsCount += 1;
        }
      });
      var utmContainsIsFine = utmAll && utmContainsCount === utmContainsList.length || !utmAll && utmContainsCount > 0;
      if (!this.isAlreadyLoggedToConsole.utmContains) {
        if (!utmContainsIsFine) {
          this.console(this.getTitle(), '%chidden%c based on URL contains', this.Log.Red, this.Log.Reset);
        } else {
          this.console(this.getTitle(), '%cshown%c based on UTM contains "' + contains + '"', this.Log.Green, this.Log.Reset);
        }
        this.isAlreadyLoggedToConsole.utmContains = true;
      }
      return utmContainsIsFine;
    }
  }, {
    key: "isHiddenBasedOnDiscount",
    value: function isHiddenBasedOnDiscount() {
      var discountHide = this.getDiscountHide();
      if (!discountHide) {
        return false;
      }
      var discount = vegamour.cart.discounts.getDiscountCode();
      var isHidden = discount && discount.code.toLowerCase() === discountHide.toLowerCase();
      if (!this.isAlreadyLoggedToConsole.discount) {
        if (!isHidden) {
          this.console(this.getTitle(), '%chidden%c based on discount applied "%c' + discount.code + '%c"', this.Log.Red, this.Log.Reset, this.Log.Orange, this.Log.Reset);
        } else {
          this.console(this.getTitle(), '%cshown%c based on discount not applied yet "%c' + discount.code + '%c"', this.Log.Green, this.Log.Reset, this.Log.Orange, this.Log.Reset);
        }
        this.isAlreadyLoggedToConsole.discount = true;
      }
      return isHidden;
    }
  }, {
    key: "isHiddenBasedOnProduct",
    value: function isHiddenBasedOnProduct() {
      var productHide = this.getProductHide();
      if (!productHide) {
        return false;
      }
      var product = vegamour.cart.getItemByHandle(productHide);
      var isHidden = !!product;
      if (!this.isAlreadyLoggedToConsole.product) {
        if (isHidden) {
          this.console(this.getTitle(), '%chidden%c based on product added to cart "%c' + productHide + '%c"', this.Log.Red, this.Log.Reset, this.Log.Brown, this.Log.Reset);
        } else {
          this.console(this.getTitle(), '%cshown%c based on product not added to cart yet "%c' + productHide + '%c"', this.Log.Green, this.Log.Reset, this.Log.Brown, this.Log.Reset);
        }
        this.isAlreadyLoggedToConsole.product = true;
      }
      return isHidden;
    }
  }, {
    key: "getDiscountHide",
    value: function getDiscountHide() {
      return this.data().discountHide ? this.data().discountHide : null;
    }
  }, {
    key: "getProductHide",
    value: function getProductHide() {
      return this.data().productHide ? this.data().productHide : null;
    }
  }, {
    key: "getGeoStateList",
    value: function getGeoStateList() {
      var toLowerCase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this.data().logicStateList ? this.makeList(this.data().logicStateList, toLowerCase) : [];
    }
  }, {
    key: "isGeoStateListReversed",
    value: function isGeoStateListReversed() {
      return !!this.data().logicStateReverse;
    }
  }, {
    key: "getTitle",
    value: function getTitle() {
      return this.data().title;
    }
  }, {
    key: "isForceShown",
    value: function isForceShown() {
      return !!this.data().forceShow;
    }
  }, {
    key: "forceShow",
    value: function forceShow() {
      this.$cache.data('force-show', true);
    }
  }, {
    key: "isHiddenByStyles",
    value: function isHiddenByStyles() {
      return this.$cache.hasClass('announcements-block-hidden');
    }
  }, {
    key: "makeList",
    value: function makeList(text) {
      var toLowerCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!text || text.trim() === '') {
        return [];
      }
      return text.split(',').map(function (item) {
        var result = item.trim();
        if (toLowerCase) {
          result = result.toLowerCase();
        }
        return result;
      });
    }
  }, {
    key: "shouldShow",
    value: function shouldShow(ignoreHidden) {
      var $block = this.$cache;
      if ($block.length === 0 || this.isRemoved()) {
        return false;
      }
      if (this.isForceShown()) {
        return true;
      }
      var show = this.isGeoCountryConditionMet() && this.isGeoStateConditionMet() && this.isUtmConditionMet() && !this.isHiddenBasedOnDiscount() && !this.isHiddenBasedOnProduct();
      if (this.isHiddenByStyles()) {
        if (!ignoreHidden) {
          show = false;
          if (!this.isAlreadyLoggedToConsole.styles) {
            this.console(this.getTitle(), '%chidden%c by styles', this.Log.Red, this.Log.Reset);
            this.isAlreadyLoggedToConsole.styles = true;
          }
        } else if (!this.isAlreadyLoggedToConsole.styles) {
          this.console(this.getTitle(), '%cshown%c by ignoring hidden styles', this.Log.Green, this.Log.Reset);
          this.isAlreadyLoggedToConsole.styles = true;
        }
      }
      return show;
    }
  }, {
    key: "requiresGeo",
    value: function requiresGeo() {
      return this.getGeoCountryList().length > 0 || this.getGeoStateList().length > 0;
    }
  }, {
    key: "requiresCart",
    value: function requiresCart() {
      return this.$cache.find('[data-cart-product], [data-not-cart-product]').length > 0;
    }
  }, {
    key: "requiresDiscount",
    value: function requiresDiscount() {
      return this.$cache.find('[data-discount], [data-not-discount]').length > 0;
    }
  }, {
    key: "console",
    value: function (_console) {
      function console(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8) {
        return _console.apply(this, arguments);
      }
      console.toString = function () {
        return _console.toString();
      };
      return console;
    }(function (title, msg, opt1, opt2, opt3, opt4, opt5, opt6) {
      if (vegamour.isDebug) {
        if (typeof opt1 === 'undefined') opt1 = '';
        if (typeof opt2 === 'undefined') opt2 = '';
        if (typeof opt3 === 'undefined') opt3 = '';
        if (typeof opt4 === 'undefined') opt4 = '';
        if (typeof opt5 === 'undefined') opt5 = '';
        if (typeof opt6 === 'undefined') opt6 = '';
        console.log('📣 Announcement "' + title + '" will be ' + msg, opt1, opt2, opt3, opt4, opt5, opt6);
      }
    })
  }]);
  return VegamourAnnouncement;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourAnnouncements = /*#__PURE__*/function () {
  function VegamourAnnouncements() {
    _classCallCheck(this, VegamourAnnouncements);
    this.initializedSlick = false;
    this.jsActiveAnnouncement = null;
    this.jsCurrrentAnnouncement = null;
    this.announcements = [];
  }
  _createClass(VegamourAnnouncements, [{
    key: "init",
    value: function init() {
      var _this = this;
      if (window.vegamourOptions.hideAnnouncementsWhenUrlPathMatches) {
        return;
      }
      var self = this;
      $(document).ready(function () {
        _this.ready();
        if (typeof window.announcement !== 'undefined') {
          _this.announce(window.announcement.id, window.announcement.duration, window.announcement.check, window.announcement.scroll);
        }
      });
      $(document).on('shopify:section:load', function (e) {
        if (e.detail.sectionId === 'announcements') {
          _this.ready();
        }
      });
      $(document).on('shopify:section:unload', function (e) {
        if (e.detail.sectionId === 'announcements') {
          //
        }
      });
      $(document).on('shopify:block:select', function (e) {
        if (e.detail.sectionId === 'announcements') {
          var $blocks = $('.announcements-blocks');
          var $timers = $blocks.find('[data-countdown]');
          $timers.each(function () {
            new VegamourCountdown($(this));
          });
          $blocks.find('.announcements-block').each(function () {
            var data = $(this).data('shopify-editor-block');
            if (data && data.id === e.detail.blockId) {
              self.slideTo($(this).data('announcement-index'));
            }
          });
        }
      });
      this.initEvents();
    }
  }, {
    key: "ready",
    value: function ready() {
      var self = this;
      var $blocks = $('.announcements-blocks');
      var $cache = $('.announcements-blocks-cache');
      this.announcements = [];
      $cache.html('');
      if ($blocks.hasClass('announcements-blocks-initialized')) {
        return;
      }
      $blocks.find('.announcements-block').each(function (i) {
        $(this).removeClass('announcements-block-not-first');
        $(this).attr('data-announcement-index', i);
        var $clone = $(this).clone();
        $cache.append($clone);
        self.announcements.push(new VegamourAnnouncement($(this), $clone, i));
      });
      $blocks.addClass('announcements-blocks-initialized');
      this.initSlick();
      this.initializedSlick = true;
      this.refresh();
    }
  }, {
    key: "initSlick",
    value: function initSlick() {
      var _this2 = this;
      var $blocks = $('.announcements-blocks');
      var options = {
        rows: 0,
        speed: 300,
        infinite: true,
        autoplay: !vegamourOptions.designMode && $blocks.data('slick-autoplay'),
        autoplaySpeed: $blocks.data('slick-autoplay-speed')
      };
      if (vegamourOptions.designMode) {
        options.speed = 0;
      }
      if (!$blocks.hasClass('events-initialized')) {
        $blocks.addClass('events-initialized').on('beforeChange', function (e, slick, currentSlide, nextSlide) {
          _this2.adjustBackground(nextSlide);
        });
      }
      var persistentAnnouncement = this.getPersistentAnnouncement();
      var activeAnnouncement = this.getJsActiveAnnouncement();
      var currentAnnouncement = this.getJsCurrentAnnouncement();
      if (currentAnnouncement) {
        if (this.jsCurrrentAnnouncement.options) {
          options.swipe = this.jsCurrrentAnnouncement.options.scroll;
          options.arrows = this.jsCurrrentAnnouncement.options.scroll;
        } else {
          options.swipe = true;
          options.arrows = true;
        }
      } else if (activeAnnouncement) {
        options.speed = 0;
        options.autoplay = false;
        if (this.jsActiveAnnouncement.options) {
          options.swipe = this.jsActiveAnnouncement.options.scroll;
          options.arrows = this.jsActiveAnnouncement.options.scroll;
        } else {
          options.swipe = true;
          options.arrows = true;
        }
      } else if (persistentAnnouncement) {
        options.speed = 0;
        options.autoplay = false;
        var persist = vegamour.session.get('announcement-persist');
        if (persist && persist.options) {
          options.swipe = persist.options.scroll;
          options.arrows = persist.options.scroll;
        } else {
          options.swipe = true;
          options.arrows = true;
        }
      } else {
        options.swipe = true;
        options.arrows = true;
      }
      $blocks.slick(options);
      if (currentAnnouncement) {
        this.slideTo(currentAnnouncement.getIndex());
      } else if (activeAnnouncement) {
        this.slideTo(activeAnnouncement.getIndex());
      } else if (persistentAnnouncement) {
        this.slideTo(persistentAnnouncement.getIndex());
      }
      $blocks.slick('slickSetOption', {
        speed: 300
      }, true);
      this.adjustBackground();
    }
  }, {
    key: "getCurrentAnnouncement",
    value: function getCurrentAnnouncement() {
      var $announcements = $('.announcements-blocks');
      var slick = $announcements.slick('getSlick');
      if (!$announcements.length || !slick) {
        return null;
      }
      var index = slick.currentSlide;
      var announcement = null;
      slick.$slides.each(function (i) {
        if (i === index) {
          announcement = $(this).data('announcement');
        }
      });
      return announcement;
    }
  }, {
    key: "adjustBackground",
    value: function adjustBackground() {
      var announcement = this.getCurrentAnnouncement();
      var $announcements = $('#announcements');
      var defaultBackground = $announcements.data('color-background');
      var background = announcement ? announcement.getBackgroundColor() : null;
      if (announcement && background) {
        $announcements.css('background', background);
      } else if (defaultBackground) {
        $announcements.css('background', defaultBackground);
      } else {
        $announcements.css('background', '');
      }
    }
  }, {
    key: "slideTo",
    value: function slideTo(index) {
      $('.announcements-blocks').slick('slickGoTo', index);
    }
  }, {
    key: "div",
    value: function div() {
      return $('#announcements');
    }
  }, {
    key: "initEvents",
    value: function initEvents() {
      var _this3 = this;
      vegamour.on('easylocationReady, geolocationReady', function () {
        _this3.refresh();
      });
      vegamour.cart.on('update', function () {
        _this3.refresh();
      });
      vegamour.cart.discounts.on('discountReady', function () {
        _this3.refresh();
      });
      vegamour.on('countdownRemove', function (countdown) {
        var $block = countdown.div.parents('.announcements-block');
        if ($block.length > 0) {
          var announcement = _this3.getAnnouncementByDivId($block.data('announcement-div-id'));
          if (announcement) {
            announcement.setRemoved();
            _this3.refresh();
          }
        }
      });
      vegamour.on('productBarHide', function () {
        console.log('📣 Resizing announcement bar after product bar is hidden');
        $('.announcements-blocks').slick('setDimensions');
      });
    }
  }, {
    key: "announce",
    value: function announce(id, duration) {
      var _this4 = this;
      var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var scroll = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      this.jsActiveAnnouncement = null;
      this.jsCurrrentAnnouncement = null;
      var announcement = this.getAnnouncementByUniqueId(id);
      if (!announcement) {
        return this.reset(true);
      }
      announcement.resetLog();
      if (force !== true && !announcement.shouldShow(true)) {
        return this.reset(true);
      }
      announcement.forceShow();
      if (duration === 'a') {
        this.jsActiveAnnouncement = {
          id: id,
          options: {
            scroll: scroll
          }
        };
        return this.refresh(true);
      }
      if (duration === 'p') {
        this.setPersist(id, {
          scroll: scroll
        });
        return this.refresh(true);
      }
      this.jsCurrrentAnnouncement = {
        id: id,
        options: {
          scroll: scroll
        }
      };
      var number = parseInt(duration);
      if (Number.isNaN(number)) {
        number = null;
      }
      if (!duration || number === 0) {
        return this.refresh(true);
      }
      if (number !== null) {
        var $blocks = $('.announcements-blocks');
        $blocks.slick('slickPause');
        setTimeout(function () {
          _this4.jsCurrrentAnnouncement = null;
          _this4.reset();
          $blocks.slick('slickPlay');
          $blocks.slick('slickNext');
        }, number);
      }
      this.refresh(true);
    }
  }, {
    key: "setPersist",
    value: function setPersist(id, options) {
      vegamour.session.put('announcement-persist', {
        id: id,
        options: options
      });
    }
  }, {
    key: "requiresGeo",
    value: function requiresGeo() {
      var requiresGeo = false;
      this.announcements.forEach(function (announcement) {
        if (announcement.requiresGeo()) {
          requiresGeo = true;
        }
      });
      return requiresGeo;
    }
  }, {
    key: "requiresCart",
    value: function requiresCart() {
      var requiresCart = false;
      this.announcements.forEach(function (announcement) {
        if (announcement.requiresCart()) {
          requiresCart = true;
        }
      });
      return requiresCart;
    }
  }, {
    key: "requiresDiscount",
    value: function requiresDiscount() {
      var requiresDiscount = false;
      this.announcements.forEach(function (announcement) {
        if (announcement.requiresDiscount()) {
          requiresDiscount = true;
        }
      });
      return requiresDiscount;
    }
  }, {
    key: "reset",
    value: function reset() {
      var play = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var $blocks = $('.announcements-blocks');
      var options = {
        speed: 300,
        swipe: true,
        arrows: true
      };
      if (play) {
        options.autoplay = true;
      }
      $blocks.slick('slickSetOption', options, true);
      if (play) {
        $blocks.slick('slickPlay');
      }
    }
  }, {
    key: "refresh",
    value: function refresh(force) {
      if (!vegamourOptions.designMode && (!this.initializedSlick || this.requiresGeo() && !vegamour.geolocation.getLocationData() || this.requiresCart() && vegamour.cart.firstTimeUpdate || this.requiresDiscount() && vegamour.cart.discounts.isDiscountQuerying())) {
        return;
      }
      this.renderBlocks(force);
      $('.announcements-blocks').addClass('show');
    }
  }, {
    key: "getVisibleAnnouncements",
    value: function getVisibleAnnouncements() {
      var result = [];
      this.announcements.forEach(function (announcement) {
        if (announcement.shouldShow()) {
          result.push(announcement);
        }
      });
      return result;
    }
  }, {
    key: "getPersistentAnnouncement",
    value: function getPersistentAnnouncement() {
      var result = null;
      this.announcements.forEach(function (announcement) {
        if (announcement.isPersistent()) {
          result = announcement;
        }
      });
      return result;
    }
  }, {
    key: "getJsActiveAnnouncement",
    value: function getJsActiveAnnouncement() {
      if (!this.jsActiveAnnouncement) {
        return null;
      }
      return this.getAnnouncementByUniqueId(this.jsActiveAnnouncement.id);
    }
  }, {
    key: "getJsCurrentAnnouncement",
    value: function getJsCurrentAnnouncement() {
      if (!this.jsCurrrentAnnouncement) {
        return null;
      }
      return this.getAnnouncementByUniqueId(this.jsCurrrentAnnouncement.id);
    }
  }, {
    key: "getAnnouncementByUniqueId",
    value: function getAnnouncementByUniqueId(id) {
      var result = null;
      this.announcements.forEach(function (announcement) {
        if (announcement.getUniqueId() === id) {
          result = announcement;
        }
      });
      return result;
    }
  }, {
    key: "getAnnouncementByDivId",
    value: function getAnnouncementByDivId(id) {
      var result = null;
      this.announcements.forEach(function (announcement) {
        if (announcement.getDivId() === id) {
          result = announcement;
        }
      });
      return result;
    }
  }, {
    key: "isAnnouncementsModified",
    value: function isAnnouncementsModified() {
      var modified = false;
      this.announcements.forEach(function (announcement) {
        if (announcement.shouldShow() !== announcement.getLastRender() || announcement.isRemoved() !== announcement.getLastRemoved()) {
          modified = true;
        }
      });
      return modified;
    }
  }, {
    key: "renderBlocks",
    value: function renderBlocks() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (force !== true && !this.isAnnouncementsModified()) {
        return;
      }
      var index = 0;
      var $blocks = this.div().find('.announcements-blocks');
      $blocks.slick('unslick');
      $blocks.html('');
      this.announcements.forEach(function (announcement) {
        if (vegamourOptions.designMode || announcement.shouldShow() || announcement.isPersistent()) {
          announcement.setIndex(index);
          announcement.setLastRender(true);
          announcement.setLastRemoved(announcement.isRemoved());
          $blocks.append(announcement.cloneDiv());
          index++;
        } else {
          announcement.setLastRender(false);
        }
      });
      this.initSlick();
      this.initCountdown();

      // Discounts
      vegamour.cart.discounts.setDiscountDisplay();
      vegamour.cart.discounts.initDiscountActions();

      // Products
      vegamour.cart.renderDependencies();
      vegamour.quickView.initQuickView();
      vegamour.quickView.initQuickViewV3();
      if (index > 0) {
        this.div().show();
      } else {
        this.div().hide();
      }
      if (index === 1) {
        this.div().addClass('single-announcement');
      } else {
        this.div().removeClass('single-announcement');
      }
    }
  }, {
    key: "initCountdown",
    value: function initCountdown() {
      this.div().find('.announcements-blocks [data-countdown]').each(function () {
        $(this).html('');
        $(this).removeClass('countdown-initialized');
        new VegamourCountdown($(this));
      });
    }
  }]);
  return VegamourAnnouncements;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourHomepage = /*#__PURE__*/function () {
  function VegamourHomepage() {
    _classCallCheck(this, VegamourHomepage);
  }
  _createClass(VegamourHomepage, [{
    key: "init",
    value: function init() {
      this.initSliders();
      this.addPausePlayControlsToAutoPlayCarousels();
    }
  }, {
    key: "initSliders",
    value: function initSliders() {
      //Real Results Section Slider
      var $slick = $('.real-results-items');
      if ($slick.length === 0) {
        return;
      }
      var slick = $slick.slick({
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $('.real-results-navigation-previous'),
        nextArrow: $('.real-results-navigation-next'),
        autoplay: false,
        fade: true
      });
      if (!slick || slick.length === 0) {
        return;
      }
      var slickObject = slick[0].slick;
      $('.item-navigation-bullets').each(function () {
        for (var i = 0; i < slickObject.$slides.length; i++) {
          var $bullet = $('<a href="#" class="item-navigation-bullet" data-slide-index="' + i + '"><p class="visually-hidden">Go to slide' + i + '</p></a>');
          $bullet.attr('role', 'button');
          if (i === 0) {
            $bullet.addClass('active');
          }
          $bullet.on('click', function (e) {
            e.preventDefault();
            slickObject.slickGoTo($(e.target).attr('data-slide-index'));
          });
          $(this).append($bullet);
        }
      });
      slick.on('afterChange', function (event, slick, currentSlide) {
        $slick.find('.item-navigation-bullet').removeClass('active');
        $slick.find('.item-navigation-bullet[data-slide-index="' + currentSlide + '"]').addClass('active');
      });
    }
  }, {
    key: "addPausePlayControlsToAutoPlayCarousels",
    value: function addPausePlayControlsToAutoPlayCarousels() {
      var $quoteListCarousel = $('.quote_list');
      $quoteListCarousel.on('ready.flickity', function (e) {
        var _$quoteList$data;
        var $quoteList = $('.quote_list');
        if ((_$quoteList$data = $quoteList.data('flickity')) !== null && _$quoteList$data !== void 0 && (_$quoteList$data = _$quoteList$data.options) !== null && _$quoteList$data !== void 0 && _$quoteList$data.autoPlay || $quoteList.data('flickity').autoPlay) {
          var autoPlayCarouselControlsHTMLString = "<li class=\"carousel-play-btn-container\"><button class=\"carousel-play-btn play-btn disabled-btn\"><p class=\"visually-hidden\">Enable auto play on carousel</p></button></li>\n                 <li class=\"carousel-pause-btn-container\"><button class=\"carousel-pause-btn pause-btn\"><p class=\"visually-hidden\">Pause auto play on carousel</p></button></li>";
          $('.quote_list .flickity-page-dots').prepend(autoPlayCarouselControlsHTMLString);
          $('.carousel-play-btn').on('click', function (e) {
            $quoteList.data('flickity').playPlayer();
            e.currentTarget.classList.add('disabled-btn');
            $('.carousel-pause-btn').removeClass('disabled-btn');
          });
          $('.carousel-pause-btn').on('click', function (e) {
            $quoteList.data('flickity').stopPlayer();
            e.currentTarget.classList.add('disabled-btn');
            $('.carousel-play-btn').removeClass('disabled-btn');
          });
        }
      });
    }
  }]);
  return VegamourHomepage;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourPagesTerms = /*#__PURE__*/function () {
  function VegamourPagesTerms() {
    var _this = this;
    _classCallCheck(this, VegamourPagesTerms);
    $(document).ready(function () {
      _this.init();
    });
  }
  _createClass(VegamourPagesTerms, [{
    key: "init",
    value: function init() {
      if ($('#terms-amp-conditions').length === 0) {
        return;
      }
      vegamour.country.getLocation();
    }
  }]);
  return VegamourPagesTerms;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourPagesScience = /*#__PURE__*/function () {
  function VegamourPagesScience() {
    var _this = this;
    _classCallCheck(this, VegamourPagesScience);
    $(document).ready(function () {
      _this.init();
    });
  }
  _createClass(VegamourPagesScience, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      this.initSliders();
      this.initFormula();
      var section = document.querySelector('.page-section-block-study');
      var hasEntered = false;
      if (!section) {
        return;
      }
      window.addEventListener('scroll', function (e) {
        var shouldAnimate = window.scrollY + window.innerHeight >= section.offsetTop;
        if (shouldAnimate && !hasEntered) {
          hasEntered = true;
          _this2.initProgressBar();
          _this2.initPercentCount();
        }
      });
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      return $(window).width() <= 640;
    }
  }, {
    key: "initSliders",
    value: function initSliders() {
      if (!this.isMobile()) {
        return;
      }
      var $slick = $('.page-ingredients-items, .page-section-video-items');
      $slick.slick({
        dots: true,
        arrows: false
      });
    }
  }, {
    key: "initProgressBar",
    value: function initProgressBar() {
      var $progressBar = $('.page-study-progress');
      $progressBar.each(function () {
        $(this).animate({
          width: $(this).attr('data-progress')
        }, 3000);
      });
    }
  }, {
    key: "initPercentCount",
    value: function initPercentCount() {
      var $countBar = $('.block-percent');
      $countBar.each(function () {
        $(this).attr('data-count', 0).animate({
          Counter: $(this).text()
        }, {
          duration: 4000,
          easing: 'swing',
          step: function step(now) {
            $(this).text(Math.ceil(now) + '%');
          }
        });
      });
    }
  }, {
    key: "initFormula",
    value: function initFormula() {
      $('.page-formula-item').each(function () {
        var $formula = $(this);
        $formula.find('.page-formula-item-show, .page-formula-item-title').on('click', function (e) {
          e.preventDefault();
          $formula.toggleClass('show');
        });
      });
    }
  }]);
  return VegamourPagesScience;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourSubscriptionWizard = /*#__PURE__*/function () {
  function VegamourSubscriptionWizard() {
    var _this = this;
    _classCallCheck(this, VegamourSubscriptionWizard);
    this.currentStep = 1;
    vegamour.on('ready', function () {
      _this.init();
    });
  }
  _createClass(VegamourSubscriptionWizard, [{
    key: "div",
    value: function div() {
      return $('.subscription-wizard');
    }
  }, {
    key: "init",
    value: function init() {
      var _this2 = this;
      if (this.div().length === 0) {
        return;
      }
      $('[data-subscription-wizard-step-back]').on('click', function (e) {
        e.preventDefault();
        _this2.stepBack();
      });
      $('[data-subscription-wizard-step-next]').on('click', function (e) {
        e.preventDefault();
        _this2.stepNext();
      });
      $('[data-subscription-wizard-step-checkout]').on('click', function (e) {
        e.preventDefault();
        _this2.checkout();
      });
      this.initStep1();
      this.initStep3();
      this.initStep4();
      this.initModal();
      this.stepUpdate();
    }
  }, {
    key: "stepCount",
    value: function stepCount() {
      return $('[data-subscription-wizard-step]').length;
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      this.currentStep--;
      if (this.currentStep < 1) {
        this.currentStep = 1;
      }
      this.stepUpdate();
    }
  }, {
    key: "stepNext",
    value: function stepNext() {
      this.currentStep++;
      if (this.currentStep > this.stepCount()) {
        this.currentStep = this.stepCount();
      }
      this.stepUpdate();
      this.updateSummary();
    }
  }, {
    key: "stepUpdate",
    value: function stepUpdate() {
      var $bar = this.div().find('.subscription-wizard-bar');
      if (this.currentStep === 1) {
        $bar.removeClass('has-step-back');
      } else {
        $bar.addClass('has-step-back');
      }
      if (this.currentStep === this.stepCount()) {
        $bar.addClass('has-step-checkout');
      } else {
        $bar.removeClass('has-step-checkout');
      }
      if (this.currentStep === 3) {
        this.step3Update();
      }
      if (this.currentStep === 2) {
        this.step2Update();
      }
      this.div().find('[data-subscription-wizard-step-current]').html(this.currentStep);
      this.div().find('[data-subscription-wizard-step-count]').html(this.stepCount());
      this.div().find('[data-subscription-wizard-step]').hide();
      this.div().find('[data-subscription-wizard-step="' + this.currentStep + '"]').show();
      $bar.show();
    }
  }, {
    key: "step2Update",
    value: function step2Update() {
      var _this3 = this;
      if (this.lastStep2UpdateId == this.getStep1ProductId()) {
        return;
      }
      this.lastStep2UpdateId = this.getStep1ProductId();
      var recharge = vegamour.getRecharge(this.getStep1ProductId());
      var $box = this.div().find('.subscription-wizard-shippings');
      $box.html('');
      var variants = [];
      recharge.getProcessedOneTimeVariants().forEach(function (variant) {
        if (variant.oneTime.page && variant.oneTime.page.hidden) {
          //
        } else {
          if (variant.oneTime.page && variant.oneTime.page.layout && variant.oneTime.page.layout.position) {
            variants[parseInt(variant.oneTime.page.layout.position)] = variant;
          } else {
            variants.push(variant);
          }
        }
      });
      if (variants.length === 0) {
        this.div().find('.subscription-wizard-bar').hide();
        $box.html('<div class="subscription-wizard-shipping-empty">There was an error. Please try again later.</div>');
        return;
      }
      var first = true;
      variants = variants.sort(function (a, b) {
        return b.subscription.price - a.subscription.price;
      });
      variants.forEach(function (variant, index) {
        var $shipping = _this3.getShippingTemplate(index, variant.oneTime.id);
        var title = variant.oneTime.processed.title;
        var description = '';
        if (variant.oneTime.page && variant.oneTime.page.layout && variant.oneTime.page.layout.label) {
          title = variant.oneTime.page.layout.label;
        }
        if (variant.oneTime.page && variant.oneTime.page.layout && variant.oneTime.page.layout.description) {
          description = variant.oneTime.page.layout.description;
        }
        $shipping.attr('data-product-variant-id', variant.oneTime.id);
        $shipping.attr('data-product-variant-subscription-id', variant.subscription.id);
        $shipping.find('[data-subscription-wizard-shipping-name]').html(title);
        $shipping.find('[data-subscription-wizard-shipping-frequency]').html(variant.subscription.processed.shipping.frequency.original);
        $shipping.find('[data-subscription-wizard-shipping-unit]').html(variant.subscription.processed.shipping.unit.formatted);
        $shipping.find('[data-subscription-wizard-shipping-info]').html('Billed every ' + '<span data-frequency>' + variant.subscription.processed.shipping.frequency.original + '</span> ' + '<span data-unit>' + variant.subscription.processed.shipping.unit.formatted + '</span> ' + '<strong>| FREE SHIPPING</strong>');
        $shipping.find('[name="step_2_shipping"]').attr('data-frequency', variant.subscription.processed.shipping.frequency.original);
        $shipping.find('[name="step_2_shipping"]').attr('data-unit', variant.subscription.processed.shipping.unit.formatted);
        if (variant.oneTime.page && variant.oneTime.page.layout && variant.oneTime.page.layout.frequency) {
          $shipping.find('[data-subscription-wizard-shipping-frequency]').show().html(variant.oneTime.page.layout.frequency);
          $shipping.find('[data-subscription-wizard-shipping-info] [data-frequency]').html(variant.oneTime.page.layout.frequency);
          $shipping.find('[name="step_2_shipping"]').attr('data-frequency', variant.oneTime.page.layout.frequency);
        }
        if (variant.oneTime.page && variant.oneTime.page.layout && variant.oneTime.page.layout.unit) {
          $shipping.find('[data-subscription-wizard-shipping-unit]').show().html(variant.oneTime.page.layout.unit);
          $shipping.find('[data-subscription-wizard-shipping-info] [data-unit]').html(variant.oneTime.page.layout.unit);
          $shipping.find('[name="step_2_shipping"]').attr('data-unit', variant.oneTime.page.layout.unit);
        }
        if (variant.oneTime.processed.discount.price && variant.oneTime.processed.discount.price > variant.oneTime.price) {
          $shipping.find('[data-subscription-wizard-shipping-price-old]').html('$' + parseFloat(variant.oneTime.processed.discount.price).toFixed(0));
        } else if (variant.oneTime.price > variant.subscription.price) {
          $shipping.find('[data-subscription-wizard-shipping-price-old]').html('$' + parseFloat(variant.oneTime.price).toFixed(0));
        }
        $shipping.find('[data-subscription-wizard-shipping-price-now]').html('$' + parseFloat(variant.subscription.price).toFixed(0));
        $shipping.find('[data-subscription-wizard-shipping-description]').html(description);
        if (variant.oneTime.page && variant.oneTime.page.layout && variant.oneTime.page.layout.shipping) {
          $shipping.find('[data-subscription-wizard-shipping-info]').show().html(variant.oneTime.page.layout.shipping);
        }
        if (variant.oneTime.page && variant.oneTime.page.layout && variant.oneTime.page.layout.badge) {
          $shipping.find('[data-subscription-wizard-shipping-badge]').show().html(variant.oneTime.page.layout.badge);
        }
        if (first) {
          $shipping.addClass('active');
          $shipping.find('[name="step_2_shipping"]').attr('checked', 'checked');
        }
        first = false;
        $box.append($shipping);
      });
      $box.find('[name="step_2_shipping"]').on('change', function (e) {
        var $input = $box.find('[name="step_2_shipping"]:checked');
        _this3.div().find('.subscription-wizard-block-step-3 .subscription-wizard-description [data-frequency]').html($input.attr('data-frequency') + ' ' + $input.attr('data-unit'));
        $box.find('.subscription-wizard-shipping').removeClass('active');
        $box.find('[name="step_2_shipping"]:checked').parents('.subscription-wizard-shipping').addClass('active');
        _this3.updateSummary();
      });
      if (recharge.product.page && recharge.product.page.step_2_description) {
        this.div().find('[data-subscription-wizard-shippings-description-original]').hide();
        this.div().find('[data-subscription-wizard-shippings-description-custom]').html(recharge.product.page.step_2_description);
        this.div().find('[data-subscription-wizard-shippings-description-custom]').show();
      } else {
        this.div().find('[data-subscription-wizard-shippings-description-original]').show();
        this.div().find('[data-subscription-wizard-shippings-description-custom]').hide();
      }
      if (recharge.product.page && recharge.product.page.step_2_image) {
        this.div().find('[data-subscription-wizard-shippings-image]').css('background-image', 'url("' + recharge.product.page.step_2_image + '")');
      } else {
        this.div().find('[data-subscription-wizard-shippings-image]').css('background-image', 'url("' + this.div().find('[data-subscription-wizard-shippings-image]').attr('data-default-image') + '")');
      }
    }
  }, {
    key: "getStep1ProductId",
    value: function getStep1ProductId() {
      return $('[name="step_1_product"]:checked').val();
    }
  }, {
    key: "getShippingTemplate",
    value: function getShippingTemplate(index, value) {
      var html = this.div().find('#subscription-wizard-shipping').html();
      html = html.replaceAll('%index%', index);
      html = html.replaceAll('%value%', value);
      return $(html);
    }
  }, {
    key: "getProductTemplate",
    value: function getProductTemplate(step, index, type, value) {
      var html = this.div().find('#subscription-wizard-product').html();
      html = html.replaceAll('%step%', step);
      html = html.replaceAll('%index%', index);
      html = html.replaceAll('%type%', type);
      html = html.replaceAll('%value%', value);
      return $(html);
    }
  }, {
    key: "getProductHtml",
    value: function getProductHtml(step, data, index, active, type, isSubscription) {
      var _this4 = this;
      var inputType = type ? type : 'radio';
      var recharge = vegamour.getRecharge(data.id);
      var $product = this.getProductTemplate(step, index + 1, inputType, data.id);
      var $badge = $product.find('[data-subscription-wizard-product-badge]');
      var variants = recharge.getProcessedOneTimeVariants();
      var variant = variants[0];
      if (data.variantId) {
        variants.forEach(function (variantData) {
          if (variantData.oneTime.id == data.variantId) {
            variant = variantData;
          }
        });
      }
      if (!variant) {
        console.error('No variant found for product', recharge);
        return;
      }
      $product.find('[data-subscription-wizard-product-image]').css('background-image', 'url("' + (data.image ? data.image : recharge.product.image) + '")');
      if (data.badge) {
        $badge.html(data.badge);
      } else {
        $badge.remove();
      }
      $product.find('[data-subscription-wizard-product-title]').html(data.title ? data.title : recharge.product.title);
      $product.find('[data-subscription-wizard-product-description]').html(data.description);
      if (variant.oneTime.processed.discount.price && variant.oneTime.processed.discount.price > variant.oneTime.price) {
        $product.find('[data-subscription-wizard-product-price-old]').html('$' + parseFloat(variant.oneTime.processed.discount.price).toFixed(0));
      } else if (isSubscription) {
        $product.find('[data-subscription-wizard-product-price-old]').html('$' + parseFloat(variant.oneTime.price).toFixed(0));
      } else {
        $product.find('[data-subscription-wizard-product-price-old]').remove();
      }
      var currentPrice = isSubscription ? variant.subscription.price : variant.oneTime.price;
      $product.find('[data-subscription-wizard-product-price-now]').html('$' + parseFloat(currentPrice).toFixed(0));
      if (index === active) {
        $product.addClass('active');
        $product.find('[data-subscription-wizard-product-check]').attr('checked', 'checked');
      }
      $product.find('[data-subscription-wizard-product-check]').on('change', function (e) {
        var checked = $product.find('[data-subscription-wizard-product-check]').is(':checked');
        if (checked) {
          if (inputType === 'radio') {
            $('[name="' + $product.find('[data-subscription-wizard-product-check]').attr('name') + '"]').each(function (i, input) {
              $(input).parents('.subscription-wizard-product').removeClass('active');
            });
          }
          $product.addClass('active');
        } else {
          $product.removeClass('active');
        }
        _this4.updateSummary();
      });
      return $product;
    }
  }, {
    key: "initStep1",
    value: function initStep1() {
      var _this5 = this;
      if (!window.subscriptionWizardProducts1) {
        return;
      }
      window.subscriptionWizardProducts1.forEach(function (data, index) {
        var $product = _this5.getProductHtml(1, data, index, 0);
        var recharge = vegamour.getRecharge(data.id);
        var variant = recharge.getProcessedOneTimeVariants()[0];
        $product.attr('data-product-id', data.id);
        $product.attr('data-product-variant-id', variant.subscription.id);
        _this5.div().find('[data-subscription-wizard-step="1"] .subscription-wizard-products').append($product);
      });
    }
  }, {
    key: "initStep3",
    value: function initStep3() {
      $('.subscription-wizard-block-step-3').each(function (i, div) {
        if (i > 0) {
          $(div).remove();
        }
      });
    }
  }, {
    key: "step3Update",
    value: function step3Update() {
      var _this6 = this;
      var $input = this.div().find('.subscription-wizard-shippings').find('[name="step_2_shipping"]:checked');
      var frequency = $input.attr('data-frequency');
      var unit = $input.attr('data-unit');
      var key = frequency + '_' + unit;
      console.log(frequency, unit);
      if (!window.subscriptionWizardProducts3 || typeof window.subscriptionWizardProducts3[key] === 'undefined') {
        console.error('Products for step 3 not found! Key is', key);
        return;
      }
      this.div().find('[data-subscription-wizard-step="3"] .subscription-wizard-products').html('');
      window.subscriptionWizardProducts3[key].forEach(function (data, index) {
        var $product = _this6.getProductHtml(3, data, index, 0, 'checkbox', true);
        var recharge = vegamour.getRecharge(data.id);
        var variants = recharge.getProcessedOneTimeVariants();
        var variant = variants[0];
        if (data.variantId) {
          variants.forEach(function (variantData) {
            if (variantData.oneTime.id == data.variantId) {
              variant = variantData;
            }
          });
        }
        console.log('variant', variant);
        $product.data('recharge', recharge);
        $product.data('product-data', data);
        $product.attr('data-type', 'subscription');
        $product.attr('data-product-id', data.id);
        $product.attr('data-product-variant-id', variant.oneTime.id);
        if (variant.subscription) {
          $product.attr('data-product-subscription-variant-id', variant.subscription.id);
        }
        _this6.initProductDiv($product);
        _this6.div().find('[data-subscription-wizard-step="3"] .subscription-wizard-products').append($product);
      });
    }
  }, {
    key: "initStep4",
    value: function initStep4() {
      var _this7 = this;
      if (!window.subscriptionWizardProducts4) {
        return;
      }
      window.subscriptionWizardProducts4.forEach(function (data, index) {
        var $product = _this7.getProductHtml(4, data, index, null, 'checkbox');
        var recharge = vegamour.getRecharge(data.id);
        var variant = recharge.getProcessedOneTimeVariants()[0];
        $product.data('recharge', recharge);
        $product.data('product-data', data);
        $product.attr('data-type', 'one-time');
        $product.attr('data-product-id', data.id);
        $product.attr('data-product-variant-id', variant.oneTime.id);
        if (variant.subscription) {
          $product.attr('data-product-subscription-variant-id', variant.subscription.id);
        }
        _this7.initProductDiv($product);
        _this7.div().find('[data-subscription-wizard-step="4"] .subscription-wizard-products').append($product);
      });
    }
  }, {
    key: "initProductDiv",
    value: function initProductDiv($product) {
      var _this8 = this;
      $product.addClass('with-price');
      if ($(window).width() > 1024) {
        $product.addClass('boxed');
      }
      $product.find('[data-subscription-wizard-product-add]').on('click', function (e) {
        e.preventDefault();
        $product.addClass('with-quantity');
        $product.find('[data-subscription-wizard-product-quantity]').val(1).trigger('change');
      });
      var recharge = $product.data('recharge');
      var variants = recharge.getProcessedOneTimeVariants();
      var variant = variants[0];
      var limit = recharge.product.cartLimit;
      if ($product.attr('data-product-variant-id') != variant.oneTime.id) {
        variants.forEach(function (variantData) {
          if ($product.attr('data-product-variant-id') == variantData.oneTime.id) {
            variant = variantData;
          }
        });
      }
      $product.find('[data-subscription-wizard-product-quantity-add]').on('click', function (e) {
        e.preventDefault();
        var $quantity = $product.find('[data-subscription-wizard-product-quantity]');
        var value = parseInt($quantity.val());
        value = isNaN(value) ? 0 : value;
        value++;
        $quantity.val(value).trigger('change');
      });
      $product.find('[data-subscription-wizard-product-quantity-remove]').on('click', function (e) {
        e.preventDefault();
        var $quantity = $product.find('[data-subscription-wizard-product-quantity]');
        var value = parseInt($quantity.val());
        value = isNaN(value) ? 0 : value;
        value--;
        $quantity.val(value).trigger('change');
      });
      $product.find('[data-subscription-wizard-product-quantity]').on('change', function (e) {
        var $quantity = $product.find('[data-subscription-wizard-product-quantity]');
        var $modal = $('#product-modal[data-product-id="' + $product.attr('data-product-id') + '"]');
        var value = parseInt($quantity.val());
        value = isNaN(value) ? 0 : value;
        if (value < 1) {
          $product.removeClass('with-quantity');
        } else {
          $product.addClass('with-quantity');
        }
        if (value === 1) {
          $modal.find('[data-subscription-wizard-modal-quantity-remove]').addClass('disabled');
          $product.find('[data-subscription-wizard-product-quantity-remove]').addClass('disabled');
        } else {
          $modal.find('[data-subscription-wizard-modal-quantity-remove]').removeClass('disabled');
          $product.find('[data-subscription-wizard-product-quantity-remove]').removeClass('disabled');
        }
        if (value >= limit) {
          $quantity.val(limit);
          $modal.find('[data-subscription-wizard-modal-quantity-add]').addClass('disabled');
          $product.find('[data-subscription-wizard-product-quantity-add]').addClass('disabled');
        } else {
          $modal.find('[data-subscription-wizard-modal-quantity-add]').removeClass('disabled');
          $product.find('[data-subscription-wizard-product-quantity-add]').removeClass('disabled');
        }
        var modalValue = parseInt($quantity.val()) >= 1 ? $quantity.val() : 1;
        $modal.find('[data-subscription-wizard-modal-quantity]').val(modalValue);
        _this8.updateSummary();
      }).inputFilter(function (value) {
        return /^\d*$/.test(value);
      });
      $product.find('[data-subscription-wizard-product-modal]').on('click', function (e) {
        e.preventDefault();
        var $modal = $('#product-modal');
        var data = $product.data('product-data');
        var isSubscription = $product.attr('data-type') === 'subscription';
        var description = recharge.product.description;
        if (recharge.product.page && recharge.product.page.popup && recharge.product.page.popup.description) {
          description = recharge.product.page.popup.description;
        }
        $modal.find('[data-subscription-wizard-modal-image]').attr('src', data.image ? data.image : recharge.product.image);
        $modal.find('[data-subscription-wizard-modal-title]').html(data.title ? data.title : recharge.product.title);
        $modal.find('[data-subscription-wizard-modal-description]').html(description);
        $modal.find('[data-subscription-wizard-modal-quantity]').val($product.find('[data-subscription-wizard-product-quantity]').val()).trigger('change');
        if (variant.oneTime.processed.discount.price && variant.oneTime.processed.discount.price > variant.oneTime.price) {
          $modal.find('[data-subscription-wizard-modal-price-old]').show();
          $modal.find('[data-subscription-wizard-modal-price-old]').html('$' + parseFloat(variant.oneTime.processed.discount.price).toFixed(0));
        } else if (isSubscription) {
          $modal.find('[data-subscription-wizard-modal-price-old]').html('$' + parseFloat(variant.oneTime.price).toFixed(0));
        } else {
          $modal.find('[data-subscription-wizard-modal-price-old]').hide();
        }
        var currentPrice = isSubscription ? variant.subscription.price : variant.oneTime.price;
        $modal.find('[data-subscription-wizard-modal-price-now]').html('$' + parseFloat(currentPrice).toFixed(0));
        $modal.data('recharge', recharge);
        $modal.data('product-data', data);
        $modal.attr('data-product-id', data.id);
        $product.find('[data-subscription-wizard-product-quantity]').trigger('change');
        $modal.find('[data-subscription-wizard-modal-quantity]').trigger('change');
        $modal.modal('show');
      });
    }
  }, {
    key: "getSummary",
    value: function getSummary() {
      var summary = {
        totalBeforeDiscount: 0,
        total: 0,
        monthly: 0
      };

      // Step 1
      var recharge1 = vegamour.getRecharge(this.getStep1ProductId());
      recharge1.setActiveVariant($('[name="step_2_shipping"]:checked').val());
      var variant1 = recharge1.getCurrentVariant();
      if (!variant1) {
        return summary;
      }
      summary.total += variant1.subscription.price;
      summary.totalBeforeDiscount += variant1.oneTime.comparePrice ? variant1.oneTime.comparePrice : variant1.oneTime.price;
      summary.monthly += variant1.subscription.price;
      $('.subscription-wizard-product.with-quantity').each(function (i, product) {
        var $product = $(product);
        var recharge = vegamour.getRecharge($product.attr('data-product-id'));
        var type = 'one-time';
        if ($product.attr('data-type') === 'subscription' && $product.attr('data-product-subscription-variant-id')) {
          type = 'subscription';
          console.log('set active variant sub', $product.attr('data-product-subscription-variant-id'));
          //  recharge.setActiveVariant($product.attr('data-product-subscription-variant-id'));
        } else {
          console.log('set active variant onetime', $product.attr('data-product-variant-id'));
          //  recharge.setActiveVariant($product.attr('data-product-variant-id'));
        }
        recharge.setActiveVariant($product.attr('data-product-variant-id'));
        console.log('summ recharge', recharge);
        var quantity = $product.find('[data-subscription-wizard-product-quantity]').val();
        var variant = recharge.getCurrentVariant();
        console.log('summ variant', variant);
        var price = type === 'subscription' ? variant.subscription.price : variant.oneTime.price;
        summary.total += parseFloat(price) * quantity;
        summary.totalBeforeDiscount += variant.oneTime.comparePrice ? variant.oneTime.comparePrice * quantity : variant.oneTime.price * quantity;
      });
      return summary;
    }
  }, {
    key: "checkout",
    value: function checkout() {
      var _this9 = this;
      var products = [];

      // Step 1
      var recharge1 = vegamour.getRecharge(this.getStep1ProductId());
      recharge1.setActiveVariant($('[name="step_2_shipping"]:checked').val());
      var oneTime = recharge1.getCurrentVariant().oneTime;
      var mainProductData = recharge1.getProductCartData(false);
      if (typeof oneTime.page !== 'undefined' && typeof oneTime.page.layout !== 'undefined') {
        if (oneTime.page.layout.frequency) {
          mainProductData.properties._shipping_interval_frequency = oneTime.page.layout.frequency;
        }
        if (oneTime.page.layout.unit) {
          mainProductData.properties._shipping_interval_unit_type = oneTime.page.layout.unit;
        }
      }
      products.push(mainProductData);
      if (typeof window.subscriptionWizardGiftVariantId !== 'undefined' && window.subscriptionWizardGiftVariantId && typeof oneTime.page !== 'undefined' && typeof oneTime.page.layout !== 'undefined' && oneTime.page.layout.gift) {
        products.push({
          id: window.subscriptionWizardGiftVariantId,
          quantity: 1,
          properties: {
            cart_limit: 1
          }
        });
      }
      $('.subscription-wizard-product.with-quantity').each(function (i, product) {
        var $product = $(product);
        var quantity = $product.find('[data-subscription-wizard-product-quantity]').val();
        var recharge = vegamour.getRecharge($product.attr('data-product-id'));
        recharge.setActiveVariant($product.attr('data-product-variant-id'));
        if ($product.attr('data-type') === 'subscription' && $product.attr('data-product-subscription-variant-id')) {
          var subscriptionProductData = recharge.getProductCartData(false, quantity);
          subscriptionProductData.properties._shipping_interval_frequency = mainProductData.properties._shipping_interval_frequency;
          subscriptionProductData.properties._shipping_interval_unit_type = mainProductData.properties._shipping_interval_unit_type;
          products.push(subscriptionProductData);
        } else {
          products.push(recharge.getProductCartData(true, quantity));
        }
      });
      this.div().find('.subscription-wizard-loader').addClass('show');
      var tries = 0;
      var addMultiple = function addMultiple() {
        vegamour.cart.addMultiple(products, function () {
          // Shopify bug?
          if (vegamour.cart.items.length === 0) {
            tries++;
            console.error('Multiples products failed to add to cart. ', tries, ' tries');
            if (tries < 3) {
              return addMultiple();
            } else {
              return alert('Something went wrong, try again later.');
            }
          }
          if (vegamour.getParam('no_redirect')) {
            _this9.div().find('.subscription-wizard-loader').removeClass('show');
            return;
          }
          vegamour.cart.checkout();
        });
      };
      vegamour.cart.empty(function () {
        addMultiple();
      });
    }
  }, {
    key: "updateSummary",
    value: function updateSummary() {
      var summary = this.getSummary();
      var saved = summary.totalBeforeDiscount - summary.total;
      var $summary = this.div().find('.subscription-wizard-bar-summary');
      $summary.find('[data-subscription-wizard-summary-total]').html('$' + parseFloat(summary.total).toFixed(0));
      $summary.find('[data-subscription-wizard-summary-saved]').html('$' + parseFloat(saved).toFixed(0));
      //$summary.find('[data-subscription-wizard-summary-monthly]').html('$' + parseFloat(summary.monthly).toFixed(0) + '/mo');
    }
  }, {
    key: "initModal",
    value: function initModal() {
      var $modal = $('#product-modal');
      $modal.find('[data-subscription-wizard-modal-quantity-add]').on('click', function (e) {
        e.preventDefault();
        var $quantity = $modal.find('[data-subscription-wizard-modal-quantity]');
        var value = parseInt($quantity.val());
        value = isNaN(value) ? 0 : value;
        value++;
        $quantity.val(value).trigger('change');
      });
      $modal.find('[data-subscription-wizard-modal-quantity-remove]').on('click', function (e) {
        e.preventDefault();
        var $quantity = $modal.find('[data-subscription-wizard-modal-quantity]');
        var value = parseInt($quantity.val());
        value = isNaN(value) ? 0 : value;
        value--;
        $quantity.val(value).trigger('change');
      });
      $modal.find('[data-subscription-wizard-modal-quantity]').on('change', function (e) {
        var recharge = $modal.data('recharge');
        if (!recharge) {
          return;
        }
        var limit = recharge.product.cartLimit;
        var $quantity = $modal.find('[data-subscription-wizard-modal-quantity]');
        var value = parseInt($quantity.val());
        value = isNaN(value) ? 0 : value;
        if (value <= 1) {
          $modal.find('[data-subscription-wizard-modal-quantity-remove]').addClass('disabled');
          $quantity.val(1);
        } else {
          $modal.find('[data-subscription-wizard-modal-quantity-remove]').removeClass('disabled');
        }
        if (value >= limit) {
          $modal.find('[data-subscription-wizard-modal-quantity-add]').addClass('disabled');
          $quantity.val(limit);
        } else {
          $modal.find('[data-subscription-wizard-modal-quantity-add]').removeClass('disabled');
        }
      });
      $modal.find('[data-subscription-wizard-modal-add]').on('click', function (e) {
        e.preventDefault();
        var $product = $('.subscription-wizard-product[data-product-id="' + $modal.attr('data-product-id') + '"]');
        var $quantity = $product.find('[data-subscription-wizard-product-quantity]');
        $quantity.val($modal.find('[data-subscription-wizard-modal-quantity]').val()).trigger('change');
        $modal.modal('hide');
      });
    }
  }]);
  return VegamourSubscriptionWizard;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourCommonBlocksBrands = /*#__PURE__*/function () {
  function VegamourCommonBlocksBrands($div) {
    _classCallCheck(this, VegamourCommonBlocksBrands);
    this.$div = $div;
    this.init();
  }
  _createClass(VegamourCommonBlocksBrands, [{
    key: "init",
    value: function init() {
      $(document).ready(function () {});
    }
  }], [{
    key: "initBlocks",
    value: function initBlocks() {
      $('.block-common-brands').each(function () {
        vegamour.commonBlocks.push(new VegamourCommonBlocksBrands($(this)));
      });
    }
  }]);
  return VegamourCommonBlocksBrands;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourCommonBlocksBlog = /*#__PURE__*/function () {
  function VegamourCommonBlocksBlog($div) {
    _classCallCheck(this, VegamourCommonBlocksBlog);
    this._div = $div;
    this.init();
  }
  _createClass(VegamourCommonBlocksBlog, [{
    key: "div",
    value: function div() {
      return this._div;
    }
  }, {
    key: "init",
    value: function init() {
      if (!vegamour.isMobile()) {
        return;
      }
      var $slick = this.div().find('.block-common-blog-items');
      $slick.slick({
        arrows: false,
        variableWidth: true,
        infinite: false
      });
      VegamourImage.resizeImages();
    }
  }], [{
    key: "initBlocks",
    value: function initBlocks() {
      $('.block-common-blog').each(function () {
        vegamour.commonBlocks.push(new VegamourCommonBlocksBlog($(this)));
      });
    }
  }]);
  return VegamourCommonBlocksBlog;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourPagesOurStory = /*#__PURE__*/function () {
  function VegamourPagesOurStory() {
    var _this = this;
    _classCallCheck(this, VegamourPagesOurStory);
    $(document).ready(function () {
      _this.init();
    });
  }
  _createClass(VegamourPagesOurStory, [{
    key: "init",
    value: function init() {
      this.initFounderSectionSlider();
      this.initHarvestSectionSlider();
      this.initAbountFounderLink();
    }
  }, {
    key: "initFounderSectionSlider",
    value: function initFounderSectionSlider() {
      var $slider = $('.grid-section-content .js-mobile-slider');
      var settings = {
        dots: true,
        arrows: false,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: '20%',
        focusOnSelect: true,
        infinite: false
      };
      function setSlideVisibility() {
        // Set the first and part of last slides visible
        var visibleSlides = $slider.find('.slick-slideshow__slide[aria-hidden="false"]');
        $(visibleSlides).each(function () {
          $(this).css('opacity', 1);
        });
        $(visibleSlides).first().prev().css('opacity', 0);
      }
      $slider.not('.slick-initialized').slick(settings);
      $slider.slick('slickGoTo', 0);
      setSlideVisibility();
      $slider.on('afterChange', function () {
        setSlideVisibility();
      });
      $(window).on('resize', function (event) {
        if (window.innerWidth < 641) {
          $slider.slick('refresh');
        }
      });
    }
  }, {
    key: "initHarvestSectionSlider",
    value: function initHarvestSectionSlider() {
      var $slider = $('.banner-slider-content .slider-wrap');
      var settings = {
        dots: false,
        arrows: false,
        slidesToShow: 2,
        centerMode: true,
        focusOnSelect: true,
        infinite: true,
        centerPadding: $slider.find('.img-wrap').outerWidth() / 2,
        responsive: [{
          breakpoint: 1024,
          settings: {
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerPadding: '20%'
          }
        }]
      };
      function setSlideVisibility() {
        // Set the first and part of last slides visible
        var visibleSlides = $slider.find('.slick-slideshow__slide[aria-hidden="false"]');
        $(visibleSlides).each(function () {
          $(this).css('opacity', 1);
        });
        $(visibleSlides).first().next().css('opacity', 0);
      }
      $slider.not('.slick-initialized').slick(settings);
      $slider.slick('slickGoTo', 3);
      setSlideVisibility();
      $slider.on('afterChange', function () {
        setSlideVisibility();
      });
    }
  }, {
    key: "initAbountFounderLink",
    value: function initAbountFounderLink() {
      $(".js-read-about-trigger").click(function (event) {
        event.preventDefault();
        $(this).hide();
        $(".js-founder-content").show();
      });
    }
  }]);
  return VegamourPagesOurStory;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourPagesReviews = /*#__PURE__*/function () {
  function VegamourPagesReviews() {
    var _this = this;
    _classCallCheck(this, VegamourPagesReviews);
    $(document).ready(function () {
      _this.init();
    });
  }
  _createClass(VegamourPagesReviews, [{
    key: "init",
    value: function init() {
      this.initReviewsSlider();
    }
  }, {
    key: "initReviewsSlider",
    value: function initReviewsSlider() {
      var $slider = $('.block-reviews__slider');
      var settings = {
        dots: false,
        arrows: true,
        slidesToShow: 1,
        centerMode: true,
        focusOnSelect: true,
        infinite: true,
        prevArrow: '<a class="product-gallery-arrow previous"></a>',
        nextArrow: '<a class="product-gallery-arrow next"></a>',
        centerPadding: '30%',
        responsive: [{
          breakpoint: 1441,
          settings: {
            centerPadding: '20%'
          }
        }, {
          breakpoint: 1025,
          settings: {
            centerPadding: '10%'
          }
        }, {
          breakpoint: 641,
          settings: {
            centerPadding: '0'
          }
        }]
      };
      function setSlideVisibility() {
        // Set the first and part of last slides visible
        var visibleSlides = $slider.find('.slick-slideshow__slide[aria-hidden="false"]');
        $(visibleSlides).each(function () {
          $(this).css('opacity', 1);
        });
        $(visibleSlides).first().prev().css('opacity', 0);
      }
      $slider.not('.slick-initialized').slick(settings);
      setSlideVisibility();
      $slider.on('afterChange', function () {
        setSlideVisibility();
      });
    }
  }]);
  return VegamourPagesReviews;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourDatalayer = /*#__PURE__*/function () {
  function VegamourDatalayer() {
    _classCallCheck(this, VegamourDatalayer);
    this.lastData = null;
    this.hookCart();
  }
  _createClass(VegamourDatalayer, [{
    key: "hookCart",
    value: function hookCart() {
      var _this = this;
      vegamour.cart.on('itemAdded', function (data) {
        _this.updateCart(true, data);
      });
      vegamour.cart.on('itemRemoved', function (data) {
        _this.updateCart(false, data);
      });
      vegamour.cart.on('itemChanged', function (data, additional) {
        _this.updateCart(null, data, additional);
      });
    }
  }, {
    key: "updateCart",
    value: function updateCart(added, data, additional) {
      if (typeof dataLayer === 'undefined') {
        return;
      }
      $.get(window.Shopify.routes.root + 'cart?view=datalayer', function (res) {
        var $script = $(res);
        jQuery.globalEval($script.html());
        if (typeof cartItems !== 'undefined') {
          var dataLayerCart = {};
          var item = {};
          if (typeof cartItems[data.id] !== 'undefined') {
            item = cartItems[data.id];
          } else {
            if (typeof data.data !== 'undefined') {
              data = data.data;
            }
            var isSub = typeof data['seling_plan_id'] !== 'undefined' && data['seling_plan_id'];
            item = {
              item_id: data.id,
              item_brand: 'VEGAMOUR',
              item_category: data.product_type,
              item_category2: '',
              item_variant: data.variant_title,
              affiliation: isSub ? 'Subscription' : 'One Time',
              sku: data.sku,
              shopifyID: data.product_id,
              subscriptionID: isSub ? data.id : null,
              onetimeID: isSub ? null : data.id,
              price: (parseFloat(data.price) / 100).toFixed(2),
              coupon: vegamour.cart.discounts.getActiveDiscountCode(),
              upc: ' ',
              quantity: data.quantity
            };
          }
          if (added === true || typeof additional !== 'undefined' && typeof additional.added !== 'undefined') {
            item.quantity = typeof additional !== 'undefined' && typeof additional.added !== 'undefined' ? additional.added : data.quantity;
            dataLayerCart.event = 'add_to_cart';
            dataLayerCart.ecommerce = {
              currency: vegamourOptions.currency["short"],
              items: [item]
            };
          } else if (added === false || typeof additional !== 'undefined' && typeof additional.removed !== 'undefined') {
            item.quantity = typeof additional !== 'undefined' && typeof additional.removed !== 'undefined' ? additional.removed : data.quantity;
            dataLayerCart.event = 'remove_from_cart';
            dataLayerCart.ecommerce = {
              currency: vegamourOptions.currency["short"],
              items: [item]
            };
          }
          dataLayer.push({
            ecommerce: null
          });
          dataLayer.push(dataLayerCart);
        }
      });
    }
  }, {
    key: "pushEmailSignupEvent",
    value: function pushEmailSignupEvent(source, vendor, email) {
      var emailSignupObject = {
        'event': 'email_signup',
        'formName': source,
        'formVendor': vendor,
        'emailHash': vegamour.hash(email)
      };
      console.log('📌 DataLayer [emailSignup]', emailSignupObject);
      dataLayer.push(emailSignupObject);
    }
  }]);
  return VegamourDatalayer;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourBtnCustom = /*#__PURE__*/function () {
  function VegamourBtnCustom() {
    _classCallCheck(this, VegamourBtnCustom);
    this.init();
  }
  _createClass(VegamourBtnCustom, [{
    key: "init",
    value: function init() {
      if ($(".btn-custom").length) {
        var _iterator = _createForOfIteratorHelper($(".btn-custom")),
          _step;
        try {
          var _loop = function _loop() {
            var btn = _step.value;
            var btnBg = btn.getAttribute("data-bg"),
              btnBgHover = btn.getAttribute("data-bg-hover"),
              btnColor = btn.getAttribute("data-color"),
              btnColorHover = btn.getAttribute("data-color-hover"),
              btnBorder = btn.getAttribute("data-border"),
              btnBorderHover = btn.getAttribute("data-border-hover"),
              defaultStyles = "background-color: ".concat(btnBg, "; color: ").concat(btnColor, "; border: 2px solid ").concat(btnBorder),
              hoverStyles = "background-color: ".concat(btnBgHover, "; color: ").concat(btnColorHover, "; border: 2px solid ").concat(btnBorderHover);
            btn.addEventListener("mouseover", function () {
              btn.style.cssText = hoverStyles;
            });
            btn.addEventListener("mouseout", function () {
              btn.style.cssText = defaultStyles;
            });
          };
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }]);
  return VegamourBtnCustom;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourApi = /*#__PURE__*/function () {
  function VegamourApi() {
    _classCallCheck(this, VegamourApi);
  }
  _createClass(VegamourApi, [{
    key: "isDev",
    value: function isDev() {
      return window.vegamourOptions.backend.api.indexOf('api-test.') > -1;
    }
  }, {
    key: "isStage",
    value: function isStage() {
      return window.vegamourOptions.backend.api.indexOf('api-stage.') > -1;
    }
  }, {
    key: "isProd",
    value: function isProd() {
      return window.vegamourOptions.backend.api.indexOf('api.') > -1;
    }
  }, {
    key: "buildUrl",
    value: function buildUrl(path, params) {
      var url = window.vegamourOptions.backend.api;
      if (path.substr(0, 1) !== '/') {
        url += '/';
      }
      var backendParams = {
        store: window.vegamourOptions.backend.store
      };
      if (vegamour.emailHash()) {
        backendParams.hash = vegamour.emailHash();
      }
      if (vegamour.customer && vegamour.customer.id) {
        backendParams.customer_id = vegamour.customer.id;
      }
      var urlParams = Object.assign({}, backendParams, typeof params !== 'undefined' ? params : {});
      url += path;
      url += '?' + Object.keys(urlParams).map(function (k) {
        return encodeURIComponent(k) + '=' + encodeURIComponent(urlParams[k]);
      }).join('&');
      return url;
    }
  }]);
  return VegamourApi;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var VegamourAdmin = /*#__PURE__*/function () {
  function VegamourAdmin() {
    _classCallCheck(this, VegamourAdmin);
  }
  _createClass(VegamourAdmin, [{
    key: "init",
    value: function init() {
      var _this = this;
      if (typeof localStorage === 'undefined') {
        return;
      }
      if (!localStorage.getItem('admin')) {
        return;
      }
      $(document).ready(function () {
        _this.initAdmin();
        _this.initEditProduct();
        _this.initEditCollection();
      });
    }
  }, {
    key: "initAdmin",
    value: function initAdmin() {
      $('body').append('<div class="admin-menu"><a class="admin-menu-toggle"></a><div class="admin-menu-items"></div></div>');
      var $items = $('.admin-menu-items');
      $(document).on('click', function (e) {
        $items.removeClass('show');
      });
      $('.admin-menu-toggle').on('click', function (e) {
        e.preventDefault();
        $items.toggleClass('show');
      });
      $('.admin-menu').on('click', function (e) {
        e.stopPropagation();
      });
    }
  }, {
    key: "initEditProduct",
    value: function initEditProduct() {
      var $productForm = $('[data-product-form]');
      if ($productForm.length === 0) {
        return;
      }
      var $items = $('.admin-menu-items');
      $items.append('<a href="/admin/products/' + $productForm.attr('data-product-id') + '" target="_blank">Edit product</a>');
      $items.append('<a href="/admin/apps/256-metafields-editor/products/0?id=' + $productForm.attr('data-product-id') + '&shop=vegalash.myshopify.com" target="_blank">Edit metafields</a>');
    }
  }, {
    key: "initEditCollection",
    value: function initEditCollection() {
      var $collectionJson = $('[data-collection-json]');
      if ($collectionJson.length === 0) {
        return;
      }
      try {
        var json = JSON.parse($collectionJson.html());
        var $items = $('.admin-menu-items');
        $items.append('<a href="/admin/collections/' + json.collection.id + '" target="_blank">Edit collection</a>');
        $items.append('<a href="/admin/apps/256-metafields-editor/collections/0?id=' + json.collection.id + '&shop=vegalash.myshopify.com&type=custom" target="_blank">Edit metafields</a>');
      } catch (e) {
        //
        console.error(e);
      }
    }
  }]);
  return VegamourAdmin;
}();
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Vegamour = /*#__PURE__*/function (_Events) {
  _inherits(Vegamour, _Events);
  var _super = _createSuper(Vegamour);
  function Vegamour() {
    _classCallCheck(this, Vegamour);
    return _super.apply(this, arguments);
  }
  _createClass(Vegamour, [{
    key: "init",
    value: function init() {
      var _this = this;
      this.isDebug = this.hasParam('vdebug');
      if (this.isDebug) {
        console.log('🦗 Debug Mode Enabled');
      }
      var self = this;
      this.domain = window.vegamourOptions.domain;
      this.customer = window.vegamourOptions.customer;
      this.api = new VegamourApi();
      this.cache = new VegamourCache();
      this.session = new VegamourSession();
      this.cart = new VegamourCart();
      this.cart.init();
      this.geolocation = new VegamourGeolocation();
      this.geolocation.init();
      this.shippingRates = new VegamourShippingRates();
      this.shippingRates.init();
      this.header = new VegamourHeader();
      this.header.init();
      this.cookie = new VegamourCookie();
      this.admin = new VegamourAdmin();
      this.admin.init();
      this.account = new VegamourAccount();
      this.account.init();
      this.blog = new VegamourBlogBanners();
      this.homepage = new VegamourHomepage();
      this.homepage.init();
      this.country = new VegamourCountry();
      this.images = [];
      this.initPages();
      this.pages.push(new VegamourPagesReviews());
      this.datalayer = new VegamourDatalayer();
      this.quickView = new VegamourQuickView();
      this.links = new VegamourLinks();
      this.commonBlocks = [];
      this.initCommonBlocks();
      this.rechargeProducts = [];
      $(document).ready(function () {
        _this.renderSelects();
        _this.initImages();
        _this.initRecharge();
        _this.initProduct();
        _this.initBtnCustom();
        _this.initReferer();
        _this.initCollection();
        _this.togglePreviewBar();
        _this.checkCookies();
        if (_this.product && _this.product.getRecharge()) {
          _this.product.getRecharge().emit('productInitialized');
        }
        _this.emit('ready');
      });
      $(window).on('resize', function () {
        self.setCssVariables();
      });
      $(window).on('scroll', function () {
        self.setCssVariables();
      });
      this.setCssVariables();
    }
  }, {
    key: "debug",
    value: function debug(content, qs) {
      if (this.isDebug) {
        var hasQS = typeof qs !== 'undefined' && !$.isEmptyObject(qs);
        if (hasQS) {
          content += '&' + new URLSearchParams(qs).toString();
        }
        console.log(content);
        if (hasQS) {
          console.table(qs);
        }
      }
    }
  }, {
    key: "setCssVariables",
    value: function setCssVariables() {
      if (this.isMobile() && $('input').is(':focus') && navigator.userAgent.match(/iPhone/i)) {
        return;
      }
      var vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
    }
  }, {
    key: "renderSelects",
    value: function renderSelects() {
      $('.vegamour-select-v2:not(.vegamour-select-v2-initialized)').each(function () {
        new VegamourSelect($(this));
      });
    }
  }, {
    key: "initProduct",
    value: function initProduct() {
      if ($('[data-product-json]').length > 0) {
        this.product = new VegamourProduct(JSON.parse($('[data-product-json]').html()).product);
      }
    }
  }, {
    key: "appendParamsToLocation",
    value: function appendParamsToLocation(params) {
      var href = window.location.href;
      for (var param in params) {
        href = this.updateParam(href, param, params[param]);
      }
      return href;
    }
  }, {
    key: "getParam",
    value: function getParam(param, url) {
      if (!url) {
        url = window.location.href;
      }
      var reg = new RegExp("([?&])" + param + "=.*?(&|$)", "i");
      var match = url.match(reg);
      if (match) {
        var result = match[0].split('=').slice(1).join('=');
        if (match[2]) {
          result = result.substr(0, result.length - 1);
        }
        return result;
      }
      return null;
    }
  }, {
    key: "hasParam",
    value: function hasParam(param, url) {
      if (this.getParam(param, url) !== null) {
        return true;
      }
      if (!url) {
        url = window.location.href;
      }
      var reg = new RegExp("([?&])" + param + "?(&|$)", "i");
      var match = url.match(reg);
      if (match && match[1]) {
        return true;
      }
      return false;
    }
  }, {
    key: "updateParam",
    value: function updateParam(url, param, value) {
      var reg = new RegExp("([?&])" + param + "=.*?(&|$)", "i");
      var separator = url.indexOf('?') !== -1 ? "&" : "?";
      if (url.match(reg)) {
        return url.replace(reg, '$1' + encodeURIComponent(param) + "=" + encodeURIComponent(value) + '$2');
      }
      return url + separator + encodeURIComponent(param) + "=" + encodeURIComponent(value);
    }
  }, {
    key: "getCookie",
    value: function getCookie(name, defaultValue) {
      var value = (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2];
      return typeof defaultValue !== 'undefined' && typeof value === 'undefined' ? defaultValue : value;
    }
  }, {
    key: "setCookie",
    value: function setCookie(name, value, expiryDays, path, domain) {
      var d = new Date();
      d.setTime(d.getTime() + expiryDays * 24 * 60 * 60 * 1000);
      document.cookie = name + "=" + value + ";expires=" + d.toUTCString() + ";path=/" + (typeof path !== 'undefined' ? path : '') + (typeof domain !== 'undefined' ? ';domain=' + domain : '');
    }
  }, {
    key: "setDomainCookie",
    value: function setDomainCookie(name, value, expiryDays, path) {
      var domain = window.location.hostname;
      var parts = domain.split('.');
      if (parts.length > 2) {
        domain = parts[parts.length - 2] + '.' + parts[parts.length - 1];
      }
      this.setCookie(name, value, expiryDays, path, domain);
    }
  }, {
    key: "checkCookies",
    value: function checkCookies() {
      var self = this;
      var len = function len(str) {
        var size = new Blob([str]).size;
        return size;
      };
      $.each(document.cookie.split(/; */), function () {
        var cookie = this.split('=');
        var cookieSize = len(cookie[1]);
        if (cookieSize > 2000) {
          console.log('🍪 Large cookie: ' + cookie[0] + ': ' + cookieSize + 'b');
          if (cookieSize > 3800) {
            console.log('🍪 Clearing cookie: ' + cookie[0]);
            self.setDomainCookie(cookie[0], '', 1);
          }
        }
      });
    }
  }, {
    key: "notify",
    value: function notify(type, content, title, options) {
      toastr.options.iconClasses = {
        warning: 'notification-warning',
        error: 'notification-error',
        success: 'notification-success',
        info: 'notification-info'
      };
      var config = $.extend({}, {
        timeOut: 10000,
        toastClass: 'notification',
        containerId: 'notification-container',
        progressBar: true,
        progressClass: 'notification-progress'
      }, options);
      toastr[type](content, title, config);
    }
  }, {
    key: "initImages",
    value: function initImages() {
      VegamourImage.initImages();
    }
  }, {
    key: "imgSize",
    value: function imgSize(src, size) {
      if (!src || !size) {
        return '';
      }
      var regex = /_([0-9]*[x]?[0-9]*|pico|icon|thumb|small|compact|medium|large|grande|master)(\.[^\.]+)$/;
      size = '_' + size;
      return src.match(regex) ? src.replace(regex, size + '$2') : src.replace(/(\.[^\.]+)$/, size + '$1');
    }
  }, {
    key: "togglePreviewBar",
    value: function togglePreviewBar() {
      setTimeout(function () {
        if ($('#preview-bar-iframe').length) {
          $('.header-logo, .header-mobile-logo').append('<div class="preview-title">' + Shopify.theme.name.substring(0, 32) + (Shopify.theme.name.length > 32 ? '...' : '') + '</div>').click(function () {
            $('#preview-bar-iframe').toggleClass('open');
          });
        }
      }, 1000);
    }
  }, {
    key: "initBtnCustom",
    value: function initBtnCustom() {
      this.btnCustom = new VegamourBtnCustom();
    }
  }, {
    key: "hash",
    value: function hash(value) {
      if (!value) {
        return '';
      }
      return sha256(value);
    }
  }, {
    key: "emailHash",
    value: function emailHash() {
      if (!window.vegamourOptions || !window.vegamourOptions.customer || !window.vegamourOptions.customer.email) {
        return '';
      }
      return this.hash(window.vegamourOptions.customer.email.trim().toLowerCase());
    }
  }, {
    key: "initCommonBlocks",
    value: function initCommonBlocks() {
      VegamourCommonBlocksBrands.initBlocks();
      VegamourCommonBlocksBlog.initBlocks();
    }
  }, {
    key: "getDeviceType",
    value: function getDeviceType() {
      var ua = navigator.userAgent;
      if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
        return 'tablet';
      }
      if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
        return 'mobile';
      }
      return 'desktop';
    }
  }, {
    key: "initReferer",
    value: function initReferer() {
      var ref = this.getParam('ref');
      if (ref) {
        this.setCookie('ref_param', ref, 1);
      }
      if (document.referrer) {
        var refUrl = new URL(document.referrer);
        if (refUrl && refUrl.host.indexOf('vegamour.com') === -1) {
          this.setCookie('ref_url', refUrl.href, 1);
        }
      }
    }
  }, {
    key: "initRecharge",
    value: function initRecharge() {
      var _this2 = this;
      if (typeof window.rechargeProducts !== 'undefined') {
        window.rechargeProducts.forEach(function (product) {
          if (product.initialised) {
            return;
          }
          var recharge = new VegamourProductRecharge(product);
          _this2.rechargeProducts.push(recharge);
          recharge.init();
          product.initialised = true;
        });
      }
    }
  }, {
    key: "initCollection",
    value: function initCollection() {
      this.collection = new VegamourCollection();
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      return $(window).width() <= 640;
    }
  }, {
    key: "getRecharge",
    value: function getRecharge(productId) {
      var result = null;
      this.rechargeProducts.forEach(function (recharge) {
        if (!result && recharge.getProductId() == productId) {
          result = recharge;
        }
      });
      return result;
    }
  }, {
    key: "initPages",
    value: function initPages() {
      this.pages = [];
      this.pages.push(new VegamourPagesTerms());
      this.pages.push(new VegamourPagesScience());
      this.pages.push(new VegamourPagesOurStory());
      this.pages.push(new VegamourSubscriptionWizard());
    }
  }]);
  return Vegamour;
}(Events);
window.vegamour = new Vegamour();
window.vegamour.init();
function announce(id, duration) {
  var force = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var scroll = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  return vegamour.header.announcements.announce(id, duration, force, scroll);
}
function modalOpenedAccessibilityAdjustments($modalContainer) {
  $modalContainer.attr('aria-hidden', false);
  $('body').attr('aria-hidden', true);
  $('body').attr('tabindex', -1);
  $modalContainer.attr('tabindex', 0);
  $modalContainer.focus();
  $modalContainer.children(":first").focus();
  $modalContainer.on("focusout", function (e) {
    if ($.contains($modalContainer[0], e.relatedTarget) == false) {
      setTimeout(function () {
        $modalContainer.focus();
        $modalContainer.children(":first").focus();
      }, 0);
    }
  });
}
function modalClosedAccessibilityAdjustments($modalContainer) {
  $modalContainer.attr('aria-hidden', true);
  $('body').attr('aria-hidden', false);
  $('body').removeAttr('tabindex');
  $modalContainer.attr('tabindex', -1);
  $modalContainer.off("focusin", "**");
  var modalTrigger = this.modalTriggerElement;
  if (modalTrigger) modalTrigger.focus();
}
